/* eslint-disable */

/**
 * @fileoverview
 *
 * This is an auto-generated file, see script/shared_constants/generate-types.js for the script that generates it.
 *
 * DO NOT MODIFY BY HAND
 */
export interface SHARED_CONSTANTS_ACCESSIBILITY_TESTING_CATEGORIES {
  OPERABLE: "OPERABLE";
  PERCEIVABLE: "PERCEIVABLE";
  ROBUST: "ROBUST";
  UNDERSTANDABLE: "UNDERSTANDABLE";
}
export interface SHARED_CONSTANTS_ACCESSIBILITY_TESTING_ERRORS {
  EMAIL_NOT_ENABLED: "EMAIL_NOT_ENABLED";
  INVALID_HTML_CONTENT: "INVALID_HTML_CONTENT";
  INVALID_PREVIEW_IDS: "INVALID_PREVIEW_IDS";
  INVALID_TEST_ID: "INVALID_TEST_ID";
  LEGACY_EOA_ENDPOINT_DISABLED: "LEGACY_EOA_ENDPOINT_DISABLED";
  NO_DATA: "NO_DATA";
  NO_SUBJECT: "NO_SUBJECT";
  RETRIED_ERROR: "RETRIED_ERROR";
  UNABLE_TO_PROCESS_REQUEST_ERROR: "UNABLE_TO_PROCESS_REQUEST_ERROR";
}
export interface SHARED_CONSTANTS_ACCESSIBILITY_TEST_STATUS {
  COMPLETED: "COMPLETED";
  FAIL: "FAIL";
  PASS: "PASS";
  PROCESSING: "PROCESSING";
}
export interface SHARED_CONSTANTS_AGENTIC_VALIDATION_ERROR_CODES {
  API_KEY_VALIDATION_FAILED: "API_KEY_VALIDATION_FAILED";
  INVALID_API_KEY_PREFIX: "INVALID_API_KEY_PREFIX";
  INVALID_AUTH_TYPE: "INVALID_AUTH_TYPE";
  INVALID_AWS_REGION: "INVALID_AWS_REGION";
  INVALID_PROJECT_NAME: "INVALID_PROJECT_NAME";
  INVALID_ROLE_ARN: "INVALID_ROLE_ARN";
  INVALID_WORKSPACE_NAME: "INVALID_WORKSPACE_NAME";
  MISSING_API_KEY: "MISSING_API_KEY";
  MISSING_AWS_REGION: "MISSING_AWS_REGION";
  MISSING_EXTERNAL_ID: "MISSING_EXTERNAL_ID";
  MISSING_PROJECT_NAME: "MISSING_PROJECT_NAME";
  MISSING_ROLE_ARN: "MISSING_ROLE_ARN";
  MISSING_WORKSPACE_NAME: "MISSING_WORKSPACE_NAME";
  ROLE_AUTH_NOT_ENABLED: "ROLE_AUTH_NOT_ENABLED";
  ROLE_VALIDATION_FAILED: "ROLE_VALIDATION_FAILED";
}
export interface SHARED_CONSTANTS_AMAZON_BEDROCK_AUTH_TYPES {
  KEY: 1;
  ROLE: 2;
}
export interface SHARED_CONSTANTS_AGENTIC_CREDENTIAL {
  AGENTIC_VALIDATION_ERROR_CODES: SHARED_CONSTANTS_AGENTIC_VALIDATION_ERROR_CODES;
  AMAZON_BEDROCK_AUTH_TYPES: SHARED_CONSTANTS_AMAZON_BEDROCK_AUTH_TYPES;
  AMAZON_BEDROCK_SUPPORTED_REGIONS: ("ap-northeast-1" | "ap-south-1" | "ap-southeast-2" | "ap-southeast-3" | "eu-central-1" | "eu-north-1" | "eu-south-1" | "eu-west-1" | "eu-west-2" | "sa-east-1" | "us-east-1" | "us-east-2" | "us-west-2")[];
}
export interface SHARED_CONSTANTS_BRAZE_CONTEXT_TYPES {
  SEGMENT_MEMBERSHIP: "segment_membership";
  USER_INTERACTION_DATA: "user_interaction_data";
}
export interface SHARED_CONSTANTS_ERROR_CODES {
  MISSING_PARAMETER: "MISSING_PARAMETER";
  UPDATE_FAILED: "UPDATE_FAILED";
}
export interface SHARED_CONSTANTS_INTERACTION_SITES {
  CAMPAIGN_SETUP: 2;
  CANVAS: 0;
  CANVAS_QA: 3;
  CATALOG: 1;
}
export interface SHARED_CONSTANTS_PROVIDERS {
  AMAZON_BEDROCK: 6;
  ANTHROPIC: 2;
  BRAZE: 0;
  DATABRICKS_MOSAIC: 4;
  GEMINI: 3;
  MICROSOFT_FOUNDRY: 5;
  OPENAI: 1;
}
export interface SHARED_CONSTANTS_PRESET_RULESET_TYPES {
  AUDIENCE_AND_TARGETING: "audience_and_targeting";
  CAMPAIGN_SETUP: "campaign_setup";
  CANVAS_SETUP: "canvas_setup";
  CANVAS_STRUCTURE: "canvas_structure";
  COMPLIANCE_AND_DELIVERABILITY: "compliance_and_deliverability";
  CONTENT_AND_COPY: "content_and_copy";
  LINKS_AND_TRACKING: "links_and_tracking";
  PERSONALIZATION_AND_DYNAMIC_CONTENT: "personalization_and_dynamic_content";
}
export interface SHARED_CONSTANTS_RULESET_SCOPES {
  CANVAS: "canvas";
  MESSAGE_STEP: "message_step";
}
export interface SHARED_CONSTANTS_QA_AGENTS {
  MAX_AGENTS_PER_REQUEST: 10;
  MAX_RULESETS_PER_AGENT: 10;
  MAX_RULES_PER_RULESET: 20;
  PRESET_RULESET_TYPES: SHARED_CONSTANTS_PRESET_RULESET_TYPES;
  RULESET_SCOPES: SHARED_CONSTANTS_RULESET_SCOPES;
}
export interface SHARED_CONSTANTS_SCHEMA_TYPES {
  ARRAY_NUMBER: "array_number";
  ARRAY_STRING: "array_string";
  BOOLEAN: "boolean";
  FIELDS: "response_fields";
  JSON_SCHEMA: "json_schema";
  NUMBER: "number";
  STRING: "string";
}
export interface SHARED_CONSTANTS_THINKING_LEVELS {
  HIGH: "high";
  LOW: "low";
  MEDIUM: "medium";
  MINIMAL: "minimal";
  NONE: "none";
}
export interface SHARED_CONSTANTS_AI_SETTINGS {
  BRAND_REFERENCE_REGEX_PATTERN: "\\b(brand(s|ing|ed)?|voices?|tones?|guidelines?)\\b";
  BRAZE_CONTEXT_TYPES: SHARED_CONSTANTS_BRAZE_CONTEXT_TYPES;
  BRAZE_MODEL: "braze-model";
  DEFAULT_DAILY_EXECUTION_LIMIT_PER_AGENT: 250000;
  DEFAULT_DAILY_EXECUTION_LIMIT_QA: 5000;
  DEFAULT_MAX_DAILY_EXECUTION_LIMIT_SUPPORTED_FOR_CUSTOMER_CONFIG: 1000000;
  ERROR_CODES: SHARED_CONSTANTS_ERROR_CODES;
  INTERACTION_SITES: SHARED_CONSTANTS_INTERACTION_SITES;
  MAX_AGENTS_PER_QA_REQUEST: 10;
  MAX_CONTEXT_KEYS: 25;
  MAX_NUM_SEGMENT_IDS_ALLOWED_FOR_AGENT: 5;
  MAX_PROMPT_LENGTH: 25600;
  PROVIDERS: SHARED_CONSTANTS_PROVIDERS;
  QA_AGENTS: SHARED_CONSTANTS_QA_AGENTS;
  RECENT_EXECUTIONS_SPARKLINE_DAYS: 7;
  SCHEMA_TYPES: SHARED_CONSTANTS_SCHEMA_TYPES;
  THINKING_LEVELS: SHARED_CONSTANTS_THINKING_LEVELS;
}
export interface SHARED_CONSTANTS_SHOPIFY {
  ABANDONED_CART: "shopify_abandoned_cart";
  ABANDONED_CHECKOUT: "shopify_abandoned_checkout";
  BRAZE_PURCHASE: "shopify_braze_purchase";
  CANCELLED_ORDER: "shopify_cancelled_order";
  CREATED_ORDER: "shopify_created_order";
  CREATED_REFUND: "shopify_created_refund";
  FULFILLED_ORDER: "shopify_fulfilled_order";
  PAID_ORDER: "shopify_paid_order";
  PARTIALLY_FULFILLED_ORDER: "shopify_partially_fulfilled_order";
  PRODUCT_CLICKED: "shopify_product_clicked";
  PRODUCT_PURCHASED: "shopify_purchase_event";
  PRODUCT_VIEWED: "shopify_product_viewed";
}
export interface SHARED_CONSTANTS_SHOPIFY_V2 {
  ACCOUNT_LOGIN: "shopify_account_login";
  CART_UPDATED: "cart_updated";
  CHECKOUT_STARTED: "checkout_started";
  CUSTOMER_CREATED: "shopify_customer_create";
  CUSTOMER_UPDATED: "shopify_customer_update";
  ORDER_CANCELLED: "order_cancelled";
  ORDER_FULFILLED: "order_fulfilled";
  ORDER_PAID: "order_paid";
  ORDER_PARTIALLY_FULFILLED: "order_partially_fulfilled";
  ORDER_PLACED: "order_placed";
  ORDER_REFUNDED: "order_refunded";
  PRODUCT_VIEWED: "product_viewed";
}
export interface SHARED_CONSTANTS_EVENT_NAMES {
  SHOPIFY: SHARED_CONSTANTS_SHOPIFY;
  SHOPIFY_V2: SHARED_CONSTANTS_SHOPIFY_V2;
}
export interface SHARED_CONSTANTS_FEATURES {
  ABANDONED_CARTS: "ABANDONED_CARTS_FEATURE";
  ABANDONED_CHECKOUTS: "ABANDONED_CHECKOUTS_FEATURE";
  ACCOUNT_LOGIN: "ACCOUNT_LOGIN_FEATURE";
  CANCELLED_ORDERS: "CANCELLED_ORDERS_FEATURE";
  CLICK_PRODUCTS: "CLICK_PRODUCTS_FEATURE";
  CONTENT_CARDS: "CONTENT_CARDS_FEATURE";
  CREATE_CUSTOMERS: "CREATE_CUSTOMERS_FEATURE";
  CREATE_ORDERS: "CREATE_ORDERS_FEATURE";
  CREATE_PURCHASES: "CREATE_PURCHASES_FEATURE";
  CREATE_REFUNDS: "CREATE_REFUNDS_FEATURE";
  EMAIL_SUBSCRIPTIONS: "EMAIL_SUBSCRIPTIONS_FEATURE";
  FULFILLED_ORDERS: "FULFILLED_ORDERS_FEATURE";
  HISTORICAL_BACKFILL: "HISTORICAL_BACKFILL_FEATURE";
  IN_BROWSER_MESSAGES: "IN_BROWSER_MESSAGES_FEATURE";
  PAID_ORDERS: "PAID_ORDERS_FEATURE";
  PARTIALLY_FULFILLED_ORDERS: "PARTIALLY_FULFILLED_ORDERS_FEATURE";
  PURCHASE_COMMERCE_EVENTS: "PURCHASE_COMMERCE_EVENTS_FEATURE";
  SHOPIFY_CATALOGS: "SHOPIFY_CATALOGS_FEATURE";
  SHOPIFY_COLLECTIONS: "SHOPIFY_COLLECTIONS_FEATURE";
  SMS_SUBSCRIPTIONS: "SMS_SUBSCRIPTIONS_FEATURE";
  UPDATE_CUSTOMERS: "UPDATE_CUSTOMERS_FEATURE";
  UPDATE_CUSTOMERS_MARKETING_CONSENT: "UPDATE_CUSTOMERS_MARKETING_CONSENT_FEATURE";
  VIEW_PRODUCTS: "VIEW_PRODUCTS_FEATURE";
  WEB_SDK: "WEB_SDK_FEATURE";
}
export interface SHARED_CONSTANTS_CATALOG_DATA_DIRECTIVE {
  CLEAN: "CLEAN";
  IMPORT: "IMPORT";
}
export interface SHARED_CONSTANTS_CATALOG_ITEM_ID_TYPE {
  SKU: "SKU";
  VARIANT_ID: "VARIANT_ID";
}
export interface SHARED_CONSTANTS_CATALOG_SYNC_STATUS {
  DEACTIVATED: "DEACTIVATED";
  ERRORED: "ERRORED";
  IN_PROGRESS: "IN_PROGRESS";
  STOPPED: "STOPPED";
  SYNCING: "SYNCING";
}
export interface SHARED_CONSTANTS_CATALOGS {
  CATALOG_DATA_DIRECTIVE: SHARED_CONSTANTS_CATALOG_DATA_DIRECTIVE;
  CATALOG_ITEM_ID_TYPE: SHARED_CONSTANTS_CATALOG_ITEM_ID_TYPE;
  CATALOG_NAME_SUFFIX: "_shopify_catalog";
  CATALOG_SYNC_STATUS: SHARED_CONSTANTS_CATALOG_SYNC_STATUS;
}
export interface SHARED_CONSTANTS_CRITERIA {
  CONTEXT: null | "INSTALL" | "PROCESSING" | "UPDATE";
  ERROR_CLASSES: ("Alloys::Ecommerce::Catalog::Errors::CatalogApiPermissionError" | "Alloys::Ecommerce::Catalog::Errors::CompanySizeLimitAlreadyReachedError" | "Alloys::Ecommerce::Catalog::Errors::CompanySizeLimitSurgeError" | "Alloys::Ecommerce::Catalog::Errors::ProductError" | "Alloys::Errors::IntegrationAlreadyExistsError" | "ShopifyAPI::Errors::HttpResponseError" | "ShopifyAPI::Errors::InvalidOauthError" | "ShopifyAPI::Errors::RequestAccessTokenError" | "Zeitwerk::SetupRequired")[];
  ERROR_MESSAGE_REGEX: null | "Reduce request rates to resume uninterrupted service" | "code=40[1|3]" | "code=500";
  FEATURES: ("Alloys::Ecommerce::Features::CatalogsFeature" | "Alloys::Ecommerce::Features::CollectionsFeature")[];
}
export interface SHARED_CONSTANTS_DEFAULT_ERROR_PROPERTIES {
  DESCRIPTION: "Error - Install" | "Error - Install - Already Exists" | "Error - Install - OAuth" | "Error - Install - Product Import" | "Error - Install - Product Import - API Token" | "Error - Install - Product Import - Shopify Permissions" | "Error - Install - Product Import - Storage Space" | "Error - Install - Rate Limit" | "Error - Install - Shopify API" | "Error - Install - Shopify API (transient)" | "Error - Install - Shopify Permissions" | "Error - Install - Zeitwork" | "Error - Processing - Product Sync - API Token" | "Error - Processing - Product Sync - Item Problems" | "Error - Processing - Product Sync - Storage Space" | "Error - Processing - Settings Update" | "General Error";
  SEVERITY: 1 | 2 | 3;
  TYPE: "PERMANENT" | "TRANSIENT";
}
export interface SHARED_CONSTANTS_ERROR_MAPPING {
  AGGREGATED: false;
  CODE: "000" | "001" | "002" | "003" | "004" | "005" | "006" | "007" | "008" | "009" | "010" | "011" | "012" | "013" | "014" | "015" | "016";
  CRITERIA: SHARED_CONSTANTS_CRITERIA;
  DEACTIVATING: false | true;
  DEFAULT_ERROR_PROPERTIES: SHARED_CONSTANTS_DEFAULT_ERROR_PROPERTIES;
  MAILER: null | "Alloys::Ecommerce::Mailers::ProductSyncWithShopifyStoppedMailer" | "Alloys::Ecommerce::Mailers::ShopifyCatalogApiEventPermissionFailedMailer" | "Alloys::Ecommerce::Mailers::ShopifyCatalogApiImportPermissionFailedMailer" | "Alloys::Ecommerce::Mailers::ShopifyCatalogEventStoppedMailer" | "Alloys::Ecommerce::Mailers::ShopifyCatalogImportFailedMailer" | "Alloys::Ecommerce::Mailers::ShopifyCatalogItemProblemsMailer";
}
export interface SHARED_CONSTANTS_EXTERNAL_IDENTIFIERS {
  CUSTOM_ID: "custom-id";
  EMAIL: "email";
  EMAIL_MD5: "email-md5";
  EMAIL_SHA1: "email-sha1";
  EMAIL_SHA256: "email-sha256";
  SHOPIFY_CUSTOMER_ID: "shopify-customer-id";
}
export interface SHARED_CONSTANTS_FEATURE_GROUPS {
  BEHAVIOR_EVENTS: ("ACCOUNT_LOGIN_FEATURE" | "CANCELLED_ORDERS_FEATURE" | "CREATE_REFUNDS_FEATURE" | "FULFILLED_ORDERS_FEATURE" | "PAID_ORDERS_FEATURE" | "PARTIALLY_FULFILLED_ORDERS_FEATURE" | "PURCHASE_COMMERCE_EVENTS_FEATURE" | "VIEW_PRODUCTS_FEATURE")[];
  CHANNEL: ("CONTENT_CARDS_FEATURE" | "IN_BROWSER_MESSAGES_FEATURE")[];
  DEFAULT: ("ABANDONED_CHECKOUTS_FEATURE" | "CREATE_ORDERS_FEATURE" | "CREATE_PURCHASES_FEATURE")[];
  SCRIPTTAG: ("ABANDONED_CARTS_FEATURE" | "CLICK_PRODUCTS_FEATURE" | "VIEW_PRODUCTS_FEATURE")[];
  WEBHOOK: ("ABANDONED_CHECKOUTS_FEATURE" | "CANCELLED_ORDERS_FEATURE" | "CREATE_ORDERS_FEATURE" | "CREATE_PURCHASES_FEATURE" | "CREATE_REFUNDS_FEATURE" | "FULFILLED_ORDERS_FEATURE" | "PAID_ORDERS_FEATURE" | "PARTIALLY_FULFILLED_ORDERS_FEATURE" | "SHOPIFY_CATALOGS_FEATURE")[];
}
export interface SHARED_CONSTANTS_FUNCTIONAL_DEPENDENCIES {
  WEB_PIXEL_SETTINGS: "WEB_PIXEL_SETTINGS";
}
export interface SHARED_CONSTANTS_TESTING {
  MOCK_STOREFRONT_NAME: "braze-mock-storefront";
}
export interface SHARED_CONSTANTS_ECOMMERCE_SHOPIFY {
  CATALOGS: SHARED_CONSTANTS_CATALOGS;
  ERROR_MAPPING: SHARED_CONSTANTS_ERROR_MAPPING[];
  EXTERNAL_IDENTIFIERS: SHARED_CONSTANTS_EXTERNAL_IDENTIFIERS;
  FEATURE_GROUPS: SHARED_CONSTANTS_FEATURE_GROUPS;
  FUNCTIONAL_DEPENDENCIES: SHARED_CONSTANTS_FUNCTIONAL_DEPENDENCIES;
  TESTING: SHARED_CONSTANTS_TESTING;
}
export interface SHARED_CONSTANTS_ECOMMERCE {
  EVENT_NAMES: SHARED_CONSTANTS_EVENT_NAMES;
  FEATURES: SHARED_CONSTANTS_FEATURES;
  SHOPIFY: SHARED_CONSTANTS_ECOMMERCE_SHOPIFY;
}
export interface SHARED_CONSTANTS_INTEGRATION_FEATURE_CONTEXT {
  INSTALL: "INSTALL";
  PROCESSING: "PROCESSING";
  UNINSTALL: "UNINSTALL";
  UPDATE: "UPDATE";
}
export interface SHARED_CONSTANTS_INTEGRATION_FEATURE_STATE {
  ACTIVE: 1;
  DEACTIVATED: -1;
  ERRORED: 999;
  IN_PROGRESS: 0;
  STOPPED: 2;
}
export interface SHARED_CONSTANTS_INTEGRATION_STATUS {
  DISABLED: 999;
  INSTALLED: 1;
  PENDING: 0;
  UNINSTALLED: -1;
}
export interface SHARED_CONSTANTS_JOB_STATUS {
  COMPLETED: 1;
  ERRORED: 999;
  IN_PROGRESS: 0;
  NOT_STARTED: -1;
  PROMPT_COMPLETION: 2;
}
export interface SHARED_CONSTANTS_PHONE_FORMAT {
  E164: "E164";
  E164_NUMBERS_ONLY: "E164_NUMBERS_ONLY";
  NONE: "NONE";
}
export interface SHARED_CONSTANTS_ALLOYS {
  ECOMMERCE: SHARED_CONSTANTS_ECOMMERCE;
  INTEGRATION_FEATURE_CONTEXT: SHARED_CONSTANTS_INTEGRATION_FEATURE_CONTEXT;
  INTEGRATION_FEATURE_STATE: SHARED_CONSTANTS_INTEGRATION_FEATURE_STATE;
  INTEGRATION_STATUS: SHARED_CONSTANTS_INTEGRATION_STATUS;
  JOB_STATUS: SHARED_CONSTANTS_JOB_STATUS;
  PHONE_FORMAT: SHARED_CONSTANTS_PHONE_FORMAT;
}
export interface SHARED_CONSTANTS_ANALYTICS_REPORT_REPORT_TYPES {
  ConversionReport: "conversion";
  ExpressiveReport: "expressive";
  FunnelReport: "funnel";
  RetentionReport: "retention";
}
export interface SHARED_CONSTANTS_ANDROID_FIREBASE_PUSH_SENDER_PRIORITIES {
  HIGH: "high";
  NORMAL: "normal";
}
export interface SHARED_CONSTANTS_GROUP_BY {
  API_KEYS: "API_KEYS";
  ENDPOINTS: "ENDPOINTS";
  RESPONSE_CODES: "RESPONSE_CODES";
  SUCCESS_AND_FAILURES: "SUCCESS_AND_FAILURES";
}
export interface SHARED_CONSTANTS_API_DASHBOARD {
  GROUP_BY: SHARED_CONSTANTS_GROUP_BY;
}
export interface SHARED_CONSTANTS_API_TYPE {
  REST: "rest";
  SDK: "sdk";
}
export interface SHARED_CONSTANTS_RATE_LIMIT_CATEGORY {
  ADAPTIVE_RATE_LIMIT: "arl";
  COMPANY_RATE_LIMIT: "crl";
  COMPANY_WORKSPACE_RATE_LIMIT: "wsrl";
}
export interface SHARED_CONSTANTS_TYPE {
  BURST: "b";
  STEADY: "s";
}
export interface SHARED_CONSTANTS_API_LIMITS {
  API_TYPE: SHARED_CONSTANTS_API_TYPE;
  RATE_LIMIT_CATEGORY: SHARED_CONSTANTS_RATE_LIMIT_CATEGORY;
  TYPE: SHARED_CONSTANTS_TYPE;
}
export interface SHARED_CONSTANTS_APPROVAL_SECTIONS {
  QA_AGENT_SECTION: "QA_AGENT_SECTION";
}
export interface SHARED_CONSTANTS_TYPES {
  CAMPAIGN: "campaign";
  CANVAS: "canvas";
}
export interface SHARED_CONSTANTS_APPROVALS {
  APPROVAL_SECTIONS: SHARED_CONSTANTS_APPROVAL_SECTIONS;
  TYPES: SHARED_CONSTANTS_TYPES;
}
export interface SHARED_CONSTANTS_APP_ANALYTICS_PROVIDER {
  LIVE_TIMEFRAME_IN_DAYS: 30;
  MIN_PERCENTAGE_SESSIONS_TO_BE_LIVE: 0.05;
}
export interface SHARED_CONSTANTS_APP_GROUP_API_KEY_PERMISSIONS {
  ADD_BUSINESS_ACCOUNT_USERS: 136;
  ADD_CATALOG_ITEMS: 84;
  APPS_GET: 78;
  BANNERS_SYNC: 144;
  BANNERS_TRACK: 145;
  CAMPAIGNS_ARCHIVE: 164;
  CAMPAIGNS_CREATE: 161;
  CAMPAIGNS_DATA_SERIES: 20;
  CAMPAIGNS_DETAILS: 21;
  CAMPAIGNS_DUPLICATE: 100;
  CAMPAIGNS_EDIT: 148;
  CAMPAIGNS_LAUNCH: 162;
  CAMPAIGNS_LIST: 19;
  CAMPAIGNS_STOP: 163;
  CAMPAIGNS_TRANSLATIONS_GET: 114;
  CAMPAIGNS_TRANSLATIONS_UPDATE: 115;
  CAMPAIGNS_TRIGGER_SCHEDULE_CREATE: 16;
  CAMPAIGNS_TRIGGER_SCHEDULE_DELETE: 18;
  CAMPAIGNS_TRIGGER_SCHEDULE_UPDATE: 17;
  CAMPAIGNS_TRIGGER_SEND: 15;
  CAMPAIGNS_URL_INFO_DETAILS: 70;
  CANVAS_DATA_SERIES: 28;
  CANVAS_DATA_SUMMARY: 30;
  CANVAS_DETAILS: 29;
  CANVAS_DUPLICATE: 110;
  CANVAS_LIST: 27;
  CANVAS_TRANSLATIONS_GET: 116;
  CANVAS_TRANSLATIONS_UPDATE: 117;
  CANVAS_TRIGGER_SCHEDULE_CREATE: 24;
  CANVAS_TRIGGER_SCHEDULE_DELETE: 26;
  CANVAS_TRIGGER_SCHEDULE_UPDATE: 25;
  CANVAS_TRIGGER_SEND: 23;
  CANVAS_URL_INFO_DETAILS: 71;
  CDI_INTEGRATION_JOB_STATUS: 103;
  CDI_INTEGRATION_LIST: 101;
  CDI_INTEGRATION_SYNC: 102;
  CONTENT_BLOCK_CREATE: 64;
  CONTENT_BLOCK_INFO: 62;
  CONTENT_BLOCK_LIST: 61;
  CONTENT_BLOCK_TRANSLATIONS_GET: 133;
  CONTENT_BLOCK_TRANSLATIONS_UPDATE: 134;
  CONTENT_BLOCK_UPDATE: 67;
  CREATE_CATALOG: 87;
  CREATE_CATALOG_FIELDS: 104;
  CREATE_CATALOG_ITEM: 89;
  CREATE_CATALOG_SELECTION: 106;
  CUSTOM_ATTRIBUTES_GET: 119;
  CUSTOM_OBJECTS_CREATE: 151;
  CUSTOM_OBJECTS_DELETE: 153;
  CUSTOM_OBJECTS_READ: 149;
  CUSTOM_OBJECTS_UPDATE: 152;
  CUSTOM_OBJECT_OBJECT_RELATIONSHIPS_CREATE: 157;
  CUSTOM_OBJECT_OBJECT_RELATIONSHIPS_DELETE: 159;
  CUSTOM_OBJECT_OBJECT_RELATIONSHIPS_UPDATE: 158;
  CUSTOM_OBJECT_USER_RELATIONSHIPS_CREATE: 154;
  CUSTOM_OBJECT_USER_RELATIONSHIPS_DELETE: 156;
  CUSTOM_OBJECT_USER_RELATIONSHIPS_READ: 150;
  CUSTOM_OBJECT_USER_RELATIONSHIPS_UPDATE: 155;
  DELETE_BUSINESS_ACCOUNT_USER: 141;
  DELETE_CATALOG: 91;
  DELETE_CATALOG_FIELDS: 105;
  DELETE_CATALOG_ITEM: 90;
  DELETE_CATALOG_ITEMS: 85;
  DELETE_CATALOG_SELECTION: 107;
  EMAIL_BLACKLIST: 63;
  EMAIL_BOUNCE_REMOVE: 8;
  EMAIL_HARD_BOUNCES: 7;
  EMAIL_SPAM_REMOVE: 9;
  EMAIL_STATUS: 6;
  EMAIL_TEMPLATE_CREATE: 50;
  EMAIL_TEMPLATE_INFO: 57;
  EMAIL_TEMPLATE_LIST: 58;
  EMAIL_TEMPLATE_UPDATE: 51;
  EMAIL_UNSUBSCRIBE: 5;
  EVENTS_DATA_SERIES: 38;
  EVENTS_GET: 120;
  EVENTS_LIST: 37;
  GET_BUSINESS_ACCOUNT: 138;
  GET_BUSINESS_ACCOUNTS: 135;
  GET_BUSINESS_ACCOUNT_USERS: 140;
  GET_CATALOGS: 92;
  GET_CATALOG_ITEM: 86;
  GET_CATALOG_ITEMS: 93;
  GET_CATALOG_SELECTIONS: 113;
  KPI_DAU_DATA_SERIES: 45;
  KPI_MAU_DATA_SERIES: 44;
  KPI_NEW_USERS_DATA_SERIES: 46;
  KPI_UNINSTALLS_DATA_SERIES: 47;
  LINK_PARENT_BUSINESS_ACCOUNT: 142;
  LIVE_ACTIVITY_START: 109;
  LIVE_ACTIVITY_UPDATE: 95;
  MEDIA_LIBRARY_CREATE: 132;
  MEDIA_LIBRARY_REPLACE: 146;
  MESSAGES_SCHEDULE_BROADCASTS: 14;
  MESSAGES_SCHEDULE_CREATE: 11;
  MESSAGES_SCHEDULE_DELETE: 13;
  MESSAGES_SCHEDULE_UPDATE: 12;
  MESSAGES_SEND: 10;
  NEWS_FEED_DATA_SERIES: 40;
  NEWS_FEED_DETAILS: 41;
  NEWS_FEED_LIST: 39;
  OAUTH: 160;
  PARTNER_ATTRIBUTION: 74;
  PREFERENCE_CENTER_GET: 80;
  PREFERENCE_CENTER_LIST: 81;
  PREFERENCE_CENTER_UPDATE: 79;
  PREFERENCE_CENTER_USER_GET: 82;
  PURCHASES_PRODUCT_LIST: 34;
  PURCHASES_QUANTITY_SERIES: 36;
  PURCHASES_REVENUE_SERIES: 35;
  PUSH_CREDENTIAL_UPDATE: 147;
  PUSH_NOTIFICATION_REMOVE: 42;
  RAW_DATA_EXPORT: 48;
  RAW_DATA_STATUS: 49;
  REMOVE_BUSINESS_ACCOUNT_USERS: 139;
  REPLACE_CATALOG_ITEM: 98;
  REPLACE_CATALOG_ITEMS: 97;
  SAML_LOGIN: 60;
  SDK_AUTH_KEY_CREATE: 124;
  SDK_AUTH_KEY_DELETE: 126;
  SDK_AUTH_KEY_LIST: 127;
  SDK_AUTH_KEY_UPDATE_PRIMARY: 125;
  SEGMENTS_CREATE: 165;
  SEGMENTS_DATA_SERIES: 32;
  SEGMENTS_DETAILS: 33;
  SEGMENTS_EDIT: 166;
  SEGMENTS_LIST: 31;
  SENDS_DATA_SERIES: 22;
  SENDS_ID_CREATE: 52;
  SESSIONS_DATA_SERIES: 43;
  SHOPIFY_LOCAL_REQUEST: 128;
  SHOPIFY_SEGMENT_SYNC: 143;
  SMS_INVALID_PHONE_NUMBERS: 76;
  SMS_INVALID_PHONE_NUMBERS_REMOVE: 77;
  SUBSCRIPTION_GROUP_STATUS_GET: 59;
  SUBSCRIPTION_STATUS_GET: 56;
  SUBSCRIPTION_STATUS_SET: 55;
  TEMPLATES_TRANSLATIONS_GET: 122;
  TEMPLATES_TRANSLATIONS_UPDATE: 123;
  TRANSACTIONAL_MESSAGING: 68;
  TRANSACTIONAL_MESSAGING_RETRIEVE_STATUS: 69;
  TRANSFORMATIONS_DATA_POST: 99;
  TRANSFORMATIONS_VALIDATE: 108;
  UNLINK_PARENT_BUSINESS_ACCOUNT: 137;
  UPDATE_CATALOG_ITEM: 88;
  UPDATE_CATALOG_ITEMS: 83;
  UPDATE_CATALOG_SELECTION: 112;
  USERS_ALIAS_NEW: 2;
  USERS_ALIAS_REPLACE: 129;
  USERS_ALIAS_UPDATE: 96;
  USERS_DELETE: 1;
  USERS_EXPORT_GLOBAL_CONTROL_GROUP: 75;
  USERS_EXPORT_IDS: 3;
  USERS_EXPORT_SEGMENT: 4;
  USERS_EXTERNAL_IDS_REMOVE: 66;
  USERS_EXTERNAL_IDS_RENAME: 65;
  USERS_IDENTIFY: 54;
  USERS_MERGE: 94;
  USERS_TRACK: 0;
  USERS_TRACK_BULK: 121;
  USERS_TRACK_STATUS: 167;
  USERS_TRACK_SYNC: 118;
}
export interface SHARED_CONSTANTS_APP_ICON {
  DEFAULT_APP_ICON_URL: "https://braze-images.com/appboy/communication/assets/image_assets/images/69b364797ae1ec006357e29f/original.png";
  LARGE_CROP_LENGTH: 120;
}
export interface SHARED_CONSTANTS_APP_NAME_ERRORS {
  CONTAINS_INVALID_CHARACTERS: "APP_NAME_CONTAINS_INVALID_CHARACTERS";
  MUST_BE_SHORTER: "APP_NAME_MUST_BE_SHORTER";
  NO_APP_NAME: "NO_APP_NAME";
  RESERVED: "APP_NAME_RESERVED";
}
export interface SHARED_CONSTANTS_ERRORS {
  ACTIVE_FILTER: "active_filter";
  ACTIVE_SEGMENT: "active_segment";
  NO_PERMISSIONS: "no_permissions";
  SHOPIFY_MANAGED: "shopify_managed";
  TOO_MANY_USERS: "too_many_users";
}
export interface SHARED_CONSTANTS_APP_SETTINGS {
  APP_NAME_ERRORS: SHARED_CONSTANTS_APP_NAME_ERRORS;
  ERRORS: SHARED_CONSTANTS_ERRORS;
  OBFUSCATED_API_KEY: "*************";
}
export interface SHARED_CONSTANTS_ATTRIBUTION_INTEGRATION_ERRORS {
  INTEGRATION_NOT_FOUND: "INTEGRATION_NOT_FOUND";
}
export interface SHARED_CONSTANTS_AUDIENCE_TYPE_MAP {
  email: "email";
  mobile_id: "madid";
}
export interface SHARED_CONSTANTS_CANVAS {
  IDENTIFIERS: ("email" | "mobile_id")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: false;
}
export interface SHARED_CONSTANTS_MAPPING {
  "400": "Alloys::AudienceSync::Errors::BadRequestError";
  "401": "Alloys::AudienceSync::Errors::AuthError";
  "403": "Alloys::AudienceSync::Errors::PermissionsError";
  "404": "Alloys::AudienceSync::Errors::DoesNotExistError";
  "413": "Alloys::AudienceSync::Errors::BadRequestError";
  "415": "Alloys::AudienceSync::Errors::BadRequestError";
  "429": "Alloys::AudienceSync::Errors::RateLimitBlockedError";
  "500": "Alloys::AudienceSync::Errors::ServiceError";
  "503": "Alloys::AudienceSync::Errors::ServiceError";
}
export interface SHARED_CONSTANTS_TYPE_PROPERTY {
  INDICATOR: "status";
  MAPPING: SHARED_CONSTANTS_MAPPING;
}
export interface SHARED_CONSTANTS_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body";
  TYPE_PROPERTY: SHARED_CONSTANTS_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_QUERY_PARAMS {
  client_id: "{get_from_config,secure.criteo.client_id}";
  redirect_uri: "{get_redirect_uri}";
  response_type: "code";
  state: "{get_state}";
}
export interface SHARED_CONSTANTS_AUTHORIZATION_URL {
  PATH: "https://consent.criteo.com/request?";
  QUERY_PARAMS: SHARED_CONSTANTS_QUERY_PARAMS;
}
export interface SHARED_CONSTANTS_BODY {
  client_id: "{get_from_config,secure.criteo.client_id}";
  client_secret: "{get_from_config,secure.criteo.client_secret}";
  code: "{get_code}";
  grant_type: "authorization_code";
  redirect_uri: "{get_redirect_uri}";
}
export interface SHARED_CONSTANTS_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_RESPONSE {
  access_token: "body:access_token";
  refresh_token: "body:refresh_token";
}
export interface SHARED_CONSTANTS_GET_TOKEN {
  BODY: SHARED_CONSTANTS_BODY;
  HEADERS: SHARED_CONSTANTS_HEADERS;
  METHOD: "POST";
  PATH: "https://api.criteo.com/oauth2/token";
  RESPONSE: SHARED_CONSTANTS_RESPONSE;
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL {
  GET_TOKEN: SHARED_CONSTANTS_GET_TOKEN;
}
export interface SHARED_CONSTANTS_contactList {
  
}
export interface SHARED_CONSTANTS_attributes {
  advertiserId: "{get_from_scope,ad_account_id}";
  contactList: SHARED_CONSTANTS_contactList;
  name: "{get_from_scope,custom_audience_name}";
}
export interface SHARED_CONSTANTS_data {
  attributes: SHARED_CONSTANTS_attributes;
  type: "Audience";
}
export interface SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_BODY {
  data: SHARED_CONSTANTS_data[];
}
export interface SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_RESPONSE {
  custom_audience_id: "body:data.0.id";
}
export interface SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE {
  BODY: SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_BODY;
  HEADERS: SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_HEADERS;
  METHOD: "POST";
  PATH: "https://api.criteo.com/{get_criteo_version}/marketing-solutions/audience-segments/create";
  RESPONSE: SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_RESPONSE;
}
export interface SHARED_CONSTANTS_Data_attributes {
  advertiserIds: "{get_from_scope,ad_account_id}"[];
  audienceSegmentTypes: "ContactList"[];
}
export interface SHARED_CONSTANTS_BODY_data {
  attributes: SHARED_CONSTANTS_Data_attributes;
  type: "Audience";
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_BODY {
  data: SHARED_CONSTANTS_BODY_data;
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_MAPPING {
  id: "id";
  name: "attributes.name";
}
export interface SHARED_CONSTANTS_PAGINATION {
  CHECK: ("less_than" | "offset" | "total_items")[];
  CURSOR: (100 | "offset")[];
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS {
  limit: 100;
  offset: "{get_from_scope_with_default,0,pagination_cursor}";
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_RESPONSE {
  all_custom_audiences: "body:data";
  offset: "body:meta.offset";
  total_items: "body:meta.totalItems";
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES {
  BODY: SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_BODY;
  HEADERS: SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_HEADERS;
  MAPPING: SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_MAPPING;
  METHOD: "POST";
  PAGINATION: SHARED_CONSTANTS_PAGINATION;
  PATH: "https://api.criteo.com/{get_criteo_version}/marketing-solutions/audience-segments/search";
  QUERY_PARAMS: SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_RESPONSE;
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT {
  GET_ACCOUNT_AUDIENCES: SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES;
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNTS_MAPPING {
  ad_account_id: "id";
  ad_account_name: "attributes.advertiserName";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNTS_RESPONSE {
  ad_accounts: "body:data";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNTS {
  HEADERS: SHARED_CONSTANTS_GET_AD_ACCOUNTS_HEADERS;
  MAPPING: SHARED_CONSTANTS_GET_AD_ACCOUNTS_MAPPING;
  METHOD: "GET";
  PATH: "https://api.criteo.com/{get_criteo_version}/advertisers/me";
  RESPONSE: SHARED_CONSTANTS_GET_AD_ACCOUNTS_RESPONSE;
}
export interface SHARED_CONSTANTS_REFRESH_TOKEN_BODY {
  client_id: "{get_from_config,secure.criteo.client_id}";
  client_secret: "{get_from_config,secure.criteo.client_secret}";
  grant_type: "refresh_token";
  refresh_token: "{get_refresh_token}";
}
export interface SHARED_CONSTANTS_REFRESH_TOKEN_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_REFRESH_TOKEN_RESPONSE {
  access_token: "body:access_token";
}
export interface SHARED_CONSTANTS_REFRESH_TOKEN {
  BODY: SHARED_CONSTANTS_REFRESH_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_REFRESH_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://api.criteo.com/oauth2/token/";
  RESPONSE: SHARED_CONSTANTS_REFRESH_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_ACTION_MAPPING {
  add_users: "add";
  remove_users: "remove";
}
export interface SHARED_CONSTANTS_BODY_Data_attributes {
  identifierType: "{get_mapped_field_to_match}";
  identifiers: "{get_from_scope,data}";
  operation: "{get_from_scope,mapped_action}";
}
export interface SHARED_CONSTANTS_SYNC_USERS_BODY_data {
  attributes: SHARED_CONSTANTS_BODY_Data_attributes;
  type: "ContactlistAmendment";
}
export interface SHARED_CONSTANTS_SYNC_USERS_BODY {
  data: SHARED_CONSTANTS_SYNC_USERS_BODY_data;
}
export interface SHARED_CONSTANTS_SYNC_USERS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_METHOD {
  add_users: "PATCH";
  remove_users: "PATCH";
}
export interface SHARED_CONSTANTS_SYNC_USERS {
  ACTION_MAPPING: SHARED_CONSTANTS_ACTION_MAPPING;
  BODY: SHARED_CONSTANTS_SYNC_USERS_BODY;
  HEADERS: SHARED_CONSTANTS_SYNC_USERS_HEADERS;
  METHOD: SHARED_CONSTANTS_METHOD;
  PATH: "https://api.criteo.com/{get_criteo_version}/marketing-solutions/audience-segments/{get_from_scope,custom_audience_id}/contact-list";
}
export interface SHARED_CONSTANTS_METHODS {
  AUTHORIZATION_URL: SHARED_CONSTANTS_AUTHORIZATION_URL;
  COMPLETE_INSTALL: SHARED_CONSTANTS_COMPLETE_INSTALL;
  CREATE_CUSTOM_AUDIENCE: SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE;
  GET_AD_ACCOUNT: SHARED_CONSTANTS_GET_AD_ACCOUNT;
  GET_AD_ACCOUNTS: SHARED_CONSTANTS_GET_AD_ACCOUNTS;
  REFRESH_TOKEN: SHARED_CONSTANTS_REFRESH_TOKEN;
  SYNC_USERS: SHARED_CONSTANTS_SYNC_USERS;
}
export interface SHARED_CONSTANTS_criteo {
  AUDIENCE_TYPE_MAP: SHARED_CONSTANTS_AUDIENCE_TYPE_MAP;
  BATCH_SIZE: 2000;
  CANVAS: SHARED_CONSTANTS_CANVAS;
  DISPLAY_NAME: "Criteo";
  ERROR_HANDLING: SHARED_CONSTANTS_ERROR_HANDLING;
  FEATURE: "audience_sync_pro";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-criteo-v2.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/icon-criteo-v2.png";
  METHODS: SHARED_CONSTANTS_METHODS;
  PARTNER_PAGE: "/integrations/technology_partners/001d000001t7ZFo";
  PARTNER_PAGE_ID: "001d000001t7ZFo";
  PHONE_FORMAT: "NONE";
  TOKEN_EXPIRATION_WINDOW: "900";
}
export interface SHARED_CONSTANTS_Dv360_CANVAS {
  IDENTIFIERS: ("email" | "mobile_id" | "phone")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: false;
}
export interface SHARED_CONSTANTS_dv360 {
  BATCH_SIZE: 10000;
  CANVAS: SHARED_CONSTANTS_Dv360_CANVAS;
  DISPLAY_NAME: "Google DV360";
  FEATURE: "audience_sync_dv360";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-googleads.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/icon-googleads.png";
  PARTNER_PAGE: "/integrations/technology_partners/3fb8a971-2f8c-481d-8868-0c3e54b45720";
  PARTNER_PAGE_ID: "3fb8a971-2f8c-481d-8868-0c3e54b45720";
  PHONE_FORMAT: "E164";
  USE_SCHEDULED_JOB_TO_REFRESH_TOKEN: true;
}
export interface SHARED_CONSTANTS_Facebook_AUDIENCE_TYPE_MAP {
  city: "CT";
  country: "COUNTRY";
  dob_day: "DOBD";
  dob_month: "DOBM";
  dob_year: "DOBY";
  email: "EMAIL";
  first_name: "FN";
  gender: "GEN";
  mobile_id: "MADID";
  phone: "PHONE";
}
export interface SHARED_CONSTANTS_IDENTIFIERS {
  all_required: true;
  display_name: "Date of Birth";
  fields: ("dob_day" | "dob_month" | "dob_year")[];
}
export interface SHARED_CONSTANTS_Facebook_CANVAS {
  IDENTIFIERS: (SHARED_CONSTANTS_IDENTIFIERS | "city" | "country" | "email" | "first_name" | "gender" | "last_name" | "mobile_id" | "phone")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: true;
}
export interface SHARED_CONSTANTS_RESPONSE_BODY_SUCCESS {
  code: 0;
}
export interface SHARED_CONSTANTS_TYPE_PROPERTY_MAPPING {
  "10"?: "Alloys::AudienceSync::Errors::AuthError";
  "100"?: "Alloys::AudienceSync::Errors::InvalidParameterError";
  "100,33"?: "Alloys::AudienceSync::Errors::DoesNotExistError";
  "102"?: "Alloys::AudienceSync::Errors::AuthError";
  "1870034"?: "Alloys::AudienceSync::Errors::TermsOfServiceError";
  "1870047"?: "Alloys::AudienceSync::Errors::AudienceSizeTooLowError";
  "1870090"?: "Alloys::AudienceSync::Errors::TermsOfServiceError";
  "190"?: "Alloys::AudienceSync::Errors::AuthError";
  "200,1870047"?: "Alloys::AudienceSync::Errors::AudienceSizeTooLowError";
  "200--299"?: "Alloys::AudienceSync::Errors::AuthError";
  "2500"?: "Alloys::AudienceSync::Errors::AuthError";
  "2650"?: "Alloys::AudienceSync::Errors::ServiceError";
  "2654"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "273"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "274"?: "Alloys::AudienceSync::Errors::AdAccountNotEnabledError";
  "33"?: "Alloys::AudienceSync::Errors::DoesNotExistError";
  "80003"?: "Alloys::AudienceSync::Errors::RateLimitError";
}
export interface SHARED_CONSTANTS_TYPE_PROPERTY_TYPE_PROPERTY {
  INDICATOR: "body.error.code" | "body.error.code,body.error.error_subcode" | "body.error.error_subcode";
  MAPPING: SHARED_CONSTANTS_TYPE_PROPERTY_MAPPING;
}
export interface SHARED_CONSTANTS_Facebook_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body.error.message";
  RESPONSE_BODY_SUCCESS: SHARED_CONSTANTS_RESPONSE_BODY_SUCCESS;
  TYPE_PROPERTY: SHARED_CONSTANTS_TYPE_PROPERTY_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_AUTHORIZATION_URL_QUERY_PARAMS {
  client_id: "{get_from_config,secure.facebook.app_id}";
  redirect_uri: "{get_redirect_uri}";
  scope: "ads_management";
  state: "{get_state}";
}
export interface SHARED_CONSTANTS_METHODS_AUTHORIZATION_URL {
  PATH: "https://www.facebook.com/v2.10/dialog/oauth?";
  QUERY_PARAMS: SHARED_CONSTANTS_AUTHORIZATION_URL_QUERY_PARAMS;
}
export interface SHARED_CONSTANTS_GET_TOKEN_HEADERS {
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_GET_TOKEN_QUERY_PARAMS {
  client_id: "{get_from_config,secure.facebook.app_id}";
  client_secret: "{get_from_config,secure.facebook.app_secret}";
  code: "{get_code}";
  redirect_uri: "{get_redirect_uri}";
}
export interface SHARED_CONSTANTS_GET_TOKEN_RESPONSE {
  access_token: "body:access_token";
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN {
  HEADERS: SHARED_CONSTANTS_GET_TOKEN_HEADERS;
  METHOD: "GET";
  PATH: "https://graph.facebook.com/{get_facebook_version}/oauth/access_token?";
  QUERY_PARAMS: SHARED_CONSTANTS_GET_TOKEN_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_GET_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_GET_USER_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "User-Agent": "fbbizsdk-ruby-{get_facebook_version}";
}
export interface SHARED_CONSTANTS_GET_USER_RESPONSE {
  connected_account: "body:id";
}
export interface SHARED_CONSTANTS_GET_USER {
  HEADERS: SHARED_CONSTANTS_GET_USER_HEADERS;
  METHOD: "GET";
  PATH: "https://graph.facebook.com/{get_facebook_version}/me?";
  RESPONSE: SHARED_CONSTANTS_GET_USER_RESPONSE;
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL {
  GET_TOKEN: SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN;
  GET_USER: SHARED_CONSTANTS_GET_USER;
}
export interface SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE_BODY {
  customer_file_source: "BOTH_USER_AND_PARTNER_PROVIDED";
  name: "{get_from_scope,custom_audience_name}";
  subtype: "CUSTOM";
}
export interface SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
  "User-Agent": "fbbizsdk-ruby-{get_facebook_version}";
}
export interface SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE {
  custom_audience_id: "body:id";
}
export interface SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE {
  BODY: SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE_BODY;
  HEADERS: SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS;
  METHOD: "POST";
  PATH: "https://graph.facebook.com/{get_facebook_version}/act_{get_from_scope,ad_account_id}/customaudiences/";
  RESPONSE: SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE;
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "User-Agent": "fbbizsdk-ruby-{get_facebook_version}";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING {
  id: "id";
  name: "name";
  type: "subtype";
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_PAGINATION {
  CHECK: ("next_cursor" | "not_null")[];
  CURSOR: "next_cursor"[];
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS {
  after: "{get_from_scope,pagination_cursor}";
  fields: "id,name,subtype";
  limit: 1000;
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE {
  all_custom_audiences: "body:data";
  next_cursor: "body:paging.cursors.after";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES {
  HEADERS: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS;
  MAPPING: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING;
  METHOD: "GET";
  PAGINATION: SHARED_CONSTANTS_GET_ACCOUNT_AUDIENCES_PAGINATION;
  PATH: "https://graph.facebook.com/{get_facebook_version}/act_{get_from_scope,ad_account_id}/customaudiences/";
  QUERY_PARAMS: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE;
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT {
  GET_ACCOUNT_AUDIENCES: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES;
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "User-Agent": "fbbizsdk-ruby-{get_facebook_version}";
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_MAPPING {
  ad_account_id: "account_id";
  ad_account_name: "name";
  user_tos_accepted: "user_tos_accepted";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNTS_PAGINATION {
  CHECK: ("next_cursor" | "not_null")[];
  CURSOR: "next_cursor"[];
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNTS_QUERY_PARAMS {
  after: "{get_from_scope,pagination_cursor}";
  fields: "account_id,name,user_tos_accepted";
  limit: 1000;
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_RESPONSE {
  ad_accounts: "body:data";
  next_cursor: "body:paging.cursors.after";
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS {
  HEADERS: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_HEADERS;
  MAPPING: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_MAPPING;
  METHOD: "GET";
  PAGINATION: SHARED_CONSTANTS_GET_AD_ACCOUNTS_PAGINATION;
  PATH: "https://graph.facebook.com/{get_facebook_version}/me/adaccounts/";
  QUERY_PARAMS: SHARED_CONSTANTS_GET_AD_ACCOUNTS_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_RESPONSE;
}
export interface SHARED_CONSTANTS_payload {
  data: "{get_from_scope,data,payload,data}";
  schema: "{get_from_scope,data,payload,schema}";
}
export interface SHARED_CONSTANTS_METHODS_SYNC_USERS_BODY {
  payload: SHARED_CONSTANTS_payload;
}
export interface SHARED_CONSTANTS_METHODS_SYNC_USERS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
  "User-Agent": "fbbizsdk-ruby-{get_facebook_version}";
}
export interface SHARED_CONSTANTS_SYNC_USERS_METHOD {
  add_users: "POST";
  remove_users: "DELETE";
}
export interface SHARED_CONSTANTS_SYNC_USERS_RESPONSE {
  errors: "body:invalid_entry_samples";
  failure_count: "body:num_invalid_entries";
  received_count: "body:num_received";
}
export interface SHARED_CONSTANTS_METHODS_SYNC_USERS {
  BODY: SHARED_CONSTANTS_METHODS_SYNC_USERS_BODY;
  HEADERS: SHARED_CONSTANTS_METHODS_SYNC_USERS_HEADERS;
  METHOD: SHARED_CONSTANTS_SYNC_USERS_METHOD;
  PATH: "https://graph.facebook.com/{get_facebook_version}/{get_from_scope,custom_audience_id}/users/";
  RESPONSE: SHARED_CONSTANTS_SYNC_USERS_RESPONSE;
}
export interface SHARED_CONSTANTS_Facebook_METHODS {
  AUTHORIZATION_URL: SHARED_CONSTANTS_METHODS_AUTHORIZATION_URL;
  COMPLETE_INSTALL: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL;
  CREATE_CUSTOM_AUDIENCE: SHARED_CONSTANTS_METHODS_CREATE_CUSTOM_AUDIENCE;
  GET_AD_ACCOUNT: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT;
  GET_AD_ACCOUNTS: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS;
  SYNC_USERS: SHARED_CONSTANTS_METHODS_SYNC_USERS;
}
export interface SHARED_CONSTANTS_facebook {
  AUDIENCE_TYPE_MAP: SHARED_CONSTANTS_Facebook_AUDIENCE_TYPE_MAP;
  BATCH_SIZE: 2000;
  CANVAS: SHARED_CONSTANTS_Facebook_CANVAS;
  DISPLAY_NAME: "Facebook";
  ERROR_HANDLING: SHARED_CONSTANTS_Facebook_ERROR_HANDLING;
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-facebook.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/secondary-icon-facebook.png?v=1682347669";
  METHODS: SHARED_CONSTANTS_Facebook_METHODS;
  PARTNER_PAGE: "/integrations/technology_partners/3622cca3-f2ee-4b4b-a4f4-d75eb43d158e#";
  PARTNER_PAGE_ID: "3622cca3-f2ee-4b4b-a4f4-d75eb43d158e";
  PHONE_FORMAT: "E164_NUMBERS_ONLY";
  USE_SCHEDULED_JOB_TO_REFRESH_TOKEN: true;
}
export interface SHARED_CONSTANTS_google {
  BATCH_SIZE: 10000;
  DISPLAY_NAME: "Google";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-googleads.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/icon-googleads.png";
  PARTNER_PAGE: "/integrations/technology_partners/0013o00002VDJCuAAP";
  PARTNER_PAGE_ID: "0013o00002VDJCuAAP";
  PHONE_FORMAT: "E164";
  USE_SCHEDULED_JOB_TO_REFRESH_TOKEN: true;
}
export interface SHARED_CONSTANTS_Linkedin_AUDIENCE_TYPE_MAP {
  email: "email";
}
export interface SHARED_CONSTANTS_IDENTIFIERS_IDENTIFIERS {
  all_required: true;
  display_name: "First/Last Name";
  fields: ("first_name" | "last_name")[];
}
export interface SHARED_CONSTANTS_Linkedin_CANVAS {
  IDENTIFIERS: (SHARED_CONSTANTS_IDENTIFIERS_IDENTIFIERS | "android_gaid" | "email")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: true;
}
export interface SHARED_CONSTANTS_ERROR_HANDLING_TYPE_PROPERTY_MAPPING {
  "400": "Alloys::AudienceSync::Errors::BadRequestError";
  "401": "Alloys::AudienceSync::Errors::AuthError";
  "403": "Alloys::AudienceSync::Errors::PermissionsError";
  "404": "Alloys::AudienceSync::Errors::DoesNotExistError";
  "405": "Alloys::AudienceSync::Errors::BadRequestError";
  "411": "Alloys::AudienceSync::Errors::BadRequestError";
  "429": "Alloys::AudienceSync::Errors::RateLimitBlockedError";
  "500": "Alloys::AudienceSync::Errors::ServiceError";
  "504": "Alloys::AudienceSync::Errors::ServiceError";
}
export interface SHARED_CONSTANTS_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY {
  INDICATOR: "status";
  MAPPING: SHARED_CONSTANTS_ERROR_HANDLING_TYPE_PROPERTY_MAPPING;
}
export interface SHARED_CONSTANTS_Linkedin_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body";
  TYPE_PROPERTY: SHARED_CONSTANTS_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_METHODS_AUTHORIZATION_URL_QUERY_PARAMS {
  client_id: "{get_from_config,secure.linkedin.client_id}";
  redirect_uri: "{get_redirect_uri}";
  response_type: "code";
  scope: "r_basicprofile r_ads rw_dmp_segments";
  state: "{get_state}";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_AUTHORIZATION_URL {
  PATH: "https://www.linkedin.com/oauth/v2/authorization?";
  QUERY_PARAMS: SHARED_CONSTANTS_METHODS_AUTHORIZATION_URL_QUERY_PARAMS;
}
export interface SHARED_CONSTANTS_GET_TOKEN_BODY {
  client_id: "{get_from_config,secure.linkedin.client_id}";
  client_secret: "{get_from_config,secure.linkedin.client_secret}";
  code: "{get_code}";
  grant_type: "authorization_code";
  redirect_uri: "{get_redirect_uri}";
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE {
  access_token: "body:access_token";
  refresh_token: "body:refresh_token";
  refresh_token_expires_in: "body:refresh_token_expires_in";
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN {
  BODY: SHARED_CONSTANTS_GET_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://www.linkedin.com/oauth/v2/accessToken";
  RESPONSE: SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL_GET_USER_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "LinkedIn-Version": "{get_linkedin_version}";
  "X-Restli-Protocol-Version": "{get_restli_protocol_version}";
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL_GET_USER_RESPONSE {
  connected_account: "body:vanityName";
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL_GET_USER {
  HEADERS: SHARED_CONSTANTS_COMPLETE_INSTALL_GET_USER_HEADERS;
  METHOD: "GET";
  PATH: "https://api.linkedin.com/rest/me";
  RESPONSE: SHARED_CONSTANTS_COMPLETE_INSTALL_GET_USER_RESPONSE;
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_COMPLETE_INSTALL {
  GET_TOKEN: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN;
  GET_USER: SHARED_CONSTANTS_COMPLETE_INSTALL_GET_USER;
}
export interface SHARED_CONSTANTS_destinations {
  destination: "LINKEDIN";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE_BODY {
  account: "urn:li:sponsoredAccount:{get_from_scope,ad_account_id}";
  destinations: SHARED_CONSTANTS_destinations[];
  name: "{get_from_scope,custom_audience_name}";
  sourcePlatform: "BRAZE";
  type: "USER";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
  "LinkedIn-Version": "{get_linkedin_version}";
  "X-Restli-Protocol-Version": "{get_restli_protocol_version}";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE {
  custom_audience_id: "header:x-linkedin-id";
  status: "text:BUILDING";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE {
  BODY: SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE_BODY;
  HEADERS: SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS;
  METHOD: "POST";
  PATH: "https://api.linkedin.com/rest/dmpSegments";
  RESPONSE: SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE;
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "LinkedIn-Version": "{get_linkedin_version}";
  "X-Restli-Protocol-Version": "{get_restli_protocol_version}";
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING {
  id: "id";
  name: "name";
  status: "destinations.0.status";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION {
  CHECK: ("equal_to" | "fetched_ad_account_num" | "page_offset")[];
  CURSOR: (1000 | "page_offset")[];
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS {
  account: "urn:li:sponsoredAccount:{get_from_scope,ad_account_id}";
  count: "1000";
  q: "account";
  start: "{get_from_scope_with_default,0,pagination_cursor}";
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE {
  all_custom_audiences: "body:elements";
  page_length: "body:paging.count";
  page_offset: "body:paging.start";
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES {
  HEADERS: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS;
  MAPPING: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING;
  METHOD: "GET";
  PAGINATION: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION;
  PATH: "https://api.linkedin.com/rest/dmpSegments";
  QUERY_PARAMS: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE;
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNT {
  GET_ACCOUNT_AUDIENCES: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES;
}
export interface SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "LinkedIn-Version": "{get_linkedin_version}";
  "X-Restli-Protocol-Version": "{get_restli_protocol_version}";
}
export interface SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS_QUERY_PARAMS {
  q: "authenticatedUser";
}
export interface SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS_RESPONSE {
  accounts_with_permissions: "body:elements";
}
export interface SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS {
  HEADERS: SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS_HEADERS;
  METHOD: "GET";
  PATH: "https://api.linkedin.com/rest/adAccountUsers";
  QUERY_PARAMS: SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS_RESPONSE;
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "LinkedIn-Version": "{get_linkedin_version}";
  "X-Restli-Protocol-Version": "{get_restli_protocol_version}";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS_MAPPING {
  ad_account_id: "id";
  ad_account_name: "name";
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_PAGINATION {
  CHECK: ("equal_to" | "fetched_ad_account_num" | "page_length")[];
  CURSOR: (1000 | "page_offset")[];
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_QUERY_PARAMS {
  count: "1000";
  q: "search";
  start: "{get_from_scope_with_default,0,pagination_cursor}";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS_RESPONSE {
  ad_accounts: "body:elements";
  page_length: "body:paging.count";
  page_offset: "body:paging.start";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS {
  ADDITIONAL_ACCOUNT_FILTERING: true;
  ADDITIONAL_BEFORE_REQUESTS: SHARED_CONSTANTS_ADDITIONAL_BEFORE_REQUESTS[];
  HEADERS: SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS_HEADERS;
  MAPPING: SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS_MAPPING;
  METHOD: "GET";
  PAGINATION: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_PAGINATION;
  PATH: "https://api.linkedin.com/rest/adAccounts";
  QUERY_PARAMS: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNTS_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS_RESPONSE;
}
export interface SHARED_CONSTANTS_GET_AUDIENCE_METRICS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "LinkedIn-Version": "{get_linkedin_version}";
  "X-Restli-Protocol-Version": "{get_restli_protocol_version}";
}
export interface SHARED_CONSTANTS_GET_AUDIENCE_METRICS_RESPONSE {
  audience_match_count: "body:matchedCount";
  audience_size: "body:audienceSize";
}
export interface SHARED_CONSTANTS_GET_AUDIENCE_METRICS {
  HEADERS: SHARED_CONSTANTS_GET_AUDIENCE_METRICS_HEADERS;
  METHOD: "GET";
  PATH: "https://api.linkedin.com/rest/dmpSegments/{get_from_scope,custom_audience_id}/destinations/LINKEDIN";
  RESPONSE: SHARED_CONSTANTS_GET_AUDIENCE_METRICS_RESPONSE;
}
export interface SHARED_CONSTANTS_METHODS_REFRESH_TOKEN_BODY {
  client_id: "{get_from_config,secure.linkedin.client_id}";
  client_secret: "{get_from_config,secure.linkedin.client_secret}";
  grant_type: "refresh_token";
  refresh_token: "{get_refresh_token}";
}
export interface SHARED_CONSTANTS_METHODS_REFRESH_TOKEN_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_METHODS_REFRESH_TOKEN_RESPONSE {
  access_token: "body:access_token";
}
export interface SHARED_CONSTANTS_METHODS_REFRESH_TOKEN {
  BODY: SHARED_CONSTANTS_METHODS_REFRESH_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_METHODS_REFRESH_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://www.linkedin.com/oauth/v2/accessToken";
  RESPONSE: SHARED_CONSTANTS_METHODS_REFRESH_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_SYNC_USERS_ACTION_MAPPING {
  add_users: "ADD";
  remove_users: "REMOVE";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_SYNC_USERS_BODY {
  elements: "{get_from_scope,data}";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_SYNC_USERS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
  "LinkedIn-Version": "{get_linkedin_version}";
  "X-RestLi-Method": "{get_batch_create}";
}
export interface SHARED_CONSTANTS_METHODS_SYNC_USERS_METHOD {
  add_users: "POST";
  remove_users: "POST";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS_SYNC_USERS {
  ACTION_MAPPING: SHARED_CONSTANTS_SYNC_USERS_ACTION_MAPPING;
  BODY: SHARED_CONSTANTS_Linkedin_METHODS_SYNC_USERS_BODY;
  HEADERS: SHARED_CONSTANTS_Linkedin_METHODS_SYNC_USERS_HEADERS;
  METHOD: SHARED_CONSTANTS_METHODS_SYNC_USERS_METHOD;
  PATH: "https://api.linkedin.com/rest/dmpSegments/{get_from_scope,custom_audience_id}/users";
}
export interface SHARED_CONSTANTS_Linkedin_METHODS {
  AUTHORIZATION_URL: SHARED_CONSTANTS_Linkedin_METHODS_AUTHORIZATION_URL;
  COMPLETE_INSTALL: SHARED_CONSTANTS_Linkedin_METHODS_COMPLETE_INSTALL;
  CREATE_CUSTOM_AUDIENCE: SHARED_CONSTANTS_Linkedin_METHODS_CREATE_CUSTOM_AUDIENCE;
  GET_AD_ACCOUNT: SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNT;
  GET_AD_ACCOUNTS: SHARED_CONSTANTS_Linkedin_METHODS_GET_AD_ACCOUNTS;
  GET_AUDIENCE_METRICS: SHARED_CONSTANTS_GET_AUDIENCE_METRICS;
  REFRESH_TOKEN: SHARED_CONSTANTS_METHODS_REFRESH_TOKEN;
  SYNC_USERS: SHARED_CONSTANTS_Linkedin_METHODS_SYNC_USERS;
}
export interface SHARED_CONSTANTS_linkedin {
  AUDIENCE_TYPE_MAP: SHARED_CONSTANTS_Linkedin_AUDIENCE_TYPE_MAP;
  BATCH_SIZE: 2000;
  CANVAS: SHARED_CONSTANTS_Linkedin_CANVAS;
  DEFAULT_REFRESH_TOKEN_EXPIRES_IN: "31535999";
  DISPLAY_NAME: "LinkedIn";
  ERROR_HANDLING: SHARED_CONSTANTS_Linkedin_ERROR_HANDLING;
  FEATURE: "audience_sync_pro";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-linkedin.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/secondary-icon-linkedin-v2.png";
  METHODS: SHARED_CONSTANTS_Linkedin_METHODS;
  PARTNER_PAGE: "/integrations/technology_partners/001d000001O3dWt";
  PARTNER_PAGE_ID: "001d000001O3dWt";
  PHONE_FORMAT: "NONE";
  REFRESH_TOKEN_EXPIRES: true;
  TOKEN_EXPIRATION_WINDOW: "5184000";
}
export interface SHARED_CONSTANTS_Pinterest_AUDIENCE_TYPE_MAP {
  android_gaid: "MAID";
  email: "EMAIL";
  ios_idfa: "IDFA";
}
export interface SHARED_CONSTANTS_Pinterest_CANVAS {
  IDENTIFIERS: ("android_gaid" | "email")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: true;
}
export interface SHARED_CONSTANTS_Pinterest_ERROR_HANDLING_TYPE_PROPERTY_MAPPING {
  "1"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "23"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "4"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "400"?: "Alloys::AudienceSync::Errors::BadRequestError";
  "401"?: "Alloys::AudienceSync::Errors::AuthError";
  "403"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "404"?: "Alloys::AudienceSync::Errors::DoesNotExistError";
  "408"?: "Alloys::AudienceSync::Errors::BadRequestError";
  "409"?: "Alloys::AudienceSync::Errors::BadRequestError";
  "410"?: "Alloys::AudienceSync::Errors::BadRequestError";
  "412"?: "Alloys::AudienceSync::Errors::AuthError";
  "413"?: "Alloys::AudienceSync::Errors::BadRequestError";
  "422"?: "Alloys::AudienceSync::Errors::BadRequestError";
  "429"?: "Alloys::AudienceSync::Errors::RateLimitBlockedError";
  "500"?: "Alloys::AudienceSync::Errors::ServiceError";
  "502"?: "Alloys::AudienceSync::Errors::ServiceError";
  "503"?: "Alloys::AudienceSync::Errors::ServiceError";
  "599"?: "Alloys::AudienceSync::Errors::ServiceError";
  "7"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "921"?: "Alloys::AudienceSync::Errors::TermsOfServiceError";
}
export interface SHARED_CONSTANTS_Pinterest_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY {
  INDICATOR: "body.code" | "status";
  MAPPING: SHARED_CONSTANTS_Pinterest_ERROR_HANDLING_TYPE_PROPERTY_MAPPING;
}
export interface SHARED_CONSTANTS_Pinterest_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body.message";
  TYPE_PROPERTY: SHARED_CONSTANTS_Pinterest_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_AUTHORIZATION_URL_QUERY_PARAMS {
  client_id: "{get_from_config,secure.pinterest.client_id}";
  redirect_uri: "{get_redirect_uri}";
  response_type: "code";
  scope: "ads:read,ads:write,user_accounts:read";
  state: "{get_state}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_AUTHORIZATION_URL {
  PATH: "https://www.pinterest.com/oauth/?";
  QUERY_PARAMS: SHARED_CONSTANTS_Pinterest_METHODS_AUTHORIZATION_URL_QUERY_PARAMS;
}
export interface SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN_BODY {
  code: "{get_code}";
  continuous_refresh: true;
  grant_type: "authorization_code";
  redirect_uri: "{get_redirect_uri}";
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS {
  Authorization: "{get_basic_auth,client_id,secret}";
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE {
  access_token: "body:access_token";
  refresh_token: "body:refresh_token";
  refresh_token_expires_in: "body:refresh_token_expires_in";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_COMPLETE_INSTALL_GET_TOKEN {
  BODY: SHARED_CONSTANTS_COMPLETE_INSTALL_GET_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://api.pinterest.com/v5/oauth/token";
  RESPONSE: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_USER_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_USER_RESPONSE {
  connected_account: "body:username";
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_USER {
  HEADERS: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_USER_HEADERS;
  METHOD: "GET";
  PATH: "https://api.pinterest.com/v5/user_account";
  RESPONSE: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_USER_RESPONSE;
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_COMPLETE_INSTALL {
  GET_TOKEN: SHARED_CONSTANTS_Pinterest_METHODS_COMPLETE_INSTALL_GET_TOKEN;
  GET_USER: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_USER;
}
export interface SHARED_CONSTANTS_rule {
  customer_list_id: "{get_from_scope,custom_audience_id}";
}
export interface SHARED_CONSTANTS_ADDITIONAL_AFTER_REQUESTS_BODY {
  audience_type: "CUSTOMER_LIST";
  name: "{get_from_scope,custom_audience_name}";
  rule: SHARED_CONSTANTS_rule;
}
export interface SHARED_CONSTANTS_ADDITIONAL_AFTER_REQUESTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_ADDITIONAL_AFTER_REQUESTS {
  BODY: SHARED_CONSTANTS_ADDITIONAL_AFTER_REQUESTS_BODY;
  HEADERS: SHARED_CONSTANTS_ADDITIONAL_AFTER_REQUESTS_HEADERS;
  METHOD: "POST";
  PATH: "https://api.pinterest.com/v5/ad_accounts/{get_from_scope,ad_account_id}/audiences";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE_BODY {
  list_type: "{get_mapped_field_to_match}";
  name: "{get_from_scope,custom_audience_name}";
  records: "";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE {
  custom_audience_id: "body:id";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE {
  ADDITIONAL_AFTER_REQUESTS: SHARED_CONSTANTS_ADDITIONAL_AFTER_REQUESTS[];
  BODY: SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE_BODY;
  HEADERS: SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS;
  METHOD: "POST";
  PATH: "https://api.pinterest.com/v5/ad_accounts/{get_from_scope,ad_account_id}/customer_lists";
  RESPONSE: SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE;
}
export interface SHARED_CONSTANTS_FILTERS {
  audience_type: "CUSTOMER_LIST";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING {
  id: "rule.customer_list_id";
  name: "name";
}
export interface SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION {
  CHECK: ("bookmark" | "not_null")[];
  CURSOR: "bookmark"[];
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS {
  bookmark: "{get_from_scope,pagination_cursor}";
  page_size: "250";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE {
  all_custom_audiences: "body:items";
  bookmark: "body:bookmark";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES {
  FILTERS: SHARED_CONSTANTS_FILTERS;
  HEADERS: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS;
  MAPPING: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING;
  METHOD: "GET";
  PAGINATION: SHARED_CONSTANTS_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION;
  PATH: "https://api.pinterest.com/v5/ad_accounts/{get_from_scope,ad_account_id}/audiences";
  QUERY_PARAMS: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE;
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_NAME_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_NAME_RESPONSE {
  ad_account_name: "body:name";
}
export interface SHARED_CONSTANTS_GET_ACCOUNT_NAME {
  HEADERS: SHARED_CONSTANTS_GET_ACCOUNT_NAME_HEADERS;
  METHOD: "GET";
  PATH: "https://api.pinterest.com/v5/ad_accounts/{get_from_scope,ad_account_id}/";
  RESPONSE: SHARED_CONSTANTS_GET_ACCOUNT_NAME_RESPONSE;
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT {
  GET_ACCOUNT_AUDIENCES: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES;
  GET_ACCOUNT_NAME: SHARED_CONSTANTS_GET_ACCOUNT_NAME;
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_MAPPING {
  ad_account_id: "id";
  ad_account_name: "name";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_QUERY_PARAMS {
  page_size: "250";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_RESPONSE {
  ad_accounts: "body:items";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS {
  HEADERS: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_HEADERS;
  MAPPING: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_MAPPING;
  METHOD: "GET";
  PATH: "https://api.pinterest.com/v5/ad_accounts";
  QUERY_PARAMS: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS_RESPONSE;
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN_BODY {
  grant_type: "refresh_token";
  refresh_token: "{get_refresh_token}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN_HEADERS {
  Authorization: "{get_basic_auth,client_id,secret}";
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN_RESPONSE {
  access_token: "body:access_token";
  refresh_token: "body:refresh_token";
  refresh_token_expires_at: "body:refresh_token_expires_at";
  refresh_token_expires_in: "body:refresh_token_expires_in";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN {
  BODY: SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://api.pinterest.com/v5/oauth/token";
  RESPONSE: SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_METHODS_SYNC_USERS_ACTION_MAPPING {
  add_users: "ADD";
  remove_users: "REMOVE";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS_BODY {
  operation_type: "{get_from_scope,mapped_action}";
  records: "{get_from_scope,data}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS_METHOD {
  add_users: "PATCH";
  remove_users: "PATCH";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS {
  ACTION_MAPPING: SHARED_CONSTANTS_METHODS_SYNC_USERS_ACTION_MAPPING;
  BODY: SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS_BODY;
  HEADERS: SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS_HEADERS;
  METHOD: SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS_METHOD;
  PATH: "https://api.pinterest.com/v5/ad_accounts/{get_from_scope,ad_account_id}/customer_lists/{get_from_scope,custom_audience_id}";
}
export interface SHARED_CONSTANTS_Pinterest_METHODS {
  AUTHORIZATION_URL: SHARED_CONSTANTS_Pinterest_METHODS_AUTHORIZATION_URL;
  COMPLETE_INSTALL: SHARED_CONSTANTS_Pinterest_METHODS_COMPLETE_INSTALL;
  CREATE_CUSTOM_AUDIENCE: SHARED_CONSTANTS_Pinterest_METHODS_CREATE_CUSTOM_AUDIENCE;
  GET_AD_ACCOUNT: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNT;
  GET_AD_ACCOUNTS: SHARED_CONSTANTS_Pinterest_METHODS_GET_AD_ACCOUNTS;
  REFRESH_TOKEN: SHARED_CONSTANTS_Pinterest_METHODS_REFRESH_TOKEN;
  SYNC_USERS: SHARED_CONSTANTS_Pinterest_METHODS_SYNC_USERS;
}
export interface SHARED_CONSTANTS_pinterest {
  AUDIENCE_TYPE_MAP: SHARED_CONSTANTS_Pinterest_AUDIENCE_TYPE_MAP;
  BATCH_SIZE: 2000;
  CANVAS: SHARED_CONSTANTS_Pinterest_CANVAS;
  DEFAULT_REFRESH_TOKEN_EXPIRES_IN: "31536000";
  DISPLAY_NAME: "Pinterest";
  ERROR_HANDLING: SHARED_CONSTANTS_Pinterest_ERROR_HANDLING;
  FEATURE: "audience_sync_pro";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-pinterest.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/icon-pinterest.png";
  METHODS: SHARED_CONSTANTS_Pinterest_METHODS;
  PARTNER_PAGE: "/integrations/technology_partners/001d000001S6amLAAR";
  PARTNER_PAGE_ID: "001d000001S6amLAAR";
  PHONE_FORMAT: "NONE";
  TOKEN_EXPIRATION_WINDOW: "2592000";
  USE_SCHEDULED_JOB_TO_REFRESH_TOKEN: true;
}
export interface SHARED_CONSTANTS_Snapchat_AUDIENCE_TYPE_MAP {
  email: "EMAIL_SHA256";
  mobile_id: "MOBILE_AD_ID_SHA256";
  phone: "PHONE_SHA256";
}
export interface SHARED_CONSTANTS_Snapchat_CANVAS {
  IDENTIFIERS: ("email" | "mobile_id" | "phone")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: false;
}
export interface SHARED_CONSTANTS_ERROR_HANDLING_RESPONSE_BODY_SUCCESS {
  request_status: "SUCCESS";
}
export interface SHARED_CONSTANTS_Snapchat_ERROR_HANDLING_TYPE_PROPERTY_MAPPING {
  "400"?: "Alloys::AudienceSync::Errors::TransientClientError";
  "401"?: "Alloys::AudienceSync::Errors::AuthError";
  "403"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "404"?: "Alloys::AudienceSync::Errors::DoesNotExistError";
  "429"?: "Alloys::AudienceSync::Errors::RateLimitBlockedError";
  "500"?: "Alloys::AudienceSync::Errors::ServiceError";
  "503"?: "Alloys::AudienceSync::Errors::ServiceError";
  E3002?: "Alloys::AudienceSync::Errors::PermissionsError";
}
export interface SHARED_CONSTANTS_Snapchat_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY {
  INDICATOR: "body.error_code" | "status";
  MAPPING: SHARED_CONSTANTS_Snapchat_ERROR_HANDLING_TYPE_PROPERTY_MAPPING;
}
export interface SHARED_CONSTANTS_Snapchat_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body";
  RESPONSE_BODY_SUCCESS: SHARED_CONSTANTS_ERROR_HANDLING_RESPONSE_BODY_SUCCESS;
  TYPE_PROPERTY: SHARED_CONSTANTS_Snapchat_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_AUTHORIZATION_URL_QUERY_PARAMS {
  client_id: "{get_from_config,secure.snapchat.client_id}";
  redirect_uri: "{get_redirect_uri}";
  response_type: "code";
  scope: "snapchat-marketing-api snapchat-profile-api";
  state: "{get_state}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_AUTHORIZATION_URL {
  PATH: "https://accounts.snapchat.com/login/oauth2/authorize?";
  QUERY_PARAMS: SHARED_CONSTANTS_Snapchat_METHODS_AUTHORIZATION_URL_QUERY_PARAMS;
}
export interface SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN_BODY {
  client_id: "{get_from_config,secure.snapchat.client_id}";
  client_secret: "{get_from_config,secure.snapchat.client_secret}";
  code: "{get_code}";
  grant_type: "authorization_code";
  redirect_uri: "{get_redirect_uri}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE {
  access_token: "body:access_token";
  refresh_token: "body:refresh_token";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_TOKEN {
  BODY: SHARED_CONSTANTS_METHODS_COMPLETE_INSTALL_GET_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://accounts.snapchat.com/login/oauth2/access_token";
  RESPONSE: SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_USER_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_USER_RESPONSE {
  connected_account: "body:me.snapchat_username";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_USER {
  HEADERS: SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_USER_HEADERS;
  METHOD: "GET";
  PATH: "https://adsapi.snapchat.com/v1/me";
  RESPONSE: SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_USER_RESPONSE;
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL {
  GET_TOKEN: SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_TOKEN;
  GET_USER: SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL_GET_USER;
}
export interface SHARED_CONSTANTS_segments {
  ad_account_id: "{get_from_scope,ad_account_id}";
  name: "{get_from_scope,custom_audience_name}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE_BODY {
  segments: SHARED_CONSTANTS_segments[];
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE {
  custom_audience_id: "body:segments.0.segment.id";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE {
  BODY: SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE_BODY;
  HEADERS: SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS;
  METHOD: "POST";
  PATH: "https://adsapi.snapchat.com/v1/adaccounts/{get_from_scope,ad_account_id}/segments";
  RESPONSE: SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE;
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING {
  id: "segment.id";
  name: "segment.name";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE {
  all_custom_audiences: "body:segments";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES {
  HEADERS: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS;
  MAPPING: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING;
  METHOD: "GET";
  PATH: "https://adsapi.snapchat.com/v1/adaccounts/{get_from_scope,ad_account_id}/segments";
  RESPONSE: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE;
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_NAME_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_NAME_RESPONSE {
  ad_account_name: "body:adaccounts.0.adaccount.name";
}
export interface SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_NAME {
  HEADERS: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_NAME_HEADERS;
  METHOD: "GET";
  PATH: "https://adsapi.snapchat.com/v1/adaccounts/{get_from_scope,ad_account_id}";
  RESPONSE: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_NAME_RESPONSE;
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT {
  GET_ACCOUNT_AUDIENCES: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES;
  GET_ACCOUNT_NAME: SHARED_CONSTANTS_GET_AD_ACCOUNT_GET_ACCOUNT_NAME;
}
export interface SHARED_CONSTANTS_GET_TOP_LEVEL_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_GET_TOP_LEVEL_MAPPING {
  organization_id: "organization.id";
}
export interface SHARED_CONSTANTS_GET_TOP_LEVEL_RESPONSE {
  top_level_accounts: "body:organizations";
}
export interface SHARED_CONSTANTS_GET_TOP_LEVEL {
  HEADERS: SHARED_CONSTANTS_GET_TOP_LEVEL_HEADERS;
  MAPPING: SHARED_CONSTANTS_GET_TOP_LEVEL_MAPPING;
  METHOD: "GET";
  PATH: "https://adsapi.snapchat.com/v1/me/organizations";
  RESPONSE: SHARED_CONSTANTS_GET_TOP_LEVEL_RESPONSE;
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS_MAPPING {
  ad_account_id: "adaccount.id";
  ad_account_name: "adaccount.name";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS_RESPONSE {
  ad_accounts: "body:adaccounts";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS {
  GET_TOP_LEVEL: SHARED_CONSTANTS_GET_TOP_LEVEL;
  HEADERS: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS_HEADERS;
  MAPPING: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS_MAPPING;
  METHOD: "GET";
  PATH: "https://adsapi.snapchat.com/v1/organizations/{get_from_scope,organization_id}/adaccounts";
  RESPONSE: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS_RESPONSE;
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN_BODY {
  client_id: "{get_from_config,secure.snapchat.client_id}";
  client_secret: "{get_from_config,secure.snapchat.client_secret}";
  grant_type: "refresh_token";
  refresh_token: "{get_refresh_token}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN_RESPONSE {
  access_token: "body:access_token";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN {
  BODY: SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://accounts.snapchat.com/login/oauth2/access_token";
  RESPONSE: SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_users {
  data: "{get_from_scope,data}";
  schema: "{get_mapped_fields_to_match}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS_BODY {
  users: SHARED_CONSTANTS_users[];
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS_METHOD {
  add_users: "POST";
  remove_users: "DELETE";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS {
  BODY: SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS_BODY;
  HEADERS: SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS_HEADERS;
  METHOD: SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS_METHOD;
  PATH: "https://adsapi.snapchat.com/v1/segments/{get_from_scope,custom_audience_id}/users";
}
export interface SHARED_CONSTANTS_Snapchat_METHODS {
  AUTHORIZATION_URL: SHARED_CONSTANTS_Snapchat_METHODS_AUTHORIZATION_URL;
  COMPLETE_INSTALL: SHARED_CONSTANTS_Snapchat_METHODS_COMPLETE_INSTALL;
  CREATE_CUSTOM_AUDIENCE: SHARED_CONSTANTS_Snapchat_METHODS_CREATE_CUSTOM_AUDIENCE;
  GET_AD_ACCOUNT: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNT;
  GET_AD_ACCOUNTS: SHARED_CONSTANTS_Snapchat_METHODS_GET_AD_ACCOUNTS;
  REFRESH_TOKEN: SHARED_CONSTANTS_Snapchat_METHODS_REFRESH_TOKEN;
  SYNC_USERS: SHARED_CONSTANTS_Snapchat_METHODS_SYNC_USERS;
}
export interface SHARED_CONSTANTS_snapchat {
  AUDIENCE_TYPE_MAP: SHARED_CONSTANTS_Snapchat_AUDIENCE_TYPE_MAP;
  BATCH_SIZE: 2000;
  CANVAS: SHARED_CONSTANTS_Snapchat_CANVAS;
  DISPLAY_NAME: "Snapchat";
  ERROR_HANDLING: SHARED_CONSTANTS_Snapchat_ERROR_HANDLING;
  FEATURE: "audience_sync_pro";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-snapchat.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/secondary-icon-snapchat.png?v=1682347677";
  METHODS: SHARED_CONSTANTS_Snapchat_METHODS;
  PARTNER_PAGE: "/integrations/technology_partners/001d000001GTpDpAAL";
  PARTNER_PAGE_ID: "001d000001GTpDpAAL";
  PHONE_FORMAT: "E164_NUMBERS_ONLY";
  TOKEN_EXPIRATION_WINDOW: "1800";
}
export interface SHARED_CONSTANTS_TheXtradeXdesk_CANVAS {
  IDENTIFIERS: ("email" | "mobile_id" | "phone")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: false;
}
export interface SHARED_CONSTANTS_TheXtradeXdesk_ERROR_HANDLING_TYPE_PROPERTY_MAPPING {
  "400": "Alloys::AudienceSync::Errors::ClientError";
  "401": "Alloys::AudienceSync::Errors::AuthError";
  "403": "Alloys::AudienceSync::Errors::PermissionsError";
  "404": "Alloys::AudienceSync::Errors::ClientError";
  "429": "Alloys::AudienceSync::Errors::RateLimitError";
  "500": "Alloys::AudienceSync::Errors::ServiceError";
  "502": "Alloys::AudienceSync::Errors::ServiceError";
  "503": "Alloys::AudienceSync::Errors::ServiceError";
}
export interface SHARED_CONSTANTS_TheXtradeXdesk_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY {
  INDICATOR: "status";
  MAPPING: SHARED_CONSTANTS_TheXtradeXdesk_ERROR_HANDLING_TYPE_PROPERTY_MAPPING;
}
export interface SHARED_CONSTANTS_TheXtradeXdesk_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body.Message";
  TYPE_PROPERTY: SHARED_CONSTANTS_TheXtradeXdesk_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_theXtradeXdesk {
  BATCH_SIZE: 50000;
  CANVAS: SHARED_CONSTANTS_TheXtradeXdesk_CANVAS;
  DISPLAY_NAME: "The Trade Desk";
  ERROR_HANDLING: SHARED_CONSTANTS_TheXtradeXdesk_ERROR_HANDLING;
  FEATURE: "audience_sync_pro";
  ICON_LINK: "https://cdn.braze.com/dashboard-assets/dashboard/icon-ttd.png";
  ICON_LINK_SECONDARY: "https://cdn.braze.com/dashboard-assets/dashboard/secondary-icon-ttd.png";
  PARTNER_PAGE: "/integrations/technology_partners/001VP000007AonWYAS";
  PARTNER_PAGE_ID: "001VP000007AonWYAS";
  PHONE_FORMAT: "E164";
  REGION_REQUIRED: true;
  SYNC_USERS_ASYNC: true;
}
export interface SHARED_CONSTANTS_Tiktok_AUDIENCE_TYPE_MAP {
  android_gaid: "AAID_SHA256";
  email: "EMAIL_SHA256";
  ios_idfa: "IDFA_SHA256";
  phone: "PHONE_SHA256";
}
export interface SHARED_CONSTANTS_Tiktok_CANVAS {
  IDENTIFIERS: ("android_gaid" | "email" | "ios_idfa" | "phone")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: true;
}
export interface SHARED_CONSTANTS_Tiktok_ERROR_HANDLING_RESPONSE_BODY_SUCCESS {
  code: 0;
}
export interface SHARED_CONSTANTS_Tiktok_ERROR_HANDLING_TYPE_PROPERTY_MAPPING {
  "400"?: "Alloys::AudienceSync::Errors::TransientClientError";
  "40001"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "40002"?: "Alloys::AudienceSync::Errors::DoesNotExistError";
  "401"?: "Alloys::AudienceSync::Errors::AuthError";
  "40100"?: "Alloys::AudienceSync::Errors::RateLimitBlockedError";
  "40101"?: "Alloys::AudienceSync::Errors::AuthError";
  "40102"?: "Alloys::AudienceSync::Errors::AuthError";
  "40103"?: "Alloys::AudienceSync::Errors::AuthError";
  "40104"?: "Alloys::AudienceSync::Errors::AuthError";
  "40105"?: "Alloys::AudienceSync::Errors::AuthError";
  "40107"?: "Alloys::AudienceSync::Errors::AuthError";
  "40108"?: "Alloys::AudienceSync::Errors::AuthError";
  "40110"?: "Alloys::AudienceSync::Errors::AuthError";
  "40113"?: "Alloys::AudienceSync::Errors::AuthError";
  "40118"?: "Alloys::AudienceSync::Errors::AuthError";
  "40125"?: "Alloys::AudienceSync::Errors::PermissionsError";
  "40300"?: "Alloys::AudienceSync::Errors::DoesNotExistError";
  "429"?: "Alloys::AudienceSync::Errors::RateLimitBlockedError";
  "500"?: "Alloys::AudienceSync::Errors::ServiceError";
  "50000"?: "Alloys::AudienceSync::Errors::ServiceError";
  "51010"?: "Alloys::AudienceSync::Errors::ServiceError";
  "51063"?: "Alloys::AudienceSync::Errors::ServiceBusyError";
}
export interface SHARED_CONSTANTS_Tiktok_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY {
  INDICATOR: "body.code" | "status";
  MAPPING: SHARED_CONSTANTS_Tiktok_ERROR_HANDLING_TYPE_PROPERTY_MAPPING;
}
export interface SHARED_CONSTANTS_Tiktok_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body.message";
  RESPONSE_BODY_SUCCESS: SHARED_CONSTANTS_Tiktok_ERROR_HANDLING_RESPONSE_BODY_SUCCESS;
  TYPE_PROPERTY: SHARED_CONSTANTS_Tiktok_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_AUTHORIZATION_URL_QUERY_PARAMS {
  app_id: "{get_from_config,secure.tiktok.app_id}";
  redirect_uri: "{get_redirect_uri}";
  state: "{get_state}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_AUTHORIZATION_URL {
  PATH: "https://ads.tiktok.com/marketing_api/auth?";
  QUERY_PARAMS: SHARED_CONSTANTS_Tiktok_METHODS_AUTHORIZATION_URL_QUERY_PARAMS;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN_BODY {
  app_id: "{get_from_config,secure.tiktok.app_id}";
  auth_code: "{get_code}";
  secret: "{get_from_config,secure.tiktok.secret}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS {
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE {
  access_token: "body:data.access_token";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN {
  BODY: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://business-api.tiktok.com/open_api/v1.3/oauth2/access_token/";
  RESPONSE: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_USER_HEADERS {
  "Access-Token": "{get_access_token}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_USER_RESPONSE {
  connected_account: "body:data.display_name";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_USER {
  HEADERS: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_USER_HEADERS;
  METHOD: "GET";
  PATH: "https://business-api.tiktok.com/open_api/v1.3/user/info/";
  RESPONSE: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_USER_RESPONSE;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL {
  GET_TOKEN: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_TOKEN;
  GET_USER: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL_GET_USER;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE_BODY {
  action: "create";
  advertiser_id: "{get_from_scope,ad_account_id}";
  custom_audience_name: "{get_from_scope,custom_audience_name}";
  id_type: "{get_mapped_field_to_match}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS {
  "Access-Token": "{get_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE {
  custom_audience_id: "body:data.audience_id";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE {
  BODY: SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE_BODY;
  HEADERS: SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS;
  METHOD: "POST";
  PATH: "https://business-api.tiktok.com/open_api/v1.3/segment/audience/";
  RESPONSE: SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS {
  "Access-Token": "{get_access_token}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING {
  id: "audience_id";
  name: "name";
  type: "calculate_type";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION {
  CHECK: ("current_page" | "less_than" | "total_pages")[];
  CURSOR: (1 | "current_page")[];
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS {
  advertiser_id: "{get_from_scope,ad_account_id}";
  page: "{get_from_scope,pagination_cursor}";
  page_size: 100;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE {
  all_custom_audiences: "body:data.list";
  current_page: "body:data.page_info.page";
  total_pages: "body:data.page_info.total_page";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES {
  HEADERS: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS;
  MAPPING: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING;
  METHOD: "GET";
  PAGINATION: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION;
  PATH: "https://business-api.tiktok.com/open_api/v1.3/dmp/custom_audience/list/";
  QUERY_PARAMS: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT {
  GET_ACCOUNT_AUDIENCES: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_HEADERS {
  "Access-Token": "{get_access_token}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_MAPPING {
  ad_account_id: "advertiser_id";
  ad_account_name: "advertiser_name";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_QUERY_PARAMS {
  app_id: "{get_from_config,secure.tiktok.app_id}";
  secret: "{get_from_config,secure.tiktok.secret}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_RESPONSE {
  ad_accounts: "body:data.list";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS {
  HEADERS: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_HEADERS;
  MAPPING: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_MAPPING;
  METHOD: "GET";
  PATH: "https://business-api.tiktok.com/open_api/v1.3/oauth2/advertiser/get/";
  QUERY_PARAMS: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS_RESPONSE;
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_ACTION_MAPPING {
  add_users: "add";
  remove_users: "delete";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_BODY {
  action: "{get_from_scope,mapped_action}";
  advertiser_ids: "{get_from_scope,ad_account_id_as_list}";
  batch_data: "{get_from_scope,data}";
  id_schema: "{get_mapped_fields_to_match}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_HEADERS {
  "Access-Token": "{get_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_METHOD {
  add_users: "POST";
  remove_users: "POST";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS {
  ACTION_MAPPING: SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_ACTION_MAPPING;
  BODY: SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_BODY;
  HEADERS: SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_HEADERS;
  METHOD: SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS_METHOD;
  PATH: "https://business-api.tiktok.com/open_api/v1.3/segment/mapping/";
}
export interface SHARED_CONSTANTS_Tiktok_METHODS {
  AUTHORIZATION_URL: SHARED_CONSTANTS_Tiktok_METHODS_AUTHORIZATION_URL;
  COMPLETE_INSTALL: SHARED_CONSTANTS_Tiktok_METHODS_COMPLETE_INSTALL;
  CREATE_CUSTOM_AUDIENCE: SHARED_CONSTANTS_Tiktok_METHODS_CREATE_CUSTOM_AUDIENCE;
  GET_AD_ACCOUNT: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNT;
  GET_AD_ACCOUNTS: SHARED_CONSTANTS_Tiktok_METHODS_GET_AD_ACCOUNTS;
  SYNC_USERS: SHARED_CONSTANTS_Tiktok_METHODS_SYNC_USERS;
}
export interface SHARED_CONSTANTS_tiktok {
  AUDIENCE_TYPE_MAP: SHARED_CONSTANTS_Tiktok_AUDIENCE_TYPE_MAP;
  BATCH_SIZE: 2000;
  CANVAS: SHARED_CONSTANTS_Tiktok_CANVAS;
  DISPLAY_NAME: "TikTok";
  ERROR_HANDLING: SHARED_CONSTANTS_Tiktok_ERROR_HANDLING;
  FEATURE: "audience_sync_pro";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-tiktok.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/secondary-icon-tiktok.png?v=1682347684";
  METHODS: SHARED_CONSTANTS_Tiktok_METHODS;
  PARTNER_PAGE: "/integrations/technology_partners/0010V00002M24eKQAR";
  PARTNER_PAGE_ID: "0010V00002M24eKQAR";
  PHONE_FORMAT: "E164";
}
export interface SHARED_CONSTANTS_Twitter_AUDIENCE_TYPE_MAP {
  email: "email";
  mobile_id: "device_id";
  phone: "phone_number";
}
export interface SHARED_CONSTANTS_Twitter_CANVAS {
  IDENTIFIERS: ("email" | "mobile_id" | "phone")[];
  MULTIPLE_IDENTIFIERS_PER_SYNC: true;
}
export interface SHARED_CONSTANTS_Twitter_ERROR_HANDLING_TYPE_PROPERTY_MAPPING {
  "400": "Alloys::AudienceSync::Errors::BadRequestError";
  "401": "Alloys::AudienceSync::Errors::AuthError";
  "403": "Alloys::AudienceSync::Errors::PermissionsError";
  "404": "Alloys::AudienceSync::Errors::DoesNotExistError";
  "413": "Alloys::AudienceSync::Errors::BadRequestError";
  "415": "Alloys::AudienceSync::Errors::BadRequestError";
  "429": "Alloys::AudienceSync::Errors::RateLimitBlockedError";
  "500": "Alloys::AudienceSync::Errors::ServiceError";
  "503": "Alloys::AudienceSync::Errors::ServiceError";
}
export interface SHARED_CONSTANTS_Twitter_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY {
  INDICATOR: "status";
  MAPPING: SHARED_CONSTANTS_Twitter_ERROR_HANDLING_TYPE_PROPERTY_MAPPING;
}
export interface SHARED_CONSTANTS_Twitter_ERROR_HANDLING {
  MESSAGE_PROPERTY: "body";
  TYPE_PROPERTY: SHARED_CONSTANTS_Twitter_ERROR_HANDLING_TYPE_PROPERTY_TYPE_PROPERTY[];
}
export interface SHARED_CONSTANTS_Twitter_METHODS_AUTHORIZATION_URL_QUERY_PARAMS {
  client_id: "{get_from_config,secure.twitter.client_id";
  code_challenge: "ALKJFASLDKHLKADJFALKSDJF";
  code_challenge_type: "plain";
  redirect_uri: "{get_redirect_uri}";
  response_type: "code";
  state: "{get_state}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_AUTHORIZATION_URL {
  PATH: "https://twitter.com/i/oauth2/authorize?";
  QUERY_PARAMS: SHARED_CONSTANTS_Twitter_METHODS_AUTHORIZATION_URL_QUERY_PARAMS;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN_BODY {
  client_id: "{get_from_config,secure.twitter.client_id}";
  code: "{get_code}";
  grant_type: "authorization_code";
  redirect_uri: "{get_redirect_uri}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE {
  access_token: "body:access_token";
  refresh_token: "body:refresh_token";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN {
  BODY: SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://api.twitter.com/oauth2/token?";
  RESPONSE: SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL {
  GET_TOKEN: SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL_GET_TOKEN;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_QUERY_PARAMS {
  name: "{get_from_scope,custom_audience_name}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE {
  custom_audience_id: "body:data.id";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_CREATE_CUSTOM_AUDIENCE {
  HEADERS: SHARED_CONSTANTS_Twitter_METHODS_CREATE_CUSTOM_AUDIENCE_HEADERS;
  METHOD: "POST";
  PATH: "https://ads-api.twitter.com/12/accounts/{get_from_scope,ad_account_id}/custom_audiences?";
  QUERY_PARAMS: SHARED_CONSTANTS_CREATE_CUSTOM_AUDIENCE_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_Twitter_METHODS_CREATE_CUSTOM_AUDIENCE_RESPONSE;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING {
  id: "id";
  name: "name";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION {
  CHECK: ("next_cursor" | "not_null")[];
  CURSOR: "next_cursor"[];
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS {
  cursor: "{get_from_scope,pagination_cursor}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE {
  all_custom_audiences: "body:data";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES {
  HEADERS: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_HEADERS;
  MAPPING: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_MAPPING;
  METHOD: "GET";
  PAGINATION: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_PAGINATION;
  PATH: "https://ads-api.twitter.com/12/accounts/{get_from_scope,ad_account_id}/custom_audiences";
  QUERY_PARAMS: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_QUERY_PARAMS;
  RESPONSE: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES_RESPONSE;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT {
  GET_ACCOUNT_AUDIENCES: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT_GET_ACCOUNT_AUDIENCES;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS_HEADERS {
  Authorization: "{get_bearer_access_token}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS_MAPPING {
  ad_account_id: "id";
  ad_account_name: "name";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS_RESPONSE {
  ad_accounts: "body:data";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS {
  HEADERS: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS_HEADERS;
  MAPPING: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS_MAPPING;
  METHOD: "GET";
  PATH: "https://ads-api.twitter.com/12/accounts";
  RESPONSE: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS_RESPONSE;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN_BODY {
  client_id: "{get_from_config,secure.twitter.client_id}";
  grant_type: "refresh_token";
  refresh_token: "{get_refresh_token}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN_HEADERS {
  "Content-Type": "{get_application_urlencoded}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN_RESPONSE {
  access_token: "body:access_token";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN {
  BODY: SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN_BODY;
  HEADERS: SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN_HEADERS;
  METHOD: "POST";
  PATH: "https://api.twitter.com/oauth2/token";
  RESPONSE: SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN_RESPONSE;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_ACTION_MAPPING {
  add_users: "Update";
  remove_users: "Delete";
}
export interface SHARED_CONSTANTS_params {
  users: "{get_from_scope,data}";
}
export interface SHARED_CONSTANTS_DATA {
  operation_type: "{get_from_scope,mapped_action}";
  params: SHARED_CONSTANTS_params;
}
export interface SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_BODY {
  DATA: SHARED_CONSTANTS_DATA[];
}
export interface SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_HEADERS {
  Authorization: "{get_bearer_access_token}";
  "Content-Type": "{get_application_json}";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_METHOD {
  add_users: "POST";
  remove_users: "POST";
}
export interface SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS {
  ACTION_MAPPING: SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_ACTION_MAPPING;
  BODY: SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_BODY;
  HEADERS: SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_HEADERS;
  METHOD: SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS_METHOD;
  PATH: "https://ads-api.twitter.com/12/accounts/{get_from_scope,ad_account_id}/custom_audiences/{get_from_scope,custom_audience_id}/users";
}
export interface SHARED_CONSTANTS_Twitter_METHODS {
  AUTHORIZATION_URL: SHARED_CONSTANTS_Twitter_METHODS_AUTHORIZATION_URL;
  COMPLETE_INSTALL: SHARED_CONSTANTS_Twitter_METHODS_COMPLETE_INSTALL;
  CREATE_CUSTOM_AUDIENCE: SHARED_CONSTANTS_Twitter_METHODS_CREATE_CUSTOM_AUDIENCE;
  GET_AD_ACCOUNT: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNT;
  GET_AD_ACCOUNTS: SHARED_CONSTANTS_Twitter_METHODS_GET_AD_ACCOUNTS;
  REFRESH_TOKEN: SHARED_CONSTANTS_Twitter_METHODS_REFRESH_TOKEN;
  SYNC_USERS: SHARED_CONSTANTS_Twitter_METHODS_SYNC_USERS;
}
export interface SHARED_CONSTANTS_twitter {
  AUDIENCE_TYPE_MAP: SHARED_CONSTANTS_Twitter_AUDIENCE_TYPE_MAP;
  BATCH_SIZE: 2000;
  CANVAS: SHARED_CONSTANTS_Twitter_CANVAS;
  DISPLAY_NAME: "Twitter";
  ERROR_HANDLING: SHARED_CONSTANTS_Twitter_ERROR_HANDLING;
  FEATURE: "canvas_consolidated_audience_sync_twitter";
  ICON_LINK: "https://marketing-assets.braze.com/production/logos/icon-twitter.png";
  ICON_LINK_SECONDARY: "https://marketing-assets.braze.com/production/logos/icon-twitter.png";
  METHODS: SHARED_CONSTANTS_Twitter_METHODS;
  PARTNER_PAGE: "/integrations/technology_partners/001d000001G9SH2";
  PARTNER_PAGE_ID: "001d000001G9SH2";
  PHONE_FORMAT: "E164";
  TOKEN_EXPIRATION_WINDOW: "900";
}
export interface SHARED_CONSTANTS_AUDIENCE_SYNC_SETTINGS {
  criteo: SHARED_CONSTANTS_criteo;
  dv360: SHARED_CONSTANTS_dv360;
  facebook: SHARED_CONSTANTS_facebook;
  google: SHARED_CONSTANTS_google;
  linkedin: SHARED_CONSTANTS_linkedin;
  pinterest: SHARED_CONSTANTS_pinterest;
  snapchat: SHARED_CONSTANTS_snapchat;
  "the-trade-desk": SHARED_CONSTANTS_theXtradeXdesk;
  tiktok: SHARED_CONSTANTS_tiktok;
  twitter: SHARED_CONSTANTS_twitter;
}
export interface SHARED_CONSTANTS_STATE {
  ENABLED: "enabled";
  MANUAL: "manual";
}
export interface SHARED_CONSTANTS_AUTOMATIC_VARIANT_SELECTION {
  STATE: SHARED_CONSTANTS_STATE;
}
export interface SHARED_CONSTANTS_BANNER_CONSTANT_ERRORS {
  CONCURRENT_UPDATE_FAILED: "concurrent_update_failed";
  EXPIRATION_SCHEDULE_TIME_AND_TTL_BOTH_BLANK: "expiration_schedule_time_and_ttl_both_blank";
  EXPIRATION_SCHEDULE_TIME_AND_TTL_BOTH_SET: "expiration_schedule_time_and_ttl_both_set";
  EXPIRATION_SCHEDULE_TIME_IN_PAST: "expiration_schedule_time_in_past";
  EXPIRATION_SCHEDULE_TTL_NEGATIVE: "expiration_schedule_ttl_negative";
  EXPIRATION_SCHEDULE_TTL_TOO_LONG: "expiration_schedule_ttl_too_long";
  INVALID_ASSOCIATION: "invalid_association";
  INVALID_PLACEMENT: "invalid_placement";
}
export interface SHARED_CONSTANTS_BANNER {
  BANNER_CONSTANT_ERRORS: SHARED_CONSTANTS_BANNER_CONSTANT_ERRORS;
  DISMISS_BUTTON_HTML_CLASS_NAME: "bz-close-btn";
  UNATTRIBUTED_CLICK_TRACKING_ID: "_bz_unattributed";
}
export interface SHARED_CONSTANTS_BANNER_CONSTANTS {
  AUTOMATIC_VARIANT_SELECTION_COMPOSE_BANNER_ID: "automatic-variant-selection-compose-banner";
  CAMPAIGN_LAUNCH_AUTOMATIC_VARIANT_SELECTION_WARNING_ID: "campaign-launch-automatic-variant-selection-warning";
  CAMPAIGN_SENDER_NOTICE_ID: "campaign-sender-notice";
  CARD_SENDER_NOTICE_ID: "card-sender-notice-id";
  DEFAULT_ID: "default";
  DELAY_INFO_ID: "delay-info-id";
  DRAFT_WARNING_ID: "draft-warning";
  KAKAO_AUTOMATIC_TAG_ID: "kakao-automatic-tag-banner";
  REPORT_BUILDER_CANVAS_INSTRUCTIONS_ID: "report-builder-2-setup-canvas-step-banner";
  SEGMENT_EDITOR_NOTICE_ID: "segment-editor-notice-id]";
}
export interface SHARED_CONSTANTS_BOUNCE_CLASSIFICATION {
  LABELS: ("authentication__dns_failure" | "block" | "invalid_domain" | "invalid_recipient" | "low_reputation__throttling" | "mailbox_unavailable" | "spam__content" | "undetermined")[];
}
export interface SHARED_CONSTANTS_DYNAMIC_PROMPTS_ERROR_CODES {
  CONTEXT_TOO_LARGE: "CONTEXT_TOO_LARGE";
  PAGE_CONTENT_TOO_LARGE: "PAGE_CONTENT_TOO_LARGE";
  TOOLS_LIST_TOO_LARGE: "TOOLS_LIST_TOO_LARGE";
  URL_TOO_LARGE: "URL_TOO_LARGE";
}
export interface SHARED_CONSTANTS_FIGMA_ERROR_CODES {
  FIGMA_API_ERROR: "FIGMA_API_ERROR";
  FIGMA_AUTH_REQUIRED: "FIGMA_AUTH_REQUIRED";
  FIGMA_RATE_LIMIT: "FIGMA_RATE_LIMIT";
  INVALID_FILE_KEY: "INVALID_FILE_KEY";
  MISSING_FILE_KEY: "MISSING_FILE_KEY";
  MISSING_IDS: "MISSING_IDS";
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR";
}
export interface SHARED_CONSTANTS_GOOGLE {
  GEMINI_3_1_PRO: "gemini-3.1-pro-preview";
  GEMINI_3_5_FLASH: "gemini-3.5-flash";
}
export interface SHARED_CONSTANTS_OPENAI {
  GPT_5_2: "gpt-5.2";
  GPT_5_4: "gpt-5.4";
  GPT_5_5: "gpt-5.5";
  GPT_5_6_LUNA: "gpt-5.6-luna";
  GPT_5_6_SOL: "gpt-5.6-sol";
  GPT_5_6_TERRA: "gpt-5.6-terra";
}
export interface SHARED_CONSTANTS_MODELS {
  GOOGLE: SHARED_CONSTANTS_GOOGLE;
  OPENAI: SHARED_CONSTANTS_OPENAI;
}
export interface SHARED_CONSTANTS_MODES {
  AGENT: "agent";
}
export interface SHARED_CONSTANTS_OPENAI_REASONING_EFFORTS {
  HIGH: "high";
  LOW: "low";
  MEDIUM: "medium";
}
export interface SHARED_CONSTANTS_OPERATOR_AGENT_ERROR_CODES {
  AGENT_MODE_NOT_ENABLED: "AGENT_MODE_NOT_ENABLED";
  DAILY_COST_CAP_EXCEEDED: "DAILY_COST_CAP_EXCEEDED";
  DUPLICATE_TOOL_NAMES: "DUPLICATE_TOOL_NAMES";
  GEN_AI_KILL_SWITCH_ON: "GEN_AI_KILL_SWITCH_ON";
  INPUT_TOO_LARGE: "INPUT_TOO_LARGE";
  INVALID_REQUEST_ID: "INVALID_REQUEST_ID";
  RATE_LIMIT_EXCEEDED: "RATE_LIMIT_EXCEEDED";
  TOOLS_LIST_TOO_LARGE: "TOOLS_LIST_TOO_LARGE";
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR";
  UNKNOWN_MODEL: "UNKNOWN_MODEL";
  UNSUPPORTED_MODE: "UNSUPPORTED_MODE";
}
export interface SHARED_CONSTANTS_STREAMING_ERROR_CODES {
  GENERIC_GOOGLE_ERROR: "generic-google-error";
  GENERIC_OPENAI_ERROR: "generic-openai-error";
  GOOGLE_RATE_LIMIT_EXCEEDED: "google-rate-limit-exceeded";
  INTERNAL_ERROR: "internal-error";
  KILL_SWITCH_ENABLED: "kill-switch-enabled";
  OPENAI_RATE_LIMIT_EXCEEDED: "openai-rate-limit-exceeded";
  STREAM_INCOMPLETE: "stream-incomplete";
}
export interface SHARED_CONSTANTS_BRAZE_AGENTIC_AI {
  DYNAMIC_PROMPTS_ERROR_CODES: SHARED_CONSTANTS_DYNAMIC_PROMPTS_ERROR_CODES;
  EXPERIMENTAL_OPENAI_MODELS: ("gpt-5.4" | "gpt-5.5" | "gpt-5.6-luna" | "gpt-5.6-sol" | "gpt-5.6-terra")[];
  FIGMA_ERROR_CODES: SHARED_CONSTANTS_FIGMA_ERROR_CODES;
  MAX_INPUT_BYTES: 1572864;
  MAX_PARALLEL_TOOL_CALLS: 15;
  MODELS: SHARED_CONSTANTS_MODELS;
  MODES: SHARED_CONSTANTS_MODES;
  OPENAI_REASONING_EFFORTS: SHARED_CONSTANTS_OPENAI_REASONING_EFFORTS;
  OPERATOR_AGENT_ERROR_CODES: SHARED_CONSTANTS_OPERATOR_AGENT_ERROR_CODES;
  STREAMING_ERROR_CODES: SHARED_CONSTANTS_STREAMING_ERROR_CODES;
}
export interface SHARED_CONSTANTS_ASSISTANT_CHANNELS {
  ANDROID_PUSH: "android-push";
  EMAIL_HTML: "email-html";
  EMAIL_HTML_TEMPLATES: "email-html-templates";
  IOS_PUSH: "ios-push";
  KINDLE_PUSH: "kindle-push";
  QUICK_PUSH: "quick-push";
  SMS: "sms";
  WEB_PUSH: "web-push";
}
export interface SHARED_CONSTANTS_COMPOSER_FEATURE_MAP {
  "android-push": true;
  "email-html": true;
  "email-html-templates": "email_html_templates_composer_sage_assistant";
  "ios-push": true;
  "kindle-push": true;
  "quick-push": true;
  sms: true;
  "web-push": true;
}
export interface SHARED_CONSTANTS_LIQUID_ASSISTANT {
  COMPOSER_FEATURE_MAP: SHARED_CONSTANTS_COMPOSER_FEATURE_MAP;
}
export interface SHARED_CONSTANTS_BRAZE_AI_ASSISTANT {
  ASSISTANT_CHANNELS: SHARED_CONSTANTS_ASSISTANT_CHANNELS;
  LIQUID_ASSISTANT: SHARED_CONSTANTS_LIQUID_ASSISTANT;
}
export interface SHARED_CONSTANTS_BRAZE_DOCS_FALLBACK_SEARCH_ERROR_CODES {
  SEARCH_STRING_EMPTY: "SEARCH_STRING_EMPTY";
  SEARCH_STRING_TOO_LONG: "SEARCH_STRING_TOO_LONG";
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR";
  URL_EMPTY: "URL_EMPTY";
}
export interface SHARED_CONSTANTS_BRAZE_DOCS_FALLBACK_SEARCH {
  ERROR_CODES: SHARED_CONSTANTS_BRAZE_DOCS_FALLBACK_SEARCH_ERROR_CODES;
}
export interface SHARED_CONSTANTS_BRAZE_DOCS_LOOKUP_ERROR_CODES {
  SEARCH_STRING_EMPTY: "SEARCH_STRING_EMPTY";
  SEARCH_STRING_TOO_LONG: "SEARCH_STRING_TOO_LONG";
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR";
  URL_EMPTY: "URL_EMPTY";
}
export interface SHARED_CONSTANTS_BRAZE_DOCS_LOOKUP {
  ERROR_CODES: SHARED_CONSTANTS_BRAZE_DOCS_LOOKUP_ERROR_CODES;
}
export interface SHARED_CONSTANTS_BRAZE_DOCS_SEARCH_ERROR_CODES {
  SEARCH_STRING_EMPTY: "SEARCH_STRING_EMPTY";
  SEARCH_STRING_TOO_LONG: "SEARCH_STRING_TOO_LONG";
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR";
  URL_EMPTY: "URL_EMPTY";
}
export interface SHARED_CONSTANTS_BRAZE_DOCS_SEARCH {
  ERROR_CODES: SHARED_CONSTANTS_BRAZE_DOCS_SEARCH_ERROR_CODES;
}
export interface SHARED_CONSTANTS_BRAZE_GITHUB_TEAMS {
  "ai-decisioning-experience": "@Appboy/ai-decisioning-experience";
  cdit: "@Appboy/cdit";
  clip: "@Appboy/clip";
  clx: "@Appboy/clx";
  "content-cards": "@Appboy/content-cards";
  "core-messaging": "@Appboy/core-messaging";
  "core-objects": "@Appboy/core-objects";
  currents: "@Appboy/currents";
  "data-lakehouse": "@Appboy/data-lakehouse";
  "data-services": "@Appboy/data-services";
  datalake: "@Appboy/datalake";
  email: "@Appboy/email";
  "feature-flags": "@Appboy/feature-flags";
  "frontend-ix": "@Appboy/frontend-ix";
  growth: "@Appboy/growth";
  "growth-engineering": "@Appboy/growth-engineering";
  "in-app-messages": "@Appboy/in-app-messages";
  ingestion: "@Appboy/ingestion";
  intelligence: "@Appboy/intelligence";
  "internal-tools": "@Appboy/clip";
  "messaging-experience": "@Appboy/messaging-experience";
  "monolith-deployments": "@Appboy/monolith-deployments";
  "monolith-foundations": "@Appboy/monolith-foundations";
  operator: "@Appboy/operator";
  "product-partnerships": "@Appboy/product-partnerships";
  push: "@Appboy/push";
  "quality-infrastructure": "@Appboy/quality-infrastructure";
  reporting: "@Appboy/reporting";
  sdks: "@Appboy/feature-flags";
  sidekiq: "@Appboy/sidekiq";
  smb: "@Appboy/smb";
  sms: "@Appboy/sms";
  "user-targeting": "@Appboy/user-targeting";
  "whats-app": "@Appboy/whats-app";
}
export interface SHARED_CONSTANTS_BRAZE_TEAMS {
  CDIT: "cdit";
  CLIP: "clip";
  CLX: "clx";
  CONTENT_CARDS: "content_cards";
  CORE_MESSAGING: "core_messaging";
  CORE_OBJECTS: "core-objects";
  CURRENTS: "currents";
  DATA_LAKE: "datalake";
  DATA_LAKEHOUSE: "data_lakehouse";
  DATA_STREAMING: "data_streaming";
  DEVOPS: "devops";
  DUST: "dust";
  EMAIL: "email";
  FEATURE_FLAGS: "feature-flags";
  FIX: "frontend_ix";
  GROWTH_ENGINEERING: "growth-engineering";
  IAM: "iam";
  INGESTION: "ingestion";
  INTELLIGENCE: "intelligence";
  IN_MEMORY_DB: "in_memory_db";
  MESSAGING_EXPERIENCE: "messaging_experience";
  MONOLITH_DEPLOYMENT: "mono_dep";
  MONOLITH_FOUNDATIONS: "monolith_foundations";
  OPERATOR: "operator";
  PARTNERSHIPS: "partnerships";
  PGAI: "pgai";
  PRODUCT_SRE: "product_sre";
  PUSH: "push";
  REPORTING: "reporting";
  SDKS: "sdks";
  SECURITY: "security";
  SIDEKIQ: "sidekiq";
  SMS: "sms";
  USER_TARGETING: "user_targeting";
  WHATS_APP: "whats-app";
}
export interface SHARED_CONSTANTS_CREATION_TYPE {
  BRAZE: "braze";
  DEVELOPER: "developer";
}
export interface SHARED_CONSTANTS_DATA_TYPE {
  BOOLEAN: "boolean";
  DATETIME: "datetime";
  NUMBER: "number";
  STRING: "string";
}
export interface SHARED_CONSTANTS_CALCULATED_ATTRIBUTES_ERROR_CODES {
  ACTIVE_LIMIT_REACHED: "calculated_attributes_active_limit_reached";
  CANNOT_REFRESH_WHEN_ARCHIVED: "calculated_attributes_cannot_refresh_when_archived";
  CANNOT_REFRESH_WHEN_DRAFT: "calculated_attributes_cannot_refresh_when_draft";
  CREATION_FAILED: "calculated_attributes_creation_failed";
  CURRENTLY_PROCESSING: "calculated_attributes_currently_processing";
  DRAFT_AFTER_PUBLISHED: "calculated_attributes_draft_after_published";
  FEATURE_DISABLED: "calculated_attributes_feature_disabled";
  INVALID_REFRESH_FREQUENCY: "calculated_attributes_invalid_refresh_frequency";
  INVALID_REQUEST_BODY: "calculated_attributes_invalid_request_body";
  IN_USE: "calculated_attributes_in_use";
  NAME_ALREADY_EXISTS: "calculated_attributes_name_already_exists";
  NOT_FOUND: "calculated_attributes_not_found";
  REFRESH_FAILED: "calculated_attributes_refresh_failed";
  TOO_MANY_AT_ONCE: "calculated_attributes_too_many_at_once";
  UPDATE_FAILED: "calculated_attributes_update_failed";
}
export interface SHARED_CONSTANTS_CALCULATED_ATTRIBUTES {
  CREATION_TYPE: SHARED_CONSTANTS_CREATION_TYPE;
  DATA_TYPE: SHARED_CONSTANTS_DATA_TYPE;
  ERROR_CODES: SHARED_CONSTANTS_CALCULATED_ATTRIBUTES_ERROR_CODES;
}
export interface SHARED_CONSTANTS_CALCULATED_FILTERS_ERROR_CODES {
  ACTIVE_LIMIT_REACHED: "calculated_filters_active_limit_reached";
  BULK_IDS_NOT_ARRAY: "calculated_filters_bulk_ids_not_array";
  BULK_SIZE_EXCEEDED: "calculated_filters_bulk_size_exceeded";
  CANNOT_REFRESH_WHEN_ARCHIVED: "calculated_filters_cannot_refresh_when_archived";
  CANNOT_REFRESH_WHEN_DRAFT: "calculated_filters_cannot_refresh_when_draft";
  CREATION_FAILED: "calculated_filters_creation_failed";
  CURRENTLY_PROCESSING: "calculated_filters_currently_processing";
  DRAFT_AFTER_PUBLISHED: "calculated_filters_draft_after_published";
  FEATURE_DISABLED: "calculated_filters_feature_disabled";
  INVALID_FILTER_TREE: "calculated_filters_invalid_filter_tree";
  INVALID_REQUEST_BODY: "calculated_filters_invalid_request_body";
  IN_USE: "calculated_filters_in_use";
  NAME_ALREADY_EXISTS: "calculated_filters_name_already_exists";
  NOT_FOUND: "calculated_filters_not_found";
  REFRESH_FAILED: "calculated_filters_refresh_failed";
  TOO_MANY_AT_ONCE: "calculated_filters_too_many_at_once";
  UNSUPPORTED_TYPE: "calculated_filters_unsupported_type";
  UPDATE_FAILED: "calculated_filters_update_failed";
}
export interface SHARED_CONSTANTS_CALCULATED_FILTERS {
  ERROR_CODES: SHARED_CONSTANTS_CALCULATED_FILTERS_ERROR_CODES;
}
export interface SHARED_CONSTANTS_email {
  CANVAS_USER_UPDATE_STEP: "cs";
  CSV_IMPORT: "c";
  LIST_UNSUBSCRIBE: "oc";
  PREFERENCE_CENTER: "f";
  REST_API: "r";
  SDK: "s";
  SHOPIFY_PROVIDER: "sh";
}
export interface SHARED_CONSTANTS_line {
  PROVIDER_EVENT: "pe";
}
export interface SHARED_CONSTANTS_sms {
  CANVAS_USER_UPDATE_STEP: "cs";
  CSV_IMPORT: "c";
  INBOUND_SMS: "i";
  PREFERENCE_CENTER: "f";
  REST_API: "r";
  SDK: "s";
  SHOPIFY_PROVIDER: "sh";
}
export interface SHARED_CONSTANTS_whatsApp {
  CANVAS_USER_UPDATE_STEP: "cs";
  CSV_IMPORT: "c";
  PREFERENCE_CENTER: "f";
  REST_API: "r";
  SDK: "s";
}
export interface SHARED_CONSTANTS_SUBSCRIPTION_GROUP_STATE_CHANGED_SOURCE_OPTIONS {
  email: SHARED_CONSTANTS_email;
  line: SHARED_CONSTANTS_line;
  sms: SHARED_CONSTANTS_sms;
  whatsApp: SHARED_CONSTANTS_whatsApp;
}
export interface SHARED_CONSTANTS_ACTION_TRIGGERS {
  SUBSCRIPTION_GROUP_STATE_CHANGED_SOURCE_OPTIONS: SHARED_CONSTANTS_SUBSCRIPTION_GROUP_STATE_CHANGED_SOURCE_OPTIONS;
}
export interface SHARED_CONSTANTS_ALERT_PREFERENCES {
  DAILY: "daily";
  EACH_RUN: "each_run";
  HOURLY: "hourly";
  NONE: "none";
}
export interface SHARED_CONSTANTS_COMPOSITION_MODE_TYPE {
  PER_VARIATION: "per-variation";
  QUICK_PUSH: "quick-push";
  QUICK_PUSH_MULTICHANNEL: "quick-push-multichannel";
}
export interface SHARED_CONSTANTS_CONVERSION_BEHAVIOR {
  MAX_COUNT: 4;
  MAX_DEADLINE_SECONDS: 2592000;
  MIN_DEADLINE_SECONDS: 300;
}
export interface SHARED_CONSTANTS_EVENTS {
  BEGAN_EDITING_CAMPAIGN_TAG: "Began editing any campaign";
}
export interface SHARED_CONSTANTS_additional_filter_data {
  
}
export interface SHARED_CONSTANTS_ce {
  additional_filter_data: SHARED_CONSTANTS_additional_filter_data;
  allowed_for_predictions: false;
  allowed_for_territories: false;
  display_name: "Basic Property";
  filter_key: "custom_event_properties_filter";
  only_for_workflow_step: false;
  varies_by_app_group: true;
}
export interface SHARED_CONSTANTS_Ce_no_additional_filter_data {
  
}
export interface SHARED_CONSTANTS_ce_no {
  additional_filter_data: SHARED_CONSTANTS_Ce_no_additional_filter_data;
  allowed_for_predictions: false;
  allowed_for_territories: false;
  display_name: "Basic Property" | "Nested Property";
  filter_key: "custom_event_properties_filter" | "nested_object_filter";
  only_for_workflow_step: false;
  varies_by_app_group: false | true;
}
export interface SHARED_CONSTANTS_Iap_additional_filter_data {
  
}
export interface SHARED_CONSTANTS_iap {
  additional_filter_data: SHARED_CONSTANTS_Iap_additional_filter_data;
  allowed_for_predictions: false;
  allowed_for_territories: false;
  display_name: "Basic Property";
  filter_key: "custom_event_properties_filter";
  only_for_workflow_step: false;
  varies_by_app_group: true;
}
export interface SHARED_CONSTANTS_Iap_no_additional_filter_data {
  
}
export interface SHARED_CONSTANTS_iap_no {
  additional_filter_data: SHARED_CONSTANTS_Iap_no_additional_filter_data;
  allowed_for_predictions: false;
  allowed_for_territories: false;
  display_name: "Basic Property" | "Nested Property";
  filter_key: "custom_event_properties_filter" | "nested_object_filter";
  only_for_workflow_step: false;
  varies_by_app_group: false | true;
}
export interface SHARED_CONSTANTS_FILTERS_BY_NAMESPACE {
  ce: SHARED_CONSTANTS_ce[];
  ce_no: SHARED_CONSTANTS_ce_no[];
  iap: SHARED_CONSTANTS_iap[];
  iap_no: SHARED_CONSTANTS_iap_no[];
}
export interface SHARED_CONSTANTS_INTELLIGENT_DELIVERY {
  OPTIMIZED: "optimized";
  UNOPTIMIZED: "unoptimized";
}
export interface SHARED_CONSTANTS_INTERACTIONS {
  CLICKED_ALIAS_IN_EMAIL: "cae";
  CLICKED_ANY_ALIAS: "caa";
  CLICKED_BANNER: "cb";
  CLICKED_CAROUSEL_SLIDE: "csc";
  CLICKED_CONTENT_CARDS: "ci";
  CLICKED_EMAIL: "ce";
  CLICKED_PUSH_BUTTON: "cpb";
  CLICKED_SHORTENED_SMS_LINK: "cs";
  CLICKED_SLIDE_UP: "s";
  CLICKED_SLIDE_UP_BUTTON0: "s0";
  CLICKED_SLIDE_UP_BUTTON1: "s1";
  CLICKED_TRACKED_KAKAO_LINK: "ck";
  CLICKED_TRACKED_LINE_LINK: "cl";
  CLICKED_TRACKED_WHATS_APP_LINK: "cw";
  CLICKED_TRIGGER_IAM: "tc";
  CLICKED_TRIGGER_IAM_BUTTON0: "t0";
  CLICKED_TRIGGER_IAM_BUTTON1: "t1";
  DISMISSED_BANNER: "db";
  DISMISSED_CONTENT_CARDS: "di";
  ENROLLED_IN_CONTROL: "ec";
  MACHINE_OPENED_EMAIL: "moe";
  OPENED_EMAIL: "oe";
  OPENED_PUSH: "op";
  OPENED_WHATS_APP: "owa";
  OTHER_OPENED_EMAIL: "ooe";
  PERFORMED_CONVERSION: "pc";
  RECEIVED_BANNER: "rvb";
  RECEIVED_CONTENT_CARD: "rc";
  RECEIVED_EMAIL: "re";
  RECEIVED_FEATURE_FLAG: "rff";
  RECEIVED_FEATURE_FLAG_EXPERIMENT: "rfe";
  RECEIVED_KAKAO: "rk";
  RECEIVED_LINE: "rl";
  RECEIVED_PUSH: "rp";
  RECEIVED_SMS: "rs";
  RECEIVED_WEBHOOK: "rw";
  RECEIVED_WHATSAPP: "rwa";
  REPLIED_TO_SMS: "rts";
  STARTED_TRIGGER_IAM_AVAILABILITY_WINDOW: "tia";
  SUBMITTED_IAM_SURVEY: "sis";
  VIEWED_BANNER: "rb";
  VIEWED_CONTENT_CARDS: "vi";
  VIEWED_SLIDE_UP: "sv";
  VIEWED_TRIGGER_IAM: "ti";
  WORKFLOW_STEP_ADVANCEMENT: "wsa";
}
export interface SHARED_CONSTANTS_buttons {
  action_type: null;
  activation_mode_foreground: false | true;
  button_string: "ab_pb_accept" | "ab_pb_cancel" | "ab_pb_confirm" | "ab_pb_decline" | "ab_pb_more" | "ab_pb_no" | "ab_pb_yes";
  default_push_button: true;
  human_readable: "Accept" | "Cancel" | "Confirm" | "Decline" | "More" | "No" | "Yes";
  marked_as_deleted: false;
  text: "Accept" | "Cancel" | "Confirm" | "Decline" | "More" | "No" | "Yes";
  uri: null;
  use_webview: true;
}
export interface SHARED_CONSTANTS_IOS_PUSH_BUTTON_CATEGORY_DEFAULTS {
  buttons: SHARED_CONSTANTS_buttons[];
  category_string: "ab_cat_accept_decline" | "ab_cat_confirm_cancel" | "ab_cat_more" | "ab_cat_yes_no";
  name: "Accept / Decline" | "Confirm / Cancel" | "More" | "Yes / No";
}
export interface SHARED_CONSTANTS_SEARCHABLE_CHANNELS {
  ANDROID_PUSH: "androidPush";
  CONTENT_CARD: "contentCard";
  CONTENT_CARDS: "content_cards";
  CONTROL: "control";
  EMAIL: "email";
  FEATURE_FLAG: "featureFlag";
  FEATURE_FLAG_EXPERIMENT: "featureFlagExperiment";
  IAM: "iam";
  IOS_PUSH: "iosPush";
  KINDLE_PUSH: "kindlePush";
  LINE: "line";
  PUSH: "push";
  SLIDEUP: "slideup";
  SMS: "sms";
  TRIGGER_IAM: "trigger";
  WEBHOOK: "webhook";
  WEB_PUSH: "webPush";
  WHATS_APP: "whatsApp";
}
export interface SHARED_CONSTANTS_SEARCHABLE_ENTRY_SCHEDULES {
  ACTION_BASED: "action-based";
  API_TRIGGERED: "api-triggered";
  ONE_TIME: "one-time";
  RECURRING: "recurring";
}
export interface SHARED_CONSTANTS_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
  DRAFT: "draft";
  DYNAMIC: "dynamic";
  EXPIRED: "expired";
  IDLE: "idle";
  MULTIVARIATE: "multivariate";
  NOT_DRAFT: "not_draft";
  ONE_TIME: "one-time";
  PAUSED: "stopped";
  RECURRING: "recurring";
  TRANSACTIONAL: "transactional";
  TRIGGERED: "triggered";
}
export interface SHARED_CONSTANTS_SEARCH_KEYS {
  ANY_SENDS_AFTER: "any_sends_after";
  ANY_SENDS_BEFORE: "any_sends_before";
  API_ID: "api_id";
  CHANNEL: "channel";
  CREATED: "created";
  CREATED_BY: "created_by";
  CREATED_BY_ME: "created_by_me";
  EDITED: "edited";
  EDITED_BY: "edited_by";
  ENTRY_SCHEDULE: "entry_schedule";
  HAS_LAST_SENT_MESSAGE: "has_last_sent_message";
  MESSAGE_PRIORITIZATION: "message_prioritization";
  NAME: "name";
  OFFERFIT: "offerfit";
  SEGMENT: "segment";
  SENT: "sent";
  STATUS: "status";
  TAG: "tag";
  TERRITORY: "team";
  TYPE: "type";
}
export interface SHARED_CONSTANTS_MANAGEMENT {
  SEARCHABLE_CHANNELS: SHARED_CONSTANTS_SEARCHABLE_CHANNELS;
  SEARCHABLE_ENTRY_SCHEDULES: SHARED_CONSTANTS_SEARCHABLE_ENTRY_SCHEDULES;
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_SUPER_OPTIMIZER_ANALYTICS_KEYS {
  FEATURE: "feature";
  VARIANT_ID: "variant_id";
}
export interface SHARED_CONSTANTS_TIME_BASED_SCHEDULE_TYPE {
  LOCAL: "local_time";
  OPTIMAL: "optimal_time";
  STANDARD: "standard";
}
export interface SHARED_CONSTANTS_UPSERT_ERROR {
  INVALID_FIELDS: "INVALID_FIELDS";
}
export interface SHARED_CONSTANTS_WIZARD_STEP {
  COMPOSE_STEP: 0;
  CONFIRM_STEP: 4;
  CONVERSIONS_STEP: 3;
  SCHEDULE_STEP: 1;
  TARGET_STEP: 2;
}
export interface SHARED_CONSTANTS_CAMPAIGNS {
  ACTION_TRIGGERS: SHARED_CONSTANTS_ACTION_TRIGGERS;
  ALERT_PREFERENCES: SHARED_CONSTANTS_ALERT_PREFERENCES;
  API_CAMPAIGN_MESSAGE_LIMIT: 40;
  COMPOSITION_MODE_TYPE: SHARED_CONSTANTS_COMPOSITION_MODE_TYPE;
  CONVERSION_BEHAVIOR: SHARED_CONSTANTS_CONVERSION_BEHAVIOR;
  DEFAULT_TIME_RATE_LIMIT: 500000;
  EVENTS: SHARED_CONSTANTS_EVENTS;
  FILTERS_BY_NAMESPACE: SHARED_CONSTANTS_FILTERS_BY_NAMESPACE;
  INTELLIGENT_DELIVERY: SHARED_CONSTANTS_INTELLIGENT_DELIVERY;
  INTERACTIONS: SHARED_CONSTANTS_INTERACTIONS;
  IOS_PUSH_BUTTON_CATEGORY_CUSTOM_KEY: "ab_cat_custom";
  IOS_PUSH_BUTTON_CATEGORY_DEFAULTS: SHARED_CONSTANTS_IOS_PUSH_BUTTON_CATEGORY_DEFAULTS[];
  MANAGEMENT: SHARED_CONSTANTS_MANAGEMENT;
  MAX_TIME_RATE_LIMIT: 1000000;
  MULTIVARIATE_CAMPAIGN_MESSAGE_LIMIT: 9;
  NAME_MAX_LENGTH: 256;
  OPEN_RATE_ESTIMATION_DELAY: 129600;
  OPEN_RATE_ESTIMATION_REFRESH_DELAY: 86400;
  SUPER_OPTIMIZER_ANALYTICS_KEYS: SHARED_CONSTANTS_SUPER_OPTIMIZER_ANALYTICS_KEYS;
  TIME_BASED_SCHEDULE_TYPE: SHARED_CONSTANTS_TIME_BASED_SCHEDULE_TYPE;
  TIME_RATE_LIMIT_OPTIONS: (10 | 100 | 1000 | 10000 | 100000 | 1000000 | 25 | 250 | 2500 | 25000 | 250000 | 50 | 500 | 5000 | 50000 | 500000)[];
  UPSERT_ERROR: SHARED_CONSTANTS_UPSERT_ERROR;
  WIZARD_STEP: SHARED_CONSTANTS_WIZARD_STEP;
}
export interface SHARED_CONSTANTS_CAMPAIGN_AB_TEST_TABS {
  AB_RESULT: 0;
  HOLDOUT_SEND: 1;
}
export interface SHARED_CONSTANTS_CAMPAIGN_BRIEF_ERROR_CODES {
  INVALID_BRIEF_FILE: "INVALID_BRIEF_FILE";
  MISSING_BRIEF_FILE: "MISSING_BRIEF_FILE";
}
export interface SHARED_CONSTANTS_CAMPAIGN_BRIEF {
  ERROR_CODES: SHARED_CONSTANTS_CAMPAIGN_BRIEF_ERROR_CODES;
}
export interface SHARED_CONSTANTS_REPORT_TYPES {
  BY_FILTER: 1;
  BY_ID: 0;
}
export interface SHARED_CONSTANTS_CAMPAIGN_COMPARISON_REPORTS {
  MAXIMUM_COMPARABLE_CAMPAIGNS: 250;
  MAX_OFFSET_MONTHS: 12;
  QUERY_BATCH_SIZE: 15;
  REPORT_TYPES: SHARED_CONSTANTS_REPORT_TYPES;
}
export interface SHARED_CONSTANTS_CAMPAIGN_COMPARISON_REPORT_TYPES {
  BY_FILTER: 1;
  BY_ID: 0;
}
export interface SHARED_CONSTANTS_CUSTOM_GROUPINGS {
  CREATED_BY: "created_by";
  LAST_SENT: "last_sent_at";
  LAST_UPDATED_BY: "last_updated_by";
  NEXT_SEND: "next_send";
  TYPE: "get_user_type";
}
export interface SHARED_CONSTANTS_CAMPAIGN_GROUPER {
  CUSTOM_GROUPINGS: SHARED_CONSTANTS_CUSTOM_GROUPINGS;
}
export interface SHARED_CONSTANTS_CAMPAIGN_MESSAGE_TYPES {
  ANDROID_PUSH: "androidPush";
  BANNER: "banner";
  CONTENT_CARD: "contentCard";
  CONTROL: "control";
  EMAIL: "email";
  FEATURE_FLAG: "featureFlag";
  FEATURE_FLAG_EXPERIMENT: "featureFlagExperiment";
  IOS_PUSH: "iosPush";
  KAKAO: "kakao";
  KINDLE_PUSH: "kindlePush";
  LINE: "line";
  PUSH: "push";
  SLIDEUP: "slideup";
  SMS: "sms";
  TRIGGER_IAM: "trigger";
  WEBHOOK: "webhook";
  WEB_PUSH: "webPush";
  WHATS_APP: "whatsApp";
}
export interface SHARED_CONSTANTS_CAMPAIGN_SCHEDULE_TYPES {
  ACTION_BASED: "action_based";
  API_TRIGGERED: "api_triggered";
  JIT: "just_in_time";
  TIME_BASED: "time_based";
}
export interface SHARED_CONSTANTS_CAMPAIGN_STATS_TIMESERIES {
  MESSAGE_TIMESERIES_KEY: "message";
  STAT_TIMESERIES_KEY: "stats";
}
export interface SHARED_CONSTANTS_CAMPAIGN_TYPES {
  API: "api";
  BANNER: "banner";
  CONTENT_CARD: "content_card";
  EMAIL: "email";
  FEATURE_FLAG: "feature_flag";
  FEATURE_FLAG_EXPERIMENT: "feature_flag_experiment";
  KAKAO: "kakao";
  LINE: "line";
  MULTICHANNEL: "multi";
  PUSH: "push";
  SLIDEUP: "slideup";
  SMS: "sms";
  TRANSACTIONAL: "transactional";
  TRIGGER_IAM: "in_app_message";
  WEBHOOK: "webhook";
  WHATS_APP: "whats_app";
}
export interface SHARED_CONSTANTS_EXIT_REASON {
  DEDUPLICATED_ACTION_PATH_EVENT: "dap";
  EXIT_AUDIENCE: "ea";
  EXIT_EVENT: "ee";
  NEXT_STEPS_EXPIRED: "nse";
  PERSONALIZATION_ERROR: "pe";
  REACHED_END_OF_PATH: "ep";
  STEP_DELETED: "sd";
  STEP_ERROR: "se";
  STEP_STOPPED: "ss";
  USER_INELIGIBLE: "ui";
  USER_MISSING_PATH: "ump";
}
export interface SHARED_CONSTANTS_ROOT_CANVAS {
  EXIT_REASON: SHARED_CONSTANTS_EXIT_REASON;
}
export interface SHARED_CONSTANTS_CANVAS_COMPARISON_REPORT_TYPES {
  BY_ID: 0;
}
export interface SHARED_CONSTANTS_CANVAS_CONVERSION_ERRORS {
  BRANCH_DIFFERENT_DELAY: "branch_different_delay";
  BRANCH_HAS_EXCEPTION_EVENT: "branch_has_exception_event";
  BRANCH_MISSING_AUDIENCE: "branch_missing_audience";
  BRANCH_MISSING_SCHEDULE: "branch_missing_schedule";
  CANVAS_ARCHIVED: "canvas_archived";
  CANVAS_NON_DRAFT: "canvas_non_draft";
  EXCEPTION_EVENT_DELAY_IN: "exception_event_with_delay_in_or_on_the_next";
  SUBSEQUENT_STEP_BRANCHING: "subsequent_step_branching";
}
export interface SHARED_CONSTANTS_CANVAS_SCHEDULE_TYPES {
  ACTION_BASED: "action_based";
  API_TRIGGERED: "api_triggered";
  TIME_BASED: "time_based";
}
export interface SHARED_CONSTANTS_ACTION {
  ADD_USERS: "add_users";
  REMOVE_USERS: "remove_users";
}
export interface SHARED_CONSTANTS_IDENTIFIER_GROUP {
  ANDROID_DATA_TYPE: "android_data_type";
  CONTACT_DATA_TYPE: "contact_data_type";
  CONTACT_INFO: "contact_info";
  IOS_DATA_TYPE: "ios_data_type";
}
export interface SHARED_CONSTANTS_INTENT {
  CREATE_NEW: "create_new";
  SYNC_TO_EXISTING: "sync_to_existing";
}
export interface SHARED_CONSTANTS_USER_FIELD {
  ANDROID_MOBILE_ID: "android_gaid";
  CITY: "city";
  COUNTRY: "country";
  DATE_OF_BIRTH: "date_of_birth";
  EMAIL: "email";
  FIRST_NAME: "first_name";
  GENDER: "gender";
  IOS_MOBILE_ID: "ios_idfa";
  LAST_NAME: "last_name";
  MOBILE_ID: "mobile_id";
  PHONE: "phone";
}
export interface SHARED_CONSTANTS_AUDIENCE_SYNC {
  ACTION: SHARED_CONSTANTS_ACTION;
  IDENTIFIER_GROUP: SHARED_CONSTANTS_IDENTIFIER_GROUP;
  INTENT: SHARED_CONSTANTS_INTENT;
  NEW_AUDIENCE_ID: "_new_audience";
  USER_FIELD: SHARED_CONSTANTS_USER_FIELD;
}
export interface SHARED_CONSTANTS_FACEBOOK_AUDIENCE_SYNC {
  MAX_CUSTOM_AUDIENCES_PER_AD_ACCOUNT: 500;
}
export interface SHARED_CONSTANTS_TIKTOK_AUDIENCE_SYNC {
  MAX_CUSTOM_AUDIENCES_PER_AD_ACCOUNT: 400;
}
export interface SHARED_CONSTANTS_USER_UPDATE {
  MAX_UPDATE_BODY_LENGTH: 65536;
}
export interface SHARED_CONSTANTS_CANVAS_STEP_CONSTANTS {
  AUDIENCE_SYNC: SHARED_CONSTANTS_AUDIENCE_SYNC;
  FACEBOOK_AUDIENCE_SYNC: SHARED_CONSTANTS_FACEBOOK_AUDIENCE_SYNC;
  TIKTOK_AUDIENCE_SYNC: SHARED_CONSTANTS_TIKTOK_AUDIENCE_SYNC;
  USER_UPDATE: SHARED_CONSTANTS_USER_UPDATE;
}
export interface SHARED_CONSTANTS_CANVAS_VERSIONS {
  CLASSIC: "classic";
  FLOW: "flow";
}
export interface SHARED_CONSTANTS_CANVAS_WIZARD_STEPS {
  AUDIENCE: 2;
  BASICS: 0;
  BUILD: 4;
  ENTRY_SCHEDULE: 1;
  SEND_SETTINGS: 3;
  SUMMARY: 5;
}
export interface SHARED_CONSTANTS_BANNER_CARD {
  CARD_TYPE: "Banner Card";
  CROP_HEIGHT: 100;
  CROP_WIDTH: 600;
}
export interface SHARED_CONSTANTS_CAPTIONED_IMAGE_CARD {
  CARD_TYPE: "Captioned Image";
  CROP_HEIGHT: 450;
  CROP_WIDTH: 600;
}
export interface SHARED_CONSTANTS_CARDS_CUSTOM_GROUPINGS {
  CREATED_BY: "created_by";
  LAST_UPDATED_BY: "last_updated_by";
}
export interface SHARED_CONSTANTS_CARDS_INTERACTIONS {
  CLICKED_CARD: "cc";
  VIEWED_CARD: "vc";
}
export interface SHARED_CONSTANTS_MANAGEMENT_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
  DRAFT: "draft";
  ENABLED: "enabled";
  EXPIRED: "expired";
  UPCOMING: "upcoming";
}
export interface SHARED_CONSTANTS_MANAGEMENT_SEARCH_KEYS {
  API_ID: "api_id";
  CREATED: "created";
  EDITED: "edited";
  EDITED_BY: "edited_by";
  SEGMENT: "segment";
  STATUS: "status";
  TAG: "tag";
  TERRITORY: "team";
}
export interface SHARED_CONSTANTS_CARDS_MANAGEMENT {
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_MANAGEMENT_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_MANAGEMENT_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_NEWS_ITEM {
  CARD_TYPE: "News Item";
  CROP_LENGTH: 110;
}
export interface SHARED_CONSTANTS_CARDS_WIZARD_STEP {
  COMPOSE_STEP: 0;
  PUBLISH_STEP: 2;
  TARGETING_STEP: 1;
}
export interface SHARED_CONSTANTS_CARDS {
  BANNER_CARD: SHARED_CONSTANTS_BANNER_CARD;
  CAPTIONED_IMAGE_CARD: SHARED_CONSTANTS_CAPTIONED_IMAGE_CARD;
  CATEGORIES: ("Advertising" | "Announcements" | "News" | "Social")[];
  CUSTOM_GROUPINGS: SHARED_CONSTANTS_CARDS_CUSTOM_GROUPINGS;
  DEFAULT_DOMAIN_TEXT: "Open";
  INTERACTIONS: SHARED_CONSTANTS_CARDS_INTERACTIONS;
  MANAGEMENT: SHARED_CONSTANTS_CARDS_MANAGEMENT;
  NEWS_ITEM: SHARED_CONSTANTS_NEWS_ITEM;
  WIZARD_STEP: SHARED_CONSTANTS_CARDS_WIZARD_STEP;
}
export interface SHARED_CONSTANTS_CATALOG_SOURCE {
  BRAZE: "Braze";
  SHOPIFY: "Shopify";
}
export interface SHARED_CONSTANTS_FREE {
  FILE_SIZE: 104857600;
  PLAN: "Free";
}
export interface SHARED_CONSTANTS_PRO {
  FILE_SIZE: 2147483648;
  PLAN: "Pro";
}
export interface SHARED_CONSTANTS_COMPANY_LIMITS {
  FILTERED_SETS_PER_CATALOG: 30;
  FILTERED_SET_FILTERS: 10;
  FREE: SHARED_CONSTANTS_FREE;
  PRO: SHARED_CONSTANTS_PRO;
}
export interface SHARED_CONSTANTS_FIELD_TYPES {
  ARRAY: "array";
  BOOLEAN: "boolean";
  GEO: "geo";
  NUMBER: "number";
  STRING: "string";
  TIME: "time";
}
export interface SHARED_CONSTANTS_OPERATORS_BY_TYPE {
  array: ("does not include value" | "includes value")[];
  boolean: "is"[];
  geo: ("geo outside" | "geo within")[];
  number: ("does not equal" | "equals" | "greater than" | "less than")[];
  string: ("contains" | "does not equal" | "equals" | "is any of" | "is none of")[];
  time: ("after" | "before")[];
}
export interface SHARED_CONSTANTS_FILTERED_SETS {
  DEFAULT_RESULTS_LIMIT: 10;
  MAX_FILTERABLE_VALUE_LENGTH: 1000;
  MAX_MULTI_VALUE_FILTER_VALUES: 10;
  MAX_RESULTS_LIMIT: 50;
  MAX_RESULTS_LIMIT_WITH_HIGHER_CAP: 100;
  MIN_RESULTS_LIMIT: 1;
  OPERATORS_BY_TYPE: SHARED_CONSTANTS_OPERATORS_BY_TYPE;
}
export interface SHARED_CONSTANTS_IMPORT_ERRORS {
  AGENT_FEATURE_DISABLED: "agent-feature-disabled";
  ARBITRARY_ERROR: "arbitrary-error";
  CANNOT_IMPORT_AGENTIC_FIELDS: "cannot-import-agentic-fields";
  CATALOG_NAME_ALREADY_EXISTS: "catalog-name-already-exists";
  COLUMN_NAMES_NOT_UNIQUE: "column-names-not-unique";
  COLUMN_NAMES_TOO_LARGE: "column-names-too-large";
  COMPANY_SIZE_LIMIT_ALREADY_REACHED: "company-size-limit-already-reached";
  COMPANY_SIZE_LIMIT_SURGE: "company-size-limit-surge";
  CSV_PARSING_ERROR: "csv-parsing-error";
  EXCEEDS_MAX_SIZE: "exceeds-max-size";
  FIELDS_DO_NOT_MATCH: "fields-do-not-match";
  FIELD_NAMES_NOT_UNIQUE: "field-names-not-unique";
  FIELD_NAMES_TOO_LARGE: "field-names-too-large";
  FIELD_REFERENCED_BY_AGENT: "field-referenced-by-agent";
  FILTERED_SET_FIELD_TOO_LONG: "filtered-set-field-too-long";
  FILTERED_SET_NAME_IN_USE: "filtered-set-name-in-use";
  IDS_NOT_UNIQUE: "ids-not-unique";
  IDS_TOO_LARGE: "ids-too-large";
  ID_NOT_FIRST_COLUMN: "id-not-first-column";
  INVALID_AGENT_COLUMNS: "invalid-agent-columns";
  INVALID_CATALOG_NAME: "invalid-catalog-name";
  INVALID_COLUMN_NAMES: "invalid-column-names";
  INVALID_ENCODING_ERROR: "invalid-encoding";
  INVALID_FIELD_NAMES: "invalid-field-names";
  INVALID_FIELD_TYPES: "invalid-field-types";
  INVALID_FILTERED_SET_NAME: "invalid-filtered-set-name";
  INVALID_IDS: "invalid-ids";
  INVALID_KEYS_IN_VALUE_OBJECT: "invalid-keys-in-value-object";
  INVALID_MISSING_AGENT: "invalid-missing-agent";
  INVALID_MISSING_RESPONSE_FIELD: "invalid-missing-response-field";
  ITEMS_TOO_LARGE: "items-too-large";
  ITEM_ALREADY_EXISTS: "item-already-exists";
  ROW_HAS_TOO_MANY_COLUMNS: "row-has-too-many-columns";
  TOO_DEEP_NESTING_IN_VALUE_OBJECT: "too-deep-nesting-in-value-object";
  TOO_MANY_COLUMNS: "too-many-columns";
  TOO_MANY_EXISTING_ITEMS_IN_ADD: "too-many-existing-items-in-add";
  TOO_MANY_FIELDS: "too-many-fields";
  TOO_MANY_ITEMS: "too-many-items";
  UNABLE_TO_COERCE_VALUE: "unable-to-coerce-value";
}
export interface SHARED_CONSTANTS_ROOT_CATALOGS {
  CATALOG_SOURCE: SHARED_CONSTANTS_CATALOG_SOURCE;
  COMPANY_LIMITS: SHARED_CONSTANTS_COMPANY_LIMITS;
  FIELD_TYPES: SHARED_CONSTANTS_FIELD_TYPES;
  FILTERED_SETS: SHARED_CONSTANTS_FILTERED_SETS;
  IMPORT_ERRORS: SHARED_CONSTANTS_IMPORT_ERRORS;
  MAX_COLUMNS: 500;
  MAX_COLUMNS_1000: 1000;
  MAX_COLUMN_NAME_LENGTH: 250;
  MAX_SUBSCRIPTIONS: 100000000;
}
export interface SHARED_CONSTANTS_FIELD_NAMES {
  ACTION_TYPE: "Action type";
  ADDITIONAL_FILTERS: "Additional Filters";
  ALERT_OPTIONS: "Alert Options";
  APPROVED_ALL: "All Approved";
  APP_ICON_COLOR_OVERRIDE: "App Icon Color Override";
  ASSOCIATED_IAM: "Associated In-App Message";
  AUDIENCE: "Audience";
  AUDIENCE_APPROVED: "Target Audience - Approved";
  AUDIENCE_DENIED: "Target Audience - Denied";
  AUDIENCE_SUMMARY: "Audience Summary";
  AUTOMATIC_DISMISSAL_DURATION: "Automatic Dismissal Duration (in milliseconds)";
  BACKGROUND_COLOR: "Background Color";
  BANNER_PLACEMENT_ID: "Banner Placement ID";
  BASICS_APPROVED: "Conversion Events - Approved";
  BASICS_DENIED: "Conversion Events - Denied";
  BODY: "Body";
  BODY_TEXT_COLOR: "Body Text Color";
  BUILD_APPROVED: "Build Canvas - Approved";
  BUILD_DENIED: "Build Canvas - Denied";
  CANVAS_TEMPLATE_CLONED_FROM_OTHER_TEMPLATE: "Cloned from Template";
  CANVAS_TEMPLATE_CREATED_FROM_BLANK: "Created";
  CANVAS_TEMPLATE_CREATED_FROM_CANVAS: "Created from Canvas";
  CARD_CREATION: "Card Creation";
  CATEGORIES: "Category";
  CATEGORY_CREATED: "Category Created";
  CATEGORY_DELETED: "Category Deleted";
  CHANNEL_RATE_LIMITS: "Channel Rate Limits";
  CLOSE_BUTTON_COLOR: "Close Button Color";
  COLLAPSE_ID: "Collapse ID";
  COMPOSE_APPROVED: "Compose - Approved";
  COMPOSE_DENIED: "Compose - Denied";
  COMPOSE_STEP: "Message step";
  CONTENT_AVAILABLE_FLAG: "Content-Available Flag";
  CONVERSION: "Conversion";
  CONVERSIONS_APPROVED: "Conversion - Approved";
  CONVERSIONS_DENIED: "Conversion - Denied";
  CONVERSIONS_STEP: "Conversion Events step";
  CONVERSION_EVENTS: "Conversion Events";
  CRITERION: "Criterion";
  CUSTOM_EVENT: "Custom Event";
  DATA_WAREHOUSE_CONNECTION: "Data warehouse connection";
  DATE_RANGE: "Date range";
  DELIVERY_DAY: "Delivery Day";
  DELIVERY_TIME: "Delivery Time";
  DELIVERY_TIME_WITHOUT_ZONE: "Delivery Time Without Zone";
  DELIVERY_TYPE: "Delivery Type";
  DELIVER_IN_DAYS: "Deliver in Days";
  DESCRIPTION: "Description";
  EMAIL_BODY: "Email body";
  EMAIL_CAPTURE_INPUT_PLACEHOLDER: "Email Capture Input Placeholder";
  ENABLE_INLINE_CSS: "Enable inline CSS";
  END_OCCURRENCES: "End After";
  END_TIME: "End Time";
  ENTRY_APPROVED: "Entry Schedule - Approved";
  ENTRY_DENIED: "Entry Schedule - Denied";
  EVALUATE_CAMPAIGN: "Re-evaluate audience membership, liquid, and Campaign status before displaying the message";
  EVALUATE_SEGMENT: "Re-evaluate audience membership and liquid at send-time";
  EXCLUDE_FREQUENCY: "Exclude From Global Frequency Count";
  EXIT_CRITERIA: "Exit Criteria";
  FORCED_ADVANCEMENT: "Forced Advancement";
  FRAME_COLOR: "Close Button Color";
  FREQUENCY: "Frequency";
  FROM_ADDRESS: "From Address";
  FROM_NAME: "From Display Name";
  HEADER_TEXT: "Header Text";
  HEADER_TEXT_COLOR: "Header Text Color";
  IGNORE_GLOBAL_CAPS: "Ignore Global Frequency Capping";
  IGNORE_QUIET_TIME: "Ignore Quiet Time";
  IMAGE: "Image";
  INTELLIGENT_SELECTION: "Intelligent Selection";
  INTERACTION: "Interaction";
  INTERACTION_LOCATION: "Interaction location";
  INTERACTION_TYPE: "Interaction type";
  INTERRUPTION_LEVEL: "Interruption Level";
  INVERSION: "Inversion";
  IOS_BADGE: "App Badge Count";
  IOS_NOTIFICATION_CATEGORY: "iOS Notification Category";
  IP_POOL: "IP Pool";
  IS_ACTIVE: "Is Active";
  IS_ARCHIVED: "Is Archived";
  IS_DRAFT: "Is Draft";
  KEY_VALUE_PAIRS: "Key Value Pairs";
  LARGE_IMAGE: "Large Notification Image";
  LAST_PROCESSED: "Last Processed";
  LOCALES_UPDATED: "Locales Updated";
  LOCAL_TIME: "Deliver in Local Time";
  MAX_RECIPIENTS: "Max Recipients";
  MAX_RECIPIENTS_GLOBAL: "Max Recipients is Global";
  MESSAGE: "Message";
  MESSAGE_CLOSE: "Message Close";
  MESSAGE_TYPE: "Message Type";
  METHOD: "Method";
  MINIMUM_IAM_GENERATION: "Minimum Recipient SDK Generation";
  MUTABLE_CONTENT_FLAG: "Mutable-Content Flag";
  NAME: "Name";
  NOTIFICATION_ID: "Notification ID";
  NOTIFICATION_TYPE: "Notification Type";
  NUMBER_OF_DAYS: "Number of days";
  NUMBER_OF_TIMES: "Number of times";
  ONLY_IPADS: "Send only to iPads";
  ONLY_IPHONES: "Send only to iPhones";
  ONLY_MOST_RECENT_BROWSER: "Send only to user's most recently used browser";
  ONLY_MOST_RECENT_DEVICE: "Send only to user's most recently used device";
  ON_CLICK_ACTIONS: "On Click Behaviors";
  OPERATOR: "Operator";
  OPTIMAL_TIME: "Deliver at Optimal Time";
  OPT_IN: "Opt-in";
  ORIENTATION: "Enforced Device Orientation";
  PINNED: "Pinned";
  POST_LAUNCH_DRAFT_DISCARDED: "Draft Discarded";
  POST_LAUNCH_DRAFT_LAUNCHED: "Draft Launched";
  POST_LAUNCH_DRAFT_SAVED: "Draft Saved";
  POST_LAUNCH_DRAFT_UPDATED: "Draft Updated";
  PREHEADER: "Preheader";
  PRIORITY: "Priority";
  PRIORITY_LEVEL: "Priority Level";
  PRODUCT: "Product";
  PROPERTIES: "Properties";
  PROPERTY_FILTERS: "Property Filters";
  PUSH_ICON_IMAGE: "Push Icon Image";
  QA_AGENT_SECTION_APPROVED: "Standard - Approved";
  QA_AGENT_SECTION_DENIED: "Standard - Denied";
  QUIET_HOURS: "Quiet hours";
  RATE_LIMIT: "Rate Limit";
  RECIPIENT_SUBSCRIPTION_STATE: "Send To";
  RECURRING: "Recurring";
  REDIRECT_TO_URL: "Redirect To URL";
  REFRESH_SCHEDULE: "Refresh Schedule";
  RELEVANCE_SCORE: "Relevance Score";
  REMOVAL_EVENT_SUMMARY: "Removal Events";
  REMOVED_CARDS_FROM_FEEDS: "Removed existing cards from users' feeds";
  REPLY_ADDRESS: "Reply To Address";
  SCHEDULE: "Schedule";
  SCHEDULE_APPROVED: "Schedule - Approved";
  SCHEDULE_DENIED: "Schedule - Denied";
  SCHEDULE_STEP: "Delivery step";
  SDK_AUTH_CHANGED_STATUS: "changed-status";
  SDK_AUTH_KEY_ADDED: "added-public-key";
  SDK_AUTH_KEY_DELETED: "deleted-public-key";
  SDK_AUTH_SET_PRIMARY: "set-primary-key";
  SEGMENT: "Segment";
  SEND_AFTER_QUIET_TIME: "Deliver Message at Next Sending Time";
  SEND_APPROVED: "Send Settings - Approved";
  SEND_DENIED: "Send Settings - Denied";
  SEND_TIME: "Send Time";
  SLIDE_UP_POSITION: "Slide Up Position";
  SOUND: "Sound";
  SQL: "SQL";
  START_TIME: "Start Time";
  STATUS: "Status";
  STEPS: "Steps";
  STEP_TYPE: "Step Type";
  STOPPED_DUE_TO_INACTIVITY: "Stopped due to inactivity";
  SUBJECT: "Subject";
  SUMMARY_TEXT: "Summary Text";
  TAGS: "Tags";
  TARGETED_PLATFORMS: "Targeted Platform(s) to Send To";
  TARGET_APPROVED: "Target - Approved";
  TARGET_DENIED: "Target - Denied";
  TARGET_STEP: "Targeted Population step";
  TERRITORY: "Team";
  TEXT_ALIGNMENT: "Text Alignment";
  TIME_RANGE: "Time range";
  TIME_TO_LIVE: "Time To Live (in seconds)";
  TITLE: "Title";
  TRANSLATIONS_UPDATED: "Translations Updated";
  TRIGGER_DELAY: "Trigger Delay";
  TRIGGER_EVENT_SUMMARY: "Trigger Events";
  URL: "URL";
  USER_REELIGIBILE: "Allow Users to Become Re-eligible";
  USER_REELIGIBLE_TIME: "User Re-eligibility Delay";
  USER_REELIGIBLE_TIME_IS_MAX_DURATION: "User Re-eligibility Delay is Max Duration";
  VARIABLES: "Variables";
  VARIANTS: "Message Variant";
  VARIANT_NAME: "Variant Name";
  VERSION: "Version Created";
  VERSION_DELETED: "Version Deleted";
  VERSION_RENAMED: "Version Renamed";
  VISIBILITY: "Lock Screen Visibility";
  WEB_MESSAGE_CLOSE: "Dismiss Message Automatically";
  WEEKDAYS: "Weekday";
}
export interface SHARED_CONSTANTS_TAGS {
  ALL: "All Changes";
  APPROVAL: "approval";
  AUDIENCE: "audience";
  CANVAS: "canvas";
  CONVERSION: "conversion";
  DESCRIPTION: "description";
  MESSAGE: "message";
  MESSAGE_PRIORITIZATION: "message_prioritization";
  MESSAGE_PRIORITIZATION_CATEGORIES: "message_prioritization_categories";
  NAME: "name";
  POST_LAUNCH_DRAFT: "post_launch_draft";
  QUIET_HOURS: "quiet_hours";
  SCHEDULE: "schedule";
  SDK_AUTH: "sdk_auth";
  STATUS: "status";
  TAGS: "tags";
  TEMPLATE: "template";
  TERRITORY: "teams";
  VERSIONING: "versioning";
}
export interface SHARED_CONSTANTS_CHANGELOG {
  FIELD_NAMES: SHARED_CONSTANTS_FIELD_NAMES;
  NO_NAME: "N/A";
  TAGS: SHARED_CONSTANTS_TAGS;
}
export interface SHARED_CONSTANTS_CHANNELS {
  ANDROID_CHINA_PUSH: "android_china_push";
  ANDROID_PUSH: "android_push";
  BANNER: "banner";
  CONTENT_CARDS: "content_cards";
  CONTROL: "control";
  EMAIL: "email";
  FEATURE_FLAG: "feature_flag";
  FEATURE_FLAG_EXPERIMENT: "feature_flag_experiment";
  IN_APP_MESSAGE: "in_app_message";
  IOS_PUSH: "ios_push";
  KAKAO: "kakao";
  KINDLE_PUSH: "kindle_push";
  LANDING_PAGE: "landing_page";
  LINE: "line";
  RCS: "rcs";
  SMS: "sms";
  TRIGGER_IN_APP_MESSAGE: "trigger_in_app_message";
  WEBHOOK: "webhook";
  WEB_PUSH: "web_push";
  WHATS_APP: "whats_app";
  WINDOWS_UNIVERSAL_PUSH: "windows_universal_push";
}
export interface SHARED_CONSTANTS_COMMENTS {
  MAX_COMMENTS_PER_THREAD: 25;
  MAX_COMMENT_LENGTH: 2048;
  MAX_OPEN_THREADS_PER_TARGET: 25;
  MAX_TAGS_PER_COMMENT: 20;
  MAX_THREADS_PER_TARGET: 50;
}
export interface SHARED_CONSTANTS_ACCENT_COLOR_DEFAULT {
  a: 1;
  b: 0;
  g: 0;
  r: 0;
}
export interface SHARED_CONSTANTS_ANDROID {
  ACCENT_COLOR_DEFAULT: SHARED_CONSTANTS_ACCENT_COLOR_DEFAULT;
  CAROUSEL_TYPE_INLINE_IMAGE: 2;
  CAROUSEL_TYPE_PUSH_STORY: 1;
  CATEGORY_ALARM: "alarm";
  CATEGORY_CALL: "call";
  CATEGORY_EMAIL: "email";
  CATEGORY_ERROR: "err";
  CATEGORY_EVENT: "event";
  CATEGORY_MESSAGE: "msg";
  CATEGORY_NONE: "";
  CATEGORY_PROGRESS: "progress";
  CATEGORY_PROMO: "promo";
  CATEGORY_RECOMMENDATION: "recommendation";
  CATEGORY_REMINDER: "reminder";
  CATEGORY_SERVICE: "service";
  CATEGORY_SOCIAL: "social";
  CATEGORY_STATUS: "status";
  CATEGORY_SYSTEM: "sys";
  CATEGORY_TRANSPORT: "transport";
  PRIORITY_DEFAULT: 0;
  PRIORITY_HIGH: 1;
  PRIORITY_LOW: -1;
  PRIORITY_MAX: 2;
  PRIORITY_MIN: -2;
  VISIBILITY_DEFAULT: 0;
  VISIBILITY_PRIVATE: 0;
  VISIBILITY_PUBLIC: 1;
  VISIBILITY_SECRET: -1;
}
export interface SHARED_CONSTANTS_PAYLOAD {
  APPBOY_CAROUSEL_TYPE_KEY: "ab_c";
  APPBOY_IMAGE_KEY: "appboy_image_url";
  APPBOY_PUSH_ICON_IMAGE_KEY: "ab_li";
  MAX_PAYLOAD_SIZE_FOR_VALIDATION: 3930;
}
export interface SHARED_CONSTANTS_ANDROID_PUSH {
  PAYLOAD: SHARED_CONSTANTS_PAYLOAD;
}
export interface SHARED_CONSTANTS_APPLE_PUSH_PAYLOAD {
  ALERT_ACTION_LOC_KEY: "action-loc-key";
  ALERT_DICTIONARY_VALID_KEYS: ("action-loc-key" | "launch-image" | "loc-args" | "loc-key" | "summary-arg" | "summary-arg-count" | "title-loc-args" | "title-loc-key")[];
  ALERT_LAUNCH_IMAGE: "launch-image";
  ALERT_LOC_ARGS: "loc-args";
  ALERT_LOC_KEY: "loc-key";
  ALERT_SUMMARY_ARG: "summary-arg";
  ALERT_SUMMARY_ARG_COUNT: "summary-arg-count";
  ALERT_TITLE_LOC_ARGS: "title-loc-args";
  ALERT_TITLE_LOC_KEY: "title-loc-key";
  CAROUSEL_TYPE_ALBUM_FLOW: 7;
  IMAGE_ASSET_FILE_TYPES: ("gif" | "jpg" | "png")[];
  MAX_PAYLOAD_SIZE_FOR_VALIDATION: 3960;
  RICH_ASSET_KEY: "att";
  SOUND_ASSET_FILE_TYPES: ("aif" | "m4a" | "mp3" | "wav")[];
  URI_KEY: "ab_uri";
  VALID_ASSET_FILE_TYPES: ("aif" | "gif" | "jpeg" | "jpg" | "m4a" | "mp3" | "mp4" | "png" | "wav")[];
  VIDEO_ASSET_FILE_TYPES: "mp4"[];
}
export interface SHARED_CONSTANTS_APPLE_PUSH {
  PAYLOAD: SHARED_CONSTANTS_APPLE_PUSH_PAYLOAD;
}
export interface SHARED_CONSTANTS_COMMUNICATION_BANNER {
  MAX_DESCRIPTION_LENGTH: 512;
  MAX_ID_LENGTH: 256;
  MAX_NAME_LENGTH: 256;
}
export interface SHARED_CONSTANTS_CAROUSEL_SLIDES {
  STAT_PREFIX: "carousel_slide_";
  STAT_SUFFIX: "_click";
}
export interface SHARED_CONSTANTS_IOS_CAROUSEL_SLIDE {
  VALID_ASSET_FILE_TYPES: ("jpeg" | "jpg" | "png")[];
}
export interface SHARED_CONSTANTS_KINDLE_PUSH_PAYLOAD {
  MAX_PAYLOAD_SIZE_FOR_VALIDATION: 5985;
}
export interface SHARED_CONSTANTS_KINDLE_PUSH {
  PAYLOAD: SHARED_CONSTANTS_KINDLE_PUSH_PAYLOAD;
}
export interface SHARED_CONSTANTS_MESSAGE_VARIATIONS_TYPES {
  ANDROID_PUSH: "android_push";
  BANNER: "banner";
  CONTENT_CARD: "content_card";
  EMAIL: "email";
  FEATURE_FLAG: "feature_flag";
  FEATURE_FLAG_EXPERIMENT: "feature_flag_experiment";
  IOS_PUSH: "apple_push";
  KINDLE_PUSH: "kindle_push";
  LINE: "line";
  SLIDEUP: "slideup";
  SMS: "sms";
  WEBHOOK: "webhook";
  WEB_PUSH: "web_push";
  WHATS_APP: "whats_app";
  WINDOWS_8_PUSH: "windows8_push";
}
export interface SHARED_CONSTANTS_MESSAGE_VARIATIONS {
  TYPES: SHARED_CONSTANTS_MESSAGE_VARIATIONS_TYPES;
}
export interface SHARED_CONSTANTS_PUSH_BUTTONS {
  MAX_NUMBER_BUTTONS_ANDROID: 3;
  MAX_NUMBER_BUTTONS_IOS: 4;
  MAX_NUMBER_BUTTONS_WEB: 2;
}
export interface SHARED_CONSTANTS_PUSH_BUTTONS_HELPER {
  STAT_PREFIX: "notif_button_";
  STAT_SUFFIX: "_click";
}
export interface SHARED_CONSTANTS_PUSH_PROVIDERS {
  AMAZON_MAX_TTL: 2678400;
  BAIDU_MAX_TTL: 604800;
  FIREBASE_MAX_TTL: 2419200;
  HUAWEI_MAX_TTL: 1296000;
  WEB_MAX_TTL: 2419200;
}
export interface SHARED_CONSTANTS_PUSH_PROVIDER_TYPES {
  AMAZON: "amz";
  APNS: "apns";
  BAIDU: "baidu";
  FIREBASE: "fcm";
  HUAWEI: "hms";
  WEB: "web";
  WINDOWS: "win";
}
export interface SHARED_CONSTANTS_IMAGE_STYLE {
  GRAPHIC: "GRAPHIC";
  TOP: "TOP";
}
export interface SHARED_CONSTANTS_MESSAGE_CLOSE {
  AUTO_DISMISS: "AUTO_DISMISS";
  SWIPE: "SWIPE";
}
export interface SHARED_CONSTANTS_OPEN_TARGET {
  BLANK: "BLANK";
  NONE: "NONE";
}
export interface SHARED_CONSTANTS_ORIENTATION {
  LANDSCAPE: "LANDSCAPE";
  PORTRAIT: "PORTRAIT";
}
export interface SHARED_CONSTANTS_SLIDE_FROM {
  BOTTOM: "BOTTOM";
  TOP: "TOP";
}
export interface SHARED_CONSTANTS_TEXT_ALIGNMENT {
  CENTER: "CENTER";
  ENDING: "END";
  START: "START";
}
export interface SHARED_CONSTANTS_SLIDEUP {
  IMAGE_STYLE: SHARED_CONSTANTS_IMAGE_STYLE;
  MESSAGE_CLOSE: SHARED_CONSTANTS_MESSAGE_CLOSE;
  OPEN_TARGET: SHARED_CONSTANTS_OPEN_TARGET;
  ORIENTATION: SHARED_CONSTANTS_ORIENTATION;
  SLIDE_FROM: SHARED_CONSTANTS_SLIDE_FROM;
  TEXT_ALIGNMENT: SHARED_CONSTANTS_TEXT_ALIGNMENT;
  ZIP_FILE_WARNING_SIZE: 307200;
}
export interface SHARED_CONSTANTS_WEB_PUSH_PAYLOAD {
  APPBOY_IMAGE_KEY: "i";
  APPBOY_LARGE_IMAGE_KEY: "img";
  APPBOY_PUSH_BUTTONS_KEY: "pab";
  APPBOY_REQUIRE_INTERACTION_KEY: "ri";
  MAX_PAYLOAD_SIZE_FOR_VALIDATION: 3794;
}
export interface SHARED_CONSTANTS_WEB_PUSH {
  PAYLOAD: SHARED_CONSTANTS_WEB_PUSH_PAYLOAD;
}
export interface SHARED_CONSTANTS_AUDIO {
  ACCEPTED_FORMATS: ("aac" | "amr" | "m4a" | "mp3" | "oga" | "ogg")[];
  MAX_SIZE: 16777216;
  MEDIA_TYPE_KEY: "a";
  MIME_TYPES: ("audio/aac" | "audio/amr" | "audio/mp4" | "audio/mpeg" | "audio/ogg")[];
}
export interface SHARED_CONSTANTS_DOCUMENT {
  ACCEPTED_FORMATS: ("doc" | "docx" | "pdf" | "ppt" | "pptx" | "txt" | "xls" | "xlsx")[];
  MAX_SIZE: 104857600;
  MEDIA_TYPE_KEY: "d";
  MIME_TYPES: ("application/msword" | "application/pdf" | "application/vnd.ms-excel" | "application/vnd.ms-powerpoint" | "application/vnd.openxmlformats-officedocument.presentationml.presentation" | "application/vnd.openxmlformats-officedocument.spresheetml.sheet" | "application/vnd.openxmlformats-officedocument.wordprocessingml.document" | "text/plain")[];
}
export interface SHARED_CONSTANTS_IMAGE {
  ACCEPTED_FORMATS: ("jpeg" | "jpg" | "png")[];
  MAX_SIZE: 5242880;
  MEDIA_TYPE_KEY: "i";
  MIME_TYPES: ("image/jpeg" | "image/png")[];
}
export interface SHARED_CONSTANTS_VIDEO {
  ACCEPTED_FORMATS: ("3gp" | "mp4")[];
  MAX_SIZE: 16777216;
  MEDIA_TYPE_KEY: "v";
  MIME_TYPES: ("video/3gpp" | "video/mp4")[];
}
export interface SHARED_CONSTANTS_MEDIA {
  AUDIO: SHARED_CONSTANTS_AUDIO;
  DOCUMENT: SHARED_CONSTANTS_DOCUMENT;
  IMAGE: SHARED_CONSTANTS_IMAGE;
  VIDEO: SHARED_CONSTANTS_VIDEO;
}
export interface SHARED_CONSTANTS_WHATS_APP {
  ACCEPTED_IMAGE_TYPES: ("image/jpeg" | "image/jpg" | "image/png")[];
  MEDIA: SHARED_CONSTANTS_MEDIA;
}
export interface SHARED_CONSTANTS_WINDOWS_8_PUSH_PAYLOAD {
  MAX_PAYLOAD_SIZE_FOR_VALIDATION: 4096;
  TOAST_KEY: "toast";
}
export interface SHARED_CONSTANTS_WINDOWS_8_PUSH {
  PAYLOAD: SHARED_CONSTANTS_WINDOWS_8_PUSH_PAYLOAD;
}
export interface SHARED_CONSTANTS_COMMUNICATION {
  ANDROID: SHARED_CONSTANTS_ANDROID;
  ANDROID_PUSH: SHARED_CONSTANTS_ANDROID_PUSH;
  APPLE_PUSH: SHARED_CONSTANTS_APPLE_PUSH;
  BANNER: SHARED_CONSTANTS_COMMUNICATION_BANNER;
  CAROUSEL_SLIDES: SHARED_CONSTANTS_CAROUSEL_SLIDES;
  IOS_CAROUSEL_SLIDE: SHARED_CONSTANTS_IOS_CAROUSEL_SLIDE;
  KINDLE_PUSH: SHARED_CONSTANTS_KINDLE_PUSH;
  MESSAGE_VARIATIONS: SHARED_CONSTANTS_MESSAGE_VARIATIONS;
  PUSH_BUTTONS: SHARED_CONSTANTS_PUSH_BUTTONS;
  PUSH_BUTTONS_HELPER: SHARED_CONSTANTS_PUSH_BUTTONS_HELPER;
  PUSH_PROVIDERS: SHARED_CONSTANTS_PUSH_PROVIDERS;
  PUSH_PROVIDER_TYPES: SHARED_CONSTANTS_PUSH_PROVIDER_TYPES;
  SLIDEUP: SHARED_CONSTANTS_SLIDEUP;
  WEB_PUSH: SHARED_CONSTANTS_WEB_PUSH;
  WHATS_APP: SHARED_CONSTANTS_WHATS_APP;
  WINDOWS_8_PUSH: SHARED_CONSTANTS_WINDOWS_8_PUSH;
}
export interface SHARED_CONSTANTS_ACCOUNT_STATUSES {
  ACTIVE: 4;
}
export interface SHARED_CONSTANTS_ESP {
  MAILJET: 2;
  SENDGRID: 0;
  SES: 4;
  SPARKPOST: 3;
}
export interface SHARED_CONSTANTS_0 {
  PERSONALIZATION_IN_HEADERS_KEYS: true;
  SUBUSER_ACCOUNT: true;
}
export interface SHARED_CONSTANTS_3 {
  PERSONALIZATION_IN_HEADERS_KEYS: false;
  SUBUSER_ACCOUNT: false;
}
export interface SHARED_CONSTANTS_4 {
  
}
export interface SHARED_CONSTANTS_ESP_FEATURES {
  "0": SHARED_CONSTANTS_0;
  "3": SHARED_CONSTANTS_3;
  "4": SHARED_CONSTANTS_4;
}
export interface SHARED_CONSTANTS_ESP_NAMES {
  "0": "SendGrid";
  "2": "Mailjet";
  "3": "SparkPost";
  "4": "Amazon SES";
}
export interface SHARED_CONSTANTS_LIMIT_LEVELS {
  FREE_TRIAL_LEVEL: 1000;
  SANDBOX_LEARNING_LEVEL: 1050;
  STANDARD_LEVEL: 2000;
}
export interface SHARED_CONSTANTS_RAW_EVENT_EXCLUSIONS {
  CUSTOM_EVENTS: 0;
  IN_APP_PURCHASES: 1;
  SESSION_END: 3;
  SESSION_START: 2;
}
export interface SHARED_CONSTANTS_COMPANY {
  ACCOUNT_STATUSES: SHARED_CONSTANTS_ACCOUNT_STATUSES;
  CUSTOM_ATTRIBUTES_ENTITLEMENT_HEADROOM: 0.333;
  CUSTOM_EVENTS_ENTITLEMENT_HEADROOM: 0.333;
  DEFAULT_MIN_PASSWORD_LENGTH: "8";
  ESP: SHARED_CONSTANTS_ESP;
  ESP_FEATURES: SHARED_CONSTANTS_ESP_FEATURES;
  ESP_NAMES: SHARED_CONSTANTS_ESP_NAMES;
  LIMIT_LEVELS: SHARED_CONSTANTS_LIMIT_LEVELS;
  MAX_PASSWORD_INTERMEDIATES: 10;
  MIN_PASSWORD_INTERMEDIATES: 1;
  RAW_EVENT_EXCLUSIONS: SHARED_CONSTANTS_RAW_EVENT_EXCLUSIONS;
}
export interface SHARED_CONSTANTS_COMPANY_ACCOUNT_STATUSES {
  active: 4;
  churned: 6;
  suspended: 3;
}
export interface SHARED_CONSTANTS_COMPANY_INDUSTRY {
  EDUCATION: "Education";
  FINANCIAL_SERVICES: "Financial Services";
  GOVERNMENT_NON_PROFIT: "Government & Non-Profit";
  HEALTHCARE_LIFE_SCIENCES: "Healthcare & Life Sciences";
  LOGISTICS_UTILITIES: "Logistics & Utilities";
  MANUFACTURING: "Manufacturing";
  MEDIA_ENTERTAINMENT: "Media & Entertainment";
  PROFESSIONAL_SERVICES: "Professional Services";
  RESTAURANTS_ON_DEMAND: "Restaurants & On-Demand";
  RETAIL_CONSUMER_GOODS: "Retail & Consumer Goods";
  TECHNOLOGY: "Technology";
  TELECOMMUNICATIONS: "Telecommunications";
  TRAVEL_TRANSPORTATION_HOSPITALITY: "Travel, Transportation, & Hospitality";
}
export interface SHARED_CONSTANTS_COMPANY_PROVISIONING_STATUSES {
  not_ready: 1;
  ready: 2;
}
export interface SHARED_CONSTANTS_COMPARATORS {
  ALL: 29;
  CONTAINS_ANY_OF: 27;
  DATE_IN_LESS_THAN_X_TIMEFRAME: 15;
  DATE_IN_MORE_THAN_X_TIMEFRAME: 16;
  DATE_NOT_TODAY: 21;
  DATE_TODAY: 20;
  DOES_NOT_CONTAIN_ANY_OF: 28;
  DOES_NOT_EXIST: 12;
  EQUALS: 1;
  EXISTS: 11;
  GREATER_THAN: 3;
  GREATER_THAN_EQUAL: 4;
  IN: 7;
  IS_ANY_OF: 25;
  IS_NONE_OF: 26;
  LESS_THAN: 5;
  LESS_THAN_EQUAL: 6;
  LOCATION_NOT_WITHIN_CIRCLE: 18;
  LOCATION_NOT_WITHIN_POLYGON: 19;
  LOCATION_WITHIN_CIRCLE: 13;
  LOCATION_WITHIN_POLYGON: 14;
  MATCHES: 10;
  MULTI: 23;
  NOT_ALL: 30;
  NOT_EQUAL: 2;
  NOT_IN: 8;
  NOT_MATCHES: 17;
  NOT_MULTI: 24;
}
export interface SHARED_CONSTANTS_COMPARISON_TYPES {
  array: 4;
  boolean: 3;
  day_of_year: 6;
  multi: 7;
  number: 2;
  string: 1;
  time: 5;
}
export interface SHARED_CONSTANTS_DATE_COMPARATORS {
  in_less_than: 3;
  in_more_than: 4;
  less_than: 1;
  more_than: 2;
}
export interface SHARED_CONSTANTS_DAY_COMPARATORS {
  
}
export interface SHARED_CONSTANTS_COMPARISONS {
  COMPARATORS: SHARED_CONSTANTS_COMPARATORS;
  COMPARISON_TYPES: SHARED_CONSTANTS_COMPARISON_TYPES;
  DATE_COMPARATORS: SHARED_CONSTANTS_DATE_COMPARATORS;
  DAY_COMPARATORS: SHARED_CONSTANTS_DAY_COMPARATORS;
}
export interface SHARED_CONSTANTS_CONSUMPTION_TYPES {
  AGENT_CONSOLE: 11;
  AUDIENCE_SYNC: 4;
  BANNERS: 5;
  CONTENT_CARDS: 7;
  CREDIT_RATIOS: 9;
  EMAIL: 1;
  KAKAO: 12;
  LINE: 10;
  MESSAGE_ARCHIVING: 6;
  SMS: 2;
  WEBHOOKS: 8;
  WHATS_APP: 3;
}
export interface SHARED_CONSTANTS_CONTENT_BLOCK_EDITOR_TYPE {
  BASIC: "basic";
  BEEFREE: "beefree";
  DND: "dnd";
  GRAPESJS: "grapesjs";
}
export interface SHARED_CONSTANTS_DEFAULT_IMAGE_ASPECT_RATIOS {
  banner: 6;
  captioned_image: 4.333;
  classic: 1;
}
export interface SHARED_CONSTANTS_DELIVERY_CONTROL {
  AT_CAMPAIGN_LAUNCH: "time_based";
  JIT: "just_in_time";
}
export interface SHARED_CONSTANTS_EXPIRATION_PRECISION_OPTIONS {
  days: "days";
  hours: "hours";
  minutes: "minutes";
  weeks: "weeks";
}
export interface SHARED_CONSTANTS_CONTENT_CARDS_TYPES {
  banner: "BANNER";
  captioned_image: "CAPTIONED_IMAGE";
  classic: "CLASSIC";
}
export interface SHARED_CONSTANTS_CONTENT_CARDS {
  DEFAULT_DOMAIN_TEXT: "Open";
  DEFAULT_IMAGE_ASPECT_RATIOS: SHARED_CONSTANTS_DEFAULT_IMAGE_ASPECT_RATIOS;
  DELIVERY_CONTROL: SHARED_CONSTANTS_DELIVERY_CONTROL;
  EXPIRATION_PRECISION_OPTIONS: SHARED_CONSTANTS_EXPIRATION_PRECISION_OPTIONS;
  TYPES: SHARED_CONSTANTS_CONTENT_CARDS_TYPES;
  default_max_size: 2048;
  default_max_ttl: 2592000;
  default_ttl: 604800;
}
export interface SHARED_CONSTANTS_CONTENT_FEED {
  TYPE: "Content Feed";
}
export interface SHARED_CONSTANTS_PHASE {
  ACTION_RECOMMENDED: "action_recommended";
  LEARNING: "learning";
  OPTIMIZING: "optimizing";
}
export interface SHARED_CONSTANTS_COMBINATION_TOKEN_SUFFIX_TO_STAT_FIELD {
  converted: "cocst";
  sent: "cs";
}
export interface SHARED_CONSTANTS_STATS {
  COMBINATION_PREFIX: "combination";
  COMBINATION_SEPARATOR: ":";
  COMBINATION_TOKEN_SUFFIX_TO_STAT_FIELD: SHARED_CONSTANTS_COMBINATION_TOKEN_SUFFIX_TO_STAT_FIELD;
}
export interface SHARED_CONSTANTS_CONTENT_OPTIMIZATION {
  MAX_ALLOWED_CO_STEPS_FREE: 1;
  MAX_VARIANTS_ALLOWED: 5;
  MIN_AUDIENCE_FOR_OPTIMIZATION: 30000;
  MIN_LIFETIME_REMAINING: 20000;
  MIN_PER_DISPATCH_VOLUME: 3000;
  MIN_VARIANTS_NEEDED: 2;
  PHASE: SHARED_CONSTANTS_PHASE;
  START_DISPLAYED_VARIANTS: 2;
  STATS: SHARED_CONSTANTS_STATS;
}
export interface SHARED_CONSTANTS_CONTENT_OPTIMIZATION_EXCLUDED_LINK_PREFIXES {
  MAX_COUNT: 20;
  MAX_LENGTH: 512;
}
export interface SHARED_CONSTANTS_CONVERSATIONAL_WORKFLOW_ERROR_CODES {
  CONFLICTING_KNOWLEDGE_SOURCE_TOOL_NAMES: "CONFLICTING_KNOWLEDGE_SOURCE_TOOL_NAMES";
  CONFLICTING_WORKFLOW_ATTRIBUTE_TOOL_NAMES: "CONFLICTING_WORKFLOW_ATTRIBUTE_TOOL_NAMES";
  INVALID_NAME: "INVALID_NAME";
  INVALID_PURPOSE: "INVALID_PURPOSE";
  INVALID_STEPS: "INVALID_STEPS";
  NOT_FOUND: "NOT_FOUND";
}
export interface SHARED_CONSTANTS_CONVERSATIONAL_WORKFLOW {
  ERROR_CODES: SHARED_CONSTANTS_CONVERSATIONAL_WORKFLOW_ERROR_CODES;
  KNOWLEDGE_SOURCE_MARKER_COMMAND: "search_knowledge";
  MARKER_DEFINITION_ID_PATTERN: "[a-f0-9]{24}";
  MAX_INSTRUCTION_LENGTH: 5000;
  MAX_NAME_LENGTH: 250;
  MAX_PURPOSE_LENGTH: 500;
  MAX_STEPS: 10;
  MAX_TOOLS_PER_STEP: 10;
  WORKFLOW_ATTRIBUTE_GETTER_MARKER_COMMAND: "get_workflow_attribute";
  WORKFLOW_ATTRIBUTE_SETTER_MARKER_COMMAND: "set_workflow_attribute";
}
export interface SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION_ERROR_CODES {
  DELETE_IN_USE: "DELETE_IN_USE";
  DUPLICATE_NAME: "DUPLICATE_NAME";
  INVALID_ALLOWED_VALUES: "INVALID_ALLOWED_VALUES";
  INVALID_DATA_TYPE: "INVALID_DATA_TYPE";
  INVALID_DESCRIPTION: "INVALID_DESCRIPTION";
  INVALID_NAME: "INVALID_NAME";
  INVALID_TYPE: "INVALID_TYPE";
}
export interface SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION {
  DATA_TYPES: ("string" | "string_array")[];
  ERROR_CODES: SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION_ERROR_CODES;
  MAX_DESCRIPTION_LENGTH: 500;
  MAX_NAME_LENGTH: 255;
}
export interface SHARED_CONSTANTS_AWS_AUTH_TYPES {
  KEY: 1;
  ROLE: 2;
}
export interface SHARED_CONSTANTS_EVENT_TYPES {
  CONTENTOPTIMIZER_COMPONENTSTORE: "contentoptimizer.ComponentStore";
  CONTENTOPTIMIZER_MODELRUNS: "contentoptimizer.ModelRuns";
  USERS_BEHAVIORS_APP_FIRST_SESSION: "users.behaviors.app.FirstSession";
  USERS_BEHAVIORS_APP_SESSION_END: "users.behaviors.app.SessionEnd";
  USERS_BEHAVIORS_APP_SESSION_START: "users.behaviors.app.SessionStart";
  USERS_BEHAVIORS_CUSTOM_EVENT: "users.behaviors.CustomEvent";
  USERS_BEHAVIORS_GEOFENCE_DATA_EVENT: "users.behaviors.geofence.DataEvent";
  USERS_BEHAVIORS_GEOFENCE_RECORD_EVENT: "users.behaviors.geofence.RecordEvent";
  USERS_BEHAVIORS_INSTALL_ATTRIBUTION: "users.behaviors.InstallAttribution";
  USERS_BEHAVIORS_LOCATION: "users.behaviors.Location";
  USERS_BEHAVIORS_PURCHASE: "users.behaviors.Purchase";
  USERS_BEHAVIORS_SUBSCRIPTIONGROUP_STATE_CHANGE: "users.behaviors.subscriptiongroup.StateChange";
  USERS_BEHAVIORS_SUBSCRIPTION_GLOBAL_STATE_CHANGE: "users.behaviors.subscription.GlobalStateChange";
  USERS_BEHAVIORS_UNINSTALL: "users.behaviors.Uninstall";
  USERS_BEHAVIORS_UPGRADED_APP: "users.behaviors.UpgradedApp";
  USERS_CAMPAIGNS_CONVERSION: "users.campaigns.Conversion";
  USERS_CAMPAIGNS_ENROLL_IN_CONTROL: "users.campaigns.EnrollInControl";
  USERS_CANVAS_CONVERSION: "users.canvas.Conversion";
  USERS_CANVAS_COSTEP_CONVERSION: "users.canvas.costep.Conversion";
  USERS_CANVAS_COSTEP_SEND: "users.canvas.costep.Send";
  USERS_CANVAS_ENTRY: "users.canvas.Entry";
  USERS_CANVAS_EXIT_MATCHED_AUDIENCE: "users.canvas.exit.MatchedAudience";
  USERS_CANVAS_EXIT_PERFORMED_EVENT: "users.canvas.exit.PerformedEvent";
  USERS_CANVAS_EXPERIMENTSTEP_CONVERSION: "users.canvas.experimentstep.Conversion";
  USERS_CANVAS_EXPERIMENTSTEP_SPLIT_ENTRY: "users.canvas.experimentstep.SplitEntry";
  USERS_MESSAGES_CONTENT_CARDS_ABORT: "users.messages.contentcard.Abort";
  USERS_MESSAGES_CONTENT_CARDS_CLICK: "users.messages.contentcard.Click";
  USERS_MESSAGES_CONTENT_CARDS_DISMISS: "users.messages.contentcard.Dismiss";
  USERS_MESSAGES_CONTENT_CARDS_IMPRESSION: "users.messages.contentcard.Impression";
  USERS_MESSAGES_CONTENT_CARDS_SEND: "users.messages.contentcard.Send";
  USERS_MESSAGES_EMAIL_ABORT: "users.messages.email.Abort";
  USERS_MESSAGES_EMAIL_BOUNCE: "users.messages.email.Bounce";
  USERS_MESSAGES_EMAIL_CLICK: "users.messages.email.Click";
  USERS_MESSAGES_EMAIL_DEFERRAL: "users.messages.email.Deferral";
  USERS_MESSAGES_EMAIL_DELIVERY: "users.messages.email.Delivery";
  USERS_MESSAGES_EMAIL_MARK_AS_SPAM: "users.messages.email.MarkAsSpam";
  USERS_MESSAGES_EMAIL_OPEN: "users.messages.email.Open";
  USERS_MESSAGES_EMAIL_RETRY: "users.messages.email.Retry";
  USERS_MESSAGES_EMAIL_SEND: "users.messages.email.Send";
  USERS_MESSAGES_EMAIL_SOFT_BOUNCE: "users.messages.email.SoftBounce";
  USERS_MESSAGES_EMAIL_UNSUBSCRIBE: "users.messages.email.Unsubscribe";
  USERS_MESSAGES_INAPPMESSAGE_ABORT: "users.messages.inappmessage.Abort";
  USERS_MESSAGES_INAPPMESSAGE_CLICK: "users.messages.inappmessage.Click";
  USERS_MESSAGES_INAPPMESSAGE_IMPRESSION: "users.messages.inappmessage.Impression";
  USERS_MESSAGES_LINE_RETRY: "users.messages.line.Retry";
  USERS_MESSAGES_PUSHNOTIFICATION_ABORT: "users.messages.pushnotification.Abort";
  USERS_MESSAGES_PUSHNOTIFICATION_BOUNCE: "users.messages.pushnotification.Bounce";
  USERS_MESSAGES_PUSHNOTIFICATION_IOS_FOREGROUND: "users.messages.pushnotification.IosForeground";
  USERS_MESSAGES_PUSHNOTIFICATION_OPEN: "users.messages.pushnotification.Open";
  USERS_MESSAGES_PUSHNOTIFICATION_RETRY: "users.messages.pushnotification.Retry";
  USERS_MESSAGES_PUSHNOTIFICATION_SEND: "users.messages.pushnotification.Send";
  USERS_MESSAGES_SMS_ABORT: "users.messages.sms.Abort";
  USERS_MESSAGES_SMS_CARRIER_SEND: "users.messages.sms.CarrierSend";
  USERS_MESSAGES_SMS_DELIVERY: "users.messages.sms.Delivery";
  USERS_MESSAGES_SMS_DELIVERY_FAILURE: "users.messages.sms.DeliveryFailure";
  USERS_MESSAGES_SMS_INBOUND_RECEIVE: "users.messages.sms.InboundReceive";
  USERS_MESSAGES_SMS_REJECTION: "users.messages.sms.Rejection";
  USERS_MESSAGES_SMS_RETRY: "users.messages.sms.Retry";
  USERS_MESSAGES_SMS_SEND: "users.messages.sms.Send";
  USERS_MESSAGES_SMS_SHORT_LINK_CLICK: "users.messages.sms.ShortLinkClick";
  USERS_MESSAGES_WEBHOOK_ABORT: "users.messages.webhook.Abort";
  USERS_MESSAGES_WEBHOOK_RETRY: "users.messages.webhook.Retry";
  USERS_MESSAGES_WEBHOOK_SEND: "users.messages.webhook.Send";
  USERS_MESSAGES_WHATSAPP_CLICK: "users.messages.whatsapp.Click";
  USERS_MESSAGES_WHATSAPP_RETRY: "users.messages.whatsapp.Retry";
  USERS_RANDOM_BUCKET_NUMBER_UPDATE: "users.RandomBucketNumberUpdate";
  USERS_USER_ORPHAN: "users.UserOrphan";
}
export interface SHARED_CONSTANTS_INTEGRATION_TYPES {
  ADOBE_EXPORT: "adobe_export";
  AMPLITUDE_EXPORT: "amplitude_export";
  AZURE_BLOB_EXPORT: "azure_blob_export";
  CUSTOM_HTTP_EXPORT: "custom_http_export";
  EVENTBRIDGE_EXPORT: "eventbridge_export";
  GCS_EXPORT: "gcs_export";
  HEAP_EXPORT: "heap_export";
  MIXPANEL_EXPORT: "mixpanel_export";
  M_PARTICLE_EXPORT: "m_particle_export";
  RUDDER_STACK_EXPORT: "rudder_stack_export";
  S3_EXPORT: "s3_export";
  SEGMENT_DOT_COM_EXPORT: "segment_dot_com_export";
  TEALIUM_EXPORT: "tealium_export";
  TREASURE_DATA_EXPORT: "treasure_data_export";
}
export interface SHARED_CONSTANTS_S3_ENCRYPTION_TYPES {
  AES_256: "AES256";
}
export interface SHARED_CONSTANTS_CURRENTS_INTEGRATION {
  AWS_AUTH_TYPES: SHARED_CONSTANTS_AWS_AUTH_TYPES;
  AZURE_BLOB_DEFAULT_FOLDER_PATH: "currents";
  EVENT_TYPES: SHARED_CONSTANTS_EVENT_TYPES;
  GCS_DEFAULT_FOLDER_PATH: "currents";
  INTEGRATION_TYPES: SHARED_CONSTANTS_INTEGRATION_TYPES;
  NEXT_GEN_STATS_CONNECTORS: ("amplitude_export" | "azure_blob_export" | "custom_http_export" | "eventbridge_export" | "gcs_export" | "heap_export" | "m_particle_export" | "mixpanel_export" | "rudder_stack_export" | "s3_export" | "segment_dot_com_export" | "tealium_export" | "treasure_data_export")[];
  S3_DEFAULT_FOLDER_PATH: "currents";
  S3_ENCRYPTION_TYPES: SHARED_CONSTANTS_S3_ENCRYPTION_TYPES;
}
export interface SHARED_CONSTANTS_BLOCKLIST_FILTER {
  ACTIVE: "active";
  ALL: "all";
  BLOCKLISTED: "blocklisted";
  CAN_BE_TRASHED: "can_be_deleted";
  DELETED: "deleted";
}
export interface SHARED_CONSTANTS_CUSTOM_ATTRIBUTES {
  BLOCKLIST_FILTER: SHARED_CONSTANTS_BLOCKLIST_FILTER;
  DEFAULT_MAX_ARRAY_LENGTH: 500;
  MAX_DESCRIPTION_LENGTH: 1000;
}
export interface SHARED_CONSTANTS_CUSTOM_EVENTS_BLOCKLIST_FILTER {
  ACTIVE: "false";
  ALL: "";
  BLOCKLISTED: "true";
  CAN_BE_TRASHED: "can_be_deleted";
  DELETED: "deleted";
}
export interface SHARED_CONSTANTS_CUSTOM_EVENTS {
  BLOCKLIST_FILTER: SHARED_CONSTANTS_CUSTOM_EVENTS_BLOCKLIST_FILTER;
}
export interface SHARED_CONSTANTS_CUSTOM_EVENTS_INTEGRATION {
  INTEGRATION_NOT_FOUND: "INTEGRATION_NOT_FOUND";
}
export interface SHARED_CONSTANTS_CUSTOM_PAGE_STRINGS {
  FOOTER: "FOOTER";
  OPT_IN: "OPT_IN";
  UNSUBSCRIBE: "UNSUBSCRIBE";
}
export interface SHARED_CONSTANTS_DASHBOARD_API_TABLE {
  DEFAULT_LIMIT: 12;
}
export interface SHARED_CONSTANTS_DASHBOARD_TYPE {
  CUSTOM: "custom";
  REPORT_BUILDER: "report_builder";
}
export interface SHARED_CONSTANTS_FRONTEND_ONLY_DASHBOARD_TYPE {
  CONVERSION_PATHS_DASHBOARD: "conversion-paths-dashboard";
  PUSH_CHANNEL_DASHBOARD: "push-channel-dashboard";
}
export interface SHARED_CONSTANTS_DASHBOARD_BUILDER_SEARCH_KEYS {
  DASHBOARD_TYPE: "dashboard_type";
  TAG: "tag";
}
export interface SHARED_CONSTANTS_TEMPLATE_DASHBOARD_TYPE {
  ABANDONED_CART_ANALYTICS: "abandoned-cart-analytics";
  ANONYMIZED_BENCHMARKING: "anonymized-benchmarking";
  DEVICES_AND_CARRIERS: "devices-and-carriers";
  ECOMMERCE_REVENUE_LTA: "ecommerce-revenue-lta";
  REVENUE_LAST_TOUCH_ATTRIBUTION: "revenue-last-touch-attribution";
  SEGMENT_INSIGHTS_EMAIL: "segment-insights-email";
  SEND_OUTCOMES: "send-outcomes";
  SESSION_ANALYTICS: "session-analytics";
}
export interface SHARED_CONSTANTS_DASHBOARD_BUILDER {
  DASHBOARD_TYPE: SHARED_CONSTANTS_DASHBOARD_TYPE;
  FRONTEND_ONLY_DASHBOARD_TYPE: SHARED_CONSTANTS_FRONTEND_ONLY_DASHBOARD_TYPE;
  SEARCH_KEYS: SHARED_CONSTANTS_DASHBOARD_BUILDER_SEARCH_KEYS;
  TEMPLATE_DASHBOARD_TYPE: SHARED_CONSTANTS_TEMPLATE_DASHBOARD_TYPE;
}
export interface SHARED_CONSTANTS_DASHBOARD_ENVIRONMENT_TYPES {
  DEVELOPMENT: "DEVELOPMENT";
  IMPERSONATION_FULL: "IMPERSONATION_FULL";
  IMPERSONATION_READONLY: "IMPERSONATION_READONLY";
  INTERNAL_AU_01: "INTERNAL_AU-01";
  INTERNAL_EU_01: "INTERNAL_EU-01";
  INTERNAL_EU_02: "INTERNAL_EU-02";
  INTERNAL_HIPAA: "INTERNAL_HIPAA";
  INTERNAL_ID_01: "INTERNAL_ID-01";
  INTERNAL_JP_01: "INTERNAL_JP-01";
  INTERNAL_KR_01: "INTERNAL_KR-01";
  INTERNAL_US_01: "INTERNAL_US-01";
  INTERNAL_US_03: "INTERNAL_US-03";
  INTERNAL_US_04: "INTERNAL_US-04";
  INTERNAL_US_05: "INTERNAL_US-05";
  INTERNAL_US_06: "INTERNAL_US-06";
  INTERNAL_US_07: "INTERNAL_US-07";
  INTERNAL_US_08: "INTERNAL_US-08";
  INTERNAL_US_09: "INTERNAL_US-09";
  INTERNAL_US_10: "INTERNAL_US-10";
  LEARNING_SANDBOX: "LEARNING_SANDBOX";
  LOCAL: "LOCAL";
  OTHER: "OTHER";
  PRODUCTION: "PRODUCTION";
  SANDBOX: "SANDBOX";
  STAGING: "STAGING";
}
export interface SHARED_CONSTANTS_DASHBOARD_ENVIRONMENT {
  TYPES: SHARED_CONSTANTS_DASHBOARD_ENVIRONMENT_TYPES;
}
export interface SHARED_CONSTANTS_DATADOG_INTEGRATION_ERRORS {
  INTEGRATION_NOT_FOUND: "INTEGRATION_NOT_FOUND";
}
export interface SHARED_CONSTANTS_CLOUD_DATA_INGESTION_API_KEYS {
  ACCOUNTS: "__CLOUD_DATA_INGESTION_ACCOUNTS_API_KEY__";
  CANVAS: "__CLOUD_DATA_INGESTION_CANVAS_API_KEY__";
  CATALOGS: "__CLOUD_DATA_INGESTION_CATALOGS_API_KEY__";
  DELETES: "__CLOUD_DATA_INGESTION_DELETES_API_KEY__";
  USERS_TRACK: "__CLOUD_DATA_INGESTION_API_KEY__";
}
export interface SHARED_CONSTANTS_KIRBY_ERRORS {
  JOB_ALREADY_RUNNING: "job_already_running";
}
export interface SHARED_CONSTANTS_sync_target_fields {
  api_field: "folder" | "queue_name";
  default_value: null | "";
  form_field: "folder" | "queueName";
  source_field: "folder" | "queue_name";
}
export interface SHARED_CONSTANTS_azure_blob {
  configuration_name: "AzureBlobConfiguration";
  display_name: "Azure Blob";
  name: "azure_blob";
  source_type: "file";
  supported_features: "cdi"[];
  sync_target_fields: SHARED_CONSTANTS_sync_target_fields[];
  sync_type: "reactive";
}
export interface SHARED_CONSTANTS_Sync_target_fields_sync_target_fields {
  api_field: "table_name";
  default_value: null;
  form_field: "table";
  source_field: "table";
}
export interface SHARED_CONSTANTS_bigquery {
  configuration_name: "BigQueryConfiguration";
  display_name: "BigQuery";
  name: "bigquery";
  source_type: "sql";
  supported_features: ("cdi" | "segments")[];
  sync_target_fields: SHARED_CONSTANTS_Sync_target_fields_sync_target_fields[];
  sync_type: "triggered";
}
export interface SHARED_CONSTANTS_Databricks_Sync_target_fields_sync_target_fields {
  api_field: "table_name";
  default_value: null;
  form_field: "table";
  source_field: "table";
}
export interface SHARED_CONSTANTS_databricks {
  configuration_name: "DatabricksConfiguration";
  display_name: "Databricks";
  name: "databricks";
  source_type: "sql";
  supported_features: ("cdi" | "segments")[];
  sync_target_fields: SHARED_CONSTANTS_Databricks_Sync_target_fields_sync_target_fields[];
  sync_type: "triggered";
}
export interface SHARED_CONSTANTS_Fabric_Sync_target_fields_sync_target_fields {
  api_field: "table_name";
  default_value: null;
  form_field: "table";
  source_field: "table";
}
export interface SHARED_CONSTANTS_fabric {
  configuration_name: "FabricConfiguration";
  display_name: "Fabric";
  name: "fabric";
  source_type: "sql";
  supported_features: ("cdi" | "segments")[];
  sync_target_fields: SHARED_CONSTANTS_Fabric_Sync_target_fields_sync_target_fields[];
  sync_type: "triggered";
}
export interface SHARED_CONSTANTS_Gcs_Sync_target_fields_sync_target_fields {
  api_field: "folder" | "pubsub_subscription";
  default_value: null | "";
  form_field: "folder" | "pubsubSubscription";
  source_field: "folder" | "pubsub_subscription";
}
export interface SHARED_CONSTANTS_gcs {
  configuration_name: "GCSConfiguration";
  display_name: "Google Cloud Storage";
  name: "gcs";
  source_type: "file";
  supported_features: "cdi"[];
  sync_target_fields: SHARED_CONSTANTS_Gcs_Sync_target_fields_sync_target_fields[];
  sync_type: "reactive";
}
export interface SHARED_CONSTANTS_Redshift_Sync_target_fields_sync_target_fields {
  api_field: "table_name";
  default_value: null;
  form_field: "table";
  source_field: "table";
}
export interface SHARED_CONSTANTS_redshift {
  configuration_name: "RedshiftConfiguration";
  display_name: "Redshift";
  name: "redshift";
  source_type: "sql";
  supported_features: ("cdi" | "segments")[];
  sync_target_fields: SHARED_CONSTANTS_Redshift_Sync_target_fields_sync_target_fields[];
  sync_type: "triggered";
}
export interface SHARED_CONSTANTS_S3_Sync_target_fields_sync_target_fields {
  api_field: "folder" | "sqs_url";
  default_value: null | "";
  form_field: "folder" | "sqsUrl";
  source_field: "folder" | "sqs_url";
}
export interface SHARED_CONSTANTS_s3 {
  configuration_name: "S3Configuration";
  display_name: "S3";
  name: "s3";
  source_type: "file";
  supported_features: "cdi"[];
  sync_target_fields: SHARED_CONSTANTS_S3_Sync_target_fields_sync_target_fields[];
  sync_type: "reactive";
}
export interface SHARED_CONSTANTS_Snowflake_Sync_target_fields_sync_target_fields {
  api_field: "table_name";
  default_value: null;
  form_field: "table";
  source_field: "table";
}
export interface SHARED_CONSTANTS_snowflake {
  configuration_name: "SnowflakeConfiguration";
  display_name: "Snowflake";
  name: "snowflake";
  source_type: "sql";
  supported_features: ("cdi" | "segments")[];
  sync_target_fields: SHARED_CONSTANTS_Snowflake_Sync_target_fields_sync_target_fields[];
  sync_type: "triggered";
}
export interface SHARED_CONSTANTS_PARTNER_NAME {
  azure_blob: SHARED_CONSTANTS_azure_blob;
  bigquery: SHARED_CONSTANTS_bigquery;
  databricks: SHARED_CONSTANTS_databricks;
  fabric: SHARED_CONSTANTS_fabric;
  gcs: SHARED_CONSTANTS_gcs;
  redshift: SHARED_CONSTANTS_redshift;
  s3: SHARED_CONSTANTS_s3;
  snowflake: SHARED_CONSTANTS_snowflake;
}
export interface SHARED_CONSTANTS_SNOWFLAKE_PROVIDER {
  AWS: ("AP-NORTHEAST-1" | "AP-NORTHEAST-2" | "AP-NORTHEAST-3" | "AP-SOUTH-1" | "AP-SOUTHEAST-1" | "AP-SOUTHEAST-2" | "AP-SOUTHEAST-3" | "CA-CENTRAL-1" | "EU-CENTRAL-1" | "EU-NORTH-1" | "EU-WEST-1" | "EU-WEST-2" | "EU-WEST-3" | "SA-EAST-1" | "US-EAST-1" | "US-EAST-2" | "US-WEST-2")[];
  AZURE: ("AUSTRALIA_EAST" | "CANADACENTRAL" | "CENTRALINDIA" | "CENTRALUS" | "EASTUS2" | "JAPANEAST" | "NORTHEUROPE" | "SOUTHCENTRALUS" | "SOUTHEASTASIA" | "SWITZERLANDNORTH" | "UAENORTH" | "UKSOUTH" | "WESTEUROPE" | "WESTUS2")[];
  GCP: ("EUROPE-WEST2" | "EUROPE-WEST3" | "EUROPE-WEST4" | "US-CENTRAL1" | "US-EAST4")[];
}
export interface SHARED_CONSTANTS_SNOWFLAKE_PROVIDER_HIPAA {
  AWS: ("EU-CENTRAL-1" | "US-EAST-1" | "US-EAST-2")[];
  AZURE: ("EASTUS2" | "WESTUS2")[];
}
export interface SHARED_CONSTANTS_DATALAKE {
  CLOUD_DATA_INGESTION_API_KEYS: SHARED_CONSTANTS_CLOUD_DATA_INGESTION_API_KEYS;
  KIRBY_ERRORS: SHARED_CONSTANTS_KIRBY_ERRORS;
  MAX_BIGQUERY_KEY_FILE_SIZE: 10240;
  PARTNER_NAME: SHARED_CONSTANTS_PARTNER_NAME;
  SNOWFLAKE_PROVIDER: SHARED_CONSTANTS_SNOWFLAKE_PROVIDER;
  SNOWFLAKE_PROVIDER_HIPAA: SHARED_CONSTANTS_SNOWFLAKE_PROVIDER_HIPAA;
}
export interface SHARED_CONSTANTS_APPROVAL_STATUSES {
  APPROVED: "APPROVED";
  ARCHIVED: "ARCHIVED";
  NOT_SUBMITTED: "NOT_SUBMITTED";
  SUBMITTED: "SUBMITTED";
}
export interface SHARED_CONSTANTS_ENDPOINTS {
  DELETE_CATALOG_ITEM: "DELETE_CATALOG_ITEM";
  DELETE_MULTIPLE_CATALOG_ITEMS: "DELETE_MULTIPLE_CATALOG_ITEMS";
  PATCH_CATALOG_ITEM: "PATCH_CATALOG_ITEM";
  PATCH_MULTIPLE_CATALOG_ITEMS: "PATCH_MULTIPLE_CATALOG_ITEMS";
  POST_CAMPAIGNS_TRIGGER_SEND: "POST_CAMPAIGNS_TRIGGER_SEND";
  POST_CANVAS_TRIGGER_SEND: "POST_CANVAS_TRIGGER_SEND";
  POST_MESSAGES_SEND: "POST_MESSAGES_SEND";
  POST_USERS_TRACK: "POST_USERS_TRACK";
  PUT_CATALOG_ITEM: "PUT_CATALOG_ITEM";
  PUT_MULTIPLE_CATALOG_ITEMS: "PUT_MULTIPLE_CATALOG_ITEMS";
}
export interface SHARED_CONSTANTS_EXECUTION_STATUSES {
  FAILURE: "FAILURE";
  SUCCESS: "SUCCESS";
}
export interface SHARED_CONSTANTS_DATA_TRANSFORMATION_SEARCHABLE_STATUSES {
  ACTIVE: "Active";
  ARCHIVED: "Archived";
  INACTIVE: "Inactive";
}
export interface SHARED_CONSTANTS_DATA_TRANSFORMATION_SEARCH_KEYS {
  ENDPOINT: "endpoint";
  STATUS: "status";
}
export interface SHARED_CONSTANTS_VALIDATION_STATES {
  NO_PAYLOAD: "NO_PAYLOAD";
  OTHER_ERROR: "OTHER_ERROR";
  SYNTAX_ERROR: "SYNTAX_ERROR";
  UNKNOWN: "UNKNOWN";
  VALIDATED: "VALIDATED";
}
export interface SHARED_CONSTANTS_DATA_TRANSFORMATION {
  APPROVAL_STATUSES: SHARED_CONSTANTS_APPROVAL_STATUSES;
  ENDPOINTS: SHARED_CONSTANTS_ENDPOINTS;
  EXECUTION_STATUSES: SHARED_CONSTANTS_EXECUTION_STATUSES;
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_DATA_TRANSFORMATION_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_DATA_TRANSFORMATION_SEARCH_KEYS;
  VALIDATION_STATES: SHARED_CONSTANTS_VALIDATION_STATES;
}
export interface SHARED_CONSTANTS_AGENT_WIZARD_STEP_IDS {
  AGENT_DETAILS: "agent-details";
  AUDIENCE: "audience";
  CREATIVES: "creatives";
  CREATIVE_COMPONENTS: "creative-components";
  REVIEW: "review";
  SCHEDULE: "schedule";
}
export interface SHARED_CONSTANTS_AUDIENCE_DISTRIBUTION {
  MAX_DS_DISTRIBUTION_PERCENT: 95;
  MIN_DS_DISTRIBUTION_PERCENT: 50;
}
export interface SHARED_CONSTANTS_CAMPAIGN_LAUNCH_ERROR_CODES {
  PRECONDITION_FAILED: "CAMPAIGN_PRECONDITION_FAILED";
  UNEXPECTED_PUBLISH_FAILURE: "UNEXPECTED_CAMPAIGN_PUBLISH_FAILURE";
  VALIDATION_FAILED: "CAMPAIGN_VALIDATION_FAILED";
}
export interface SHARED_CONSTANTS_CONSTRAINTS {
  ALLOWED_COMPONENTS: ("base_creative" | "body_copy" | "body_header" | "call_to_action" | "image_1" | "image_2" | "subject_line")[];
  ALLOWED_PERIODS: (14 | 30 | 7)[];
}
export interface SHARED_CONSTANTS_COMPONENT_TYPES {
  body_copy: "html";
  body_header: "html";
  call_to_action: "text";
  image_1: "image";
  image_2: "image";
  subject_line: "text";
}
export interface SHARED_CONSTANTS_SLUGS {
  BODY_COPY: "body_copy";
  BODY_HEADER: "body_header";
  CALL_TO_ACTION: "call_to_action";
  IMAGE_1: "image_1";
  IMAGE_2: "image_2";
  SUBJECT_LINE: "subject_line";
}
export interface SHARED_CONSTANTS_CREATIVE_COMPONENTS_TYPES {
  HTML: "html";
  IMAGE: "image";
  TEXT: "text";
}
export interface SHARED_CONSTANTS_CREATIVE_COMPONENTS {
  COMPONENT_TYPES: SHARED_CONSTANTS_COMPONENT_TYPES;
  SLUGS: SHARED_CONSTANTS_SLUGS;
  TYPES: SHARED_CONSTANTS_CREATIVE_COMPONENTS_TYPES;
}
export interface SHARED_CONSTANTS_DECISIONING_STUDIO_ERROR_CODES {
  AGENT_MISSING_FROM_DAG: "AGENT_MISSING_FROM_DAG";
  CAMPAIGN_NOT_FOUND: "CAMPAIGN_NOT_FOUND";
  CONSTRAINT_ALREADY_EXISTS: "CONSTRAINT_ALREADY_EXISTS";
  CONSTRAINT_NOT_FOUND: "CONSTRAINT_NOT_FOUND";
  DECISIONING_STUDIO_AGENT_NOT_FOUND: "DECISIONING_STUDIO_AGENT_NOT_FOUND";
  DECISIONING_STUDIO_NOT_ENABLED: "DECISIONING_STUDIO_NOT_ENABLED";
  DECISIONING_STUDIO_PRIMARY_KPI_NOT_FOUND: "DECISIONING_STUDIO_PRIMARY_KPI_NOT_FOUND";
  DECISIONING_STUDIO_USECASE_NOT_FOUND: "DECISIONING_STUDIO_USECASE_NOT_FOUND";
  DIMENSION_REQUIRED: "DIMENSION_REQUIRED";
  FAILED_TO_CREATE_CAMPAIGN: "FAILED_TO_CREATE_CAMPAIGN";
  FAILED_TO_CREATE_CONSTRAINT: "FAILED_TO_CREATE_CONSTRAINT";
  FAILED_TO_CREATE_VARIANT: "FAILED_TO_CREATE_VARIANT";
  FAILED_TO_DELETE_CAMPAIGN: "FAILED_TO_DELETE_CAMPAIGN";
  FAILED_TO_DELETE_CONSTRAINT: "FAILED_TO_DELETE_CONSTRAINT";
  FAILED_TO_DELETE_VARIANT: "FAILED_TO_DELETE_VARIANT";
  FAILED_TO_GET_AGENT_DETAILS: "FAILED_TO_GET_AGENT_DETAILS";
  FAILED_TO_GET_AGENT_STATUS: "FAILED_TO_GET_AGENT_STATUS";
  FAILED_TO_GET_AUDIENCE_DISTRIBUTION: "FAILED_TO_GET_AUDIENCE_DISTRIBUTION";
  FAILED_TO_GET_AUDIENCE_SEGMENTS: "FAILED_TO_GET_AUDIENCE_SEGMENTS";
  FAILED_TO_GET_SCHEDULE: "FAILED_TO_GET_SCHEDULE";
  FAILED_TO_INITIALIZE_OFFERFIT_CUSTOMER: "FAILED_TO_INITIALIZE_OFFERFIT_CUSTOMER";
  FAILED_TO_LAUNCH_AGENT: "FAILED_TO_LAUNCH_AGENT";
  FAILED_TO_POPULATE_BRAZE_INGESTION_CONFIG: "FAILED_TO_POPULATE_BRAZE_INGESTION_CONFIG";
  FAILED_TO_PREPARE_CAMPAIGNS: "FAILED_TO_PREPARE_CAMPAIGNS";
  FAILED_TO_PROMOTE_AGENT: "FAILED_TO_PROMOTE_AGENT";
  FAILED_TO_PUBLISH_CAMPAIGNS: "FAILED_TO_PUBLISH_CAMPAIGNS";
  FAILED_TO_RESUME_AGENT: "FAILED_TO_RESUME_AGENT";
  FAILED_TO_RETRIEVE_ACTION_BANK: "FAILED_TO_RETRIEVE_ACTION_BANK";
  FAILED_TO_RETRIEVE_ACTION_BANK_DIMENSIONS: "FAILED_TO_RETRIEVE_ACTION_BANK_DIMENSIONS";
  FAILED_TO_RETRIEVE_CONSTRAINT: "FAILED_TO_RETRIEVE_CONSTRAINT";
  FAILED_TO_RETRIEVE_DIMENSION_ACTIONS: "FAILED_TO_RETRIEVE_DIMENSION_ACTIONS";
  FAILED_TO_RETRIEVE_PERFORMANCE_REPORT_DATA: "FAILED_TO_RETRIEVE_PERFORMANCE_REPORT_DATA";
  FAILED_TO_RETRIEVE_PRIMARY_KPI: "FAILED_TO_RETRIEVE_PRIMARY_KPI";
  FAILED_TO_RETRIEVE_TIMING_DATA: "FAILED_TO_RETRIEVE_TIMING_DATA";
  FAILED_TO_RETRIEVE_VARIANTS: "FAILED_TO_RETRIEVE_VARIANTS";
  FAILED_TO_STOP_AGENT: "FAILED_TO_STOP_AGENT";
  FAILED_TO_SYNC_SEGMENT_EXPORTS: "FAILED_TO_SYNC_SEGMENT_EXPORTS";
  FAILED_TO_UPDATE_AGENT_DETAILS: "FAILED_TO_UPDATE_AGENT_DETAILS";
  FAILED_TO_UPDATE_AUDIENCE_DISTRIBUTION: "FAILED_TO_UPDATE_AUDIENCE_DISTRIBUTION";
  FAILED_TO_UPDATE_AUDIENCE_SEGMENTS: "FAILED_TO_UPDATE_AUDIENCE_SEGMENTS";
  FAILED_TO_UPDATE_CAMPAIGN: "FAILED_TO_UPDATE_CAMPAIGN";
  FAILED_TO_UPDATE_CONSTRAINT: "FAILED_TO_UPDATE_CONSTRAINT";
  FAILED_TO_UPDATE_QUIET_HOURS: "FAILED_TO_UPDATE_QUIET_HOURS";
  FAILED_TO_UPDATE_SCHEDULE: "FAILED_TO_UPDATE_SCHEDULE";
  FAILED_TO_UPDATE_VARIANT: "FAILED_TO_UPDATE_VARIANT";
  FAILED_TO_VALIDATE_CAMPAIGNS: "FAILED_TO_VALIDATE_CAMPAIGNS";
  INCOMPATIBLE_BASE_CREATIVE: "INCOMPATIBLE_BASE_CREATIVE";
  INVALID_CONSTRAINT_PARAMS: "INVALID_CONSTRAINT_PARAMS";
  INVALID_CREATIVE_COMPONENT: "INVALID_CREATIVE_COMPONENT";
  INVALID_CREATIVE_VARIANT_PARAMS: "INVALID_CREATIVE_VARIANT_PARAMS";
  INVALID_VARIANT_PARAMS: "INVALID_VARIANT_PARAMS";
  LAUNCH_INCOMPLETE: "LAUNCH_INCOMPLETE";
  MESSAGE_VARIATION_NOT_FOUND: "MESSAGE_VARIATION_NOT_FOUND";
  MISSING_REQUIRED_PARAMETERS: "MISSING_REQUIRED_PARAMETERS";
  WORKFLOW_STEP_NOT_FOUND: "WORKFLOW_STEP_NOT_FOUND";
}
export interface SHARED_CONSTANTS_DECISIONING_STUDIO {
  AGENT_WIZARD_STEP_IDS: SHARED_CONSTANTS_AGENT_WIZARD_STEP_IDS;
  AUDIENCE_DISTRIBUTION: SHARED_CONSTANTS_AUDIENCE_DISTRIBUTION;
  CAMPAIGN_LAUNCH_ERROR_CODES: SHARED_CONSTANTS_CAMPAIGN_LAUNCH_ERROR_CODES;
  CONSTRAINTS: SHARED_CONSTANTS_CONSTRAINTS;
  CREATIVE_COMPONENTS: SHARED_CONSTANTS_CREATIVE_COMPONENTS;
  ERROR_CODES: SHARED_CONSTANTS_DECISIONING_STUDIO_ERROR_CODES;
}
export interface SHARED_CONSTANTS_DEDUPLICATE_CLASS_NAMES {
  Array: "Array";
  BigDecimal: "Fixnum";
  FalseClass: "TrueClass";
  Fixnum: "Fixnum";
  Float: "Fixnum";
  Hash: "Hash";
  Integer: "Fixnum";
  "Mongoid::Boolean": "TrueClass";
  NilClass: "NilClass";
  ObjectArray: "ObjectArray";
  String: "String";
  Time: "Time";
  TrueClass: "TrueClass";
}
export interface SHARED_CONSTANTS_DEPARTMENTS {
  agency: "Agency / Third Party";
  bi: "BI / Analytics";
  "c-suite": "C-Suite";
  engineering: "Engineering";
  finance: "Finance";
  marketing: "Marketing / Editorial";
  pm: "Product Management";
}
export interface SHARED_CONSTANTS_DEPARTMENT_ROLE_MAP {
  agency: "Agency / Third Party";
  bi: "BI / Analytics";
  "c-suite": "C-Suite";
  engineering: "Engineering";
  finance: "Finance";
  marketing: "Marketing / Editorial";
  pm: "Product Management";
}
export interface SHARED_CONSTANTS_DEVELOPER {
  CROP_LENGTH: 60;
  DEPARTMENT_ROLE_MAP: SHARED_CONSTANTS_DEPARTMENT_ROLE_MAP;
  MAX_NAME_LENGTH: 250;
}
export interface SHARED_CONSTANTS_DISPLAY_NAME_BY_CHANNEL {
  ANDROID_PUSH: "Android Push";
  BANNER: "Banner";
  CONTENT_CARD: "Content Cards";
  CONTROL: "Control";
  EMAIL: "Email";
  FEATURE_FLAG: "Feature Flags";
  FEATURE_FLAG_EXPERIMENT: "Feature Flag Experiments";
  IOS_PUSH: "iOS Push";
  KAKAO: "KakaoTalk";
  KINDLE_PUSH: "Kindle Push";
  LINE: "LINE";
  MMS: "MMS";
  PUSH: "Push";
  SLIDEUP: "Original In-App Message";
  SMS: "SMS/RCS";
  SMS_MMS: "SMS/MMS/RCS";
  SMS_MMS_WITH_SPACE: "SMS / MMS";
  TRIGGER_IAM: "In-App Message";
  WEBHOOK: "Webhook";
  WEB_PUSH: "Web Push";
  WHATS_APP: "WhatsApp";
}
export interface SHARED_CONSTANTS_DISPLAY_NAME_BY_CONSUMPTION_TYPE {
  AGENT_CONSOLE: "Agent Console";
  AUDIENCE_SYNC: "Audience Sync";
  BANNERS: "Banners";
  CONTENT_CARDS: "Content Cards";
  EMAIL: "Email";
  KAKAO: "Kakao Talk";
  MESSAGE_ARCHIVING: "Message Archiving";
  SMS_MMS_WITH_SPACE: "SMS / MMS";
  WEBHOOKS: "Webhooks";
  WHATS_APP: "WhatsApp";
}
export interface SHARED_CONSTANTS_CONTEXT_TYPES {
  BANNER: "banner";
  LINE: "line";
}
export interface SHARED_CONSTANTS_DND_EDITOR {
  CONTEXT_TYPES: SHARED_CONSTANTS_CONTEXT_TYPES;
}
export interface SHARED_CONSTANTS_DOMAIN {
  MAX_DOMAIN_LENGTH: 253;
}
export interface SHARED_CONSTANTS_ECOMMERCE_ERROR_CODES {
  INVALID_ECOMMERCE_RECOMMENDED_EVENT: "invalid_ecommerce_recommended_event";
  MISSING_ECOMMERCE_EVENT_NAME: "missing_ecommerce_event_name";
}
export interface SHARED_CONSTANTS_ECOMMERCE_EVENT_NAMES {
  CART_UPDATED: "ecommerce.cart_updated";
  CHECKOUT_STARTED: "ecommerce.checkout_started";
  ORDER_CANCELLED: "ecommerce.order_cancelled";
  ORDER_PLACED: "ecommerce.order_placed";
  ORDER_REFUNDED: "ecommerce.order_refunded";
  PRODUCT_VIEWED: "ecommerce.product_viewed";
}
export interface SHARED_CONSTANTS_ROOT_ECOMMERCE {
  ERROR_CODES: SHARED_CONSTANTS_ECOMMERCE_ERROR_CODES;
  EVENT_NAMES: SHARED_CONSTANTS_ECOMMERCE_EVENT_NAMES;
}
export interface SHARED_CONSTANTS_EMAIL {
  "# 40 kb": null;
  "# 400 kb": null;
  "# Date.new(2017, 7, 19).at_midnight": null;
  "# Old bare Liquid objects rejected by the email composer / launch validator": null;
  AMP_BODY_MAX_SIZE: 409600;
  AMP_BODY_WARN_SIZE: 204800;
  BODY_MAX_SIZE: 409600;
  BODY_MAX_SIZE_CHECK_START_DATE: 1500422400;
  BODY_WARN_SIZE: 104448;
  DEPRECATED_BARE_LIQUID_OBJECTS: ("{{email_address}}" | "{{resubscribe_url}}" | "{{subscription_confirmation_url}}" | "{{unsubscribe_url}}" | "{{user_id}}")[];
  NO_REPLY_TO: "NO_REPLY_TO";
  PLAINTEXT_BODY_MAX_SIZE: 40960;
}
export interface SHARED_CONSTANTS_EMAIL_EDITOR_EDIT_PANELS {
  ADVANCED_SENDING_SETTINGS: 3;
  BODY: 0;
  PREVIEW_AND_TEST: 2;
  SENDING_INFO: 1;
}
export interface SHARED_CONSTANTS_EMAIL_EDITOR_PREVIEW_TYPES {
  AMP: 5;
  DESKTOP: 0;
  INBOX_VISION: 3;
  MOBILE: 1;
  PLAINTEXT: 2;
  SPAM_TEST: 4;
}
export interface SHARED_CONSTANTS_EMAIL_GLOBAL_STYLE_SETTINGS {
  INVALID_SETTINGS_ERROR: "Failed strict GlobalStyleSettings validation with errors";
}
export interface SHARED_CONSTANTS_CAMPAIGN_STATUS {
  PENDING: "pending";
  SCHEDULED: "scheduled";
  VOLUME_REACHED: "volume_reached";
}
export interface SHARED_CONSTANTS_EMAIL_IP_WARMING_ERRORS {
  AI_DATA_USAGE_OPTED_OUT: "AI_DATA_USAGE_OPTED_OUT";
  DUPLICATE_PLAN_NAME: "DUPLICATE_PLAN_NAME";
  ENGAGEMENT_DATA_FILE_INVALID: "ENGAGEMENT_DATA_FILE_INVALID";
  ENGAGEMENT_DATA_FILE_MISSING: "ENGAGEMENT_DATA_FILE_MISSING";
  ENGAGEMENT_DATA_FILE_TOO_LARGE: "ENGAGEMENT_DATA_FILE_TOO_LARGE";
  INITIAL_AND_TARGET_VOLUME_MUST_BE_NON_NEGATIVE: "INITIAL_AND_TARGET_VOLUME_MUST_BE_NON_NEGATIVE";
  INITIAL_AND_TARGET_VOLUME_MUST_BE_NUMERIC: "INITIAL_AND_TARGET_VOLUME_MUST_BE_NUMERIC";
  INVALID_ARGUMENT: "INVALID_ARGUMENT";
  PLAN_NAME_REQUIRED: "PLAN_NAME_REQUIRED";
  START_DATE_INVALID: "START_DATE_INVALID";
  START_DATE_REQUIRED: "START_DATE_REQUIRED";
  START_TIME_REQUIRED: "START_TIME_REQUIRED";
}
export interface SHARED_CONSTANTS_ITP_RUN_STATUSES {
  FAILED: "failed";
  IN_PROGRESS: "in_progress";
  PENDING: "pending";
  SUCCEEDED: "succeeded";
}
export interface SHARED_CONSTANTS_RANKS_WRITTEN_STATUSES {
  FAILED: "failed";
  IN_PROGRESS: "in_progress";
  PENDING: "pending";
  SUCCEEDED: "succeeded";
}
export interface SHARED_CONSTANTS_STATUS {
  ACTIVE: "active";
  ARCHIVED: "archived";
  COMPLETED: "completed";
  DRAFT: "draft";
  PAUSED: "paused";
  STOPPED: "stopped";
}
export interface SHARED_CONSTANTS_TARGETING_METHODS {
  INTELLIGENT: "intelligent";
  MANUAL: "manual";
}
export interface SHARED_CONSTANTS_UPLOAD_IDENTIFIER_TYPES {
  EMAIL: "email";
  EXTERNAL_ID: "external_id";
}
export interface SHARED_CONSTANTS_EMAIL_IP_WARMING {
  CAMPAIGN_STATUS: SHARED_CONSTANTS_CAMPAIGN_STATUS;
  ERRORS: SHARED_CONSTANTS_EMAIL_IP_WARMING_ERRORS;
  ITP_RUN_STATUSES: SHARED_CONSTANTS_ITP_RUN_STATUSES;
  MAX_ENGAGEMENT_DATA_UPLOAD_SIZE_BYTES: 524288000;
  NAME_MAX_LENGTH: 256;
  RANKS_WRITTEN_STATUSES: SHARED_CONSTANTS_RANKS_WRITTEN_STATUSES;
  STATUS: SHARED_CONSTANTS_STATUS;
  TARGETING_METHODS: SHARED_CONSTANTS_TARGETING_METHODS;
  UPLOAD_IDENTIFIER_TYPES: SHARED_CONSTANTS_UPLOAD_IDENTIFIER_TYPES;
}
export interface SHARED_CONSTANTS_apple {
  domain_exact_matches: ("icloud.com" | "mac.com" | "me.com")[];
  domain_prefixes: never[];
  name: "Apple iCloud";
}
export interface SHARED_CONSTANTS_att {
  domain_exact_matches: ("att.net" | "bellsouth.net" | "sbcglobal.net")[];
  domain_prefixes: never[];
  name: "AT&T";
}
export interface SHARED_CONSTANTS_cloudmark {
  domain_exact_matches: ("cox.net" | "mchsi.com" | "shaw.ca")[];
  domain_prefixes: never[];
  name: "Cloudmark";
}
export interface SHARED_CONSTANTS_EMAIL_MAILBOX_PROVIDERS_google {
  domain_exact_matches: ("gmail.com" | "google.com" | "googlemail.com")[];
  domain_prefixes: never[];
  name: "Google";
}
export interface SHARED_CONSTANTS_microsoft {
  domain_exact_matches: never[];
  domain_prefixes: ("hotmail." | "live." | "msn." | "outlook.")[];
  name: "Microsoft";
}
export interface SHARED_CONSTANTS_united_internet {
  domain_exact_matches: ("gmx.com" | "gmx.de" | "gmx.net" | "mail.com" | "web.de")[];
  domain_prefixes: never[];
  name: "United Internet";
}
export interface SHARED_CONSTANTS_united_online {
  domain_exact_matches: ("juno.com" | "netzero.com" | "netzero.net")[];
  domain_prefixes: never[];
  name: "United Online";
}
export interface SHARED_CONSTANTS_vade_secure {
  domain_exact_matches: ("earthlink.net" | "mindspring.com")[];
  domain_prefixes: never[];
  name: "Vade Secure";
}
export interface SHARED_CONSTANTS_yahoo {
  domain_exact_matches: "verizon.net"[];
  domain_prefixes: ("aol." | "yahoo." | "ymail.")[];
  name: "Yahoo";
}
export interface SHARED_CONSTANTS_EMAIL_MAILBOX_PROVIDERS {
  apple: SHARED_CONSTANTS_apple;
  att: SHARED_CONSTANTS_att;
  cloudmark: SHARED_CONSTANTS_cloudmark;
  google: SHARED_CONSTANTS_EMAIL_MAILBOX_PROVIDERS_google;
  microsoft: SHARED_CONSTANTS_microsoft;
  united_internet: SHARED_CONSTANTS_united_internet;
  united_online: SHARED_CONSTANTS_united_online;
  vade_secure: SHARED_CONSTANTS_vade_secure;
  yahoo: SHARED_CONSTANTS_yahoo;
}
export interface SHARED_CONSTANTS_EMAIL_MESSAGE_STATS {
  CLICK_STATS_MAX_URLS_LIMIT: 100;
}
export interface SHARED_CONSTANTS_EMAIL_MESSAGE {
  STATS: SHARED_CONSTANTS_EMAIL_MESSAGE_STATS;
}
export interface SHARED_CONSTANTS_DOMAIN_STATUS {
  FAILED: "FAILED";
  PENDING: "PENDING";
  SUCCESS: "SUCCESS";
}
export interface SHARED_CONSTANTS_EMAIL_SELF_SERVE_ERRORS {
  DOMAIN_CREATION_IN_PROGRESS: "DOMAIN_CREATION_IN_PROGRESS";
  INTERNAL_ERROR: "INTERNAL_ERROR";
  INVALID_ARGUMENT: "INVALID_REQUEST";
  MULTIPLE_SES_ACCOUNTS: "MULTIPLE_SES_ACCOUNTS";
  NO_SES_ACCOUNT: "NO_SES_ACCOUNT";
  SENDING_DOMAIN_CLEANUP_FAILED: "SENDING_DOMAIN_CLEANUP_FAILED";
  SENDING_DOMAIN_IN_USE: "SENDING_DOMAIN_IN_USE";
  SES_PROVISION_FAILED: "SES_PROVISION_FAILED";
  TENANT_VALIDATION_FAILED: "TENANT_VALIDATION_FAILED";
  TRACKING_DOMAIN_CLEANUP_FAILED: "TRACKING_DOMAIN_CLEANUP_FAILED";
}
export interface SHARED_CONSTANTS_PREREQUISITE_STATUS {
  ADD_DELEGATED_DOMAIN: "ADD_DELEGATED_DOMAIN";
  ADD_IP_ADDRESSES: "ADD_IP_ADDRESSES";
  ADD_IP_POOL: "ADD_IP_POOL";
  COMPLETED: "COMPLETED";
}
export interface SHARED_CONSTANTS_EMAIL_SELF_SERVE {
  DOMAIN_STATUS: SHARED_CONSTANTS_DOMAIN_STATUS;
  ERRORS: SHARED_CONSTANTS_EMAIL_SELF_SERVE_ERRORS;
  PREREQUISITE_STATUS: SHARED_CONSTANTS_PREREQUISITE_STATUS;
}
export interface SHARED_CONSTANTS_TEMPLATABLE_AD_ID_VALUES {
  gaid: "google_ad_id";
  raid: "roku_ad_id";
  waid: "windows_ad_id";
}
export interface SHARED_CONSTANTS_TEMPLATABLE_VALUES {
  ad_id_type: "ad_id_type";
  ad_tracking_enabled: "ad_tracking_enabled";
  browser: "browser";
  carrier: "carrier";
  foreground_push_enabled: "foreground_push_enabled";
  id: "id";
  idfa: "idfa";
  idfv: "idfv";
  model: "model";
  operating_system: "os";
  platform: "platform";
}
export interface SHARED_CONSTANTS_EMBEDDED_DEVICE {
  TEMPLATABLE_AD_ID_VALUES: SHARED_CONSTANTS_TEMPLATABLE_AD_ID_VALUES;
  TEMPLATABLE_VALUES: SHARED_CONSTANTS_TEMPLATABLE_VALUES;
  ___COMMENT___: "Please keep TEMPLATABLE_VALUES in sync with EmbeddedDevice::TEMPLATABLE_PROJECTION_KEYS in ruby";
}
export interface SHARED_CONSTANTS_CAMPAIGN_STAT_KEYS {
  ADDITIONAL_CONVERSIONS: "additional_conversions";
  ADDITIONAL_CONVERSIONS_BY_ENTRY_TIME: "additional_conversions_by_entry_time";
  ADDITIONAL_CONVERSIONS_BY_ENTRY_TIME_PERCENTAGE: "additional_conversions_by_entry_time_percentage";
  ADDITIONAL_CONVERSIONS_BY_SEND_TIME: "additional_conversions_by_send_time";
  ADDITIONAL_CONVERSIONS_BY_SEND_TIME_PERCENTAGE: "additional_conversions_by_send_time_percentage";
  ADDITIONAL_CONVERSIONS_PERCENTAGE: "additional_conversions_percentage";
  BODY_CLICKS: "body_clicks";
  BODY_CLICK_PERCENTAGE: "body_click_percentage";
  BOUNCES: "bounces";
  BOUNCE_PERCENTAGE: "bounce_percentage";
  BUTTON_1_CLICKS: "first_button_clicks";
  BUTTON_1_CLICK_PERCENTAGE: "first_button_click_percentage";
  BUTTON_2_CLICKS: "second_button_clicks";
  BUTTON_2_CLICK_PERCENTAGE: "second_button_click_percentage";
  CLICKED_SHORTENED_SMS_LINK: "clicked_shortened_sms_link";
  CLICKED_SHORTENED_SMS_LINK_PERCENTAGE: "clicked_shortened_sms_link_percentage";
  CLICKS: "clicks";
  CLICK_PERCENTAGE: "click_percentage";
  CLICK_TO_OPEN_RATE: "click_to_open_rate";
  CONFIRMED_DELIVERIES: "confirmed_deliveries";
  CONFIRMED_DELIVERY_PERCENTAGE: "confirmed_delivery_percentage";
  CONVERSIONS: "primary_conversion_a";
  CONVERSIONS1: "conversion_b";
  CONVERSIONS1_BY_SEND_TIME: "conversion_b_by_send_time";
  CONVERSIONS1_BY_SEND_TIME_PERCENTAGE: "conversion_b_by_send_time_percentage";
  CONVERSIONS1_PERCENTAGE: "conversion_b_percentage";
  CONVERSIONS2: "conversion_c";
  CONVERSIONS2_BY_SEND_TIME: "conversion_c_by_send_time";
  CONVERSIONS2_BY_SEND_TIME_PERCENTAGE: "conversion_c_by_send_time_percentage";
  CONVERSIONS2_PERCENTAGE: "conversion_c_percentage";
  CONVERSIONS3: "conversion_d";
  CONVERSIONS3_BY_SEND_TIME: "conversion_d_by_send_time";
  CONVERSIONS3_BY_SEND_TIME_PERCENTAGE: "conversion_d_by_send_time_percentage";
  CONVERSIONS3_PERCENTAGE: "conversion_d_percentage";
  CONVERSIONS_BY_ENTRY_TIME: "primary_conversion_a_by_entry_time";
  CONVERSIONS_BY_ENTRY_TIME_PERCENTAGE: "primary_conversion_a_by_entry_time_percentage";
  CONVERSIONS_BY_SEND_TIME: "primary_conversion_a_by_send_time";
  CONVERSIONS_BY_SEND_TIME_PERCENTAGE: "primary_conversion_a_by_send_time_percentage";
  CONVERSIONS_PERCENTAGE: "primary_conversion_a_percentage";
  DELIVERED: "delivered";
  DELIVERIES: "deliveries";
  DELIVERY_FAILED: "delivery_failed";
  DELIVERY_FAILED_PERCENTAGE: "delivery_failed_percentage";
  DELIVERY_PERCENTAGE: "delivery_percentage";
  DIRECT_OPENS: "direct_opens";
  DIRECT_OPEN_PERCENTAGE: "direct_open_percentage";
  ENROLLED: "enrolled";
  ENTRIES: "entries";
  ERRORS: "errors";
  FAILURES: "failures";
  FAILURE_PERCENTAGE: "failure_percentage";
  IMPRESSIONS: "impressions";
  IMPRESSION_PERCENTAGE: "impressions_percentage";
  INFLUENCED_OPENS: "influenced_opens";
  INFLUENCED_OPEN_PERCENTAGE: "influenced_open_percentage";
  MACHINE_OPEN: "machine_opens";
  OPENS: "opens";
  OPEN_PERCENTAGE: "open_percentage";
  OPT_IN: "opt_in";
  OPT_IN_PERCENTAGE: "opt_in_percentage";
  OPT_OUT: "opt_out";
  OPT_OUT_PERCENTAGE: "opt_out_percentage";
  OTHER_OPENS: "other_opens";
  READS: "reads";
  READ_PERCENTAGE: "read_percentage";
  REJECTED: "rejected";
  REJECTED_PERCENTAGE: "rejected_percentage";
  REVENUE: "revenue";
  SENDS: "sent";
  SENDS_TO_CARRIER: "sends_to_carrier";
  SENDS_TO_CARRIER_PERCENTAGE: "sends_to_carrier_percentage";
  SPAM_REPORTS: "reported_spam";
  SPAM_REPORT_PERCENTAGE: "reported_spam_percentage";
  TOTAL_CLICKS: "total_clicks";
  TOTAL_CLICK_PERCENTAGE: "total_click_percentage";
  TOTAL_DISMISSALS: "total_dismissals";
  TOTAL_DISMISSAL_PERCENTAGE: "total_dismissal_percentage";
  TOTAL_IMPRESSIONS: "total_impressions";
  TOTAL_OPENS: "total_opens";
  TOTAL_OPEN_PERCENTAGE: "total_open_percentage";
  UNIQUE_CLICKS: "unique_clicks";
  UNIQUE_CLICK_PERCENTAGE: "unique_click_percentage";
  UNIQUE_DISMISSALS: "unique_dismissals";
  UNIQUE_DISMISSAL_PERCENTAGE: "unique_dismissal_percentage";
  UNIQUE_IMPRESSIONS: "unique_impressions";
  UNIQUE_OPENS: "unique_opens";
  UNIQUE_OPEN_PERCENTAGE: "unique_open_percentage";
  UNIQUE_RECIPIENTS: "unique_recipients";
  UNSUBSCRIBES: "unsubscribes";
  UNSUBSCRIBE_PERCENTAGE: "unsubscribe_percentage";
}
export interface SHARED_CONSTANTS_CHART_TYPES {
  APP_USAGE: "app_usage";
  CUSTOM_EVENTS: "custom_event";
  REVENUE: "purchase";
}
export interface SHARED_CONSTANTS_DELIMITER_NAMES {
  COLON: "Colon (:)";
  COMMA: "Comma (,)";
  LINE: "Pipe (|)";
  SEMI_COLON: "Semicolon (;)";
}
export interface SHARED_CONSTANTS_FIELDS {
  ANY_PURCHASE: "Any Purchase";
  CUSTOM_EVENT: "Custom Event";
  DAU: "DAU";
  MAU: "MAU";
  PURCHASE: "Purchase";
  SEGMENT_SIZE: "Segment Size";
  SESSIONS: "Sessions";
}
export interface SHARED_CONSTANTS_FORMATS {
  GZIP: "Gzip";
  UNCOMPRESSED: "Uncompressed";
  ZIP: "ZIP";
}
export interface SHARED_CONSTANTS_PAGES {
  CONFIRM_STEP: 3;
  FILE_SETTINGS_STEP: 2;
  SELECT_ENGAGEMENT_TYPE_STEP: 0;
  SELECT_KPIS_STEP: 1;
}
export interface SHARED_CONSTANTS_ENGAGEMENT_REPORT_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
}
export interface SHARED_CONSTANTS_ENGAGEMENT_REPORT_SEARCH_KEYS {
  STATUS: "status";
  TAG: "tag";
}
export interface SHARED_CONSTANTS_TAG_SELECTORS {
  ALL: "With all of these tags";
  ANY: "With any of these tags";
}
export interface SHARED_CONSTANTS_ENGAGEMENT_REPORT {
  CAMPAIGN_STAT_KEYS: SHARED_CONSTANTS_CAMPAIGN_STAT_KEYS;
  CHART_TYPES: SHARED_CONSTANTS_CHART_TYPES;
  DELIMITER_NAMES: SHARED_CONSTANTS_DELIMITER_NAMES;
  FIELDS: SHARED_CONSTANTS_FIELDS;
  FORMATS: SHARED_CONSTANTS_FORMATS;
  MAX_DAYS_TO_LIMIT_DATA_BY: 1825;
  MAX_EMAIL_LENGTH: 256;
  MAX_ITEMS_TO_AGGREGATE_FOR_CHART: 120;
  MAX_NUM_EMAILS: 20;
  MAX_WEEKS_TO_LIMIT_DATA_BY: 260;
  MULTIPLIER_KEY: "m";
  PAGES: SHARED_CONSTANTS_PAGES;
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_ENGAGEMENT_REPORT_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_ENGAGEMENT_REPORT_SEARCH_KEYS;
  TAG_SELECTORS: SHARED_CONSTANTS_TAG_SELECTORS;
}
export interface SHARED_CONSTANTS_MAILJET_FEATURES {
  PERSONALIZATION_IN_HEADERS_KEYS: false;
  SUBUSER_ACCOUNT: false;
}
export interface SHARED_CONSTANTS_MAILJET {
  DISPLAY_NAME: "MailJet";
  FEATURES: SHARED_CONSTANTS_MAILJET_FEATURES;
  VALUE: 2;
}
export interface SHARED_CONSTANTS_SENDGRID_FEATURES {
  PERSONALIZATION_IN_HEADERS_KEYS: true;
  SUBUSER_ACCOUNT: true;
}
export interface SHARED_CONSTANTS_SENDGRID {
  DISPLAY_NAME: "SendGrid";
  FEATURES: SHARED_CONSTANTS_SENDGRID_FEATURES;
  VALUE: 0;
}
export interface SHARED_CONSTANTS_SES_FEATURES {
  PERSONALIZATION_IN_HEADERS_KEYS: false;
}
export interface SHARED_CONSTANTS_SES {
  DISPLAY_NAME: "Amazon SES";
  FEATURES: SHARED_CONSTANTS_SES_FEATURES;
  VALUE: 4;
}
export interface SHARED_CONSTANTS_SPARKPOST_FEATURES {
  PERSONALIZATION_IN_HEADERS_KEYS: false;
  SUBUSER_ACCOUNT: false;
}
export interface SHARED_CONSTANTS_SPARKPOST {
  DISPLAY_NAME: "SparkPost";
  FEATURES: SHARED_CONSTANTS_SPARKPOST_FEATURES;
  VALUE: 3;
}
export interface SHARED_CONSTANTS_ROOT_ESP {
  MAILJET: SHARED_CONSTANTS_MAILJET;
  SENDGRID: SHARED_CONSTANTS_SENDGRID;
  SES: SHARED_CONSTANTS_SES;
  SPARKPOST: SHARED_CONSTANTS_SPARKPOST;
}
export interface SHARED_CONSTANTS_EVENT_NAMESPACES {
  CUSTOM_EVENT: "ce";
  CUSTOM_EVENT_NESTED_OBJECT: "ce_no";
  PURCHASE: "iap";
  PURCHASE_NESTED_OBJECT: "iap_no";
}
export interface SHARED_CONSTANTS_EXPERIMENT_BEHAVIOR {
  CLICK: "click";
  CONVERSION: "conversion";
  OPEN: "open";
}
export interface SHARED_CONSTANTS_EXPERIMENT {
  EXPERIMENT_BEHAVIOR: SHARED_CONSTANTS_EXPERIMENT_BEHAVIOR;
}
export interface SHARED_CONSTANTS_EXPERIMENT_STEP_EXPERIMENT_PREFIXES {
  DURING_EXPERIMENT: "during_experiment_";
  POST_EXPERIMENT: "post_experiment_";
  PRE_EXPERIMENT: "pre_experiment_";
}
export interface SHARED_CONSTANTS_EXPERIMENT_STEP_INPUTS {
  DAYS: "days";
  HOURS: "hours";
}
export interface SHARED_CONSTANTS_EXPORT_LOGS_ERROR_CODES {
  EXPORT_LOG_NOT_FOUND: "EXPORT_LOG_NOT_FOUND";
  EXPORT_LOG_NOT_RUNNING: "EXPORT_LOG_NOT_RUNNING";
}
export interface SHARED_CONSTANTS_EXPORT_LOGS {
  ERROR_CODES: SHARED_CONSTANTS_EXPORT_LOGS_ERROR_CODES;
}
export interface SHARED_CONSTANTS_DEPENDENCY_TYPES {
  CANVAS_STEP: "canvas_step";
  EXPERIMENT: "experiment";
  ROLLOUT: "rollout";
}
export interface SHARED_CONSTANTS_LIMITS {
  MAX_DESCRIPTION_LENGTH: 255;
  MAX_FLAG_ID_LENGTH: 255;
  MAX_MULTI_ROLLOUTS: 3;
  MAX_NAME_LENGTH: 255;
  MIN_FLAG_ID_LENGTH: 3;
  MIN_NAME_LENGTH: 3;
}
export interface SHARED_CONSTANTS_FEATURE_FLAG_MANAGEMENT_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
  INACTIVE: "inactive";
}
export interface SHARED_CONSTANTS_FEATURE_FLAG_MANAGEMENT_SEARCH_KEYS {
  CREATED: "created";
  CREATED_BY: "created_by";
  CREATED_BY_ME: "created_by_me";
  EDITED: "edited";
  EDITED_BY: "edited_by";
  NAME: "name";
  ROLLOUT_ID: "rollout_id";
  SEGMENT: "segment";
  SENT: "sent";
  STATUS: "status";
  TAG: "tag";
  TERRITORY: "team";
  TYPE: "type";
}
export interface SHARED_CONSTANTS_FEATURE_FLAG_MANAGEMENT {
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_FEATURE_FLAG_MANAGEMENT_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_FEATURE_FLAG_MANAGEMENT_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_VALIDATION_ERRORS {
  DESCRIPTION_TOO_LONG: "description_too_long";
  ID_MUST_BE_UNIQUE: "id_must_be_unique";
  ID_TOO_LONG: "id_too_long";
  ID_TOO_SHORT: "id_too_short";
  INVALID_MULTI_ROLLOUT_FILTERS: "invalid_multi_rollout_filters";
  INVALID_MULTI_ROLLOUT_SEGMENTS: "invalid_multi_rollout_segments";
  NAME_MISSING: "name_missing";
  NAME_TOO_LONG: "name_too_long";
  NAME_TOO_SHORT: "name_too_short";
  NO_ID_PRESENT: "no_id_present";
  PARENT_CAMPAIGN_ID_INVALID_ERROR: "parent_campaign_id_invalid_error";
  PARENT_ROLLOUT_ID_INVALID_ERROR: "parent_rollout_id_invalid_error";
  ROLLOUT_LIMIT_REACHED: "FEATURE_FLAG_ROLLOUT_LIMIT_REACHED";
  SEND_PERCENTAGE_NONZERO_YET_NO_TARGET: "send_percentage_nonzero_yet_no_target";
  SEND_PERCENTAGE_NOT_PRESENT: "send_percentage_not_present";
  SEND_PERCENTAGE_OUT_OF_BOUNDS: "send_percentage_out_of_bounds";
  STEP_OVERRIDE_ENABLED_MISSING_ERROR: "step_override_enabled_missing_error";
  STEP_PARENT_NST_MISSING_ERROR: "parent_nst_missing_error";
  STEP_ROLLOUT_ID_MISSING_ERROR: "step_feature_flag_rollout_id_missing_error";
  TOO_MANY_MULTI_ROLLOUTS: "too_many_multi_rollouts";
}
export interface SHARED_CONSTANTS_FEATURE_FLAG {
  DEPENDENCY_TYPES: SHARED_CONSTANTS_DEPENDENCY_TYPES;
  LIMITS: SHARED_CONSTANTS_LIMITS;
  MANAGEMENT: SHARED_CONSTANTS_FEATURE_FLAG_MANAGEMENT;
  VALIDATION_ERRORS: SHARED_CONSTANTS_VALIDATION_ERRORS;
}
export interface SHARED_CONSTANTS_AGENTIC_AI_OPERATOR_RATE_LIMIT {
  LIMIT_KEY: "agentic_ai_operator_rate_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_AGENTIC_AI_OPERATOR_RATE_PERIOD {
  LIMIT_KEY: "agentic_ai_operator_rate_period";
  TYPE: "string";
}
export interface SHARED_CONSTANTS_CANVAS_STEPS_LIMIT {
  LIMIT_KEY: "canvas_steps_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_CAN_ACCESS_PAGE_VOUCHERS_LIST {
  LIMIT_KEY: "can_access_page_vouchers_list";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_GATED_FEATURE {
  LIMIT_KEY: "can_only_view_gated_feature";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_AI_ITEM_RECOMMENDATIONS {
  LIMIT_KEY: "can_only_view_landing_page_ai_item_recommendations";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_CDI {
  LIMIT_KEY: "can_only_view_landing_page_cdi";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_CONVERSION_DASHBOARD {
  LIMIT_KEY: "can_only_view_landing_page_conversion_dashboard";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_CURRENTS {
  LIMIT_KEY: "can_only_view_landing_page_currents";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_DATA_SHARING {
  LIMIT_KEY: "can_only_view_landing_page_data_sharing";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_DATA_TRANSFORMATION {
  LIMIT_KEY: "can_only_view_landing_page_data_transformation";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_FEATURE_FLAGS {
  LIMIT_KEY: "can_only_view_landing_page_feature_flags";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_PREDICTIVE_CHURN {
  LIMIT_KEY: "can_only_view_landing_page_predictive_churn";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_PREDICTIVE_EVENTS {
  LIMIT_KEY: "can_only_view_landing_page_predictive_events";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_QUERY_BUILDER {
  LIMIT_KEY: "can_only_view_landing_page_query_builder";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_SEGMENT_EXTENSIONS {
  LIMIT_KEY: "can_only_view_landing_page_segment_extensions";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_PREVIEW_LANDING_PAGE {
  LIMIT_KEY: "can_preview_landing_page";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_PUBLISH_LANDING_PAGE {
  LIMIT_KEY: "can_publish_landing_page";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_USE_CONNECTED_CONTENT {
  LIMIT_KEY: "can_use_connected_content";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_USE_WEB_FONTS {
  LIMIT_KEY: "can_use_web_fonts";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CAN_VIEW_API_KEYS {
  LIMIT_KEY: "can_view_api_keys";
  TYPE: "boolean";
}
export interface SHARED_CONSTANTS_CONTENT_BLOCK_MAX_COUNT {
  LIMIT_KEY: "content_block_max_count";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_CONTENT_BLOCK_MAX_SIZE {
  LIMIT_KEY: "content_block_max_size";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_CSV_IMPORT_COLUMN_LIMIT {
  LIMIT_KEY: "csv_import_column_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_CSV_IMPORT_FILE_LIMIT {
  LIMIT_KEY: "csv_import_file_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_CSV_IMPORT_FILE_SIZE_IN_MB_LIMIT {
  LIMIT_KEY: "csv_import_file_size_in_mb_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_CSV_IMPORT_ROW_LIMIT {
  LIMIT_KEY: "csv_import_row_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_DEVELOPER_CREATION_LIMIT {
  LIMIT_KEY: "developer_creation_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_FEATURE_LIMITATIONS_ERRORS {
  MISSING_LIMIT_KEY: "missing_limit_key";
}
export interface SHARED_CONSTANTS_GENERATE_CHAT_COMPLETION_RATE_LIMIT {
  LIMIT_KEY: "generate_chat_completion_rate_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_GENERATE_CHAT_COMPLETION_RATE_PERIOD {
  LIMIT_KEY: "generate_chat_completion_rate_period";
  TYPE: "string";
}
export interface SHARED_CONSTANTS_GENERATE_COPY_RATE_LIMIT {
  LIMIT_KEY: "generate_copy_rate_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_GENERATE_COPY_RATE_PERIOD {
  LIMIT_KEY: "generate_copy_rate_period";
  TYPE: "string";
}
export interface SHARED_CONSTANTS_GENERATE_IMAGES_RATE_LIMIT {
  LIMIT_KEY: "generate_images_rate_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_GENERATE_IMAGES_RATE_PERIOD {
  LIMIT_KEY: "generate_images_rate_period";
  TYPE: "string";
}
export interface SHARED_CONSTANTS_GPT_QA_MESSAGE_RATE_LIMIT {
  LIMIT_KEY: "gpt_qa_message_rate_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_GPT_QA_MESSAGE_RATE_PERIOD {
  LIMIT_KEY: "gpt_qa_message_rate_period";
  TYPE: "string";
}
export interface SHARED_CONSTANTS_IAM_CAMPAIGNS_LIMIT {
  LIMIT_KEY: "iam_campaigns_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_INBOX_VISION_PREVIEW_CAPACITY_LIMIT {
  LIMIT_KEY: "inbox_vision_preview_capacity_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_IN_APP_MESSAGE_IMPRESSION_LIMIT {
  LIMIT_KEY: "in_app_message_impression_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_LIQUID_ASSISTANT_RATE_LIMIT {
  LIMIT_KEY: "liquid_assistant_rate_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_LIQUID_ASSISTANT_RATE_PERIOD {
  LIMIT_KEY: "liquid_assistant_rate_period";
  TYPE: "string";
}
export interface SHARED_CONSTANTS_MEDIA_LIBRARY_ASSET_MAX_SIZE {
  LIMIT_KEY: "media_library_asset_max_size";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MEDIA_LIBRARY_MAX_COUNT {
  LIMIT_KEY: "media_library_max_count";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MEDIA_LIBRARY_VIDEO_MAX_SIZE {
  LIMIT_KEY: "media_library_video_max_size";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_CATEGORIES_LIMIT {
  LIMIT_KEY: "message_prioritization_categories_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_RETRY_WINDOW_SECONDS_LIMIT {
  LIMIT_KEY: "message_prioritization_retry_window_seconds_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_RULES_LIMIT {
  LIMIT_KEY: "message_prioritization_rules_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_SCHEDULED_ACTIVE_OPT_IN_LIMIT {
  LIMIT_KEY: "message_prioritization_scheduled_active_opt_in_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_TRIGGERED_ACTIVE_OPT_IN_LIMIT {
  LIMIT_KEY: "message_prioritization_triggered_active_opt_in_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_MULTI_LANGUAGE_LOCALE_MAX_COUNT {
  LIMIT_KEY: "multi_language_locale_max_count";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_AGENT_DEFINITION {
  LIMIT_KEY: "object_creation_limits.agent_definition";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_CAMPAIGN {
  LIMIT_KEY: "object_creation_limits.campaign";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_CANVAS {
  LIMIT_KEY: "object_creation_limits.canvas";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_VOUCHER_GROUP {
  LIMIT_KEY: "object_creation_limits.voucher_group";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_TOTAL_VOLUME_LIMIT {
  LIMIT_KEY: "total_volume_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_USER_LIMIT {
  LIMIT_KEY: "user_limit";
  TYPE: "numerical";
}
export interface SHARED_CONSTANTS_FEATURE_LIMITATIONS {
  AGENTIC_AI_OPERATOR_RATE_LIMIT: SHARED_CONSTANTS_AGENTIC_AI_OPERATOR_RATE_LIMIT;
  AGENTIC_AI_OPERATOR_RATE_PERIOD: SHARED_CONSTANTS_AGENTIC_AI_OPERATOR_RATE_PERIOD;
  CANVAS_STEPS_LIMIT: SHARED_CONSTANTS_CANVAS_STEPS_LIMIT;
  CAN_ACCESS_PAGE_VOUCHERS_LIST: SHARED_CONSTANTS_CAN_ACCESS_PAGE_VOUCHERS_LIST;
  CAN_ONLY_VIEW_GATED_FEATURE: SHARED_CONSTANTS_CAN_ONLY_VIEW_GATED_FEATURE;
  CAN_ONLY_VIEW_LANDING_PAGE_AI_ITEM_RECOMMENDATIONS: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_AI_ITEM_RECOMMENDATIONS;
  CAN_ONLY_VIEW_LANDING_PAGE_CDI: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_CDI;
  CAN_ONLY_VIEW_LANDING_PAGE_CONVERSION_DASHBOARD: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_CONVERSION_DASHBOARD;
  CAN_ONLY_VIEW_LANDING_PAGE_CURRENTS: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_CURRENTS;
  CAN_ONLY_VIEW_LANDING_PAGE_DATA_SHARING: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_DATA_SHARING;
  CAN_ONLY_VIEW_LANDING_PAGE_DATA_TRANSFORMATION: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_DATA_TRANSFORMATION;
  CAN_ONLY_VIEW_LANDING_PAGE_FEATURE_FLAGS: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_FEATURE_FLAGS;
  CAN_ONLY_VIEW_LANDING_PAGE_PREDICTIVE_CHURN: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_PREDICTIVE_CHURN;
  CAN_ONLY_VIEW_LANDING_PAGE_PREDICTIVE_EVENTS: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_PREDICTIVE_EVENTS;
  CAN_ONLY_VIEW_LANDING_PAGE_QUERY_BUILDER: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_QUERY_BUILDER;
  CAN_ONLY_VIEW_LANDING_PAGE_SEGMENT_EXTENSIONS: SHARED_CONSTANTS_CAN_ONLY_VIEW_LANDING_PAGE_SEGMENT_EXTENSIONS;
  CAN_PREVIEW_LANDING_PAGE: SHARED_CONSTANTS_CAN_PREVIEW_LANDING_PAGE;
  CAN_PUBLISH_LANDING_PAGE: SHARED_CONSTANTS_CAN_PUBLISH_LANDING_PAGE;
  CAN_USE_CONNECTED_CONTENT: SHARED_CONSTANTS_CAN_USE_CONNECTED_CONTENT;
  CAN_USE_WEB_FONTS: SHARED_CONSTANTS_CAN_USE_WEB_FONTS;
  CAN_VIEW_API_KEYS: SHARED_CONSTANTS_CAN_VIEW_API_KEYS;
  CONTENT_BLOCK_MAX_COUNT: SHARED_CONSTANTS_CONTENT_BLOCK_MAX_COUNT;
  CONTENT_BLOCK_MAX_SIZE: SHARED_CONSTANTS_CONTENT_BLOCK_MAX_SIZE;
  CSV_IMPORT_COLUMN_LIMIT: SHARED_CONSTANTS_CSV_IMPORT_COLUMN_LIMIT;
  CSV_IMPORT_FILE_LIMIT: SHARED_CONSTANTS_CSV_IMPORT_FILE_LIMIT;
  CSV_IMPORT_FILE_SIZE_IN_MB_LIMIT: SHARED_CONSTANTS_CSV_IMPORT_FILE_SIZE_IN_MB_LIMIT;
  CSV_IMPORT_ROW_LIMIT: SHARED_CONSTANTS_CSV_IMPORT_ROW_LIMIT;
  DEVELOPER_CREATION_LIMIT: SHARED_CONSTANTS_DEVELOPER_CREATION_LIMIT;
  ERRORS: SHARED_CONSTANTS_FEATURE_LIMITATIONS_ERRORS;
  GENERATE_CHAT_COMPLETION_RATE_LIMIT: SHARED_CONSTANTS_GENERATE_CHAT_COMPLETION_RATE_LIMIT;
  GENERATE_CHAT_COMPLETION_RATE_PERIOD: SHARED_CONSTANTS_GENERATE_CHAT_COMPLETION_RATE_PERIOD;
  GENERATE_COPY_RATE_LIMIT: SHARED_CONSTANTS_GENERATE_COPY_RATE_LIMIT;
  GENERATE_COPY_RATE_PERIOD: SHARED_CONSTANTS_GENERATE_COPY_RATE_PERIOD;
  GENERATE_IMAGES_RATE_LIMIT: SHARED_CONSTANTS_GENERATE_IMAGES_RATE_LIMIT;
  GENERATE_IMAGES_RATE_PERIOD: SHARED_CONSTANTS_GENERATE_IMAGES_RATE_PERIOD;
  GPT_QA_MESSAGE_RATE_LIMIT: SHARED_CONSTANTS_GPT_QA_MESSAGE_RATE_LIMIT;
  GPT_QA_MESSAGE_RATE_PERIOD: SHARED_CONSTANTS_GPT_QA_MESSAGE_RATE_PERIOD;
  IAM_CAMPAIGNS_LIMIT: SHARED_CONSTANTS_IAM_CAMPAIGNS_LIMIT;
  INBOX_VISION_PREVIEW_CAPACITY_LIMIT: SHARED_CONSTANTS_INBOX_VISION_PREVIEW_CAPACITY_LIMIT;
  IN_APP_MESSAGE_IMPRESSION_LIMIT: SHARED_CONSTANTS_IN_APP_MESSAGE_IMPRESSION_LIMIT;
  LIQUID_ASSISTANT_RATE_LIMIT: SHARED_CONSTANTS_LIQUID_ASSISTANT_RATE_LIMIT;
  LIQUID_ASSISTANT_RATE_PERIOD: SHARED_CONSTANTS_LIQUID_ASSISTANT_RATE_PERIOD;
  MEDIA_LIBRARY_ASSET_MAX_SIZE: SHARED_CONSTANTS_MEDIA_LIBRARY_ASSET_MAX_SIZE;
  MEDIA_LIBRARY_MAX_COUNT: SHARED_CONSTANTS_MEDIA_LIBRARY_MAX_COUNT;
  MEDIA_LIBRARY_VIDEO_MAX_SIZE: SHARED_CONSTANTS_MEDIA_LIBRARY_VIDEO_MAX_SIZE;
  MESSAGE_PRIORITIZATION_CATEGORIES_LIMIT: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_CATEGORIES_LIMIT;
  MESSAGE_PRIORITIZATION_RETRY_WINDOW_SECONDS_LIMIT: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_RETRY_WINDOW_SECONDS_LIMIT;
  MESSAGE_PRIORITIZATION_RULES_LIMIT: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_RULES_LIMIT;
  MESSAGE_PRIORITIZATION_SCHEDULED_ACTIVE_OPT_IN_LIMIT: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_SCHEDULED_ACTIVE_OPT_IN_LIMIT;
  MESSAGE_PRIORITIZATION_TRIGGERED_ACTIVE_OPT_IN_LIMIT: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_TRIGGERED_ACTIVE_OPT_IN_LIMIT;
  MULTI_LANGUAGE_LOCALE_MAX_COUNT: SHARED_CONSTANTS_MULTI_LANGUAGE_LOCALE_MAX_COUNT;
  OBJECT_CREATION_LIMITS_AGENT_DEFINITION: SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_AGENT_DEFINITION;
  OBJECT_CREATION_LIMITS_CAMPAIGN: SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_CAMPAIGN;
  OBJECT_CREATION_LIMITS_CANVAS: SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_CANVAS;
  OBJECT_CREATION_LIMITS_VOUCHER_GROUP: SHARED_CONSTANTS_OBJECT_CREATION_LIMITS_VOUCHER_GROUP;
  TOTAL_VOLUME_LIMIT: SHARED_CONSTANTS_TOTAL_VOLUME_LIMIT;
  USER_LIMIT: SHARED_CONSTANTS_USER_LIMIT;
}
export interface SHARED_CONSTANTS_FIELD_LEVEL_ENCRYPTION_ERROR_CODES {
  HMAC_KEY_CHANGE_NOT_ALLOWED: "HMAC_KEY_CHANGE_NOT_ALLOWED";
  INVALID_CREDENTIALS: "INVALID_CREDENTIALS";
  ROLE_AUTH_NOT_ENABLED: "ROLE_AUTH_NOT_ENABLED";
  ROLE_TO_KEY_AUTH_SWITCH_NOT_ALLOWED: "ROLE_TO_KEY_AUTH_SWITCH_NOT_ALLOWED";
  WORKSPACE_CHECK_TIMED_OUT: "WORKSPACE_CHECK_TIMED_OUT";
  WORKSPACE_INCOMPATIBLE: "WORKSPACE_INCOMPATIBLE";
}
export interface SHARED_CONSTANTS_FIELD_LEVEL_ENCRYPTION {
  AUTH_TYPE_KEY: "1";
  AUTH_TYPE_ROLE: "2";
  ERROR_CODES: SHARED_CONSTANTS_FIELD_LEVEL_ENCRYPTION_ERROR_CODES;
}
export interface SHARED_CONSTANTS_FILTER {
  LOOK_BACK_MAXIMUM_DAYS: 30;
  LOOK_BACK_MINIMUM_DAYS: 1;
  VALUE_INPUT_METHOD_DATE: "date";
  VALUE_INPUT_METHOD_TIME: "time";
}
export interface SHARED_CONSTANTS_FLEXIBLE_ON_CLICK {
  CLOSE: "CLOSE";
  DEEP_LINK: "DEEP_LINK";
  LOG_CUSTOM_ATTRIBUTE: "LOG_CUSTOM_ATTRIBUTE";
  LOG_CUSTOM_EVENT: "LOG_CUSTOM_EVENT";
  NEWS_FEED: "NEWS_FEED";
  NONE: "NONE";
  OPEN_APP: "OPEN_APP";
  SHOW_PUSH_PROMPT: "SHOW_PUSH_PROMPT";
  URI: "URI";
}
export interface SHARED_CONSTANTS_FREE_TRIAL_DASHBOARD_BUILDER {
  TEMPLATE_NAMES: "Example Dashboard"[];
}
export interface SHARED_CONSTANTS_GATED_FEATURES {
  INGESTION_API: "ingestion_api";
  SDK_INTEGRATION: "sdk_integration";
}
export interface SHARED_CONSTANTS_PILOT {
  DEMO_ANDROID_APP_NAME: "Android Demo App";
  DEMO_IOS_APP_NAME: "iOS Demo App";
  LIVE_ANDROID_APP_NAME: "My Android App";
  LIVE_IOS_APP_NAME: "My Ios App";
}
export interface SHARED_CONSTANTS_FREE_TRIAL {
  DASHBOARD_BUILDER: SHARED_CONSTANTS_FREE_TRIAL_DASHBOARD_BUILDER;
  EMAIL_LENGTH_LIMIT: 254;
  GATED_FEATURES: SHARED_CONSTANTS_GATED_FEATURES;
  PARAM_LENGTH_LIMIT: 50;
  PHONE_LENGTH_LIMIT: 15;
  PILOT: SHARED_CONSTANTS_PILOT;
  SUPPORTED_REST_ENDPOINTS: ("/users/delete" | "/users/export/ids" | "/users/export/segment" | "/users/track")[];
  SUPPORTED_SDK_ENDPOINTS: "/api/v3/data"[];
}
export interface SHARED_CONSTANTS_FREQUENCY_CAPPING {
  MAX_RULES: 10;
  MAX_RULES_HIGHER: 15;
}
export interface SHARED_CONSTANTS_AGENT_DOCUMENT_UPLOAD_MIME_TYPES_BY_EXTENSION {
  ".csv": "text/csv";
  ".md": "text/markdown";
  ".pdf": "application/pdf";
  ".txt": "text/plain";
}
export interface SHARED_CONSTANTS_BRAND_GUIDELINES_SYNTHESIS_SOURCE_ERRORS {
  CRAWL_FAILED: "crawl_failed";
  DOCUMENT_UNREADABLE: "document_unreadable";
  DOCUMENT_UNRESOLVABLE: "document_unresolvable";
  EMPTY_CONTENT: "empty_content";
}
export interface SHARED_CONSTANTS_BRAND_GUIDELINE_IMAGE_MIME_TYPES_BY_EXTENSION {
  ".jpeg": "image/jpeg";
  ".jpg": "image/jpeg";
  ".png": "image/png";
  ".webp": "image/webp";
}
export interface SHARED_CONSTANTS_BRAND_GUIDELINE_UPLOAD_MIME_TYPES_BY_EXTENSION {
  ".csv": "text/csv";
  ".jpeg": "image/jpeg";
  ".jpg": "image/jpeg";
  ".md": "text/markdown";
  ".pdf": "application/pdf";
  ".png": "image/png";
  ".txt": "text/plain";
  ".webp": "image/webp";
}
export interface SHARED_CONSTANTS_DOCUMENT_UPLOAD_MIME_TYPES_BY_EXTENSION {
  ".csv": "text/csv";
  ".md": "text/markdown";
  ".pdf": "application/pdf";
  ".txt": "text/plain";
}
export interface SHARED_CONSTANTS_GENERATIVE_AI_ERRORS {
  CONTENT_POLICY_VIOLATION: "content_policy_violation";
  DAILY_COST_CAP_EXCEEDED: "daily_cost_cap_exceeded";
  DOCUMENT_DELETE_FAILED: "document_delete_failed";
  DOCUMENT_FILE_TOO_LARGE: "document_file_too_large";
  DOCUMENT_LIMIT_REACHED: "document_limit_reached";
  DOCUMENT_NOT_FOUND: "document_not_found";
  DOCUMENT_TOTAL_SIZE_EXCEEDED: "document_total_size_exceeded";
  EMPTY_DOCUMENT_FILE: "empty_document_file";
  FEATURE_NOT_ENABLED: "feature_not_enabled";
  GEN_AI_KILL_SWITCH_ON: "gen_ai_kill_switch_on";
  GUIDELINE_NOT_FOUND: "guideline_not_found";
  IMAGE_FILE_TOO_LARGE: "image_file_too_large";
  INVALID_BRAND_GUIDELINE: "invalid_brand_guideline";
  INVALID_DOCUMENT_FILE: "invalid_document_file";
  INVALID_PROMPT: "invalid_prompt";
  INVALID_STATUS: "invalid_status";
  INVALID_TYPE: "invalid_type";
  MALFORMED_REQUEST: "malformed_request";
  MESSAGE_TYPE_UNSUPPORTED: "on_brand_message_type_unsupported";
  NAME_ALREADY_EXISTS: "name_already_exists";
  RATE_LIMIT_EXCEEDED: "rate_limit_exceeded";
  SERVER_UNRESPONSIVE: "server_unresponsive";
  SYNTHESIS_TOO_LONG: "synthesis_too_long";
  UNKNOWN: "unknown";
  UNSUPPORTED_DOCUMENT_FILE_TYPE: "unsupported_document_file_type";
}
export interface SHARED_CONSTANTS_GENERATIVE_AI_LIMITS {
  MAX_AGENT_DOCUMENT_TOTAL_BYTES: 15728640;
  MAX_BRAND_GUIDELINE_FIELD_LENGTH: 10000;
  MAX_BRAND_GUIDELINE_GENERAL_LENGTH: 300;
  MAX_BRAND_GUIDELINE_IMAGE_UPLOAD_BYTES: 15728640;
  MAX_BRAND_GUIDELINE_STUDIO_FIELD_LENGTH: 100000;
  MAX_DOCUMENTS_PER_AGENT: 10;
  MAX_DOCUMENTS_PER_GUIDELINE: 10;
  MAX_DOCUMENT_UPLOAD_BYTES: 15728640;
  MAX_LLM_IMAGE_PART_BYTES: 3145728;
  MAX_SOURCE_URLS_PER_GUIDELINE: 25;
  MAX_SOURCE_URL_LENGTH: 2048;
}
export interface SHARED_CONSTANTS_TONES {
  CASUAL: "Casual";
  EXCITING: "Exciting";
  EYE_CATCHING: "Eye-catching";
  FORMAL: "Formal";
  PASSIVE: "Passive";
  PERSONAL: "Personal";
  PROFESSIONAL: "Professional";
  SOPHISTICATED: "Sophisticated";
  STRAIGHTFORWARD: "Straightforward";
  URGENT: "Urgent";
}
export interface SHARED_CONSTANTS_GENERATIVE_AI {
  AGENT_DOCUMENT_UPLOAD_ALLOWED_EXTENSIONS: (".csv" | ".md" | ".pdf" | ".txt")[];
  AGENT_DOCUMENT_UPLOAD_MIME_TYPES_BY_EXTENSION: SHARED_CONSTANTS_AGENT_DOCUMENT_UPLOAD_MIME_TYPES_BY_EXTENSION;
  BRAND_GUIDELINES_SYNTHESIS_SOURCE_ERRORS: SHARED_CONSTANTS_BRAND_GUIDELINES_SYNTHESIS_SOURCE_ERRORS;
  BRAND_GUIDELINE_IMAGE_ALLOWED_EXTENSIONS: (".jpeg" | ".jpg" | ".png" | ".webp")[];
  BRAND_GUIDELINE_IMAGE_MIME_TYPES_BY_EXTENSION: SHARED_CONSTANTS_BRAND_GUIDELINE_IMAGE_MIME_TYPES_BY_EXTENSION;
  BRAND_GUIDELINE_UPLOAD_ALLOWED_EXTENSIONS: (".csv" | ".jpeg" | ".jpg" | ".md" | ".pdf" | ".png" | ".txt" | ".webp")[];
  BRAND_GUIDELINE_UPLOAD_MIME_TYPES_BY_EXTENSION: SHARED_CONSTANTS_BRAND_GUIDELINE_UPLOAD_MIME_TYPES_BY_EXTENSION;
  DOCUMENT_UPLOAD_ALLOWED_EXTENSIONS: (".csv" | ".md" | ".pdf" | ".txt")[];
  DOCUMENT_UPLOAD_MIME_TYPES_BY_EXTENSION: SHARED_CONSTANTS_DOCUMENT_UPLOAD_MIME_TYPES_BY_EXTENSION;
  ERRORS: SHARED_CONSTANTS_GENERATIVE_AI_ERRORS;
  LIMITS: SHARED_CONSTANTS_GENERATIVE_AI_LIMITS;
  POSTWS_TIMEOUT_MS: 120000;
  TONES: SHARED_CONSTANTS_TONES;
}
export interface SHARED_CONSTANTS_GLOBAL_FREQUENCY_CAPPING_RULE {
  ANY: "any";
  PUSH: "push";
}
export interface SHARED_CONSTANTS_GLOBAL_RATE_LIMITS {
  LOW_LIMIT_WARNING_THRESHOLD: 5000;
  MAX_MESSAGES: 5000000;
  MIN_MESSAGES: 1000;
}
export interface SHARED_CONSTANTS_GLOBAL_SUBSCRIPTION_CHANNELS {
  EMAIL: 0;
  PUSH: 1;
}
export interface SHARED_CONSTANTS_GRAPES_EDITOR_CONTEXT_TYPES {
  BANNER: "banner";
  EMAIL_PREF_CENTER: "email_preference_center";
  IN_APP_MESSAGE: "in_app_message";
  LANDING_PAGE: "landing_page";
  LINE: "line";
}
export interface SHARED_CONSTANTS_TRAIT_HANDLER_SCRIPT {
  END_COMMENT: "<!--BRAZE_END_TRAIT_HANDLER_SCRIPT-->";
  START_COMMENT: "<!--BRAZE_START_TRAIT_HANDLER_SCRIPT-->";
  TARGETED_PLATFORM_PLACEHOLDER: "BRAZE_REPLACE_THIS_WITH_TARGETED_PLATFORM";
}
export interface SHARED_CONSTANTS_GRAPES_EDITOR {
  CONTEXT_TYPES: SHARED_CONSTANTS_GRAPES_EDITOR_CONTEXT_TYPES;
  TRAIT_HANDLER_SCRIPT: SHARED_CONSTANTS_TRAIT_HANDLER_SCRIPT;
}
export interface SHARED_CONSTANTS_android {
  display_name: "Android Mobile";
  prefix: "android";
}
export interface SHARED_CONSTANTS_aolcom {
  display_name: "AOL Mail";
  prefix: "aolcom";
}
export interface SHARED_CONSTANTS_applemail {
  display_name: "Apple Mail";
  prefix: "applemail";
}
export interface SHARED_CONSTANTS_freefr {
  display_name: "Free.fr";
  prefix: "freefr";
}
export interface SHARED_CONSTANTS_gmailcom {
  display_name: "Gmail";
  prefix: "gmailcom";
}
export interface SHARED_CONSTANTS_gmxnet {
  display_name: "GMX";
  prefix: "gmxnet";
}
export interface SHARED_CONSTANTS_iphone {
  display_name: "iPhone/iOS";
  prefix: "iphone";
}
export interface SHARED_CONSTANTS_liberoit {
  display_name: "Libero";
  prefix: "liberoit";
}
export interface SHARED_CONSTANTS_m365 {
  display_name: "Microsoft 365";
  prefix: "m365";
}
export interface SHARED_CONSTANTS_o365 {
  display_name: "Office 365";
  prefix: "o365";
}
export interface SHARED_CONSTANTS_outlook {
  display_name: "Outlook Desktop";
  prefix: "outlook";
}
export interface SHARED_CONSTANTS_tonlinede {
  display_name: "T-Online";
  prefix: "tonlinede";
}
export interface SHARED_CONSTANTS_webde {
  display_name: "Web.de";
  prefix: "webde";
}
export interface SHARED_CONSTANTS_yahoocom {
  display_name: "Yahoo Mail";
  prefix: "yahoocom";
}
export interface SHARED_CONSTANTS_CLIENT_GROUPS {
  android: SHARED_CONSTANTS_android;
  aolcom: SHARED_CONSTANTS_aolcom;
  applemail: SHARED_CONSTANTS_applemail;
  freefr: SHARED_CONSTANTS_freefr;
  gmailcom: SHARED_CONSTANTS_gmailcom;
  gmxnet: SHARED_CONSTANTS_gmxnet;
  iphone: SHARED_CONSTANTS_iphone;
  liberoit: SHARED_CONSTANTS_liberoit;
  m365: SHARED_CONSTANTS_m365;
  o365: SHARED_CONSTANTS_o365;
  outlook: SHARED_CONSTANTS_outlook;
  tonlinede: SHARED_CONSTANTS_tonlinede;
  webde: SHARED_CONSTANTS_webde;
  yahoocom: SHARED_CONSTANTS_yahoocom;
}
export interface SHARED_CONSTANTS_INBOX_VISION_ERROR_CODES {
  EXPIRED_TEST: "EXPIRED_TEST";
  INBOX_VISION_ABORT_MESSAGE_ERROR: "INBOX_VISION_ABORT_MESSAGE_ERROR";
  INBOX_VISION_DATA_RETRIEVAL_ERROR: "INBOX_VISION_DATA_RETRIEVAL_ERROR";
  INBOX_VISION_INSUFFICIENT_QUOTA: "INBOX_VISION_INSUFFICIENT_QUOTA";
  INBOX_VISION_INVALID_ARGUMENT: "INBOX_VISION_INVALID_ARGUMENT";
  INBOX_VISION_NOT_ENABLED: "INBOX_VISION_NOT_ENABLED";
  INBOX_VISION_RESULT_RETRIEVAL_ERROR: "INBOX_VISION_RESULT_RETRIEVAL_ERROR";
  INBOX_VISION_RETRY_MESSAGE_ERROR: "INBOX_VISION_RETRY_MESSAGE_ERROR";
  INBOX_VISION_UNKNOWN_HTTP_ERROR: "INBOX_VISION_UNKNOWN_HTTP_ERROR";
  INBOX_VISION_UNKNOWN_TEMPLATING_ERROR: "INBOX_VISION_UNKNOWN_TEMPLATING_ERROR";
  INVALID_TEST_ID: "InvalidTestID";
  TEST_METADATA_NOT_FOUND: "TEST_METADATA_NOT_FOUND";
  TEST_NOT_FOUND: "TEST_NOT_FOUND";
}
export interface SHARED_CONSTANTS_PREVIEW_API_VERSIONS {
  EMAIL_ON_ACID: "eoa";
  MAILGUN: "mg";
}
export interface SHARED_CONSTANTS_INBOX_VISION {
  CLIENT_GROUPS: SHARED_CONSTANTS_CLIENT_GROUPS;
  DEFAULT_PREVIEW_IDS: ("android12_outlookapp_pixel6_dm" | "android12_outlookapp_pixel6_lm" | "android13_gmailapp_pixel7_dm" | "android13_gmailapp_pixel7_lm" | "applemail16" | "applemail16_dm" | "gmailcom-lm_chrcurrent_win10" | "iphone13ol_15" | "iphone13ol_15_dm" | "iphone17_26" | "iphone17_26_dm" | "m365_mac13_dm_dt" | "m365_mac13_lm_dt" | "m365_w11_dm_dt" | "m365_w11_lm_dt" | "outlook16_win10" | "outlook19" | "outlook2021_win11_lm_dt" | "outlookcom-lm_edgecurrent_win10" | "yahoocom-lm_chrcurrent_win10")[];
  ERROR_CODES: SHARED_CONSTANTS_INBOX_VISION_ERROR_CODES;
  PREVIEW_API_VERSIONS: SHARED_CONSTANTS_PREVIEW_API_VERSIONS;
}
export interface SHARED_CONSTANTS_INDUSTRY {
  EDUCATION: "Education";
  FINANCIAL_SERVICES: "Financial Services";
  GOVERNMENT_NON_PROFIT: "Government & Non-Profit";
  HEALTHCARE_LIFE_SCIENCES: "Healthcare & Life Sciences";
  LOGISTICS_UTILITIES: "Logistics & Utilities";
  MANUFACTURING: "Manufacturing";
  MEDIA_ENTERTAINMENT: "Media & Entertainment";
  PROFESSIONAL_SERVICES: "Professional Services";
  RESTAURANTS_ON_DEMAND: "Restaurants & On-Demand";
  RETAIL_CONSUMER_GOODS: "Retail & Consumer Goods";
  TECHNOLOGY: "Technology";
  TELECOMMUNICATIONS: "Telecommunications";
  TRAVEL_TRANSPORTATION_HOSPITALITY: "Travel, Transportation, & Hospitality";
}
export interface SHARED_CONSTANTS_SUPER_OPTIMIZER {
  PROJECTED_LIFT_THRESHOLD: 0.005;
}
export interface SHARED_CONSTANTS_TRAINING_FAILURE_CODE {
  CONVERSION_RATE_OUTSIDE_THRESHOLD: "CONVERSION_RATE_OUTSIDE_THRESHOLD";
  FILTERED_SET_CONTAINS_LIQUID: "FILTERED_SET_CONTAINS_LIQUID";
  FILTERED_SET_NOT_FOUND: "FILTERED_SET_NOT_FOUND";
  FILTERED_SET_PROCESSING: "FILTERED_SET_PROCESSING";
  MODEL_PERFORMANCE_INSUFFICIENT: "MODEL_PERFORMANCE_INSUFFICIENT";
  NOT_ENOUGH_DATA: "NOT_ENOUGH_DATA";
  NOT_ENOUGH_PURCHASES: "NOT_ENOUGH_PURCHASES";
  NO_DATA: "NO_DATA";
  UNKNOWN: "UNKNOWN";
}
export interface SHARED_CONSTANTS_INTELLIGENCE {
  SUPER_OPTIMIZER: SHARED_CONSTANTS_SUPER_OPTIMIZER;
  TRAINING_FAILURE_CODE: SHARED_CONSTANTS_TRAINING_FAILURE_CODE;
}
export interface SHARED_CONSTANTS_CAN_IMPERSONATE_PERMISSIONS {
  can_full_access_eu_impersonate: "can_full_access_eu_impersonate";
  can_full_access_hipaa_impersonate: "can_full_access_hipaa_impersonate";
  can_full_access_impersonate: "can_full_access_impersonate";
  can_read_only_eu_impersonate: "can_read_only_eu_impersonate";
  can_read_only_hipaa_impersonate: "can_read_only_hipaa_impersonate";
  can_read_only_impersonate: "can_read_only_impersonate";
}
export interface SHARED_CONSTANTS_CAN_REQUEST_IMPERSONATION_PERMISSIONS {
  can_request_full_access_eu_impersonation_auto_approved: "can_request_full_access_eu_impersonation_auto_approved";
  can_request_full_access_eu_impersonation_manually_approved: "can_request_full_access_eu_impersonation_manually_approved";
  can_request_full_access_hipaa_impersonation_auto_approved: "can_request_full_access_hipaa_impersonation_auto_approved";
  can_request_full_access_hipaa_impersonation_manually_approved: "can_request_full_access_hipaa_impersonation_manually_approved";
  can_request_full_access_impersonation_auto_approved: "can_request_full_access_impersonation_auto_approved";
  can_request_full_access_impersonation_manually_approved: "can_request_full_access_impersonation_manually_approved";
  can_request_read_only_eu_impersonation_auto_approved: "can_request_read_only_eu_impersonation_auto_approved";
  can_request_read_only_eu_impersonation_manually_approved: "can_request_read_only_eu_impersonation_manually_approved";
  can_request_read_only_hipaa_impersonation_auto_approved: "can_request_read_only_hipaa_impersonation_auto_approved";
  can_request_read_only_hipaa_impersonation_manually_approved: "can_request_read_only_hipaa_impersonation_manually_approved";
  can_request_read_only_impersonation_auto_approved: "can_request_read_only_impersonation_auto_approved";
  can_request_read_only_impersonation_manually_approved: "can_request_read_only_impersonation_manually_approved";
}
export interface SHARED_CONSTANTS_INTERNAL_PERMISSIONS {
  BASIC_READ_ONLY: "basic_read_only";
  CAN_ACCESS_MILESTONE_CHECKLIST_SETTINGS: "can_access_milestone_checklist_settings";
  CAN_ARCHIVE_AND_DELETE_COMPANIES: "can_archive_and_delete_companies";
  CAN_BAN_COMPANIES: "can_ban_companies";
  CAN_BULK_ADD_TAGS: "can_bulk_add_tags";
  CAN_CHANGE_EXPORT_ANONYMOUS_USER_EVENTS: "can_change_export_anonymous_user_events";
  CAN_CREATE_SMS_SUBSCRIPTION_GROUPS: "can_create_sms_subscription_groups";
  CAN_DELETE_APP_GROUP: "can_delete_app_group";
  CAN_DELETE_DEVELOPERS: "can_delete_developers";
  CAN_EDIT_TENANT_LIST: "can_edit_tenant_list";
  CAN_EXPORT_SEGMENT_USERS_INTERNAL: "can_export_segment_users_internal";
  CAN_FULL_ACCESS_EU_IMPERSONATE: "can_full_access_eu_impersonate";
  CAN_FULL_ACCESS_HIPAA_IMPERSONATE: "can_full_access_hipaa_impersonate";
  CAN_FULL_ACCESS_IMPERSONATE: "can_full_access_impersonate";
  CAN_MANAGE_ACCOUNT_MANAGER_ROLES: "can_manage_account_manager_roles";
  CAN_MANAGE_ADMIN_ROLES: "can_manage_admin_roles";
  CAN_MANAGE_ALLIANCE_ROLES: "can_manage_alliance_roles";
  CAN_MANAGE_AUDIT_ROLES: "can_manage_audit_roles";
  CAN_MANAGE_CUSTOM_DATA_SCHEMA: "can_manage_custom_data_schema";
  CAN_MANAGE_DEVOPS_ROLES: "can_manage_devops_roles";
  CAN_MANAGE_ENGINEERING_ROLES: "can_manage_engineering_roles";
  CAN_MANAGE_GROWTH_ROLES: "can_manage_growth_roles";
  CAN_MANAGE_INTEGRATION_ROLES: "can_manage_integration_roles";
  CAN_MANAGE_INTERNAL_ACCESS: "can_manage_internal_access";
  CAN_MANAGE_MARKETING_ROLES: "can_manage_marketing_roles";
  CAN_MANAGE_PARTNER_ROLES: "can_manage_partner_roles";
  CAN_MANAGE_PRODUCT_ROLES: "can_manage_product_roles";
  CAN_MANAGE_PROVISIONING_OPS_ROLES: "can_manage_provisioning_ops_roles";
  CAN_MANAGE_REVENUE_OPS_ROLES: "can_manage_revenue_ops_roles";
  CAN_MANAGE_SALES_ROLES: "can_manage_sales_roles";
  CAN_MANAGE_SERVICE_ACCOUNT_ROLES: "can_manage_service_account_roles";
  CAN_MANAGE_SMSOPS_ROLES: "can_manage_smsops_roles";
  CAN_MANAGE_SOLCON_ROLES: "can_manage_solcon_roles";
  CAN_MANAGE_SUCCESS_ROLES: "can_manage_success_roles";
  CAN_MANAGE_SUPPORT_ROLES: "can_manage_support_roles";
  CAN_MANAGE_TECHNICAL_ACCOUNT_MANAGER_ROLES: "can_manage_technical_account_manager_roles";
  CAN_MANUALLY_APPROVE_IMPERSONATION_REQUESTS: "can_manually_approve_impersonation_requests";
  CAN_MOVE_DEVELOPERS: "can_move_developers";
  CAN_PERFORM_RANDOM_BUCKET_NUMBER_BACKFILL: "can_perform_random_bucket_number_backfill";
  CAN_RANDOMIZE_USER_SAMPLING_BUCKETS: "can_randomize_user_sampling_buckets";
  CAN_READ_GLOBAL_UPTIME_REPORTS: "can_read_global_uptime_reports";
  CAN_READ_ONLY_EU_IMPERSONATE: "can_read_only_eu_impersonate";
  CAN_READ_ONLY_HIPAA_IMPERSONATE: "can_read_only_hipaa_impersonate";
  CAN_READ_ONLY_IMPERSONATE: "can_read_only_impersonate";
  CAN_REMOVE_FROM_DROPDOWN: "can_remove_from_dropdown";
  CAN_REQUEST_FULL_ACCESS_EU_IMPERSONATION_AUTO_APPROVED: "can_request_full_access_eu_impersonation_auto_approved";
  CAN_REQUEST_FULL_ACCESS_EU_IMPERSONATION_MANUALLY_APPROVED: "can_request_full_access_eu_impersonation_manually_approved";
  CAN_REQUEST_FULL_ACCESS_HIPAA_IMPERSONATION_AUTO_APPROVED: "can_request_full_access_hipaa_impersonation_auto_approved";
  CAN_REQUEST_FULL_ACCESS_HIPAA_IMPERSONATION_MANUALLY_APPROVED: "can_request_full_access_hipaa_impersonation_manually_approved";
  CAN_REQUEST_FULL_ACCESS_IMPERSONATION_AUTO_APPROVED: "can_request_full_access_impersonation_auto_approved";
  CAN_REQUEST_FULL_ACCESS_IMPERSONATION_MANUALLY_APPROVED: "can_request_full_access_impersonation_manually_approved";
  CAN_REQUEST_READ_ONLY_EU_IMPERSONATION_AUTO_APPROVED: "can_request_read_only_eu_impersonation_auto_approved";
  CAN_REQUEST_READ_ONLY_EU_IMPERSONATION_MANUALLY_APPROVED: "can_request_read_only_eu_impersonation_manually_approved";
  CAN_REQUEST_READ_ONLY_HIPAA_IMPERSONATION_AUTO_APPROVED: "can_request_read_only_hipaa_impersonation_auto_approved";
  CAN_REQUEST_READ_ONLY_HIPAA_IMPERSONATION_MANUALLY_APPROVED: "can_request_read_only_hipaa_impersonation_manually_approved";
  CAN_REQUEST_READ_ONLY_IMPERSONATION_AUTO_APPROVED: "can_request_read_only_impersonation_auto_approved";
  CAN_REQUEST_READ_ONLY_IMPERSONATION_MANUALLY_APPROVED: "can_request_read_only_impersonation_manually_approved";
  CAN_RUN_DATA_EXPORTS: "can_run_data_exports";
  CAN_RUN_MIGRATIONS: "can_run_migrations";
  CAN_USE_AUTO_REGRESSION_TESTING: "can_use_auto_regression_testing";
  CAN_USE_DUST_TOOL: "can_use_dust_tool";
  CAN_USE_FREE_TRIAL_API: "can_use_free_trial_api";
  CAN_USE_INCIDENTS_MANAGEMENT: "can_use_incidents_management";
  CAN_USE_SAMPLE_INTERNAL_TOOL: "can_use_sample_internal_tool";
  CREATE_COMPANY: "create_company";
  MANAGE_COMPANY: "manage_company";
  MANAGE_EMAIL: "manage_email";
  MANAGE_ENTITLEMENTS: "manage_entitlements";
  MANAGE_FEATURE_FLIPPERS: "manage_feature_flippers";
  MANAGE_FEATURE_FLIPPER_FREEZES: "manage_feature_flipper_freezes";
  MANAGE_GLOBAL_FEATURE_FLIPPERS: "manage_global_feature_flippers";
  OVERRIDE_FEATURE_FLIPPER_FREEZES: "override_feature_flipper_freezes";
}
export interface SHARED_CONSTANTS_ROLES_TO_PERMISSIONS {
  account_manager: ("basic_read_only" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company")[];
  account_manager_admin: ("basic_read_only" | "can_manage_account_manager_roles" | "can_manage_internal_access" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company")[];
  admin: ("basic_read_only" | "can_access_milestone_checklist_settings" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_delete_developers" | "can_edit_tenant_list" | "can_export_segment_users_internal" | "can_manage_account_manager_roles" | "can_manage_admin_roles" | "can_manage_alliance_roles" | "can_manage_audit_roles" | "can_manage_devops_roles" | "can_manage_engineering_roles" | "can_manage_growth_roles" | "can_manage_integration_roles" | "can_manage_internal_access" | "can_manage_marketing_roles" | "can_manage_partner_roles" | "can_manage_product_roles" | "can_manage_provisioning_ops_roles" | "can_manage_revenue_ops_roles" | "can_manage_sales_roles" | "can_manage_service_account_roles" | "can_manage_smsops_roles" | "can_manage_solcon_roles" | "can_manage_success_roles" | "can_manage_support_roles" | "can_manage_technical_account_manager_roles" | "can_manually_approve_impersonation_requests" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_manually_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_manually_approved" | "can_request_read_only_impersonation_auto_approved" | "can_request_read_only_impersonation_manually_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_auto_regression_testing" | "can_use_dust_tool" | "can_use_free_trial_api" | "can_use_incidents_management" | "can_use_sample_internal_tool" | "create_company" | "manage_company" | "manage_email" | "manage_entitlements" | "manage_feature_flipper_freezes" | "manage_feature_flippers" | "manage_global_feature_flippers" | "override_feature_flipper_freezes")[];
  alliance: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email")[];
  alliance_admin: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_manage_alliance_roles" | "can_manage_internal_access" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email")[];
  audit_admin: ("basic_read_only" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_manage_audit_roles" | "can_manage_custom_data_schema" | "can_manage_internal_access" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_run_data_exports" | "can_run_migrations" | "can_use_incidents_management" | "manage_company" | "manage_email")[];
  business_intelligence: ("basic_read_only" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email")[];
  devops: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_edit_tenant_list" | "can_manage_internal_access" | "can_move_developers" | "can_randomize_user_sampling_buckets" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_dust_tool" | "can_use_incidents_management" | "can_use_sample_internal_tool" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  devops_admin: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_delete_developers" | "can_edit_tenant_list" | "can_export_segment_users_internal" | "can_manage_account_manager_roles" | "can_manage_alliance_roles" | "can_manage_devops_roles" | "can_manage_engineering_roles" | "can_manage_growth_roles" | "can_manage_integration_roles" | "can_manage_internal_access" | "can_manage_marketing_roles" | "can_manage_partner_roles" | "can_manage_product_roles" | "can_manage_revenue_ops_roles" | "can_manage_sales_roles" | "can_manage_service_account_roles" | "can_manage_smsops_roles" | "can_manage_solcon_roles" | "can_manage_success_roles" | "can_manage_support_roles" | "can_manage_technical_account_manager_roles" | "can_manually_approve_impersonation_requests" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_manually_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_manually_approved" | "can_request_read_only_impersonation_auto_approved" | "can_request_read_only_impersonation_manually_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_auto_regression_testing" | "can_use_dust_tool" | "can_use_incidents_management" | "can_use_sample_internal_tool" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  engineering: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_manage_custom_data_schema" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_auto_regression_testing" | "can_use_dust_tool" | "can_use_sample_internal_tool" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  engineering_admin: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_delete_developers" | "can_edit_tenant_list" | "can_export_segment_users_internal" | "can_manage_custom_data_schema" | "can_manage_engineering_roles" | "can_manage_internal_access" | "can_manage_service_account_roles" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_auto_regression_testing" | "can_use_dust_tool" | "can_use_incidents_management" | "can_use_sample_internal_tool" | "create_company" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  engineering_with_oncall: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_delete_developers" | "can_edit_tenant_list" | "can_export_segment_users_internal" | "can_manage_custom_data_schema" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_auto_regression_testing" | "can_use_dust_tool" | "can_use_incidents_management" | "can_use_sample_internal_tool" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  growth: ("basic_read_only" | "can_access_milestone_checklist_settings" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_use_free_trial_api" | "manage_company" | "manage_email")[];
  growth_admin: ("basic_read_only" | "can_access_milestone_checklist_settings" | "can_delete_developers" | "can_manage_growth_roles" | "can_manage_internal_access" | "can_manage_provisioning_ops_roles" | "can_manually_approve_impersonation_requests" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_use_free_trial_api" | "create_company" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  growth_engineer: ("basic_read_only" | "can_access_milestone_checklist_settings" | "can_delete_developers" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_use_free_trial_api" | "create_company" | "manage_company" | "manage_email" | "manage_feature_flippers")[];
  integration: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "create_company" | "manage_company" | "manage_email")[];
  integration_admin: ("basic_read_only" | "can_access_milestone_checklist_settings" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_manage_integration_roles" | "can_manage_internal_access" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "create_company" | "manage_company" | "manage_email" | "manage_entitlements" | "manage_feature_flippers")[];
  marketing: ("can_request_read_only_eu_impersonation_manually_approved" | "can_request_read_only_hipaa_impersonation_manually_approved" | "can_request_read_only_impersonation_manually_approved" | "can_run_data_exports")[];
  marketing_admin: ("can_manage_internal_access" | "can_manage_marketing_roles" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports")[];
  partner: "can_run_data_exports"[];
  partner_admin: ("can_manage_internal_access" | "can_manage_partner_roles" | "can_run_data_exports")[];
  product: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_dust_tool" | "can_use_sample_internal_tool" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  product_admin: ("basic_read_only" | "can_access_milestone_checklist_settings" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_delete_developers" | "can_export_segment_users_internal" | "can_manage_internal_access" | "can_manage_product_roles" | "can_move_developers" | "can_perform_random_bucket_number_backfill" | "can_randomize_user_sampling_buckets" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "can_use_dust_tool" | "can_use_free_trial_api" | "can_use_sample_internal_tool" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  provisioning_ops: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_delete_app_group" | "can_delete_developers" | "can_manage_internal_access" | "can_manage_provisioning_ops_roles" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "create_company" | "manage_company" | "manage_email" | "manage_entitlements" | "manage_feature_flippers")[];
  provisioning_ops_admin: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_delete_app_group" | "can_delete_developers" | "can_manage_internal_access" | "can_manage_provisioning_ops_roles" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "create_company" | "manage_company" | "manage_email" | "manage_entitlements" | "manage_feature_flippers")[];
  revenue_ops: ("basic_read_only" | "can_ban_companies" | "can_request_read_only_eu_impersonation_manually_approved" | "can_request_read_only_hipaa_impersonation_manually_approved" | "can_request_read_only_impersonation_manually_approved" | "can_run_data_exports")[];
  revenue_ops_admin: ("basic_read_only" | "can_ban_companies" | "can_manage_internal_access" | "can_manage_revenue_ops_roles" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports")[];
  robot: never[];
  sales: ("basic_read_only" | "can_run_data_exports" | "manage_company")[];
  sales_admin: ("basic_read_only" | "can_manage_internal_access" | "can_manage_sales_roles" | "can_request_read_only_impersonation_manually_approved" | "can_run_data_exports" | "manage_company")[];
  segments_export: ("basic_read_only" | "can_export_segment_users_internal" | "can_run_data_exports")[];
  smsops: ("basic_read_only" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_delete_developers" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "manage_company" | "manage_email" | "manage_feature_flippers")[];
  smsops_admin: ("basic_read_only" | "can_bulk_add_tags" | "can_create_sms_subscription_groups" | "can_delete_app_group" | "can_delete_developers" | "can_manage_internal_access" | "can_manage_smsops_roles" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "manage_company" | "manage_email" | "manage_feature_flippers")[];
  solcon: ("basic_read_only" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports")[];
  solcon_admin: ("basic_read_only" | "can_manage_internal_access" | "can_manage_solcon_roles" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_use_free_trial_api")[];
  solcon_eu: ("basic_read_only" | "can_request_full_access_eu_impersonation_manually_approved" | "can_request_full_access_hipaa_impersonation_manually_approved" | "can_request_full_access_impersonation_manually_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports")[];
  success: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email")[];
  success_admin: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_manage_internal_access" | "can_manage_success_roles" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email" | "manage_feature_flippers")[];
  success_eu: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email")[];
  support: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_change_export_anonymous_user_events" | "can_delete_developers" | "can_manage_custom_data_schema" | "can_move_developers" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "manage_company" | "manage_email")[];
  support_admin: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_change_export_anonymous_user_events" | "can_delete_developers" | "can_manage_custom_data_schema" | "can_manage_internal_access" | "can_manage_support_roles" | "can_move_developers" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  support_engineer: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_change_export_anonymous_user_events" | "can_delete_developers" | "can_manage_custom_data_schema" | "can_move_developers" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "manage_company" | "manage_email")[];
  support_eu: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_change_export_anonymous_user_events" | "can_delete_developers" | "can_manage_custom_data_schema" | "can_move_developers" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "manage_company" | "manage_email")[];
  support_sme: ("basic_read_only" | "can_archive_and_delete_companies" | "can_ban_companies" | "can_bulk_add_tags" | "can_change_export_anonymous_user_events" | "can_delete_developers" | "can_manage_custom_data_schema" | "can_move_developers" | "can_read_global_uptime_reports" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "can_run_migrations" | "manage_company" | "manage_email" | "manage_feature_flippers" | "manage_global_feature_flippers")[];
  technical_account_manager: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email")[];
  technical_account_manager_admin: ("basic_read_only" | "can_bulk_add_tags" | "can_delete_app_group" | "can_delete_developers" | "can_manage_internal_access" | "can_manage_technical_account_manager_roles" | "can_move_developers" | "can_remove_from_dropdown" | "can_request_full_access_eu_impersonation_auto_approved" | "can_request_full_access_hipaa_impersonation_auto_approved" | "can_request_full_access_impersonation_auto_approved" | "can_request_read_only_eu_impersonation_auto_approved" | "can_request_read_only_hipaa_impersonation_auto_approved" | "can_request_read_only_impersonation_auto_approved" | "can_run_data_exports" | "manage_company" | "manage_email")[];
}
export interface SHARED_CONSTANTS_SCOPES {
  APP_GROUP: "appgroup";
  COMPANY: "company";
  TERRITORY: "territory";
}
export interface SHARED_CONSTANTS_STATUSES {
  APPROVED: "approved";
  DECLINED: "declined";
  PENDING: "pending";
}
export interface SHARED_CONSTANTS_ROOT_INTERNAL_PERMISSIONS {
  CAN_IMPERSONATE_PERMISSIONS: SHARED_CONSTANTS_CAN_IMPERSONATE_PERMISSIONS;
  CAN_REQUEST_IMPERSONATION_PERMISSIONS: SHARED_CONSTANTS_CAN_REQUEST_IMPERSONATION_PERMISSIONS;
  INTERNAL_PERMISSIONS: SHARED_CONSTANTS_INTERNAL_PERMISSIONS;
  ROLES_TO_PERMISSIONS: SHARED_CONSTANTS_ROLES_TO_PERMISSIONS;
  SCOPES: SHARED_CONSTANTS_SCOPES;
  STATUSES: SHARED_CONSTANTS_STATUSES;
}
export interface SHARED_CONSTANTS_IMPERSONATION_ACCOUNTS {
  SUCCESS_IMPERSONATION_ACCOUNT: "Security::InternalRoles::SUCCESS_IMPERSONATION_ACCOUNT";
  SUCCESS_READ_ONLY_IMPERSONATION_ACCOUNT: "Security::InternalRoles::SUCCESS_READ_ONLY_IMPERSONATION_ACCOUNT";
}
export interface SHARED_CONSTANTS_INTERNAL_ROLES {
  ACCOUNT_MANAGER: "account_manager";
  ACCOUNT_MANAGER_ADMIN: "account_manager_admin";
  ADMIN: "admin";
  ALLIANCE: "alliance";
  ALLIANCE_ADMIN: "alliance_admin";
  AUDIT_ADMIN: "audit_admin";
  BUSINESS_INTELLIGENCE: "business_intelligence";
  DEVOPS: "devops";
  DEVOPS_ADMIN: "devops_admin";
  ENGINEERING: "engineering";
  ENGINEERING_ADMIN: "engineering_admin";
  ENGINEERING_WITH_ONCALL: "engineering_with_oncall";
  GROWTH: "growth";
  GROWTH_ADMIN: "growth_admin";
  GROWTH_ENGINEER: "growth_engineer";
  INTEGRATION: "integration";
  INTEGRATION_ADMIN: "integration_admin";
  MARKETING: "marketing";
  MARKETING_ADMIN: "marketing_admin";
  PARTNER: "partner";
  PARTNER_ADMIN: "partner_admin";
  PRODUCT: "product";
  PRODUCT_ADMIN: "product_admin";
  PROVISIONING_OPS: "provisioning_ops";
  PROVISIONING_OPS_ADMIN: "provisioning_ops_admin";
  REVENUE_OPS: "revenue_ops";
  REVENUE_OPS_ADMIN: "revenue_ops_admin";
  ROBOT: "robot";
  SALES: "sales";
  SALES_ADMIN: "sales_admin";
  SEGMENTS_EXPORT: "segments_export";
  SMSOPS: "smsops";
  SMSOPS_ADMIN: "smsops_admin";
  SOLCON: "solcon";
  SOLCON_ADMIN: "solcon_admin";
  SOLCON_EU: "solcon_eu";
  SUCCESS: "success";
  SUCCESS_ADMIN: "success_admin";
  SUCCESS_EU: "success_eu";
  SUPPORT: "support";
  SUPPORT_ADMIN: "support_admin";
  SUPPORT_ENGINEER: "support_engineer";
  SUPPORT_EU: "support_eu";
  SUPPORT_SME: "support_sme";
  TECHNICAL_ACCOUNT_MANAGER: "technical_account_manager";
  TECHNICAL_ACCOUNT_MANAGER_ADMIN: "technical_account_manager_admin";
}
export interface SHARED_CONSTANTS_INTERNAL_ROLE {
  IMPERSONATION_ACCOUNTS: SHARED_CONSTANTS_IMPERSONATION_ACCOUNTS;
  INTERNAL_ROLES: SHARED_CONSTANTS_INTERNAL_ROLES;
}
export interface SHARED_CONSTANTS_PROPERTY {
  CONTENT_TEST: "content_test";
  REST_API_LOG: "rest_api_log";
  SDK_INTERNAL_MESSAGE_LOG: "sdk_internal_message_log";
  SDK_LOG: "sdk_log";
  SEED_GROUP: "seed_group";
  USER_EVENT_LOG: "user_event_log";
}
export interface SHARED_CONSTANTS_INTERNAL_USER_GROUP {
  MAX_USERS_IN_GROUP: 2000;
  PROPERTY: SHARED_CONSTANTS_PROPERTY;
}
export interface SHARED_CONSTANTS_COMPOSER_MODE {
  DRAG_AND_DROP: "DRAG_AND_DROP";
  TRADITIONAL: "TRADITIONAL";
}
export interface SHARED_CONSTANTS_DND_DISPLAY_TYPE {
  FULLSCREEN: "FULLSCREEN";
  MODAL: "MODAL";
}
export interface SHARED_CONSTANTS_FONT_AWESOME_ICON {
  BLOCKLISTED_ICONS: ("f00f" | "f01f" | "f020" | "f03f" | "f04f" | "f05f" | "f06f" | "f07f" | "f08f" | "f09f" | "f0af" | "f0b3" | "f0b4" | "f0b5" | "f0b6" | "f0b7" | "f0b8" | "f0b9" | "f0ba" | "f0bb" | "f0bc" | "f0bd" | "f0be" | "f0bf" | "f0cf" | "f0df" | "f0ef" | "f0ff" | "f10f" | "f116" | "f117" | "f11f" | "f12f" | "f13f" | "f14f" | "f15f" | "f16f" | "f17f" | "f18f" | "f19f" | "f1af" | "f1bf" | "f1cf" | "f1df" | "f1ef" | "f1ff" | "f20f" | "f21f" | "f220" | "f22d" | "f22e" | "f22f")[];
  FIRST_VALID_ICON: "f000";
  LAST_VALID_ICON: "f23a";
}
export interface SHARED_CONSTANTS_IOS_DEVICE_OPTIONS {
  ALL: "all";
  IPADS: "ipads";
  IPHONES: "iphones";
}
export interface SHARED_CONSTANTS_SUPPORT_WARNINGS {
  ALL_DEGRADED: "all_degraded";
  ALL_UNSUPPORTED: "all_unsupported";
  SOME_DEGRADED: "some_degraded";
  SOME_UNSUPPORTED_ALL_DEGRADED: "some_unsupported_all_degraded";
  SOME_UNSUPPORTED_NONE_DEGRADED: "some_unsupported_none_degraded";
  SOME_UNSUPPORTED_SOME_DEGRADED: "some_unsupported_some_degraded";
}
export interface SHARED_CONSTANTS_CONFIRMATION_ON_CLICK_BEHAVIORS {
  CLOSE: "CLOSE";
  DEEP_LINK: "DEEP_LINK";
  REDIRECT_TO_URL: "REDIRECT_TO_URL";
}
export interface SHARED_CONSTANTS_onClickBehavior {
  action: "CLOSE";
  uri: "";
  useWebview: true;
}
export interface SHARED_CONSTANTS_confirmationButton {
  onClickBehavior: SHARED_CONSTANTS_onClickBehavior;
  text: "Close";
}
export interface SHARED_CONSTANTS_themeColor {
  a: 1;
  b: 207;
  g: 120;
  r: 27;
}
export interface SHARED_CONSTANTS_DEFAULT_SURVEY {
  body: "";
  choices: never[];
  confirmationBody: "";
  confirmationButton: SHARED_CONSTANTS_confirmationButton;
  confirmationHeader: "";
  header: "";
  helperText: "Select one.";
  isLoggingCustomAttribute: true;
  isMultipleChoice: false;
  submitBehavior: "DISPLAY_CONFIRMATION_PAGE";
  submitButtonText: "Submit";
  themeColor: SHARED_CONSTANTS_themeColor;
}
export interface SHARED_CONSTANTS_ON_CLICK_BEHAVIORS {
  CLOSE_MESSAGE_IMMEDIATELY: "CLOSE_MESSAGE_IMMEDIATELY";
  DISPLAY_CONFIRMATION_PAGE: "DISPLAY_CONFIRMATION_PAGE";
}
export interface SHARED_CONSTANTS_SURVEY {
  CONFIRMATION_ON_CLICK_BEHAVIORS: SHARED_CONSTANTS_CONFIRMATION_ON_CLICK_BEHAVIORS;
  DEFAULT_SURVEY: SHARED_CONSTANTS_DEFAULT_SURVEY;
  MAX_CHOICE_COUNT: 12;
  ON_CLICK_BEHAVIORS: SHARED_CONSTANTS_ON_CLICK_BEHAVIORS;
}
export interface SHARED_CONSTANTS_IN_APP_MESSAGE {
  COMPOSER_MODE: SHARED_CONSTANTS_COMPOSER_MODE;
  DND_DISPLAY_TYPE: SHARED_CONSTANTS_DND_DISPLAY_TYPE;
  FONT_AWESOME_ICON: SHARED_CONSTANTS_FONT_AWESOME_ICON;
  IOS_DEVICE_OPTIONS: SHARED_CONSTANTS_IOS_DEVICE_OPTIONS;
  SCRIPTS_TRAITS_CDN_URL: "https://js.appboycdn.com/channel-scripts/in-app-messages/1.2/in-app-messages.js";
  SCRIPTS_TRAITS_CDN_URL_PREV: "https://js.appboycdn.com/channel-scripts/in-app-messages/1.1/in-app-messages.js";
  SUPPORT_WARNINGS: SHARED_CONSTANTS_SUPPORT_WARNINGS;
  SURVEY: SHARED_CONSTANTS_SURVEY;
}
export interface SHARED_CONSTANTS_IOS_INTERRUPTION_LEVEL {
  ACTIVE: "active";
  CRITICAL: "critical";
  PASSIVE: "passive";
  TIME_SENSITIVE: "time-sensitive";
}
export interface SHARED_CONSTANTS_IOS_RELEVANCE_SCORE {
  DEFAULT_SCORE: 0.5;
  MAX_SCORE: 1;
  MIN_SCORE: 0;
}
export interface SHARED_CONSTANTS_BUTTON_TEXT_MAX_LENGTH {
  NARROW: 14;
  WIDE: 8;
}
export interface SHARED_CONSTANTS_BUTTON_TYPES {
  APP_LINK: "appButton";
  TEXT_REPLY: "textReplyButton";
  URL: "webButton";
}
export interface SHARED_CONSTANTS_IMAGE_LAYOUTS {
  NARROW: "narrow";
  WIDE: "wide";
}
export interface SHARED_CONSTANTS_MAX_BUTTONS {
  NARROW: 5;
  WIDE: 2;
}
export interface SHARED_CONSTANTS_MAX_IMAGE_BODY_LENGTH {
  NARROW: 400;
  WIDE: 76;
}
export interface SHARED_CONSTANTS_MESSAGE_TYPES {
  CAROUSEL: "carousel";
  IMAGE: "image";
  LIST: "list";
  TEXT: "text";
}
export interface SHARED_CONSTANTS_KAKAO {
  BUTTON_TEXT_MAX_LENGTH: SHARED_CONSTANTS_BUTTON_TEXT_MAX_LENGTH;
  BUTTON_TYPES: SHARED_CONSTANTS_BUTTON_TYPES;
  CAROUSEL_ELEMENTS_MAX: 6;
  CAROUSEL_ELEMENTS_MIN: 2;
  CAROUSEL_ELEMENT_HEADER_MAX_LENGTH: 20;
  CAROUSEL_ELEMENT_MESSAGE_MAX_LENGTH: 180;
  CAROUSEL_MAX_URL_LENGTH: 250;
  IMAGE_LAYOUTS: SHARED_CONSTANTS_IMAGE_LAYOUTS;
  LIST_ADDITIONAL_ITEMS_MAX: 3;
  LIST_ADDITIONAL_ITEMS_MIN: 2;
  LIST_FEATURED_ITEM_TITLE_MAX_LENGTH: 25;
  LIST_HEADER_MAX_LENGTH: 20;
  LIST_ITEM_TITLE_MAX_LENGTH: 30;
  LIST_ITEM_URL_MAX_LENGTH: 250;
  MAX_BUTTONS: SHARED_CONSTANTS_MAX_BUTTONS;
  MAX_BUTTON_TEXT_LENGTH: 28;
  MAX_IMAGE_BODY_LENGTH: SHARED_CONSTANTS_MAX_IMAGE_BODY_LENGTH;
  MAX_IMAGE_URL_LENGTH: 250;
  MAX_TEXT_BODY_LENGTH: 1000;
  MAX_WEBSITE_URL_LENGTH: 500;
  MESSAGE_TYPES: SHARED_CONSTANTS_MESSAGE_TYPES;
}
export interface SHARED_CONSTANTS_ROOT_KINDLE_PUSH_PAYLOAD {
  RESERVED_KEYS: ("_ab" | "a" | "ab_bs" | "ab_bt" | "ab_ct" | "ab_vs" | "cid" | "p" | "s" | "sd" | "t" | "ttl" | "uri")[];
}
export interface SHARED_CONSTANTS_ROOT_KINDLE_PUSH {
  PAYLOAD: SHARED_CONSTANTS_ROOT_KINDLE_PUSH_PAYLOAD;
}
export interface SHARED_CONSTANTS_CATALOG {
  REFRESH_INTERVAL_HOURS: 6;
}
export interface SHARED_CONSTANTS_KNOWLEDGE_SOURCE_ERROR_CODES {
  CATALOG_NOT_FOUND: "CATALOG_NOT_FOUND";
  DELETE_IN_PROGRESS: "DELETE_IN_PROGRESS";
  DELETE_IN_USE: "DELETE_IN_USE";
  DESCRIPTION_REQUIRED: "DESCRIPTION_REQUIRED";
  DESCRIPTION_TOO_LONG: "DESCRIPTION_TOO_LONG";
  DUPLICATE_CATALOG: "DUPLICATE_CATALOG";
  INVALID_TYPE: "INVALID_TYPE";
  NAME_REQUIRED: "NAME_REQUIRED";
  NAME_TOO_LONG: "NAME_TOO_LONG";
  REFRESH_IN_PROGRESS: "REFRESH_IN_PROGRESS";
  REFRESH_TOO_SOON: "REFRESH_TOO_SOON";
}
export interface SHARED_CONSTANTS_KNOWLEDGE_SOURCE {
  CATALOG: SHARED_CONSTANTS_CATALOG;
  ERROR_CODES: SHARED_CONSTANTS_KNOWLEDGE_SOURCE_ERROR_CODES;
  MIN_REFRESH_INTERVAL_HOURS: 1;
}
export interface SHARED_CONSTANTS_LANDING_PAGE_STATUS {
  ARCHIVED: "archived";
  DRAFT: "draft";
  PUBLISHED: "published";
  UNPUBLISHED: "unpublished";
}
export interface SHARED_CONSTANTS_LANDING_PAGE {
  STATUS: SHARED_CONSTANTS_LANDING_PAGE_STATUS;
}
export interface SHARED_CONSTANTS_LANDING_PAGES_COMPOSER_MODE {
  DRAG_AND_DROP: "DRAG_AND_DROP";
  TEMPLATES: "TEMPLATES";
}
export interface SHARED_CONSTANTS_LANDING_PAGES_INTERACTIONS {
  FORM_SUBMITTED: "lp_fs";
  SURVEY_SUBMITTED: "lp_ss";
}
export interface SHARED_CONSTANTS_LANDING_PAGES {
  COMPOSER_MODE: SHARED_CONSTANTS_LANDING_PAGES_COMPOSER_MODE;
  INTERACTIONS: SHARED_CONSTANTS_LANDING_PAGES_INTERACTIONS;
  MAX_HTML_LENGTH_IN_KB: 500;
  SCRIPTS_TRAITS_CDN_URL: "https://js.appboycdn.com/channel-scripts/landing-pages/2.10/landing-pages.js";
  SCRIPTS_TRAITS_CDN_URL_PREV: "https://js.appboycdn.com/channel-scripts/landing-pages/2.8/landing-pages.js";
}
export interface SHARED_CONSTANTS_LANDING_PAGE_ERRORS {
  ERROR_DUPLICATING_LANDING_PAGE: "ERROR_DUPLICATING_LANDING_PAGE";
  JUMPSTART_FOR_SAME_APPGROUP_NOT_SUPPORTED: "JUMPSTART_FOR_SAME_APPGROUP_NOT_SUPPORTED";
  JUMPSTART_INVALID_TARGET_AG: "JUMPSTART_INVALID_TARGET_AG";
  LANDING_PAGES_CROSS_WORKSPACE_CLONING_NOT_ENABLED: "LANDING_PAGES_CROSS_WORKSPACE_CLONING_NOT_ENABLED";
  LANDING_PAGE_CUSTOM_DOMAINS_LEDGER_CONFLICT: "LANDING_PAGE_CUSTOM_DOMAINS_LEDGER_CONFLICT";
  LANDING_PAGE_CUSTOM_DOMAINS_LIMIT: "LANDING_PAGE_CUSTOM_DOMAINS_LIMIT";
  LANDING_PAGE_CUSTOM_DOMAINS_LIMIT_REACHED: "LANDING_PAGE_CUSTOM_DOMAINS_LIMIT_REACHED";
  LANDING_PAGE_CUSTOM_DOMAINS_NOT_ENABLED: "LANDING_PAGE_CUSTOM_DOMAINS_NOT_ENABLED";
  LANDING_PAGE_CUSTOM_DOMAIN_ALREADY_EXISTS: "LANDING_PAGE_CUSTOM_DOMAIN_ALREADY_EXISTS";
  LANDING_PAGE_CUSTOM_DOMAIN_DOES_NOT_EXIST: "LANDING_PAGE_CUSTOM_DOMAIN_DOES_NOT_EXIST";
  LANDING_PAGE_NOT_FOUND: "LANDING_PAGE_NOT_FOUND";
  LANDING_PAGE_NOT_OPTED_IN: "LANDING_PAGE_NOT_OPTED_IN";
  LANDING_PAGE_TEMPLATE_NOT_FOUND: "LANDING_PAGE_TEMPLATE_NOT_FOUND";
  SOURCE_LANDING_PAGE_NOT_FOUND: "SOURCE_LANDING_PAGE_NOT_FOUND";
  TARGET_APP_GROUP_NOT_FOUND: "TARGET_APP_GROUP_NOT_FOUND";
}
export interface SHARED_CONSTANTS_LEARNING_SANDBOX_TEST_SEND_ERRORS {
  TEST_SEND_DISABLED: "LEARNING_SANDBOX_TEST_SEND_DISABLED";
}
export interface SHARED_CONSTANTS_FOLLOW_TYPES {
  FOLLOW: 1;
  UNFOLLOW: 0;
}
export interface SHARED_CONSTANTS_LINE_MESSAGE_TYPES {
  CAROUSEL: "carousel";
  IMAGE: "image";
  RICH_MESSAGE: "rich_message";
  TEXT: "text";
}
export interface SHARED_CONSTANTS_LINE {
  FOLLOW_TYPES: SHARED_CONSTANTS_FOLLOW_TYPES;
  MESSAGE_TYPES: SHARED_CONSTANTS_LINE_MESSAGE_TYPES;
  USER_ALIAS_LABEL: "line_id";
}
export interface SHARED_CONSTANTS_ALLOWED_APP_ATTRIBUTES_WHITELIST {
  api_id: "ak";
  name: "name";
}
export interface SHARED_CONSTANTS_ALLOWED_ATTRIBUTES_WHITELIST {
  braze_id: "_id";
  brz_created_at: "c_at";
  city: "up.c";
  country: "up.cc";
  date_of_birth: "up.d";
  email_address: "email";
  first_name: "fn";
  gender: "up.g";
  language: "up.l";
  last_name: "ln";
  last_used_app_date: "up.s.ls";
  line_id: "up.lid";
  most_recent_app_version: "up.s.mv";
  most_recent_locale: "up.lc";
  most_recent_location: "up.mrla";
  phone_number: "up.p";
  random_bucket_number: "rc";
  time_zone: "up.tz";
  user_id: "eid";
}
export interface SHARED_CONSTANTS_ALLOWED_CAMPAIGN_ATTRIBUTES_WHITELIST {
  api_id: "ac_id";
  name: "n";
}
export interface SHARED_CONSTANTS_ALLOWED_CARD_ATTRIBUTES_WHITELIST {
  api_id: "eid";
  name: "n";
}
export interface SHARED_CONSTANTS_ALLOWED_MESSAGE_VARIATION_ATTRIBUTES_WHITELIST {
  message_api_id: "am_id";
  message_name: "name";
}
export interface SHARED_CONSTANTS_ALLOWED_SMS_PROPERTIES_WHITELIST {
  inbound_media_urls: "media_urls";
  inbound_message_body: "body";
  "subscribed_state.${<subscription_group_id>}": "subscribed_state.${<subscription_group_id>}";
}
export interface SHARED_CONSTANTS_ALLOWED_SUBSCRIBED_STATE_WHITE_LIST {
  email_global: ("up.eo_at" | "up.eu_at")[];
}
export interface SHARED_CONSTANTS_ALLOWED_WHATS_APP_PROPERTIES_WHITELIST {
  inbound_bsuid: "bsuid";
  inbound_catalog_id: "catalog_id";
  inbound_flow_response: "flow_response";
  inbound_media_urls: "media_urls";
  inbound_message_body: "body";
  inbound_product_id: "product_id";
  inbound_profile_name: "profile_name";
}
export interface SHARED_CONSTANTS_ALLOWED_WORKFLOW_ATTRIBUTES_WHITELIST {
  api_id: "ac_id";
  name: "n";
}
export interface SHARED_CONSTANTS_ALLOWED_WORKFLOW_VARIANT_ATTRIBUTES_WHITELIST {
  variant_api_id: "av_id";
  variant_name: "n";
}
export interface SHARED_CONSTANTS_LIQUID_EMAIL {
  DEPRECATED_OPT_IN_URL_KEY: "subscription_confirmation_url";
  DEPRECATED_SUBSCRIBE_URL_KEY: "resubscribe_url";
  DEPRECATED_UNSUBSCRIBE_URL_KEY: "unsubscribe_url";
  FOOTER_KEY: "email_footer";
  GLOBAL_ONE_CLICK_UNSUBSCRIBE_URL_KEY: "set_user_to_one_click_list_unsubscribe";
  OPT_IN_URL_KEY: "set_user_to_opted_in_url";
  PREFERENCE_CENTER_URL_KEY: "preference_center_url";
  SUBSCRIBE_STATE_EMAIL_GLOBAL: "subscribed_state.${email_global}";
  SUBSCRIBE_STATE_SUBSCRIPTION_GROUP_ID: "subscribed_state.${<subscription_group_id>}";
  SUBSCRIBE_URL_KEY: "set_user_to_subscribed_url";
  UNSUBSCRIBE_URL_KEY: "set_user_to_unsubscribed_url";
}
export interface SHARED_CONSTANTS_GENDERS {
  FEMALE: "female";
  MALE: "male";
  NOT_APPLICABLE: "not applicable";
  OTHER: "other";
  PREFER_NOT_TO_SAY: "prefer not to say";
  UNKNOWN: "unknown";
}
export interface SHARED_CONSTANTS_NAMESPACES {
  AI_STEP_OUTPUT: "ai_step_output";
  API_TRIGGER_EVENT_PROPERTIES: "api_trigger_properties";
  B2B: "business";
  CAMPAIGN_PROPERTIES: "campaign";
  CANVAS_ENTRY_PROPERTIES: "canvas_entry_properties";
  CARD_PROPERTIES: "card";
  CATALOG_FILTERED_SETS: "catalog_selection_items";
  CATALOG_ITEMS: "catalog_items";
  CONTENT_BLOCKS: "content_blocks";
  CONTEXT_PROPERTIES: "context";
  CUSTOM_ATTRIBUTES: "custom_attribute";
  DATA_OBJECTS: "data_object";
  EVENT_PROPERTIES: "event_properties";
  LANDING_PAGE: "landing_page_url";
  MESSAGE_EXTRAS: "message_extras";
  MOST_RECENT_DEVICE_ATTRIBUTES: "most_recently_used_device";
  PREFERENCE_CENTER: "preference_center";
  PRODUCT_RECOMMENDATION: "product_recommendation";
  SMS_PROPERTIES: "sms";
  SUBSCRIBED_STATE_PROPERTIES: "subscribed_state";
  TARGETED_DEVICE_ATTRIBUTES: "targeted_device";
  TRANSLATIONS: "translation";
  WHATS_APP_PROPERTIES: "whats_app";
  WORKFLOW_PROPERTIES: "canvas";
}
export interface SHARED_CONSTANTS_REGEXES {
  CONDITIONAL_TAG: "{%\\s*(if|elsif|unless).+?%}";
  OBJECT: "\\{\\{.*?\\}?\\}\\}";
  OBJECT_END: "\\}\\}";
  OBJECT_START: "\\{\\{";
  TAG: "\\{\\%.*?\\%\\}";
  TAG_END: "\\%\\}";
  TAG_OR_OBJECT: "\\{\\%.*?\\%\\}|\\{\\{.*?\\}?\\}\\}";
  TAG_START: "\\{\\%";
}
export interface SHARED_CONSTANTS_LIQUID_TYPES {
  ADVANCED_EVENT_PROPERTIES: "advancedEventProperty";
  AI_STEP_OUTPUT: "aiStepOutput";
  API_TRIGGER_EVENT_PROPERTIES: "apiTriggerEventProperty";
  B2B: "business";
  BASIC_ATTRIBUTES: "basicAttribute";
  CAMPAIGN_PROPERTIES: "campaignProperty";
  CARD_PROPERTIES: "cardProperty";
  CATALOG_ITEMS: "catalogItem";
  CONTENT_BLOCKS: "contentBlock";
  CONTENT_OPTIMIZATION: "contentOptimization";
  CONTEXT_PROPERTIES: "contextProperty";
  CONTEXT_VARIABLES: "contextVariables";
  CUSTOM_ATTRIBUTES: "customAttribute";
  DATA_OBJECTS: "dataObject";
  DECISIONING_CREATIVE_COMPONENT: "decisioningCreativeComponent";
  EMAIL_PROPERTIES: "emailProperty";
  EVENT_PROPERTIES: "eventProperty";
  INVALID: "invalid";
  LANDING_PAGE: "landingPage";
  MESSAGE_EXTRAS: "messageExtras";
  MOST_RECENT_DEVICE_ATTRIBUTES: "mostRecentDeviceAttribute";
  MOST_RECENT_LOCATION: "mostRecentLocation";
  NESTED_CUSTOM_ATTRIBUTES: "nestedCustomAttribute";
  PREFERENCE_CENTER: "preferenceCenter";
  PRODUCT_RECOMMENDATION: "productRecommendation";
  SMS_PROPERTIES: "smsProperty";
  SUBSCRIBED_STATE_PROPERTIES: "subscribedStateProperty";
  TARGETED_DEVICE_ATTRIBUTES: "targetedDeviceAttribute";
  TRANSLATION: "translation";
  WHATS_APP_PROPERTIES: "whatsAppProperty";
  WORKFLOW_PROPERTIES: "workflowProperty";
}
export interface SHARED_CONSTANTS_LIQUID {
  ALLOWED_APP_ATTRIBUTES_WHITELIST: SHARED_CONSTANTS_ALLOWED_APP_ATTRIBUTES_WHITELIST;
  ALLOWED_ATTRIBUTES_WHITELIST: SHARED_CONSTANTS_ALLOWED_ATTRIBUTES_WHITELIST;
  ALLOWED_CAMPAIGN_ATTRIBUTES_WHITELIST: SHARED_CONSTANTS_ALLOWED_CAMPAIGN_ATTRIBUTES_WHITELIST;
  ALLOWED_CARD_ATTRIBUTES_WHITELIST: SHARED_CONSTANTS_ALLOWED_CARD_ATTRIBUTES_WHITELIST;
  ALLOWED_MESSAGE_VARIATION_ATTRIBUTES_WHITELIST: SHARED_CONSTANTS_ALLOWED_MESSAGE_VARIATION_ATTRIBUTES_WHITELIST;
  ALLOWED_SMS_PROPERTIES_WHITELIST: SHARED_CONSTANTS_ALLOWED_SMS_PROPERTIES_WHITELIST;
  ALLOWED_SUBSCRIBED_STATE_WHITE_LIST: SHARED_CONSTANTS_ALLOWED_SUBSCRIBED_STATE_WHITE_LIST;
  ALLOWED_WHATS_APP_PROPERTIES_WHITELIST: SHARED_CONSTANTS_ALLOWED_WHATS_APP_PROPERTIES_WHITELIST;
  ALLOWED_WORKFLOW_ATTRIBUTES_WHITELIST: SHARED_CONSTANTS_ALLOWED_WORKFLOW_ATTRIBUTES_WHITELIST;
  ALLOWED_WORKFLOW_VARIANT_ATTRIBUTES_WHITELIST: SHARED_CONSTANTS_ALLOWED_WORKFLOW_VARIANT_ATTRIBUTES_WHITELIST;
  DISPATCH_ID_KEY: "dispatch_id";
  EMAIL: SHARED_CONSTANTS_LIQUID_EMAIL;
  GENDERS: SHARED_CONSTANTS_GENDERS;
  NAMESPACES: SHARED_CONSTANTS_NAMESPACES;
  REGEXES: SHARED_CONSTANTS_REGEXES;
  TYPES: SHARED_CONSTANTS_LIQUID_TYPES;
}
export interface SHARED_CONSTANTS_CONTENT_TYPES {
  HTML: "html";
  TEXT: "text";
}
export interface SHARED_CONSTANTS_CONTENT_BLOCKS_CUSTOM_GROUPINGS {
  CREATED_BY: "created_by";
  LAST_EDITED_BY: "last_edited_by";
}
export interface SHARED_CONSTANTS_CONTENT_BLOCKS_ERROR_CODES {
  CANNOT_ARCHIVE_INCLUDED_CONTENT_BLOCK: "CANNOT_ARCHIVE_INCLUDED_CONTENT_BLOCK";
  CONTENT_BLOCK_NOT_FOUND: "CONTENT_BLOCK_NOT_FOUND";
  CONTENT_BLOCK_NOT_FOUND_FOR_JUMPSTART: "CONTENT_BLOCK_NOT_FOUND_FOR_JUMPSTART";
  CONTENT_TOO_LONG: "CONTENT_TOO_LONG";
  DUPLICATE_CONTENT_BLOCK_NAME: "DUPLICATE_CONTENT_BLOCK_NAME";
  INVALID_CONTENT_BLOCK_REFERENCE: "INVALID_CONTENT_BLOCK_REFERENCE";
  INVALID_GRAPES_JS_DATA: "INVALID_GRAPES_JS_DATA";
  INVALID_GRAPES_SUPPORTED_CHANNELS: "INVALID_GRAPES_SUPPORTED_CHANNELS";
  NO_PERMISSIONS: "NO_PERMISSIONS";
  TEMPLATE_PARSE_ERROR: "TEMPLATE_PARSE_ERROR";
  VALIDATION_ERROR: "VALIDATION_ERROR";
}
export interface SHARED_CONSTANTS_INCLUSION_SUFFIXES {
  "Appboy::Communication::Marketing::Campaign": "Campaign";
  "Appboy::Communication::Marketing::Workflow": "Canvas Step";
}
export interface SHARED_CONSTANTS_INCLUSION_TYPES {
  android_china_push: "Android China Push";
  android_push: "Android Push";
  api: "API";
  banner: "Banner";
  banner_template: "Banner Template";
  card: "Card";
  content_block: "Content Block";
  content_cards: "Content Cards";
  control: "Control";
  email: "Email";
  email_template: "Email Template";
  feature_flag: "Feature Flags";
  feature_flag_experiment: "Feature Flag Experiments";
  in_app_message: "Original In-App Message";
  ios_push: "iOS Push";
  kindle_push: "Kindle Push";
  landing_page: "Landing Page";
  landing_page_template: "Landing Page Template";
  line: "LINE";
  link_template: "Link Template";
  multi: "Multichannel";
  preference_center: "Preference Center";
  sms: "SMS/RCS";
  step_base: "Step Base";
  trigger_in_app_message: "In-App Message";
  web_push: "Web Push";
  webhook: "Webhook";
  webhook_template: "Webhook Template";
  whats_app: "WhatsApp";
  windows_universal_push: "Windows Universal Push";
}
export interface SHARED_CONSTANTS_CONTENT_BLOCKS_SEARCHABLE_STATUSES {
  DRAFT: "draft";
}
export interface SHARED_CONSTANTS_CONTENT_BLOCKS_SEARCH_KEYS {
  CONTENT_TYPE: "content_type";
}
export interface SHARED_CONSTANTS_CONTENT_BLOCKS {
  CONTENT_BLOCKS_LIMIT: 8;
  CONTENT_DEFAULT_MAX_SIZE: 51200;
  CONTENT_FREE_TRIAL_MAX_SIZE: 51200;
  CONTENT_TYPES: SHARED_CONSTANTS_CONTENT_TYPES;
  CUSTOM_GROUPINGS: SHARED_CONSTANTS_CONTENT_BLOCKS_CUSTOM_GROUPINGS;
  DESCRIPTION_MAX_LENGTH: 250;
  ERROR_CODES: SHARED_CONSTANTS_CONTENT_BLOCKS_ERROR_CODES;
  INCLUSION_SUFFIXES: SHARED_CONSTANTS_INCLUSION_SUFFIXES;
  INCLUSION_TYPES: SHARED_CONSTANTS_INCLUSION_TYPES;
  LIQUID_TAG: "content_blocks";
  NAME_MAX_LENGTH: 100;
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_CONTENT_BLOCKS_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_CONTENT_BLOCKS_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_LIQUID_CONSTANTS_NAMESPACES {
  API_TRIGGER_EVENT_PROPERTIES: "api_trigger_properties";
  CAMPAIGN_PROPERTIES: "campaign";
  CAMPAIGN_PROPERTIES_WITHOUT_DISPATCH: "campaign";
  CANVAS_ENTRY_PROPERTIES: "canvas_entry_properties";
  CARD_PROPERTIES: "card";
  CATALOG_FILTERED_SETS: "catalog_selection_items";
  CATALOG_ITEMS: "catalog_items";
  CONTENT_BLOCKS: "content_blocks";
  CONTEXT_PROPERTIES: "context";
  CUSTOM_ATTRIBUTES: "custom_attribute";
  EVENT_PROPERTIES: "event_properties";
  LANDING_PAGE: "landing_page_url";
  MESSAGE_EXTRAS: "message_extras";
  MOST_RECENT_DEVICE_ATTRIBUTES: "most_recently_used_device";
  PREFERENCE_CENTER: "preference_center";
  PRODUCT_RECOMMENDATION: "product_recommendation";
  SMS_PROPERTIES: "sms";
  SUBSCRIBED_STATE_PROPERTIES: "subscribed_state";
  TARGETED_DEVICE_ATTRIBUTES: "targeted_device";
  WHATS_APP_PROPERTIES: "whats_app";
  WORKFLOW_PROPERTIES: "canvas";
}
export interface SHARED_CONSTANTS_SPECIAL_TAGS {
  ABORT_MESSAGE: "abort_message";
  CONNECTED_CONTENT: "connected_content";
  DATA_FEED: "load_data_feed";
  DECISIONING_CREATIVE_COMPONENT: "decisioning_creative_component";
  PROMOTIONS: "promotion";
  RANDOM: "random";
  SUBSCRIBE_STATE_EMAIL_GLOBAL: "subscribed_state.${email_global}";
  SUBSCRIBE_STATE_SUBSCRIPTION_GROUP_ID: "subscribed_state.${<subscription_group_id>}";
  VOUCHER: "voucher";
}
export interface SHARED_CONSTANTS_LIQUID_CONSTANTS_TYPES {
  ADVANCED_EVENT_PROPERTIES: "advancedEventProperty";
  AI_STEP_OUTPUT: "aiStepOutput";
  API_TRIGGER_EVENT_PROPERTIES: "apiTriggerEventProperty";
  B2B: "business";
  BASIC_ATTRIBUTES: "basicAttribute";
  CAMPAIGN_PROPERTIES: "campaignProperty";
  CARD_PROPERTIES: "cardProperty";
  CATALOG_ITEMS: "catalogItem";
  CONTENT_BLOCKS: "contentBlock";
  CONTENT_OPTIMIZATION: "contentOptimization";
  CONTEXT_PROPERTIES: "contextProperty";
  CONTEXT_VARIABLES: "contextVariables";
  CUSTOM_ATTRIBUTES: "customAttribute";
  DATA_OBJECTS: "dataObject";
  DECISIONING_CREATIVE_COMPONENT: "decisioningCreativeComponent";
  EMAIL_PROPERTIES: "emailProperty";
  EVENT_PROPERTIES: "eventProperty";
  INVALID: "invalid";
  LANDING_PAGE: "landingPage";
  MESSAGE_EXTRAS: "messageExtras";
  MOST_RECENT_DEVICE_ATTRIBUTES: "mostRecentDeviceAttribute";
  MOST_RECENT_LOCATION: "mostRecentLocation";
  NESTED_CUSTOM_ATTRIBUTES: "nestedCustomAttribute";
  PREFERENCE_CENTER: "preferenceCenter";
  PRODUCT_RECOMMENDATION: "productRecommendation";
  SMS_PROPERTIES: "smsProperty";
  SUBSCRIBED_STATE_PROPERTIES: "subscribedStateProperty";
  TARGETED_DEVICE_ATTRIBUTES: "targetedDeviceAttribute";
  TRANSLATION: "translation";
  WHATS_APP_PROPERTIES: "whatsAppProperty";
  WORKFLOW_PROPERTIES: "workflowProperty";
}
export interface SHARED_CONSTANTS_WHITELISTED_VALUES {
  BASIC_ATTRIBUTES: ("braze_id" | "brz_created_at" | "city" | "country" | "date_of_birth" | "email_address" | "first_name" | "gender" | "language" | "last_name" | "last_used_app_date" | "line_id" | "most_recent_app_version" | "most_recent_locale" | "most_recent_location" | "phone_number" | "random_bucket_number" | "time_zone" | "user_id")[];
  CARD_PROPERTIES: ("api_id" | "name")[];
  EMAIL_PROPERTIES: ("email_footer" | "set_user_to_opted_in_url" | "set_user_to_subscribed_url" | "set_user_to_unsubscribed_url" | "subscribed_state.${<subscription_group_id>}" | "subscribed_state.${email_global}")[];
  SMS_PROPERTIES: ("inbound_media_urls" | "inbound_message_body" | "subscribed_state.${<subscription_group_id>}")[];
  SUBSCRIBED_STATE_PROPERTIES: "email_global"[];
  WHATS_APP_PROPERTIES: ("inbound_bsuid" | "inbound_catalog_id" | "inbound_flow_response" | "inbound_media_urls" | "inbound_message_body" | "inbound_product_id" | "inbound_profile_name")[];
  WORKFLOW_PROPERTIES: ("api_id" | "name" | "variant_api_id" | "variant_name")[];
}
export interface SHARED_CONSTANTS_LIQUID_CONSTANTS {
  ALLOWED_DEVICE_ATTRIBUTES_WHITELIST_FF_OFF: ("ad_id_type" | "ad_tracking_enabled" | "browser" | "carrier" | "foreground_push_enabled" | "id" | "idfa" | "idfv" | "model" | "os" | "platform")[];
  ALLOWED_DEVICE_ATTRIBUTES_WHITELIST_FF_ON: ("ad_id_type" | "ad_tracking_enabled" | "browser" | "carrier" | "foreground_push_enabled" | "google_ad_id" | "id" | "idfa" | "idfv" | "model" | "os" | "platform" | "roku_ad_id" | "windows_ad_id")[];
  CAMPAIGN_UNIVERSAL_PROPERTIES: ("api_id" | "message_api_id" | "message_name" | "name")[];
  CONTENT_BLOCKS: SHARED_CONSTANTS_CONTENT_BLOCKS;
  DEPRECATED_OPT_IN_URL_KEY: "{{${subscription_confirmation_url}}}";
  DEPRECATED_SUBSCRIBE_URL_KEY: "{{${resubscribe_url}}}";
  DEPRECATED_UNSUBSCRIBE_URL_KEY: "{{${unsubscribe_url}}}";
  DISPATCH_ID_KEY: "dispatch_id";
  FOOTER_KEY: "{{${email_footer}}}";
  GLOBAL_ONE_CLICK_UNSUBSCRIBE_URL_KEY: "{{${set_user_to_one_click_list_unsubscribe}}}";
  INBOUND_BSUID_KEY: "{{${inbound_bsuid}}}";
  INBOUND_CATALOG_ID_KEY: "{{${inbound_catalog_id}}}";
  INBOUND_FLOW_RESPONSE_KEY: "{{${inbound_flow_response}}}";
  INBOUND_MEDIA_URLS_KEY: "{{${inbound_media_urls}}}";
  INBOUND_MESSAGE_BODY_KEY: "{{${inbound_message_body}}}";
  INBOUND_PRODUCT_ID_KEY: "{{${inbound_product_id}}}";
  INBOUND_PROFILE_NAME_KEY: "{{${inbound_profile_name}}}";
  NAMESPACES: SHARED_CONSTANTS_LIQUID_CONSTANTS_NAMESPACES;
  OPT_IN_URL_KEY: "{{${set_user_to_opted_in_url}}}";
  PREFERENCE_CENTER_URL_ACTUAL_KEY: "preference_center_url";
  PREFERENCE_CENTER_URL_KEY: "{{${preference_center_url}}}";
  SPECIAL_TAGS: SHARED_CONSTANTS_SPECIAL_TAGS;
  SUBSCRIBE_STATE_EMAIL_GLOBAL_KEY: "{{subscribed_state.${email_global}}}";
  SUBSCRIBE_STATE_SUBSCRIPTION_GROUP_ID_KEY: "{{subscribed_state.${<subscription group id>}}}";
  SUBSCRIBE_URL_KEY: "{{${set_user_to_subscribed_url}}}";
  TYPES: SHARED_CONSTANTS_LIQUID_CONSTANTS_TYPES;
  UNSUBSCRIBE_URL_KEY: "{{${set_user_to_unsubscribed_url}}}";
  WHITELISTED_VALUES: SHARED_CONSTANTS_WHITELISTED_VALUES;
}
export interface SHARED_CONSTANTS_LIQUID_VALIDATION_ERROR_CODES {
  MESSAGE_EMPTY: "MESSAGE_EMPTY";
  MESSAGE_TOO_LARGE: "MESSAGE_TOO_LARGE";
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR";
}
export interface SHARED_CONSTANTS_LIQUID_VALIDATION {
  ERROR_CODES: SHARED_CONSTANTS_LIQUID_VALIDATION_ERROR_CODES;
}
export interface SHARED_CONSTANTS_LIST_UNSUBSCRIBE_SCOPES {
  EXCLUDE_UNSUBSCRIBE: 4;
  UNSUBSCRIBE_FROM_SPECIFIC_SUBSCRIPTION_GROUP: 2;
  UNSUBSCRIBE_GLOBALLY_FROM_ALL_EMAILS: 1;
  USE_CUSTOM_URL: 3;
  USE_WORKSPACE_DEFAULT: 0;
}
export interface SHARED_CONSTANTS_LIST_UNSUBSCRIBE {
  SCOPES: SHARED_CONSTANTS_LIST_UNSUBSCRIBE_SCOPES;
}
export interface SHARED_CONSTANTS_POLYGON {
  lat: 40.53780786355762 | 40.56389453066509 | 40.60561205826018 | 40.62437645591559 | 40.75297891717686 | 40.83251504043271 | 40.853293085675155 | 40.932190241465634 | 40.967455873296714 | 40.98197154086656 | 40.9840449469281 | 41.075210270566636 | 41.10212132036491 | 41.19932314127607 | 41.21585377825921 | 41.29431726315258 | 41.37680856570233 | 41.508577297439324 | 41.6195489884308 | 41.840920397579936 | 41.881831370505594 | 41.95540515378059 | 42.004407212963585 | 42.01665183556825 | 42.27730877423709 | 42.80144655484334 | 42.85784648372956 | 42.99309675891523 | 43.05383740681216 | 43.06512552869402 | 43.0819284373621 | 43.12103377575541 | 43.14358318577351 | 43.26170616337345 | 43.26720631662829 | 43.27720532212024 | 43.29020157325698 | 43.297198404646366 | 43.34914966389313 | 43.35813671794957 | 43.39706523932025 | 43.52266348752663 | 43.52714431360083 | 43.54058479482877 | 43.54854811091286 | 43.5505387755674 | 43.618182252818244 | 43.62613531177414 | 43.781009658142914 | 43.84245116699039 | 43.97700467496408 | 44.12702800650004 | 44.136884638560495 | 44.275688020707946 | 44.64911632343077 | 44.859762688042736 | 45.00365115687189 | 45.01530198999212;
  lng: -71.81591033935545 | -72.19493865966797 | -72.476806640625 | -73.15074920654297 | -73.18645477294922 | -73.18920135498047 | -73.2623291015625 | -73.2733154296875 | -73.27880859375 | -73.30078125 | -73.3172607421875 | -73.34197998046875 | -73.3612060546875 | -73.36944580078125 | -73.3941650390625 | -73.4061813354492 | -73.4326171875 | -73.43536376953125 | -73.48480224609375 | -73.5040283203125 | -73.55003356933594 | -73.57372283935547 | -73.6468505859375 | -73.72650146484375 | -73.81267547607422 | -73.89404296875 | -73.96751403808592 | -74.01695251464844 | -74.04441833496094 | -74.69261169433592 | -74.7509765625 | -74.96726989746094 | -75.05516052246094 | -75.1190185546875 | -75.22544860839844 | -75.2398681640625 | -75.35179138183594 | -75.55847167968749 | -76.18743896484375 | -76.29180908203125 | -76.37695312499999 | -76.40510559082031 | -77.02239990234375 | -77.10205078124999 | -77.46047973632811 | -77.78045654296875 | -78.2666015625 | -78.67584228515625 | -78.84063720703124 | -78.99856567382812 | -79.00543212890625 | -79.01847839355469 | -79.03804779052734 | -79.06791687011719 | -79.07066345214844 | -79.07478332519531 | -79.72503662109375 | -79.74700927734375;
}
export interface SHARED_CONSTANTS_DEFAULT_LOCATIONS {
  LAT: 40.75354;
  LNG: -73.99527;
  POLYGON: SHARED_CONSTANTS_POLYGON[];
  RADIUS_IN_METERS: 8046.722489462817;
}
export interface SHARED_CONSTANTS_GEO_FENCE_TYPES {
  WITHIN_CIRCLE: "13";
  WITHIN_POLYGON: "14";
}
export interface SHARED_CONSTANTS_LOCATION_SETS_SEARCH_KEYS {
  STATUS: "status";
  TAG: "tag";
}
export interface SHARED_CONSTANTS_LOCATION_SETS {
  SEARCH_KEYS: SHARED_CONSTANTS_LOCATION_SETS_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_LOCATION_SET_MANAGEMENT_ERRORS {
  GEOFENCE_COOLDOWN_ENTER_RANGE: "GEOFENCE_COOLDOWN_ENTER_RANGE";
  GEOFENCE_COOLDOWN_EXIT_RANGE: "GEOFENCE_COOLDOWN_EXIT_RANGE";
  GEOFENCE_LATITUDE_RANGE: "GEOFENCE_LATITUDE_RANGE";
  GEOFENCE_LOCATION_REQUIRED: "GEOFENCE_LOCATION_REQUIRED";
  GEOFENCE_LONGITUDE_RANGE: "GEOFENCE_LONGITUDE_RANGE";
  GEOFENCE_NAME_REQUIRED: "GEOFENCE_NAME_REQUIRED";
  GEOFENCE_NOTIFICATION_RESPONSIVENESS_RANGE: "GEOFENCE_NOTIFICATION_RESPONSIVENESS_RANGE";
  GEOFENCE_RADIUS_RANGE: "GEOFENCE_RADIUS_RANGE";
  GEOFENCE_RADIUS_REQUIRED: "GEOFENCE_RADIUS_REQUIRED";
  LOCATION_SET_ID_INVALID: "LOCATION_SET_ID_INVALID";
  LOCATION_SET_ID_REQUIRED: "LOCATION_SET_ID_REQUIRED";
  LOCATION_SET_NAME_REQUIRED: "LOCATION_SET_NAME_REQUIRED";
}
export interface SHARED_CONSTANTS_LOCATION_TYPES {
  CIRCLE: "circle";
  POLYGON: "polygon";
}
export interface SHARED_CONSTANTS_LOCATION {
  CIRCLE_COMPARISON_KEY: "13";
  CIRCLE_NOT_COMPARISON_KEY: "18";
  DEFAULT_LOCATIONS: SHARED_CONSTANTS_DEFAULT_LOCATIONS;
  GEO_FENCE_TYPES: SHARED_CONSTANTS_GEO_FENCE_TYPES;
  LAT_LNG_SHORT_DISPLAY_PRECISION: 2;
  LOCATION_SETS: SHARED_CONSTANTS_LOCATION_SETS;
  LOCATION_SET_MANAGEMENT_ERRORS: SHARED_CONSTANTS_LOCATION_SET_MANAGEMENT_ERRORS;
  LOCATION_TYPES: SHARED_CONSTANTS_LOCATION_TYPES;
  MAPBOX_API_KEY: "pk.eyJ1IjoiYXBwYm95bWFwcyIsImEiOiJyRGdWalRZIn0.WBXRAWkPHe-pVgjgT_S75w";
  MAPBOX_GEOCODING_TYPE: "mapbox.places";
  MAPBOX_MAP_ID: "appboymaps.h5d73j1k";
  MAPBOX_STYLE_LAYER: "mapbox://styles/mapbox/streets-v11";
  MARKER_ICON_URL: "https://cdn.braze.com/dashboard-assets/dashboard/marker-icon-2x.png";
  MAX_GEOFENCE_LATITUDE: 85.05112878;
  MAX_GEOFENCE_LONGITUDE: 180;
  MAX_GEOFENCE_RADIUS: 100000;
  METERS_TO_MILES_CONVERSION_FACTOR: 0.000621371;
  MIN_GEOFENCE_LATITUDE: -85.05112878;
  MIN_GEOFENCE_LONGITUDE: -180;
  MIN_GEOFENCE_RADIUS: 1;
  NUM_SLIDER_STEPS: 1000;
  POLYGON_COMPARISON_KEY: "14";
  POLYGON_NOT_COMPARISON_KEY: "19";
}
export interface SHARED_CONSTANTS_BULK_DUPLICATE_USER_MERGER {
  IDENTIFIER_EMAIL: "email_address";
  IDENTIFIER_PHONE: "phone_number";
  SORT_ORDER_NEWEST: "Newest";
  SORT_ORDER_OLDEST: "Oldest";
  TIEBREAKER_FIELD_CREATED: "Created date";
  TIEBREAKER_FIELD_LAST_SESSION: "Last session";
  TIEBREAKER_FIELD_UPDATED: "Updated date";
}
export interface SHARED_CONSTANTS_MANAGE_AUDIENCE {
  BULK_DUPLICATE_USER_MERGER: SHARED_CONSTANTS_BULK_DUPLICATE_USER_MERGER;
}
export interface SHARED_CONSTANTS_API_ERRORS {
  ASSET_NOT_FOUND: "ASSET_NOT_FOUND";
  GENERIC_ERROR: "GENERIC_ERROR";
  UNSUPPORTED_FILE_TYPE: "UNSUPPORTED_FILE_TYPE";
  VIDEO_NOT_FOUND_URL_GENERATION_FAILED: "VIDEO_NOT_FOUND_URL_GENERATION_FAILED";
}
export interface SHARED_CONSTANTS_ASPECT_RATIOS {
  FIVE_TO_FOUR: "5:4";
  FIVE_TO_THREE: "5:3";
  FOUR_TO_THREE: "4:3";
  ONE_TO_ONE: "1:1";
  SIXTEEN_TO_FIVE: "16:5";
  SIXTEEN_TO_TEN: "16:10";
  SIX_TO_FIVE: "6:5";
  SIX_TO_ONE: "6:1";
  TEN_TO_SIXTEEN: "10:16";
  TEN_TO_THREE: "10:3";
  THREE_TO_FIVE: "3:5";
  THREE_TO_FOUR: "3:4";
  THREE_TO_TWO: "3:2";
  TWENTY_NINE_TO_TEN: "29:10";
  TWO_TO_ONE: "2:1";
}
export interface SHARED_CONSTANTS_ASPECT_RATIO_DECIMALS {
  "10:16": 0.625;
  "10:3": 3.333;
  "16:10": 1.6;
  "16:5": 3.2;
  "1:1": 1;
  "29:10": 2.9;
  "2:1": 2;
  "3:2": 1.5;
  "3:4": 0.75;
  "3:5": 0.6;
  "4:3": 1.333;
  "5:3": 1.667;
  "5:4": 1.25;
  "6:1": 6;
  "6:5": 1.2;
}
export interface SHARED_CONSTANTS_ASSET_TYPES {
  CODE: "Appboy::Communication::Assets::CodeAsset";
  DOCUMENT: "Appboy::Communication::Assets::DocumentAsset";
  FONT: "Appboy::Communication::Assets::FontAsset";
  IMAGE: "Appboy::Communication::Assets::ImageAsset";
  OTHER: "Appboy::Communication::Assets::ContactCardAsset";
  SVG: "Appboy::Communication::Assets::SvgAsset";
  VIDEO: "Appboy::Communication::Assets::VideoAsset";
}
export interface SHARED_CONSTANTS_MEDIA_LIBRARY_CUSTOM_GROUPINGS {
  TYPE: "content_type";
}
export interface SHARED_CONSTANTS_DEFAULT_ICON_URLS {
  CSS: "https://cdn.braze.com/dashboard-assets/dashboard/media-library/css-icon.png";
  FONT: "https://cdn.braze.com/dashboard-assets/dashboard/media-library/font-icon.png";
  JAVASCRIPT: "https://cdn.braze.com/dashboard-assets/dashboard/media-library/javascript-icon.png";
  VCARD: "https://cdn.braze.com/dashboard-assets/dashboard/media-library/vcf-contact-card-icon.png";
}
export interface SHARED_CONSTANTS_MEDIA_LIBRARY_ERROR_CODES {
  ASSET_NOT_FOUND: "ASSET_NOT_FOUND";
  ASSET_SIZE_EXCEEDS_LIMIT: "ASSET_SIZE_EXCEEDS_LIMIT";
  ASSET_UPLOAD_FAILED: "ASSET_UPLOAD_FAILED";
  CORRUPT_FILE: "CORRUPT_FILE";
  EXTENSION_MISMATCH: "EXTENSION_MISMATCH";
  FAILED_TO_DOWNLOAD_ASSET: "FAILED_TO_DOWNLOAD_ASSET";
  GENERIC_ERROR: "GENERIC_ERROR";
  INVALID_ASSET_URL: "INVALID_ASSET_URL";
  INVALID_SEARCH_PARAMETERS: "INVALID_SEARCH_PARAMETERS";
  MEDIA_LIBRARY_LIMIT_REACHED: "MEDIA_LIBRARY_LIMIT_REACHED";
  MISSING_ASSET_ID: "MISSING_ASSET_ID";
  UNSUPPORTED_ASSET_TYPE_FOR_REPLACE: "UNSUPPORTED_ASSET_TYPE_FOR_REPLACE";
  UNSUPPORTED_FILE_TYPE: "UNSUPPORTED_FILE_TYPE";
  VIDEO_NOT_FOUND_URL_GENERATION_FAILED: "VIDEO_NOT_FOUND_URL_GENERATION_FAILED";
}
export interface SHARED_CONSTANTS_SEARCHABLE_TYPES {
  Code: ("css" | "js")[];
  Document: ("doc" | "docx" | "pdf" | "ppt" | "pptx" | "xls" | "xlsx")[];
  Font: ("otf" | "ttf" | "woff" | "woff2")[];
  Image: ("gif" | "ico" | "jpeg" | "jpg" | "png" | "svg" | "webp")[];
  Other: "vcf"[];
  Video: "mp4"[];
}
export interface SHARED_CONSTANTS_SEARCHABLE_TYPE_KEYS {
  Code: "Code";
  Document: "Document";
  Font: "Font";
  Image: "Image";
  Other: "Other";
  Video: "Video";
}
export interface SHARED_CONSTANTS_MEDIA_LIBRARY_SEARCH_KEYS {
  ASPECT_RATIO_WITH_TOLERANCE: "aspect_ratio";
  CATEGORY: "category";
  CREATED: "created";
  CREATED_BY: "created_by";
  CREATED_BY_ME: "created_by_me";
  EDITED: "edited";
  TAG: "tag";
  TERRITORY: "team";
  TERRITORY_ID: "team_id";
  TYPE: "type";
}
export interface SHARED_CONSTANTS_MEDIA_LIBRARY {
  API_ERRORS: SHARED_CONSTANTS_API_ERRORS;
  ASPECT_RATIOS: SHARED_CONSTANTS_ASPECT_RATIOS;
  ASPECT_RATIO_DECIMALS: SHARED_CONSTANTS_ASPECT_RATIO_DECIMALS;
  ASSET_TYPES: SHARED_CONSTANTS_ASSET_TYPES;
  CODE_SUPPORTED_EXTENSIONS: ("css" | "js")[];
  CUSTOM_GROUPINGS: SHARED_CONSTANTS_MEDIA_LIBRARY_CUSTOM_GROUPINGS;
  DEFAULT_ICON_URLS: SHARED_CONSTANTS_DEFAULT_ICON_URLS;
  DOCUMENT_SUPPORTED_EXTENSIONS: ("doc" | "docx" | "pdf" | "ppt" | "pptx" | "xls" | "xlsx")[];
  ERROR_CODES: SHARED_CONSTANTS_MEDIA_LIBRARY_ERROR_CODES;
  FONT_SUPPORTED_EXTENSIONS: ("otf" | "ttf" | "woff" | "woff2")[];
  IMAGE_SUPPORTED_EXTENSIONS: ("gif" | "ico" | "jpeg" | "jpg" | "png" | "svg" | "webp")[];
  MEDIA_LIBRARY_ASSET_MAX_SIZE_BYTES_LIMIT: 5242880;
  MEDIA_LIBRARY_LIMIT: 200;
  MEDIA_LIBRARY_VIDEO_MAX_SIZE_BYTES_LIMIT: 16777216;
  OTHER_SUPPORTED_EXTENSIONS: "vcf"[];
  SEARCHABLE_TYPES: SHARED_CONSTANTS_SEARCHABLE_TYPES;
  SEARCHABLE_TYPE_KEYS: SHARED_CONSTANTS_SEARCHABLE_TYPE_KEYS;
  SEARCH_KEYS: SHARED_CONSTANTS_MEDIA_LIBRARY_SEARCH_KEYS;
  UPLOADABLE_TYPES: ("css" | "doc" | "docx" | "gif" | "ico" | "jpeg" | "jpg" | "js" | "mp4" | "otf" | "pdf" | "png" | "ppt" | "pptx" | "svg" | "ttf" | "vcf" | "webp" | "woff" | "woff2" | "xls" | "xlsx" | "zip")[];
  VCARD_SUPPORTED_EXTENSIONS: "vcf"[];
  VIDEO_SUPPORTED_EXTENSIONS: "mp4"[];
  VIDEO_SUPPORTED_MIME_TYPES: "video/mp4"[];
  ZIP_SUPPORTED_EXTENSIONS: "zip"[];
}
export interface SHARED_CONSTANTS_MESSAGE_ACTIVITY_LOG_TYPES {
  ABORTED_MESSAGE_ERROR: 0;
  AGENT_CONSOLE_ERROR: 18;
  ALIASING_ERROR: 1;
  API_MESSAGE_RECORD: 2;
  BAD_USER_TRIGGER: 3;
  CONNECTED_CONTENT_ERROR: 4;
  EMAIL_BLOCK_ERROR: 5;
  EMAIL_DECRYPTION_ERROR: 17;
  EMAIL_HARD_BOUNCE_ERROR: 6;
  EMAIL_SOFT_BOUNCE_ERROR: 7;
  EXPERIMENT_ERROR: 8;
  LIVE_ACTIVITY_ERROR: 15;
  PUSH_NOTIFICATION_ERROR: 9;
  REST_API_CUSTOM_AUDIENCE_ERROR: 10;
  SMS_DELIVERY_FAILURE_ERROR: 11;
  SMS_REJECTION_ERROR: 12;
  WEBHOOK_ERROR: 13;
  WHATS_APP_DELAY_ERROR: 19;
  WHATS_APP_FAILURE_ERROR: 14;
  WHATS_APP_INBOUND_MESSAGE_PROCESSING_ERROR: 16;
}
export interface SHARED_CONSTANTS_MESSAGE_ACTIVITY_LOG {
  TYPES: SHARED_CONSTANTS_MESSAGE_ACTIVITY_LOG_TYPES;
}
export interface SHARED_CONSTANTS_BAD_REQUEST {
  code: "BAD_REQUEST";
  message: "Bad request";
  status: "bad_request";
}
export interface SHARED_CONSTANTS_CATEGORIES_LIMIT_REACHED {
  code: "CATEGORIES_LIMIT_REACHED";
  message: "Categories limit reached";
  status: "bad_request";
}
export interface SHARED_CONSTANTS_CATEGORY_DESCRIPTION_TOO_LONG {
  code: "CATEGORY_DESCRIPTION_TOO_LONG";
  message: "Category description exceeds the maximum allowed length";
  status: "bad_request";
}
export interface SHARED_CONSTANTS_CATEGORY_NAME_TOO_LONG {
  code: "CATEGORY_NAME_TOO_LONG";
  message: "Category name exceeds the maximum allowed length";
  status: "bad_request";
}
export interface SHARED_CONSTANTS_CATEGORY_NOT_FOUND {
  code: "CATEGORY_NOT_FOUND";
  message: "Category not found";
  status: "not_found";
}
export interface SHARED_CONSTANTS_CATEGORY_WITH_DEPENDENCIES {
  code: "CATEGORY_WITH_DEPENDENCIES";
  message: "Category has dependencies and cannot be deleted";
  status: "conflict";
}
export interface SHARED_CONSTANTS_DUPLICATED_CATEGORY {
  code: "DUPLICATED_CATEGORY";
  message: "Duplicated category";
  status: "bad_request";
}
export interface SHARED_CONSTANTS_INVALID_RULES {
  code: "INVALID_RULES";
  message: "Invalid rules";
  status: "bad_request";
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_API_ERRORS {
  BAD_REQUEST: SHARED_CONSTANTS_BAD_REQUEST;
  CATEGORIES_LIMIT_REACHED: SHARED_CONSTANTS_CATEGORIES_LIMIT_REACHED;
  CATEGORY_DESCRIPTION_TOO_LONG: SHARED_CONSTANTS_CATEGORY_DESCRIPTION_TOO_LONG;
  CATEGORY_NAME_TOO_LONG: SHARED_CONSTANTS_CATEGORY_NAME_TOO_LONG;
  CATEGORY_NOT_FOUND: SHARED_CONSTANTS_CATEGORY_NOT_FOUND;
  CATEGORY_WITH_DEPENDENCIES: SHARED_CONSTANTS_CATEGORY_WITH_DEPENDENCIES;
  DUPLICATED_CATEGORY: SHARED_CONSTANTS_DUPLICATED_CATEGORY;
  INVALID_RULES: SHARED_CONSTANTS_INVALID_RULES;
}
export interface SHARED_CONSTANTS_API {
  ERRORS: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_API_ERRORS;
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_LIMITS {
  CATEGORIES: 50;
  CATEGORIES_FREE_TRIAL: 20;
  RULES: 10;
  SCHEDULED: 25;
  TRIGGERED: 25;
}
export interface SHARED_CONSTANTS_MESSAGE_PRIORITIZATION {
  API: SHARED_CONSTANTS_API;
  CATEGORY_DESCRIPTION_MAX_LENGTH: 250;
  CATEGORY_NAME_MAX_LENGTH: 256;
  LIMITS: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION_LIMITS;
}
export interface SHARED_CONSTANTS_ERROR_CODE {
  INVALID_WORKSPACE_QUIET_HOURS_RULES: "INVALID_WORKSPACE_QUIET_HOURS_RULES";
}
export interface SHARED_CONSTANTS_QUIET_HOURS_SOURCE {
  CUSTOM: "custom";
  NONE: "none";
  WORKSPACE: "workspace";
}
export interface SHARED_CONSTANTS_MESSAGE_QUIET_HOURS {
  AGGREGATE_PUSH_CHANNEL: "push";
  ERROR_CODE: SHARED_CONSTANTS_ERROR_CODE;
  QUIET_HOURS_SOURCE: SHARED_CONSTANTS_QUIET_HOURS_SOURCE;
  VALID_CHANNELS: ("content_cards" | "email" | "kakao" | "line" | "push" | "sms" | "webhook" | "whats_app")[];
}
export interface SHARED_CONSTANTS_SMS_TYPES {
  BYO_MMS: "BYO MMS";
  BYO_SMS: "BYO SMS";
  MMS: "MMS";
  RCS_BASIC: "RCS - Basic";
  RCS_RICH: "RCS - Rich";
  RCS_RICH_MEDIA: "RCS - Rich Media";
  RCS_SINGLE: "RCS - Single";
  SMS: "SMS";
}
export interface SHARED_CONSTANTS_MESSAGE_USAGE {
  SMS_TYPES: SHARED_CONSTANTS_SMS_TYPES;
}
export interface SHARED_CONSTANTS_CUSTOM_EVENT_TYPES {
  ADD_TO_CART: "ADD_TO_CART";
  INITIATED_CHECKOUT: "INITIATED_CHECKOUT";
  PURCHASE: "PURCHASE";
}
export interface SHARED_CONSTANTS_DATA_TABLE {
  FAILED_TO_GET_BIDS: "FAILED_TO_GET_BIDS";
}
export interface SHARED_CONSTANTS_READ {
  FAILED_TO_READ_BID: "failed_to_read_bid";
  INVALID_WHATSAPP_ACCOUNT: "invalid_whatsapp_account";
}
export interface SHARED_CONSTANTS_UPSERT {
  INVALID_BID_BUDGET: "INVALID_BID_BUDGET";
}
export interface SHARED_CONSTANTS_META_BIDS_ERRORS {
  DATA_TABLE: SHARED_CONSTANTS_DATA_TABLE;
  READ: SHARED_CONSTANTS_READ;
  UPSERT: SHARED_CONSTANTS_UPSERT;
}
export interface SHARED_CONSTANTS_META_BIDS_MANAGEMENT_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
  DELETED: "deleted";
  DISAPPROVED: "disapproved";
  PAUSED: "paused";
  PENDING: "pending";
  PREAPPROVED: "preapproved";
  UNSUPPORTED: "unsupported";
}
export interface SHARED_CONSTANTS_META_BIDS_MANAGEMENT {
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_META_BIDS_MANAGEMENT_SEARCHABLE_STATUSES;
}
export interface SHARED_CONSTANTS_PERFORMANCE_GOALS {
  IMPRESSIONS: "IMPRESSIONS";
  LINK_CLICKS: "LINK_CLICKS";
  OFFSITE_CONVERSIONS: "OFFSITE_CONVERSIONS";
}
export interface SHARED_CONSTANTS_META_BIDS_STATUSES {
  ACTIVE: "ACTIVE";
  ADSET_PAUSED: "ADSET_PAUSED";
  ARCHIVED: "ARCHIVED";
  CAMPAIGN_PAUSED: "CAMPAIGN_PAUSED";
  DELETED: "DELETED";
  DISAPPROVED: "DISAPPROVED";
  IN_PROCESS: "IN_PROCESS";
  PAUSED: "PAUSED";
  PENDING_BILLING_INFO: "PENDING_BILLING_INFO";
  PENDING_REVIEW: "PENDING_REVIEW";
  PREAPPROVED: "PREAPPROVED";
  WITH_ISSUES: "WITH_ISSUES";
}
export interface SHARED_CONSTANTS_META_BIDS {
  CUSTOM_EVENT_TYPES: SHARED_CONSTANTS_CUSTOM_EVENT_TYPES;
  ERRORS: SHARED_CONSTANTS_META_BIDS_ERRORS;
  MANAGEMENT: SHARED_CONSTANTS_META_BIDS_MANAGEMENT;
  PERFORMANCE_GOALS: SHARED_CONSTANTS_PERFORMANCE_GOALS;
  STATUSES: SHARED_CONSTANTS_META_BIDS_STATUSES;
}
export interface SHARED_CONSTANTS_MMAPI_AUDIENCE_EXPORT_ERROR_CODES {
  EXPIRED_OBJECT: "EXPIRED_OBJECT";
  IN_PROGRESS_EXPORT: "IN_PROGRESS_EXPORT";
  MISSING_AD_ACCOUNT_ID: "MISSING_AD_ACCOUNT_ID";
  MISSING_CUSTOM_AUDIENCE_NAME: "MISSING_CUSTOM_AUDIENCE_NAME";
  MISSING_SUBSCRIPTION_GROUP_ID: "MISSING_SUBSCRIPTION_GROUP_ID";
}
export interface SHARED_CONSTANTS_MMAPI_AUDIENCE_EXPORT {
  ERROR_CODES: SHARED_CONSTANTS_MMAPI_AUDIENCE_EXPORT_ERROR_CODES;
}
export interface SHARED_CONSTANTS_MOBILE_APP_LINKING {
  CONFIG_NAME_MAX_LENGTH: 256;
  MAX_ASSIGNMENTS_PER_REQUEST: 10;
}
export interface SHARED_CONSTANTS_MOBILE_APP_LINKING_ERRORS {
  AASA_FILE_REQUIRED: "AASA_FILE_REQUIRED";
  AASA_INVALID_APP_ID: "AASA_INVALID_APP_ID";
  AASA_INVALID_COMPONENTS: "AASA_INVALID_COMPONENTS";
  AASA_INVALID_DETAIL: "AASA_INVALID_DETAIL";
  AASA_INVALID_JSON: "AASA_INVALID_JSON";
  AASA_INVALID_PATHS: "AASA_INVALID_PATHS";
  AASA_MISSING_APPLINKS: "AASA_MISSING_APPLINKS";
  AASA_MISSING_APP_ID: "AASA_MISSING_APP_ID";
  AASA_MISSING_DETAILS: "AASA_MISSING_DETAILS";
  AASA_WRONG_ROOT_TYPE: "AASA_WRONG_ROOT_TYPE";
  ASSETLINKS_FILE_REQUIRED: "ASSETLINKS_FILE_REQUIRED";
  ASSETLINKS_INVALID_FINGERPRINT: "ASSETLINKS_INVALID_FINGERPRINT";
  ASSETLINKS_INVALID_INCLUDE: "ASSETLINKS_INVALID_INCLUDE";
  ASSETLINKS_INVALID_JSON: "ASSETLINKS_INVALID_JSON";
  ASSETLINKS_INVALID_PACKAGE_NAME: "ASSETLINKS_INVALID_PACKAGE_NAME";
  ASSETLINKS_INVALID_RELATION: "ASSETLINKS_INVALID_RELATION";
  ASSETLINKS_INVALID_STATEMENT: "ASSETLINKS_INVALID_STATEMENT";
  ASSETLINKS_MISSING_NAMESPACE: "ASSETLINKS_MISSING_NAMESPACE";
  ASSETLINKS_MISSING_TARGET: "ASSETLINKS_MISSING_TARGET";
  ASSETLINKS_NO_VALID_FINGERPRINTS: "ASSETLINKS_NO_VALID_FINGERPRINTS";
  ASSETLINKS_STATEMENT_MISSING_FINGERPRINTS: "ASSETLINKS_STATEMENT_MISSING_FINGERPRINTS";
  ASSETLINKS_WRONG_ROOT_TYPE: "ASSETLINKS_WRONG_ROOT_TYPE";
  MOBILE_APP_LINKING_CONFIG_HAS_ACTIVE_ASSIGNMENTS: "MOBILE_APP_LINKING_CONFIG_HAS_ACTIVE_ASSIGNMENTS";
  MOBILE_APP_LINKING_CONFIG_NAME_REQUIRED: "MOBILE_APP_LINKING_CONFIG_NAME_REQUIRED";
  MOBILE_APP_LINKING_CONFIG_NAME_TOO_LONG: "MOBILE_APP_LINKING_CONFIG_NAME_TOO_LONG";
  MOBILE_APP_LINKING_CONFIG_NOT_FOUND: "MOBILE_APP_LINKING_CONFIG_NOT_FOUND";
  MOBILE_APP_LINKING_CONFIG_VALIDATION_FAILED: "MOBILE_APP_LINKING_CONFIG_VALIDATION_FAILED";
  PAYLOAD_TOO_LARGE: "PAYLOAD_TOO_LARGE";
}
export interface SHARED_CONSTANTS_MULTI_LANGUAGE_COMPOSITION_ERROR_CODES {
  DISALLOWED_CONTENT_IN_TRANSLATION: "DISALLOWED_CONTENT_IN_TRANSLATION";
  DUPLICATE_IDS_IN_MESSAGE: "DUPLICATE_IDS_IN_MESSAGE";
  DUPLICATE_IDS_IN_UPLOAD: "DUPLICATE_IDS_IN_UPLOAD";
  DUPLICATE_TRANSLATIONS_FOR_LOCALES: "DUPLICATE_TRANSLATIONS_FOR_LOCALES";
  EMPTY_TRANSLATION_IDS: "EMPTY_TRANSLATION_IDS";
  EXTRA_TRANSLATIONS: "EXTRA_TRANSLATIONS";
  LIQUID_SYNTAX_ERROR: "LIQUID_SYNTAX_ERROR";
  LOCALE_NOT_FOUND_IN_TARGET_WORKSPACE: "LOCALE_NOT_FOUND_IN_TARGET_WORKSPACE";
  MISMATCHED_DEFAULT_TRANSLATIONS: "MISMATCHED_DEFAULT_TRANSLATIONS";
  MISSING_LOCALE_KEYS: "MISSING_LOCALE_KEYS";
  MISSING_TRANSLATIONS: "MISSING_TRANSLATIONS";
  NON_STRING_TRANSLATION_VALUES: "NON_STRING_TRANSLATION_VALUES";
  NO_MATCHING_LOCALE_FOR_TRANSLATION: "NO_MATCHING_LOCALE_FOR_TRANSLATION";
  NO_TRANSLATABLE_TEXT: "NO_TRANSLATABLE_TEXT";
  TRANSLATION_FILE_TOO_LARGE: "TRANSLATION_FILE_TOO_LARGE";
  TRANSLATION_IDS_MISMATCH: "TRANSLATION_IDS_MISMATCH";
  UNIQUE_LOCALES: "UNIQUE_LOCALES";
}
export interface SHARED_CONSTANTS_NON_CHANNEL_ENTITIES {
  BANNER_TEMPLATE: "banner_template";
  CONTENT_BLOCK: "content_block";
  EMAIL_TEMPLATE: "email_template";
  GENERIC_MESSAGE: "message";
  IAM_TEMPLATE: "iam_template";
}
export interface SHARED_CONSTANTS_MULTI_LANGUAGE_COMPOSITION {
  A11Y_LANGUAGE_NAMESPACE: "accessibility_language";
  ERROR_CODES: SHARED_CONSTANTS_MULTI_LANGUAGE_COMPOSITION_ERROR_CODES;
  MAX_CHARS_IN_TRANSLATION_BLOCK: 2000;
  MAX_LOCALES_COUNT: 200;
  MAX_LOCALES_COUNT_FREE_TRIAL: 10;
  MAX_LOCALE_NAME_LENGTH: 100;
  MAX_TRANSLATION_BLOCKS_COUNT: 200;
  MAX_USER_PROVIDED_TRANSLATION_CONTENT: 409600;
  NON_CHANNEL_ENTITIES: SHARED_CONSTANTS_NON_CHANNEL_ENTITIES;
  TOAST_DURATION_MS: 2500;
  VALID_HTML_LANG_REGEX: "/^[a-zA-Z]{1,8}(-[a-zA-Z0-9]{1,8})*$/";
  VALID_LOCALE_NAME_REGEX: "/^[\\w-]+$/";
}
export interface SHARED_CONSTANTS_AGENT_CONSOLE_ERRORS {
  ID: 21;
  NAME: "Agent Console Errors";
  TYPE: "Technical Error";
}
export interface SHARED_CONSTANTS_API_SDK_ALERTS {
  ID: 20;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_AUDIENCE_SYNC_ERRORS {
  ID: 19;
  TYPE: "Technical Error";
}
export interface SHARED_CONSTANTS_AWS_CREDENTIALS {
  ID: 2;
  TYPE: "Technical Error";
}
export interface SHARED_CONSTANTS_AZURE_CREDENTIALS {
  ID: 12;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_CAMPAIGN_INTERACTION_EXPIRATION {
  ID: 13;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_CAMPAIGN_LIMIT_MET {
  ID: 4;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_CANVAS_COMMENTS {
  ID: 16;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_CONNECTED_CONTENT_ERRORS {
  ID: 8;
  TYPE: "Technical Error";
}
export interface SHARED_CONSTANTS_GCS_CREDENTIALS {
  ID: 17;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_MARKETING_CAMPAIGN_DELIVERY {
  ID: 3;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_MARKETING_OBJECT_UPDATED {
  ID: 11;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_NEWS_FEED_CARD_LIVE {
  ID: 9;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_PAYMENT_AND_BILLING {
  ID: 1;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_PUSH_CREDENTIALS {
  ID: 7;
  TYPE: "Technical Error";
}
export interface SHARED_CONSTANTS_SCHEDULED_CAMPAIGN_FINISHED_SENDING {
  ID: 5;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_STALE_CAMPAIGN_STOPPED {
  ID: 15;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_STALE_CANVAS_STOPPED {
  ID: 18;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_WEBHOOK_ERRORS {
  ID: 6;
  TYPE: "Technical Error";
}
export interface SHARED_CONSTANTS_WEEKLY_ANALYTICS_REPORT {
  ID: 10;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_WORKFLOW_INTERACTION_EXPIRATION {
  ID: 14;
  TYPE: "Notification";
}
export interface SHARED_CONSTANTS_NOTIFICATIONS {
  AGENT_CONSOLE_ERRORS: SHARED_CONSTANTS_AGENT_CONSOLE_ERRORS;
  API_SDK_ALERTS: SHARED_CONSTANTS_API_SDK_ALERTS;
  AUDIENCE_SYNC_ERRORS: SHARED_CONSTANTS_AUDIENCE_SYNC_ERRORS;
  AWS_CREDENTIALS: SHARED_CONSTANTS_AWS_CREDENTIALS;
  AZURE_CREDENTIALS: SHARED_CONSTANTS_AZURE_CREDENTIALS;
  CAMPAIGN_INTERACTION_EXPIRATION: SHARED_CONSTANTS_CAMPAIGN_INTERACTION_EXPIRATION;
  CAMPAIGN_LIMIT_MET: SHARED_CONSTANTS_CAMPAIGN_LIMIT_MET;
  CANVAS_COMMENTS: SHARED_CONSTANTS_CANVAS_COMMENTS;
  CONNECTED_CONTENT_ERRORS: SHARED_CONSTANTS_CONNECTED_CONTENT_ERRORS;
  GCS_CREDENTIALS: SHARED_CONSTANTS_GCS_CREDENTIALS;
  MARKETING_CAMPAIGN_DELIVERY: SHARED_CONSTANTS_MARKETING_CAMPAIGN_DELIVERY;
  MARKETING_OBJECT_UPDATED: SHARED_CONSTANTS_MARKETING_OBJECT_UPDATED;
  NEWS_FEED_CARD_LIVE: SHARED_CONSTANTS_NEWS_FEED_CARD_LIVE;
  PAYMENT_AND_BILLING: SHARED_CONSTANTS_PAYMENT_AND_BILLING;
  PUSH_CREDENTIALS: SHARED_CONSTANTS_PUSH_CREDENTIALS;
  SCHEDULED_CAMPAIGN_FINISHED_SENDING: SHARED_CONSTANTS_SCHEDULED_CAMPAIGN_FINISHED_SENDING;
  STALE_CAMPAIGN_STOPPED: SHARED_CONSTANTS_STALE_CAMPAIGN_STOPPED;
  STALE_CANVAS_STOPPED: SHARED_CONSTANTS_STALE_CANVAS_STOPPED;
  WEBHOOK_ERRORS: SHARED_CONSTANTS_WEBHOOK_ERRORS;
  WEEKLY_ANALYTICS_REPORT: SHARED_CONSTANTS_WEEKLY_ANALYTICS_REPORT;
  WORKFLOW_INTERACTION_EXPIRATION: SHARED_CONSTANTS_WORKFLOW_INTERACTION_EXPIRATION;
}
export interface SHARED_CONSTANTS_NOTIFICATION_PREFERENCE_ERRORS {
  UNSAFE_WEBHOOK_ENDPOINT: "UNSAFE_WEBHOOK_ENDPOINT";
}
export interface SHARED_CONSTANTS_OAUTH_API_ERRORS {
  APPLICATION_NOT_FOUND: "APPLICATION_NOT_FOUND";
  APP_GROUP_ID_REQUIRED: "APP_GROUP_ID_REQUIRED";
  APP_GROUP_NOT_FOUND: "APP_GROUP_NOT_FOUND";
  ERROR: "OAUTH_ERROR";
  INSUFFICIENT_PERMISSIONS: "OAUTH_INSUFFICIENT_PERMISSIONS";
  INSUFFICIENT_SCOPE: "OAUTH_INSUFFICIENT_SCOPE";
  INVALID_CLIENT: "OAUTH_INVALID_CLIENT";
  INVALID_OBJECT_ID: "INVALID_OBJECT_ID";
  INVALID_REDIRECT_URI: "OAUTH_INVALID_REDIRECT_URI";
  INVALID_SCOPE: "OAUTH_INVALID_SCOPE";
  TOKEN_EXPIRED: "OAUTH_TOKEN_EXPIRED";
  TOKEN_REVOKED: "OAUTH_TOKEN_REVOKED";
  UNSUPPORTED_RESPONSE_TYPE: "OAUTH_UNSUPPORTED_RESPONSE_TYPE";
}
export interface SHARED_CONSTANTS_ASSET {
  CREATE: "asset:create";
  GROUP_ID: "ASSET";
}
export interface SHARED_CONSTANTS_CAMPAIGN {
  ARCHIVE: "campaign:archive";
  EDIT: "campaign:edit";
  GROUP_ID: "CAMPAIGN";
  LAUNCH: "campaign:launch";
}
export interface SHARED_CONSTANTS_EMAIL_TEMPLATE {
  CREATE: "email_template:create";
  GROUP_ID: "EMAIL_TEMPLATE";
}
export interface SHARED_CONSTANTS_MCP {
  GROUP_ID: "MCP";
  OPERATOR: "mcp:operator";
  RESOURCES: "mcp:resources";
  TOOLS: "mcp:tools";
}
export interface SHARED_CONSTANTS_SEGMENT {
  EDIT: "segment:edit";
  GROUP_ID: "SEGMENT";
}
export interface SHARED_CONSTANTS_WORKSPACE {
  GROUP_ID: "WORKSPACE";
  READ: "workspace:read";
}
export interface SHARED_CONSTANTS_OAUTH_SCOPES {
  ASSET: SHARED_CONSTANTS_ASSET;
  CAMPAIGN: SHARED_CONSTANTS_CAMPAIGN;
  EMAIL_TEMPLATE: SHARED_CONSTANTS_EMAIL_TEMPLATE;
  MCP: SHARED_CONSTANTS_MCP;
  SEGMENT: SHARED_CONSTANTS_SEGMENT;
  WORKSPACE: SHARED_CONSTANTS_WORKSPACE;
}
export interface SHARED_CONSTANTS_OAUTH {
  API_ERRORS: SHARED_CONSTANTS_OAUTH_API_ERRORS;
  SCOPES: SHARED_CONSTANTS_OAUTH_SCOPES;
}
export interface SHARED_CONSTANTS_CHANNEL_OPTIONS {
  EMAIL_BODY: "email body";
  EMAIL_BODY_HEADER: "email body header";
  EMAIL_PREHEADER: "email preheader";
  EMAIL_PRIMARY_CALL_TO_ACTION: "email primary call-to-action";
  EMAIL_SENDER_NAME: "email sender name";
  EMAIL_SUBJECT_LINE: "email subject line";
  GENERAL: "general";
  IAM: "in app message";
  PUSH_NOTIFICATION: "push notification";
  PUSH_NOTIFICATION_TITLE: "push notification title";
  SMS: "SMS";
  SMS_BODY: "SMS body";
  SMS_CALL_TO_ACTION: "SMS call-to-action";
  SMS_HOOK: "SMS hook";
}
export interface SHARED_CONSTANTS_LENGTH_TYPES {
  LONG: "long";
  MEDIUM: "medium";
  SHORT: "short";
}
export interface SHARED_CONSTANTS_OPEN_AI {
  CHANNEL_OPTIONS: SHARED_CONSTANTS_CHANNEL_OPTIONS;
  LENGTH_TYPES: SHARED_CONSTANTS_LENGTH_TYPES;
}
export interface SHARED_CONSTANTS_PERMISSIONS_BY_SCOPE {
  appGroup: ("admin" | "approveDenyCampaigns" | "approveDenyCanvases" | "archiveBannerTemplates" | "archiveCampaigns" | "archiveCanvasTemplates" | "archiveCanvases" | "archiveContentBlocks" | "archiveCustomAgents" | "archiveEmailTemplates" | "archiveFeatureFlags" | "archiveIamTemplates" | "archiveLandingPageTemplates" | "archiveLocations" | "archivePlacements" | "archiveSegments" | "archiveTeams" | "archiveWebhookTemplates" | "basicReadOnly" | "blocklistCustomAttributes" | "blocklistCustomEvents" | "blocklistProducts" | "createFreeTrialDevelopers" | "createLandingPageDrafts" | "createSupportTicket" | "deleteCatalogs" | "deleteCustomAttributes" | "deleteCustomEvents" | "deleteCustomObjects" | "deleteFreeTrialDevelopers" | "deleteInternalUserGroups" | "deleteKnowledgeSources" | "deleteMediaLibraryAssets" | "deleteMultiLanguageLocaleSettings" | "deleteReporting" | "deleteTags" | "deleteUsers" | "deleteWhatsappMessageTemplates" | "developerConsole" | "editApiKeys" | "editApiUsageAlerts" | "editAppSettings" | "editBannerTemplates" | "editBrandGuidelines" | "editCampaigns" | "editCanvasTemplates" | "editCanvases" | "editCatalogs" | "editCloudDataIngestion" | "editContentBlocks" | "editConversationalSettings" | "editConversationalWorkflows" | "editCrossChannelProfileLinking" | "editCurrentsIntegrations" | "editCustomAgents" | "editCustomAttributes" | "editCustomEventPropertySegmentation" | "editCustomEvents" | "editCustomObjects" | "editDashboardUsers" | "editDecisioningStudioAgents" | "editDecisioningStudioCreativeVariants" | "editDecisioningStudioGuardrails" | "editDecisioningStudioReports" | "editEmailSettings" | "editEmailTemplates" | "editFeatureFlags" | "editFrequencyCaps" | "editGlobalControlGroup" | "editGlobalRateLimits" | "editIamTemplates" | "editInternalUserGroups" | "editKnowledgeSources" | "editLandingPageTemplates" | "editLinkTemplates" | "editLocations" | "editMediaLibraryAssets" | "editMessageArchivingSettings" | "editMessagePrioritization" | "editMultiLanguageLocaleSettings" | "editPlacements" | "editPreferenceCenters" | "editProducts" | "editPurchasePropertySegmentation" | "editPushSettings" | "editQuietHoursSettings" | "editReporting" | "editSdkDebugger" | "editSegments" | "editTags" | "editTeams" | "editTechnologyPartners" | "editUserData" | "editVouchers" | "editWebhookTemplates" | "editWhatsappMessageTemplates" | "exportCatalogs" | "exportCustomAttributes" | "exportCustomEvents" | "exportCustomObjects" | "exportData" | "exportVouchers" | "externalIntegrations" | "importAndUpdateUsers" | "importUsers" | "launchAndManageContentBlocks" | "launchCampaigns" | "launchCanvases" | "launchContentBlocks" | "launchDecisioningStudioAgents" | "manageAppGroup" | "manageApps" | "manageCatalogsDashboardPermission" | "manageCustomAttributesEventsProducts" | "manageCustomEventPropertySegmentation" | "manageDevelopersAndPermissions" | "manageEmailSettings" | "manageFeatureFlags" | "manageFieldLevelEncryption" | "manageMediaLibrary" | "manageMultiLanguageSettings" | "managePreferenceCenters" | "manageSubscriptionGroups" | "manageTags" | "manageTerritories" | "manageTransformations" | "mergeDuplicateUsers" | "previewDuplicateUsers" | "publishCards" | "publishLandingPages" | "readLandingPages" | "replaceMediaLibraryAssets" | "searchUsers" | "sendCampaigns" | "updateFreeTrialDevelopers" | "useMcpServer" | "useOperator" | "viewApiIdentifiers" | "viewApiKeys" | "viewApiLimits" | "viewApiUsageAlerts" | "viewApiUsageDashboard" | "viewAppSettings" | "viewAppUsage" | "viewAudiencePopulation" | "viewAudienceSyncSettings" | "viewBannerTemplates" | "viewBilling" | "viewCampaigns" | "viewCanvasTemplates" | "viewCanvases" | "viewCatalogs" | "viewContentBlocks" | "viewConversationalSettings" | "viewConversationalWorkflows" | "viewCrossChannelProfileLinking" | "viewCurrentsIntegrations" | "viewCustomAgents" | "viewCustomAttributes" | "viewCustomAttributesMarkedAsPii" | "viewCustomEvents" | "viewCustomObjects" | "viewDecisioningStudioActionBanks" | "viewDecisioningStudioAgents" | "viewDecisioningStudioAudience" | "viewDecisioningStudioConversionEvent" | "viewDecisioningStudioGuardrails" | "viewDecisioningStudioReports" | "viewDecisioningStudioTiming" | "viewEmailSettings" | "viewEmailTemplates" | "viewEventUserLog" | "viewFeatureFlags" | "viewFreeTrialDevelopers" | "viewFrequencyCaps" | "viewGlobalControlGroup" | "viewGlobalRateLimits" | "viewIamTemplates" | "viewImportUsers" | "viewInternalUserGroups" | "viewKnowledgeSources" | "viewLandingPageTemplates" | "viewLinkTemplates" | "viewLocations" | "viewMediaLibraryAssets" | "viewMessageActivityLog" | "viewMessageArchivingSettings" | "viewMessagePrioritization" | "viewMultiLanguageLocaleSettings" | "viewPii" | "viewPlacements" | "viewPreferenceCenters" | "viewProducts" | "viewPushSettings" | "viewQuietHoursSettings" | "viewReporting" | "viewSdkDebugger" | "viewSegments" | "viewTags" | "viewTeams" | "viewTransformations" | "viewUserDeletionRecords" | "viewUserEventProperties" | "viewUserMergeRecords" | "viewVouchers" | "viewWebhookTemplates" | "viewWhatsappCatalog" | "viewWhatsappFlows" | "viewWhatsappMessageTemplates" | "viewWhatsappMessageTemplatesFromMeta" | "viewWhatsappSettings")[];
  company: ("addRemoveAppGroups" | "admin" | "createSupportTicket" | "editDomainSettings" | "exportDashboardUsers" | "manageCompanySettings" | "viewDomainSettings")[];
  team: ("admin" | "approveDenyCampaigns" | "approveDenyCanvases" | "archiveBannerTemplates" | "archiveCampaigns" | "archiveCanvasTemplates" | "archiveCanvases" | "archiveContentBlocks" | "archiveCustomAgents" | "archiveEmailTemplates" | "archiveIamTemplates" | "archiveLandingPageTemplates" | "archiveSegments" | "archiveWebhookTemplates" | "basicReadOnly" | "deleteKnowledgeSources" | "deleteMediaLibraryAssets" | "deleteReporting" | "editBannerTemplates" | "editCampaigns" | "editCanvasTemplates" | "editCanvases" | "editContentBlocks" | "editConversationalSettings" | "editConversationalWorkflows" | "editCustomAgents" | "editDashboardUsers" | "editEmailTemplates" | "editIamTemplates" | "editKnowledgeSources" | "editLandingPageTemplates" | "editLinkTemplates" | "editMediaLibraryAssets" | "editReporting" | "editSegments" | "editWebhookTemplates" | "exportData" | "launchAndManageContentBlocks" | "launchCampaigns" | "launchCanvases" | "launchContentBlocks" | "manageDevelopersAndPermissions" | "manageMediaLibrary" | "publishCards" | "replaceMediaLibraryAssets" | "searchUsers" | "sendCampaigns" | "viewAudiencePopulation" | "viewBannerTemplates" | "viewCampaigns" | "viewCanvasTemplates" | "viewCanvases" | "viewContentBlocks" | "viewConversationalSettings" | "viewConversationalWorkflows" | "viewCustomAgents" | "viewEmailTemplates" | "viewIamTemplates" | "viewKnowledgeSources" | "viewLandingPageTemplates" | "viewLinkTemplates" | "viewMediaLibraryAssets" | "viewPii" | "viewReporting" | "viewSegments" | "viewWebhookTemplates")[];
}
export interface SHARED_CONSTANTS_PERMISSIONS_BY_VALUE {
  addRemoveAppGroups: 14;
  admin: 0;
  approveDenyCampaigns: 31;
  approveDenyCanvases: 32;
  archiveBannerTemplates: 89;
  archiveCampaigns: 123;
  archiveCanvasTemplates: 44;
  archiveCanvases: 126;
  archiveContentBlocks: 119;
  archiveCustomAgents: 192;
  archiveEmailTemplates: 159;
  archiveFeatureFlags: 65;
  archiveIamTemplates: 162;
  archiveLandingPageTemplates: 58;
  archiveLocations: 97;
  archivePlacements: 68;
  archiveSegments: 173;
  archiveTeams: 171;
  archiveWebhookTemplates: 165;
  basicReadOnly: 1;
  blocklistCustomAttributes: 72;
  blocklistCustomEvents: 77;
  blocklistProducts: 83;
  createFreeTrialDevelopers: 47;
  createLandingPageDrafts: 38;
  createSupportTicket: 168;
  deleteCatalogs: 94;
  deleteCustomAttributes: 73;
  deleteCustomEvents: 78;
  deleteCustomObjects: 214;
  deleteFreeTrialDevelopers: 48;
  deleteInternalUserGroups: 149;
  deleteKnowledgeSources: 202;
  deleteMediaLibraryAssets: 145;
  deleteMultiLanguageLocaleSettings: 142;
  deleteReporting: 184;
  deleteTags: 176;
  deleteUsers: 62;
  deleteWhatsappMessageTemplates: 156;
  developerConsole: 6;
  editApiKeys: 105;
  editApiUsageAlerts: 109;
  editAppSettings: 152;
  editBannerTemplates: 88;
  editBrandGuidelines: 222;
  editCampaigns: 122;
  editCanvasTemplates: 42;
  editCanvases: 125;
  editCatalogs: 92;
  editCloudDataIngestion: 129;
  editContentBlocks: 118;
  editConversationalSettings: 206;
  editConversationalWorkflows: 204;
  editCrossChannelProfileLinking: 103;
  editCurrentsIntegrations: 46;
  editCustomAgents: 100;
  editCustomAttributes: 71;
  editCustomEventPropertySegmentation: 80;
  editCustomEvents: 76;
  editCustomObjects: 213;
  editDashboardUsers: 90;
  editDecisioningStudioAgents: 198;
  editDecisioningStudioCreativeVariants: 210;
  editDecisioningStudioGuardrails: 217;
  editDecisioningStudioReports: 220;
  editDomainSettings: 59;
  editEmailSettings: 60;
  editEmailTemplates: 158;
  editFeatureFlags: 64;
  editFrequencyCaps: 139;
  editGlobalControlGroup: 180;
  editGlobalRateLimits: 85;
  editIamTemplates: 161;
  editInternalUserGroups: 148;
  editKnowledgeSources: 201;
  editLandingPageTemplates: 56;
  editLinkTemplates: 167;
  editLocations: 96;
  editMediaLibraryAssets: 144;
  editMessageArchivingSettings: 196;
  editMessagePrioritization: 137;
  editMultiLanguageLocaleSettings: 141;
  editPlacements: 67;
  editPreferenceCenters: 135;
  editProducts: 82;
  editPurchasePropertySegmentation: 84;
  editPushSettings: 115;
  editQuietHoursSettings: 209;
  editReporting: 183;
  editSdkDebugger: 151;
  editSegments: 5;
  editTags: 175;
  editTeams: 170;
  editTechnologyPartners: 199;
  editUserData: 113;
  editVouchers: 131;
  editWebhookTemplates: 164;
  editWhatsappMessageTemplates: 155;
  exportCatalogs: 93;
  exportCustomAttributes: 74;
  exportCustomEvents: 79;
  exportCustomObjects: 215;
  exportDashboardUsers: 54;
  exportData: 2;
  exportVouchers: 132;
  externalIntegrations: 23;
  importAndUpdateUsers: 22;
  importUsers: 133;
  launchAndManageContentBlocks: 33;
  launchCampaigns: 127;
  launchCanvases: 128;
  launchContentBlocks: 120;
  launchDecisioningStudioAgents: 221;
  manageAppGroup: 9;
  manageApps: 19;
  manageCatalogsDashboardPermission: 36;
  manageCompanySettings: 15;
  manageCustomAttributesEventsProducts: 16;
  manageCustomEventPropertySegmentation: 53;
  manageDevelopersAndPermissions: 13;
  manageEmailSettings: 17;
  manageFeatureFlags: 29;
  manageFieldLevelEncryption: 37;
  manageMediaLibrary: 18;
  manageMultiLanguageSettings: 34;
  managePreferenceCenters: 30;
  manageSubscriptionGroups: 25;
  manageTags: 11;
  manageTerritories: 7;
  manageTransformations: 28;
  mergeDuplicateUsers: 41;
  placeholder: 999;
  previewDuplicateUsers: 50;
  publishCards: 4;
  publishLandingPages: 39;
  readLandingPages: 40;
  replaceMediaLibraryAssets: 207;
  searchUsers: 12;
  sendCampaigns: 3;
  updateFreeTrialDevelopers: 51;
  useMcpServer: 218;
  useOperator: 169;
  viewApiIdentifiers: 106;
  viewApiKeys: 104;
  viewApiLimits: 111;
  viewApiUsageAlerts: 108;
  viewApiUsageDashboard: 110;
  viewAppSettings: 153;
  viewAppUsage: 8;
  viewAudiencePopulation: 211;
  viewAudienceSyncSettings: 190;
  viewBannerTemplates: 86;
  viewBilling: 10;
  viewCampaigns: 121;
  viewCanvasTemplates: 43;
  viewCanvases: 124;
  viewCatalogs: 91;
  viewContentBlocks: 117;
  viewConversationalSettings: 205;
  viewConversationalWorkflows: 203;
  viewCrossChannelProfileLinking: 102;
  viewCurrentsIntegrations: 45;
  viewCustomAgents: 98;
  viewCustomAttributes: 70;
  viewCustomAttributesMarkedAsPii: 35;
  viewCustomEvents: 75;
  viewCustomObjects: 212;
  viewDecisioningStudioActionBanks: 194;
  viewDecisioningStudioAgents: 177;
  viewDecisioningStudioAudience: 181;
  viewDecisioningStudioConversionEvent: 178;
  viewDecisioningStudioGuardrails: 185;
  viewDecisioningStudioReports: 219;
  viewDecisioningStudioTiming: 193;
  viewDomainSettings: 191;
  viewEmailSettings: 61;
  viewEmailTemplates: 157;
  viewEventUserLog: 107;
  viewFeatureFlags: 63;
  viewFreeTrialDevelopers: 49;
  viewFrequencyCaps: 138;
  viewGlobalControlGroup: 179;
  viewGlobalRateLimits: 197;
  viewIamTemplates: 160;
  viewImportUsers: 112;
  viewInternalUserGroups: 146;
  viewKnowledgeSources: 200;
  viewLandingPageTemplates: 57;
  viewLinkTemplates: 166;
  viewLocations: 95;
  viewMediaLibraryAssets: 143;
  viewMessageActivityLog: 116;
  viewMessageArchivingSettings: 195;
  viewMessagePrioritization: 136;
  viewMultiLanguageLocaleSettings: 140;
  viewPii: 24;
  viewPlacements: 66;
  viewPreferenceCenters: 134;
  viewProducts: 81;
  viewPushSettings: 114;
  viewQuietHoursSettings: 208;
  viewReporting: 182;
  viewSdkDebugger: 150;
  viewSegments: 172;
  viewTags: 174;
  viewTeams: 55;
  viewTransformations: 27;
  viewUserDeletionRecords: 69;
  viewUserEventProperties: 216;
  viewUserMergeRecords: 101;
  viewVouchers: 130;
  viewWebhookTemplates: 163;
  viewWhatsappCatalog: 188;
  viewWhatsappFlows: 187;
  viewWhatsappMessageTemplates: 154;
  viewWhatsappMessageTemplatesFromMeta: 189;
  viewWhatsappSettings: 186;
}
export interface SHARED_CONSTANTS_PERMISSIONS {
  PERMISSIONS_BY_SCOPE: SHARED_CONSTANTS_PERMISSIONS_BY_SCOPE;
  PERMISSIONS_BY_VALUE: SHARED_CONSTANTS_PERMISSIONS_BY_VALUE;
}
export interface SHARED_CONSTANTS_PERMISSION_ACTIONS {
  allowlist: "allowlist";
  approve: "approve";
  archive: "archive";
  blocklist: "blocklist";
  delete: "delete";
  edit: "edit";
  export: "export";
  import: "import";
  launch: "launch";
  merge: "merge";
  publish: "publish";
  replace: "replace";
  search: "search";
  send: "send";
  suspend: "suspend";
  view: "view";
}
export interface SHARED_CONSTANTS_addRemoveAppGroups {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 14;
}
export interface SHARED_CONSTANTS_admin {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 0;
}
export interface SHARED_CONSTANTS_approveDenyCampaigns {
  action: "approve";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCampaigns";
  resource: "campaigns";
  value: 31;
}
export interface SHARED_CONSTANTS_approveDenyCanvases {
  action: "approve";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCanvases";
  resource: "canvas";
  value: 32;
}
export interface SHARED_CONSTANTS_archiveBannerTemplates {
  action: "archive";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewBannerTemplates";
  resource: "banner_templates";
  value: 89;
}
export interface SHARED_CONSTANTS_archiveCampaigns {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewCampaigns";
  prerequisite_permissions: "editCampaigns"[];
  resource: "campaigns";
  value: 123;
}
export interface SHARED_CONSTANTS_archiveCanvasTemplates {
  action: "archive";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCanvasTemplates";
  resource: "canvas_templates";
  value: 44;
}
export interface SHARED_CONSTANTS_archiveCanvases {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewCanvases";
  prerequisite_permissions: "editCanvases"[];
  resource: "canvas";
  value: 126;
}
export interface SHARED_CONSTANTS_archiveContentBlocks {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "launchAndManageContentBlocks";
  is_sensitive: false;
  parent_permission: "viewContentBlocks";
  resource: "content_blocks";
  value: 119;
}
export interface SHARED_CONSTANTS_archiveCustomAgents {
  action: "archive";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCustomAgents";
  resource: "custom_agents";
  value: 192;
}
export interface SHARED_CONSTANTS_archiveEmailTemplates {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewEmailTemplates";
  resource: "email_templates";
  value: 159;
}
export interface SHARED_CONSTANTS_archiveFeatureFlags {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageFeatureFlags";
  is_sensitive: false;
  parent_permission: "viewFeatureFlags";
  resource: "feature_flags";
  value: 65;
}
export interface SHARED_CONSTANTS_archiveIamTemplates {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewIamTemplates";
  resource: "iam_templates";
  value: 162;
}
export interface SHARED_CONSTANTS_archiveLandingPageTemplates {
  action: "archive";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewLandingPageTemplates";
  resource: "landing_page_templates";
  value: 58;
}
export interface SHARED_CONSTANTS_archiveLocations {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewLocations";
  resource: "locations";
  value: 97;
}
export interface SHARED_CONSTANTS_archivePlacements {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageApps";
  is_sensitive: false;
  parent_permission: "viewPlacements";
  resource: "placements";
  value: 68;
}
export interface SHARED_CONSTANTS_archiveSegments {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "editSegments";
  is_sensitive: false;
  parent_permission: "viewSegments";
  prerequisite_permissions: ("archiveCampaigns" | "archiveCanvases")[];
  resource: "segments";
  value: 173;
}
export interface SHARED_CONSTANTS_archiveTeams {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageTerritories";
  is_sensitive: false;
  parent_permission: "viewTeams";
  prerequisite_permission: null;
  resource: "teams";
  value: 171;
}
export interface SHARED_CONSTANTS_archiveWebhookTemplates {
  action: "archive";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewWebhookTemplates";
  resource: "webhook_templates";
  value: 165;
}
export interface SHARED_CONSTANTS_basicReadOnly {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 1;
}
export interface SHARED_CONSTANTS_blocklistCustomAttributes {
  action: "blocklist";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomAttributes";
  resource: "custom_attributes";
  value: 72;
}
export interface SHARED_CONSTANTS_blocklistCustomEvents {
  action: "blocklist";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomEvents";
  resource: "custom_events";
  value: 77;
}
export interface SHARED_CONSTANTS_blocklistProducts {
  action: "blocklist";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewProducts";
  resource: "products";
  value: 83;
}
export interface SHARED_CONSTANTS_createFreeTrialDevelopers {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewFreeTrialDevelopers";
  resource: "free_trial_developers";
  value: 47;
}
export interface SHARED_CONSTANTS_createLandingPageDrafts {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "readLandingPages";
  resource: "landing_pages";
  value: 38;
}
export interface SHARED_CONSTANTS_createSupportTicket {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "support_tickets";
  value: 168;
}
export interface SHARED_CONSTANTS_deleteCatalogs {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCatalogsDashboardPermission";
  is_sensitive: false;
  parent_permission: "viewCatalogs";
  resource: "catalogs";
  value: 94;
}
export interface SHARED_CONSTANTS_deleteCustomAttributes {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomAttributes";
  resource: "custom_attributes";
  value: 73;
}
export interface SHARED_CONSTANTS_deleteCustomEvents {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomEvents";
  resource: "custom_events";
  value: 78;
}
export interface SHARED_CONSTANTS_deleteCustomObjects {
  action: "delete";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCustomObjects";
  resource: "custom_objects";
  value: 214;
}
export interface SHARED_CONSTANTS_deleteFreeTrialDevelopers {
  action: "delete";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewFreeTrialDevelopers";
  resource: "free_trial_developers";
  value: 48;
}
export interface SHARED_CONSTANTS_deleteInternalUserGroups {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: "viewInternalUserGroups";
  resource: "internal_groups";
  value: 149;
}
export interface SHARED_CONSTANTS_deleteKnowledgeSources {
  action: "delete";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewKnowledgeSources";
  resource: "knowledge_sources";
  value: 202;
}
export interface SHARED_CONSTANTS_deleteMediaLibraryAssets {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageMediaLibrary";
  is_sensitive: false;
  parent_permission: "viewMediaLibraryAssets";
  resource: "media_library_assets";
  value: 145;
}
export interface SHARED_CONSTANTS_deleteMultiLanguageLocaleSettings {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageMultiLanguageSettings";
  is_sensitive: false;
  parent_permission: "viewMultiLanguageLocaleSettings";
  resource: "multi_language_settings";
  value: 142;
}
export interface SHARED_CONSTANTS_deleteReporting {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewReporting";
  resource: "dashboard_reports";
  value: 184;
}
export interface SHARED_CONSTANTS_deleteTags {
  action: "delete";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageTags";
  is_sensitive: false;
  parent_permission: "viewTags";
  resource: "tags";
  value: 176;
}
export interface SHARED_CONSTANTS_deleteUsers {
  action: "delete";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "user_data";
  value: 62;
}
export interface SHARED_CONSTANTS_deleteWhatsappMessageTemplates {
  action: "delete";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewWhatsappMessageTemplates";
  resource: "whatsapp_message_templates";
  value: 156;
}
export interface SHARED_CONSTANTS_developerConsole {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 6;
}
export interface SHARED_CONSTANTS_editApiKeys {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: "viewApiKeys";
  resource: "api_keys";
  value: 105;
}
export interface SHARED_CONSTANTS_editApiUsageAlerts {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: "viewApiUsageAlerts";
  resource: "api_usage_alerts";
  value: 109;
}
export interface SHARED_CONSTANTS_editAppSettings {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageApps";
  is_sensitive: false;
  resource: "app_settings";
  value: 152;
}
export interface SHARED_CONSTANTS_editBannerTemplates {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewBannerTemplates";
  resource: "banner_templates";
  value: 88;
}
export interface SHARED_CONSTANTS_editBrandGuidelines {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "brand_guidelines";
  value: 222;
}
export interface SHARED_CONSTANTS_editCampaigns {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewCampaigns";
  resource: "campaigns";
  value: 122;
}
export interface SHARED_CONSTANTS_editCanvasTemplates {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCanvasTemplates";
  resource: "canvas_templates";
  value: 42;
}
export interface SHARED_CONSTANTS_editCanvases {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewCanvases";
  prerequisite_permissions: "viewCanvasTemplates"[];
  resource: "canvas";
  value: 125;
}
export interface SHARED_CONSTANTS_editCatalogs {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCatalogsDashboardPermission";
  is_sensitive: false;
  parent_permission: "viewCatalogs";
  resource: "catalogs";
  value: 92;
}
export interface SHARED_CONSTANTS_editCloudDataIngestion {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "externalIntegrations";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: ("editApiKeys" | "editCatalogs" | "viewCanvases")[];
  resource: "cloud_data_ingestion";
  value: 129;
}
export interface SHARED_CONSTANTS_editContentBlocks {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewContentBlocks";
  resource: "content_blocks";
  value: 118;
}
export interface SHARED_CONSTANTS_editConversationalSettings {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewConversationalSettings";
  resource: "conversational_settings";
  value: 206;
}
export interface SHARED_CONSTANTS_editConversationalWorkflows {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewConversationalWorkflows";
  resource: "conversational_workflows";
  value: 204;
}
export interface SHARED_CONSTANTS_editCrossChannelProfileLinking {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCrossChannelProfileLinking";
  resource: "cross_channel_profile_linking";
  value: 103;
}
export interface SHARED_CONSTANTS_editCurrentsIntegrations {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCurrentsIntegrations";
  resource: "currents_integrations";
  value: 46;
}
export interface SHARED_CONSTANTS_editCustomAgents {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCustomAgents";
  resource: "custom_agents";
  value: 100;
}
export interface SHARED_CONSTANTS_editCustomAttributes {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomAttributes";
  resource: "custom_attributes";
  value: 71;
}
export interface SHARED_CONSTANTS_editCustomEventPropertySegmentation {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomEventPropertySegmentation";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewCustomEvents"[];
  resource: "custom_event_property_segmentation";
  value: 80;
}
export interface SHARED_CONSTANTS_editCustomEvents {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomEvents";
  resource: "custom_events";
  value: 76;
}
export interface SHARED_CONSTANTS_editCustomObjects {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCustomObjects";
  resource: "custom_objects";
  value: 213;
}
export interface SHARED_CONSTANTS_editDashboardUsers {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageDevelopersAndPermissions";
  is_sensitive: false;
  parent_permission: null;
  resource: "dashboard_users";
  value: 90;
}
export interface SHARED_CONSTANTS_editDecisioningStudioAgents {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewDecisioningStudioAgents";
  resource: "decisioning_studio_agents";
  value: 198;
}
export interface SHARED_CONSTANTS_editDecisioningStudioCreativeVariants {
  action: "edit";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewDecisioningStudioAgents"[];
  resource: "decisioning_studio_creative_variants";
  value: 210;
}
export interface SHARED_CONSTANTS_editDecisioningStudioGuardrails {
  action: "edit";
  is_sensitive: false;
  parent_permission: "viewDecisioningStudioGuardrails";
  resource: "decisioning_studio_guardrails";
  value: 217;
}
export interface SHARED_CONSTANTS_editDecisioningStudioReports {
  action: "edit";
  is_sensitive: false;
  parent_permission: "viewDecisioningStudioReports";
  resource: "decisioning_studio_reports";
  value: 220;
}
export interface SHARED_CONSTANTS_editDomainSettings {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 59;
}
export interface SHARED_CONSTANTS_editEmailSettings {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageEmailSettings";
  is_sensitive: false;
  parent_permission: "viewEmailSettings";
  resource: "email_settings";
  value: 60;
}
export interface SHARED_CONSTANTS_editEmailTemplates {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewEmailTemplates";
  resource: "email_templates";
  value: 158;
}
export interface SHARED_CONSTANTS_editFeatureFlags {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageFeatureFlags";
  is_sensitive: false;
  parent_permission: "viewFeatureFlags";
  resource: "feature_flags";
  value: 64;
}
export interface SHARED_CONSTANTS_editFrequencyCaps {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "sendCampaigns";
  is_sensitive: false;
  parent_permission: "viewFrequencyCaps";
  prerequisite_permissions: ("launchCampaigns" | "launchCanvases")[];
  resource: "frequency_caps";
  value: 139;
}
export interface SHARED_CONSTANTS_editGlobalControlGroup {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "sendCampaigns";
  is_sensitive: false;
  parent_permission: "viewGlobalControlGroup";
  prerequisite_permissions: ("launchCampaigns" | "launchCanvases")[];
  resource: "global_control_group";
  value: 180;
}
export interface SHARED_CONSTANTS_editGlobalRateLimits {
  action: "edit";
  is_sensitive: false;
  parent_permission: "viewGlobalRateLimits";
  resource: "global_rate_limits";
  value: 85;
}
export interface SHARED_CONSTANTS_editIamTemplates {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewIamTemplates";
  resource: "iam_templates";
  value: 161;
}
export interface SHARED_CONSTANTS_editInternalUserGroups {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: "viewInternalUserGroups";
  resource: "internal_groups";
  value: 148;
}
export interface SHARED_CONSTANTS_editKnowledgeSources {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewKnowledgeSources";
  resource: "knowledge_sources";
  value: 201;
}
export interface SHARED_CONSTANTS_editLandingPageTemplates {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewLandingPageTemplates";
  resource: "landing_page_templates";
  value: 56;
}
export interface SHARED_CONSTANTS_editLinkTemplates {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewLinkTemplates";
  resource: "email_link_templates";
  value: 167;
}
export interface SHARED_CONSTANTS_editLocations {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewLocations";
  resource: "locations";
  value: 96;
}
export interface SHARED_CONSTANTS_editMediaLibraryAssets {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageMediaLibrary";
  is_sensitive: false;
  parent_permission: "viewMediaLibraryAssets";
  resource: "media_library_assets";
  value: 144;
}
export interface SHARED_CONSTANTS_editMessageArchivingSettings {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageApps";
  is_sensitive: false;
  parent_permission: "viewMessageArchivingSettings";
  resource: "message_archiving_settings";
  value: 196;
}
export interface SHARED_CONSTANTS_editMessagePrioritization {
  action: "edit";
  is_sensitive: false;
  parent_permission: "viewMessagePrioritization";
  prerequisite_permissions: ("launchCampaigns" | "launchCanvases")[];
  resource: "message_prioritization";
  value: 137;
}
export interface SHARED_CONSTANTS_editMultiLanguageLocaleSettings {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageMultiLanguageSettings";
  is_sensitive: false;
  parent_permission: "viewMultiLanguageLocaleSettings";
  resource: "multi_language_settings";
  value: 141;
}
export interface SHARED_CONSTANTS_editPlacements {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageApps";
  is_sensitive: false;
  parent_permission: "viewPlacements";
  resource: "placements";
  value: 67;
}
export interface SHARED_CONSTANTS_editPreferenceCenters {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewPreferenceCenters";
  resource: "preference_centers";
  value: 135;
}
export interface SHARED_CONSTANTS_editProducts {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewProducts";
  resource: "products";
  value: 82;
}
export interface SHARED_CONSTANTS_editPurchasePropertySegmentation {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomEventPropertySegmentation";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewProducts"[];
  resource: "purchase_property_segmentation";
  value: 84;
}
export interface SHARED_CONSTANTS_editPushSettings {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageApps";
  is_sensitive: false;
  parent_permission: "viewPushSettings";
  resource: "push_settings";
  value: 115;
}
export interface SHARED_CONSTANTS_editQuietHoursSettings {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageApps";
  is_sensitive: false;
  parent_permission: "viewQuietHoursSettings";
  prerequisite_permissions: "viewQuietHoursSettings"[];
  resource: "quiet_hours_settings";
  value: 209;
}
export interface SHARED_CONSTANTS_editReporting {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewReporting";
  resource: "dashboard_reports";
  value: 183;
}
export interface SHARED_CONSTANTS_editSdkDebugger {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: "viewSdkDebugger";
  resource: "sdk_debugger";
  value: 151;
}
export interface SHARED_CONSTANTS_editSegments {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewSegments";
  prerequisite_permissions: never[];
  resource: "segments";
  value: 5;
}
export interface SHARED_CONSTANTS_editTags {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageTags";
  is_sensitive: false;
  parent_permission: "viewTags";
  resource: "tags";
  value: 175;
}
export interface SHARED_CONSTANTS_editTeams {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageTerritories";
  is_sensitive: false;
  parent_permission: "viewTeams";
  prerequisite_permission: null;
  resource: "teams";
  value: 170;
}
export interface SHARED_CONSTANTS_editTechnologyPartners {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "externalIntegrations";
  is_sensitive: false;
  parent_permission: null;
  resource: "technology_partners";
  value: 199;
}
export interface SHARED_CONSTANTS_editUserData {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "importAndUpdateUsers";
  is_sensitive: false;
  parent_permission: null;
  resource: "user_data";
  value: 113;
}
export interface SHARED_CONSTANTS_editVouchers {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewVouchers";
  resource: "promotion_codes";
  value: 131;
}
export interface SHARED_CONSTANTS_editWebhookTemplates {
  action: "edit";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewWebhookTemplates";
  resource: "webhook_templates";
  value: 164;
}
export interface SHARED_CONSTANTS_editWhatsappMessageTemplates {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewWhatsappMessageTemplates";
  resource: "whatsapp_message_templates";
  value: 155;
}
export interface SHARED_CONSTANTS_exportCatalogs {
  action: "export";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCatalogsDashboardPermission";
  is_sensitive: false;
  parent_permission: "viewCatalogs";
  resource: "catalogs";
  value: 93;
}
export interface SHARED_CONSTANTS_exportCustomAttributes {
  action: "export";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomAttributes";
  resource: "custom_attributes";
  value: 74;
}
export interface SHARED_CONSTANTS_exportCustomEvents {
  action: "export";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: "viewCustomEvents";
  resource: "custom_events";
  value: 79;
}
export interface SHARED_CONSTANTS_exportCustomObjects {
  action: "export";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewCustomObjects";
  resource: "custom_objects";
  value: 215;
}
export interface SHARED_CONSTANTS_exportDashboardUsers {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 54;
}
export interface SHARED_CONSTANTS_exportData {
  action: "export";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "user_data";
  value: 2;
}
export interface SHARED_CONSTANTS_exportVouchers {
  action: "export";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: "viewVouchers";
  resource: "promotion_codes";
  value: 132;
}
export interface SHARED_CONSTANTS_externalIntegrations {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "external_integrations";
  value: 23;
}
export interface SHARED_CONSTANTS_importAndUpdateUsers {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 22;
}
export interface SHARED_CONSTANTS_importUsers {
  action: "import";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "importAndUpdateUsers";
  is_sensitive: false;
  parent_permission: "viewImportUsers";
  resource: "import_users";
  value: 133;
}
export interface SHARED_CONSTANTS_launchAndManageContentBlocks {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 33;
}
export interface SHARED_CONSTANTS_launchCampaigns {
  action: "launch";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "sendCampaigns";
  is_sensitive: true;
  parent_permission: "viewCampaigns";
  prerequisite_permissions: ("editCampaigns" | "viewAudiencePopulation")[];
  resource: "campaigns";
  value: 127;
}
export interface SHARED_CONSTANTS_launchCanvases {
  action: "launch";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "sendCampaigns";
  is_sensitive: true;
  parent_permission: "viewCanvases";
  prerequisite_permissions: ("editCanvases" | "viewAudiencePopulation")[];
  resource: "canvas";
  value: 128;
}
export interface SHARED_CONSTANTS_launchContentBlocks {
  action: "launch";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "launchAndManageContentBlocks";
  is_sensitive: false;
  parent_permission: "viewContentBlocks";
  resource: "content_blocks";
  value: 120;
}
export interface SHARED_CONSTANTS_launchDecisioningStudioAgents {
  action: "launch";
  is_sensitive: true;
  parent_permission: "viewDecisioningStudioAgents";
  prerequisite_permissions: "editDecisioningStudioAgents"[];
  resource: "decisioning_studio_agents";
  value: 221;
}
export interface SHARED_CONSTANTS_manageAppGroup {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: null;
  value: 9;
}
export interface SHARED_CONSTANTS_manageApps {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 19;
}
export interface SHARED_CONSTANTS_manageCatalogsDashboardPermission {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 36;
}
export interface SHARED_CONSTANTS_manageCompanySettings {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: null;
  value: 15;
}
export interface SHARED_CONSTANTS_manageCustomAttributesEventsProducts {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 16;
}
export interface SHARED_CONSTANTS_manageCustomEventPropertySegmentation {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 53;
}
export interface SHARED_CONSTANTS_manageDevelopersAndPermissions {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 13;
}
export interface SHARED_CONSTANTS_manageEmailSettings {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 17;
}
export interface SHARED_CONSTANTS_manageFeatureFlags {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 29;
}
export interface SHARED_CONSTANTS_manageFieldLevelEncryption {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "field_level_encryption";
  value: 37;
}
export interface SHARED_CONSTANTS_manageMediaLibrary {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 18;
}
export interface SHARED_CONSTANTS_manageMultiLanguageSettings {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 34;
}
export interface SHARED_CONSTANTS_managePreferenceCenters {
  action: "launch";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewPreferenceCenters";
  resource: "preference_centers";
  value: 30;
}
export interface SHARED_CONSTANTS_manageSubscriptionGroups {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "subscription_groups";
  value: 25;
}
export interface SHARED_CONSTANTS_manageTags {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 11;
}
export interface SHARED_CONSTANTS_manageTerritories {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 7;
}
export interface SHARED_CONSTANTS_manageTransformations {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "transformations";
  value: 28;
}
export interface SHARED_CONSTANTS_mergeDuplicateUsers {
  action: "merge";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewUserMergeRecords"[];
  resource: "user_data";
  value: 41;
}
export interface SHARED_CONSTANTS_previewDuplicateUsers {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "duplicate_users";
  value: 50;
}
export interface SHARED_CONSTANTS_publishCards {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 4;
}
export interface SHARED_CONSTANTS_publishLandingPages {
  action: "publish";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "readLandingPages";
  prerequisite_permissions: "createLandingPageDrafts"[];
  resource: "landing_pages";
  value: 39;
}
export interface SHARED_CONSTANTS_readLandingPages {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "landing_pages";
  value: 40;
}
export interface SHARED_CONSTANTS_replaceMediaLibraryAssets {
  action: "replace";
  granular_permission_feature_flippers: never[];
  is_sensitive: false;
  parent_permission: "viewMediaLibraryAssets";
  resource: "media_library_assets";
  value: 207;
}
export interface SHARED_CONSTANTS_searchUsers {
  action: "search";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "user_data";
  value: 12;
}
export interface SHARED_CONSTANTS_sendCampaigns {
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: true;
  parent_permission: null;
  value: 3;
}
export interface SHARED_CONSTANTS_updateFreeTrialDevelopers {
  action: "edit";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: "viewFreeTrialDevelopers";
  resource: "free_trial_developers";
  value: 51;
}
export interface SHARED_CONSTANTS_useMcpServer {
  action: "view";
  is_sensitive: false;
  parent_permission: null;
  resource: "mcp_server";
  value: 218;
}
export interface SHARED_CONSTANTS_useOperator {
  action: "view";
  is_sensitive: false;
  parent_permission: null;
  resource: "operator";
  value: 169;
}
export interface SHARED_CONSTANTS_viewApiIdentifiers {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "api_identifiers";
  value: 106;
}
export interface SHARED_CONSTANTS_viewApiKeys {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "api_keys";
  value: 104;
}
export interface SHARED_CONSTANTS_viewApiLimits {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "api_limits";
  value: 111;
}
export interface SHARED_CONSTANTS_viewApiUsageAlerts {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "api_usage_alerts";
  value: 108;
}
export interface SHARED_CONSTANTS_viewApiUsageDashboard {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "api_usage_data";
  value: 110;
}
export interface SHARED_CONSTANTS_viewAppSettings {
  action: "view";
  is_sensitive: false;
  parent_permission: null;
  resource: "app_settings";
  value: 153;
}
export interface SHARED_CONSTANTS_viewAppUsage {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "app_usage";
  value: 8;
}
export interface SHARED_CONSTANTS_viewAudiencePopulation {
  action: "view";
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "audience_population";
  value: 211;
}
export interface SHARED_CONSTANTS_viewAudienceSyncSettings {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "audience_sync_settings";
  value: 190;
}
export interface SHARED_CONSTANTS_viewBannerTemplates {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "banner_templates";
  value: 86;
}
export interface SHARED_CONSTANTS_viewBilling {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "billing";
  value: 10;
}
export interface SHARED_CONSTANTS_viewCampaigns {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewSegments"[];
  resource: "campaigns";
  value: 121;
}
export interface SHARED_CONSTANTS_viewCanvasTemplates {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "canvas_templates";
  value: 43;
}
export interface SHARED_CONSTANTS_viewCanvases {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewSegments"[];
  resource: "canvas";
  value: 124;
}
export interface SHARED_CONSTANTS_viewCatalogs {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCatalogsDashboardPermission";
  is_sensitive: false;
  parent_permission: null;
  resource: "catalogs";
  value: 91;
}
export interface SHARED_CONSTANTS_viewContentBlocks {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "content_blocks";
  value: 117;
}
export interface SHARED_CONSTANTS_viewConversationalSettings {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: ("viewCatalogs" | "viewConversationalWorkflows" | "viewKnowledgeSources")[];
  resource: "conversational_settings";
  value: 205;
}
export interface SHARED_CONSTANTS_viewConversationalWorkflows {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: ("viewCatalogs" | "viewKnowledgeSources")[];
  resource: "conversational_workflows";
  value: 203;
}
export interface SHARED_CONSTANTS_viewCrossChannelProfileLinking {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "cross_channel_profile_linking";
  value: 102;
}
export interface SHARED_CONSTANTS_viewCurrentsIntegrations {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "currents_integrations";
  value: 45;
}
export interface SHARED_CONSTANTS_viewCustomAgents {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: ("viewCatalogs" | "viewKnowledgeSources")[];
  resource: "custom_agents";
  value: 98;
}
export interface SHARED_CONSTANTS_viewCustomAttributes {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "custom_attributes";
  value: 70;
}
export interface SHARED_CONSTANTS_viewCustomAttributesMarkedAsPii {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: true;
  parent_permission: null;
  resource: "custom_attributes_marked_as_pii";
  value: 35;
}
export interface SHARED_CONSTANTS_viewCustomEvents {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "custom_events";
  value: 75;
}
export interface SHARED_CONSTANTS_viewCustomObjects {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "custom_objects";
  value: 212;
}
export interface SHARED_CONSTANTS_viewDecisioningStudioActionBanks {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewDecisioningStudioAgents"[];
  resource: "decisioning_studio_action_banks";
  value: 194;
}
export interface SHARED_CONSTANTS_viewDecisioningStudioAgents {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "decisioning_studio_agents";
  value: 177;
}
export interface SHARED_CONSTANTS_viewDecisioningStudioAudience {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewDecisioningStudioAgents"[];
  resource: "decisioning_studio_audience";
  value: 181;
}
export interface SHARED_CONSTANTS_viewDecisioningStudioConversionEvent {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewDecisioningStudioAgents"[];
  resource: "decisioning_studio_conversion_event";
  value: 178;
}
export interface SHARED_CONSTANTS_viewDecisioningStudioGuardrails {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  hide_from_new_permissions_flow_feature_flippers: never[];
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewDecisioningStudioAgents"[];
  resource: "decisioning_studio_guardrails";
  value: 185;
}
export interface SHARED_CONSTANTS_viewDecisioningStudioReports {
  action: "view";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewDecisioningStudioAgents"[];
  resource: "decisioning_studio_reports";
  value: 219;
}
export interface SHARED_CONSTANTS_viewDecisioningStudioTiming {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewDecisioningStudioAgents"[];
  resource: "decisioning_studio_timing";
  value: 193;
}
export interface SHARED_CONSTANTS_viewDomainSettings {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  value: 191;
}
export interface SHARED_CONSTANTS_viewEmailSettings {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageEmailSettings";
  is_sensitive: false;
  parent_permission: null;
  resource: "email_settings";
  value: 61;
}
export interface SHARED_CONSTANTS_viewEmailTemplates {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "email_templates";
  value: 157;
}
export interface SHARED_CONSTANTS_viewEventUserLog {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "event_user_log";
  value: 107;
}
export interface SHARED_CONSTANTS_viewFeatureFlags {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "feature_flags";
  value: 63;
}
export interface SHARED_CONSTANTS_viewFreeTrialDevelopers {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "free_trial_developers";
  value: 49;
}
export interface SHARED_CONSTANTS_viewFrequencyCaps {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "frequency_caps";
  value: 138;
}
export interface SHARED_CONSTANTS_viewGlobalControlGroup {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "global_control_group";
  value: 179;
}
export interface SHARED_CONSTANTS_viewGlobalRateLimits {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "global_rate_limits";
  value: 197;
}
export interface SHARED_CONSTANTS_viewIamTemplates {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "iam_templates";
  value: 160;
}
export interface SHARED_CONSTANTS_viewImportUsers {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "importAndUpdateUsers";
  is_sensitive: false;
  parent_permission: null;
  resource: "import_users";
  value: 112;
}
export interface SHARED_CONSTANTS_viewInternalUserGroups {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "internal_groups";
  value: 146;
}
export interface SHARED_CONSTANTS_viewKnowledgeSources {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: "viewCatalogs"[];
  resource: "knowledge_sources";
  value: 200;
}
export interface SHARED_CONSTANTS_viewLandingPageTemplates {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "landing_page_templates";
  value: 57;
}
export interface SHARED_CONSTANTS_viewLinkTemplates {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "email_link_templates";
  value: 166;
}
export interface SHARED_CONSTANTS_viewLocations {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "locations";
  value: 95;
}
export interface SHARED_CONSTANTS_viewMediaLibraryAssets {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "media_library_assets";
  value: 143;
}
export interface SHARED_CONSTANTS_viewMessageActivityLog {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "message_activity_log";
  value: 116;
}
export interface SHARED_CONSTANTS_viewMessageArchivingSettings {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageApps";
  is_sensitive: false;
  parent_permission: null;
  resource: "message_archiving_settings";
  value: 195;
}
export interface SHARED_CONSTANTS_viewMessagePrioritization {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "message_prioritization";
  value: 136;
}
export interface SHARED_CONSTANTS_viewMultiLanguageLocaleSettings {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "multi_language_settings";
  value: 140;
}
export interface SHARED_CONSTANTS_viewPii {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: true;
  parent_permission: null;
  resource: "pii";
  value: 24;
}
export interface SHARED_CONSTANTS_viewPlacements {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "placements";
  value: 66;
}
export interface SHARED_CONSTANTS_viewPreferenceCenters {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "preference_centers";
  value: 134;
}
export interface SHARED_CONSTANTS_viewProducts {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageCustomAttributesEventsProducts";
  is_sensitive: false;
  parent_permission: null;
  resource: "products";
  value: 81;
}
export interface SHARED_CONSTANTS_viewPushSettings {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "push_settings";
  value: 114;
}
export interface SHARED_CONSTANTS_viewQuietHoursSettings {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "quiet_hours_settings";
  value: 208;
}
export interface SHARED_CONSTANTS_viewReporting {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: ("viewCampaigns" | "viewCanvases")[];
  resource: "dashboard_reports";
  value: 182;
}
export interface SHARED_CONSTANTS_viewSdkDebugger {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "developerConsole";
  is_sensitive: false;
  parent_permission: null;
  resource: "sdk_debugger";
  value: 150;
}
export interface SHARED_CONSTANTS_viewSegments {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  prerequisite_permissions: never[];
  resource: "segments";
  value: 172;
}
export interface SHARED_CONSTANTS_viewTags {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageTags";
  is_sensitive: false;
  parent_permission: null;
  resource: "tags";
  value: 174;
}
export interface SHARED_CONSTANTS_viewTeams {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "manageTerritories";
  is_sensitive: false;
  parent_permission: null;
  resource: "teams";
  value: 55;
}
export interface SHARED_CONSTANTS_viewTransformations {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "transformations";
  value: 27;
}
export interface SHARED_CONSTANTS_viewUserDeletionRecords {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "user_deletion_records";
  value: 69;
}
export interface SHARED_CONSTANTS_viewUserEventProperties {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: true;
  parent_permission: null;
  resource: "user_event_properties";
  value: 216;
}
export interface SHARED_CONSTANTS_viewUserMergeRecords {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "mergeDuplicateUsers";
  is_sensitive: false;
  parent_permission: null;
  resource: "user_merge_records";
  value: 101;
}
export interface SHARED_CONSTANTS_viewVouchers {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "promotion_codes";
  value: 130;
}
export interface SHARED_CONSTANTS_viewWebhookTemplates {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "webhook_templates";
  value: 163;
}
export interface SHARED_CONSTANTS_viewWhatsappCatalog {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "whatsapp_catalog";
  value: 188;
}
export interface SHARED_CONSTANTS_viewWhatsappFlows {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  hide_from_new_permissions_flow_feature_flippers: never[];
  is_sensitive: false;
  parent_permission: null;
  resource: "whatsapp_flows";
  value: 187;
}
export interface SHARED_CONSTANTS_viewWhatsappMessageTemplates {
  action: "view";
  granular_permission_feature_flippers: never[];
  granular_permission_of: null;
  is_sensitive: false;
  parent_permission: null;
  resource: "whatsapp_message_templates";
  value: 154;
}
export interface SHARED_CONSTANTS_viewWhatsappMessageTemplatesFromMeta {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  is_sensitive: false;
  parent_permission: null;
  resource: "whatsapp_message_templates_from_meta";
  value: 189;
}
export interface SHARED_CONSTANTS_viewWhatsappSettings {
  action: "view";
  granular_permission_feature_flippers: "clip_granular_permissions_all"[];
  granular_permission_of: "basicReadOnly";
  hide_from_new_permissions_flow_feature_flippers: never[];
  is_sensitive: false;
  parent_permission: null;
  resource: "whatsapp_settings";
  value: 186;
}
export interface SHARED_CONSTANTS_PERMISSION_INFOS {
  addRemoveAppGroups: SHARED_CONSTANTS_addRemoveAppGroups;
  admin: SHARED_CONSTANTS_admin;
  approveDenyCampaigns: SHARED_CONSTANTS_approveDenyCampaigns;
  approveDenyCanvases: SHARED_CONSTANTS_approveDenyCanvases;
  archiveBannerTemplates: SHARED_CONSTANTS_archiveBannerTemplates;
  archiveCampaigns: SHARED_CONSTANTS_archiveCampaigns;
  archiveCanvasTemplates: SHARED_CONSTANTS_archiveCanvasTemplates;
  archiveCanvases: SHARED_CONSTANTS_archiveCanvases;
  archiveContentBlocks: SHARED_CONSTANTS_archiveContentBlocks;
  archiveCustomAgents: SHARED_CONSTANTS_archiveCustomAgents;
  archiveEmailTemplates: SHARED_CONSTANTS_archiveEmailTemplates;
  archiveFeatureFlags: SHARED_CONSTANTS_archiveFeatureFlags;
  archiveIamTemplates: SHARED_CONSTANTS_archiveIamTemplates;
  archiveLandingPageTemplates: SHARED_CONSTANTS_archiveLandingPageTemplates;
  archiveLocations: SHARED_CONSTANTS_archiveLocations;
  archivePlacements: SHARED_CONSTANTS_archivePlacements;
  archiveSegments: SHARED_CONSTANTS_archiveSegments;
  archiveTeams: SHARED_CONSTANTS_archiveTeams;
  archiveWebhookTemplates: SHARED_CONSTANTS_archiveWebhookTemplates;
  basicReadOnly: SHARED_CONSTANTS_basicReadOnly;
  blocklistCustomAttributes: SHARED_CONSTANTS_blocklistCustomAttributes;
  blocklistCustomEvents: SHARED_CONSTANTS_blocklistCustomEvents;
  blocklistProducts: SHARED_CONSTANTS_blocklistProducts;
  createFreeTrialDevelopers: SHARED_CONSTANTS_createFreeTrialDevelopers;
  createLandingPageDrafts: SHARED_CONSTANTS_createLandingPageDrafts;
  createSupportTicket: SHARED_CONSTANTS_createSupportTicket;
  deleteCatalogs: SHARED_CONSTANTS_deleteCatalogs;
  deleteCustomAttributes: SHARED_CONSTANTS_deleteCustomAttributes;
  deleteCustomEvents: SHARED_CONSTANTS_deleteCustomEvents;
  deleteCustomObjects: SHARED_CONSTANTS_deleteCustomObjects;
  deleteFreeTrialDevelopers: SHARED_CONSTANTS_deleteFreeTrialDevelopers;
  deleteInternalUserGroups: SHARED_CONSTANTS_deleteInternalUserGroups;
  deleteKnowledgeSources: SHARED_CONSTANTS_deleteKnowledgeSources;
  deleteMediaLibraryAssets: SHARED_CONSTANTS_deleteMediaLibraryAssets;
  deleteMultiLanguageLocaleSettings: SHARED_CONSTANTS_deleteMultiLanguageLocaleSettings;
  deleteReporting: SHARED_CONSTANTS_deleteReporting;
  deleteTags: SHARED_CONSTANTS_deleteTags;
  deleteUsers: SHARED_CONSTANTS_deleteUsers;
  deleteWhatsappMessageTemplates: SHARED_CONSTANTS_deleteWhatsappMessageTemplates;
  developerConsole: SHARED_CONSTANTS_developerConsole;
  editApiKeys: SHARED_CONSTANTS_editApiKeys;
  editApiUsageAlerts: SHARED_CONSTANTS_editApiUsageAlerts;
  editAppSettings: SHARED_CONSTANTS_editAppSettings;
  editBannerTemplates: SHARED_CONSTANTS_editBannerTemplates;
  editBrandGuidelines: SHARED_CONSTANTS_editBrandGuidelines;
  editCampaigns: SHARED_CONSTANTS_editCampaigns;
  editCanvasTemplates: SHARED_CONSTANTS_editCanvasTemplates;
  editCanvases: SHARED_CONSTANTS_editCanvases;
  editCatalogs: SHARED_CONSTANTS_editCatalogs;
  editCloudDataIngestion: SHARED_CONSTANTS_editCloudDataIngestion;
  editContentBlocks: SHARED_CONSTANTS_editContentBlocks;
  editConversationalSettings: SHARED_CONSTANTS_editConversationalSettings;
  editConversationalWorkflows: SHARED_CONSTANTS_editConversationalWorkflows;
  editCrossChannelProfileLinking: SHARED_CONSTANTS_editCrossChannelProfileLinking;
  editCurrentsIntegrations: SHARED_CONSTANTS_editCurrentsIntegrations;
  editCustomAgents: SHARED_CONSTANTS_editCustomAgents;
  editCustomAttributes: SHARED_CONSTANTS_editCustomAttributes;
  editCustomEventPropertySegmentation: SHARED_CONSTANTS_editCustomEventPropertySegmentation;
  editCustomEvents: SHARED_CONSTANTS_editCustomEvents;
  editCustomObjects: SHARED_CONSTANTS_editCustomObjects;
  editDashboardUsers: SHARED_CONSTANTS_editDashboardUsers;
  editDecisioningStudioAgents: SHARED_CONSTANTS_editDecisioningStudioAgents;
  editDecisioningStudioCreativeVariants: SHARED_CONSTANTS_editDecisioningStudioCreativeVariants;
  editDecisioningStudioGuardrails: SHARED_CONSTANTS_editDecisioningStudioGuardrails;
  editDecisioningStudioReports: SHARED_CONSTANTS_editDecisioningStudioReports;
  editDomainSettings: SHARED_CONSTANTS_editDomainSettings;
  editEmailSettings: SHARED_CONSTANTS_editEmailSettings;
  editEmailTemplates: SHARED_CONSTANTS_editEmailTemplates;
  editFeatureFlags: SHARED_CONSTANTS_editFeatureFlags;
  editFrequencyCaps: SHARED_CONSTANTS_editFrequencyCaps;
  editGlobalControlGroup: SHARED_CONSTANTS_editGlobalControlGroup;
  editGlobalRateLimits: SHARED_CONSTANTS_editGlobalRateLimits;
  editIamTemplates: SHARED_CONSTANTS_editIamTemplates;
  editInternalUserGroups: SHARED_CONSTANTS_editInternalUserGroups;
  editKnowledgeSources: SHARED_CONSTANTS_editKnowledgeSources;
  editLandingPageTemplates: SHARED_CONSTANTS_editLandingPageTemplates;
  editLinkTemplates: SHARED_CONSTANTS_editLinkTemplates;
  editLocations: SHARED_CONSTANTS_editLocations;
  editMediaLibraryAssets: SHARED_CONSTANTS_editMediaLibraryAssets;
  editMessageArchivingSettings: SHARED_CONSTANTS_editMessageArchivingSettings;
  editMessagePrioritization: SHARED_CONSTANTS_editMessagePrioritization;
  editMultiLanguageLocaleSettings: SHARED_CONSTANTS_editMultiLanguageLocaleSettings;
  editPlacements: SHARED_CONSTANTS_editPlacements;
  editPreferenceCenters: SHARED_CONSTANTS_editPreferenceCenters;
  editProducts: SHARED_CONSTANTS_editProducts;
  editPurchasePropertySegmentation: SHARED_CONSTANTS_editPurchasePropertySegmentation;
  editPushSettings: SHARED_CONSTANTS_editPushSettings;
  editQuietHoursSettings: SHARED_CONSTANTS_editQuietHoursSettings;
  editReporting: SHARED_CONSTANTS_editReporting;
  editSdkDebugger: SHARED_CONSTANTS_editSdkDebugger;
  editSegments: SHARED_CONSTANTS_editSegments;
  editTags: SHARED_CONSTANTS_editTags;
  editTeams: SHARED_CONSTANTS_editTeams;
  editTechnologyPartners: SHARED_CONSTANTS_editTechnologyPartners;
  editUserData: SHARED_CONSTANTS_editUserData;
  editVouchers: SHARED_CONSTANTS_editVouchers;
  editWebhookTemplates: SHARED_CONSTANTS_editWebhookTemplates;
  editWhatsappMessageTemplates: SHARED_CONSTANTS_editWhatsappMessageTemplates;
  exportCatalogs: SHARED_CONSTANTS_exportCatalogs;
  exportCustomAttributes: SHARED_CONSTANTS_exportCustomAttributes;
  exportCustomEvents: SHARED_CONSTANTS_exportCustomEvents;
  exportCustomObjects: SHARED_CONSTANTS_exportCustomObjects;
  exportDashboardUsers: SHARED_CONSTANTS_exportDashboardUsers;
  exportData: SHARED_CONSTANTS_exportData;
  exportVouchers: SHARED_CONSTANTS_exportVouchers;
  externalIntegrations: SHARED_CONSTANTS_externalIntegrations;
  importAndUpdateUsers: SHARED_CONSTANTS_importAndUpdateUsers;
  importUsers: SHARED_CONSTANTS_importUsers;
  launchAndManageContentBlocks: SHARED_CONSTANTS_launchAndManageContentBlocks;
  launchCampaigns: SHARED_CONSTANTS_launchCampaigns;
  launchCanvases: SHARED_CONSTANTS_launchCanvases;
  launchContentBlocks: SHARED_CONSTANTS_launchContentBlocks;
  launchDecisioningStudioAgents: SHARED_CONSTANTS_launchDecisioningStudioAgents;
  manageAppGroup: SHARED_CONSTANTS_manageAppGroup;
  manageApps: SHARED_CONSTANTS_manageApps;
  manageCatalogsDashboardPermission: SHARED_CONSTANTS_manageCatalogsDashboardPermission;
  manageCompanySettings: SHARED_CONSTANTS_manageCompanySettings;
  manageCustomAttributesEventsProducts: SHARED_CONSTANTS_manageCustomAttributesEventsProducts;
  manageCustomEventPropertySegmentation: SHARED_CONSTANTS_manageCustomEventPropertySegmentation;
  manageDevelopersAndPermissions: SHARED_CONSTANTS_manageDevelopersAndPermissions;
  manageEmailSettings: SHARED_CONSTANTS_manageEmailSettings;
  manageFeatureFlags: SHARED_CONSTANTS_manageFeatureFlags;
  manageFieldLevelEncryption: SHARED_CONSTANTS_manageFieldLevelEncryption;
  manageMediaLibrary: SHARED_CONSTANTS_manageMediaLibrary;
  manageMultiLanguageSettings: SHARED_CONSTANTS_manageMultiLanguageSettings;
  managePreferenceCenters: SHARED_CONSTANTS_managePreferenceCenters;
  manageSubscriptionGroups: SHARED_CONSTANTS_manageSubscriptionGroups;
  manageTags: SHARED_CONSTANTS_manageTags;
  manageTerritories: SHARED_CONSTANTS_manageTerritories;
  manageTransformations: SHARED_CONSTANTS_manageTransformations;
  mergeDuplicateUsers: SHARED_CONSTANTS_mergeDuplicateUsers;
  previewDuplicateUsers: SHARED_CONSTANTS_previewDuplicateUsers;
  publishCards: SHARED_CONSTANTS_publishCards;
  publishLandingPages: SHARED_CONSTANTS_publishLandingPages;
  readLandingPages: SHARED_CONSTANTS_readLandingPages;
  replaceMediaLibraryAssets: SHARED_CONSTANTS_replaceMediaLibraryAssets;
  searchUsers: SHARED_CONSTANTS_searchUsers;
  sendCampaigns: SHARED_CONSTANTS_sendCampaigns;
  updateFreeTrialDevelopers: SHARED_CONSTANTS_updateFreeTrialDevelopers;
  useMcpServer: SHARED_CONSTANTS_useMcpServer;
  useOperator: SHARED_CONSTANTS_useOperator;
  viewApiIdentifiers: SHARED_CONSTANTS_viewApiIdentifiers;
  viewApiKeys: SHARED_CONSTANTS_viewApiKeys;
  viewApiLimits: SHARED_CONSTANTS_viewApiLimits;
  viewApiUsageAlerts: SHARED_CONSTANTS_viewApiUsageAlerts;
  viewApiUsageDashboard: SHARED_CONSTANTS_viewApiUsageDashboard;
  viewAppSettings: SHARED_CONSTANTS_viewAppSettings;
  viewAppUsage: SHARED_CONSTANTS_viewAppUsage;
  viewAudiencePopulation: SHARED_CONSTANTS_viewAudiencePopulation;
  viewAudienceSyncSettings: SHARED_CONSTANTS_viewAudienceSyncSettings;
  viewBannerTemplates: SHARED_CONSTANTS_viewBannerTemplates;
  viewBilling: SHARED_CONSTANTS_viewBilling;
  viewCampaigns: SHARED_CONSTANTS_viewCampaigns;
  viewCanvasTemplates: SHARED_CONSTANTS_viewCanvasTemplates;
  viewCanvases: SHARED_CONSTANTS_viewCanvases;
  viewCatalogs: SHARED_CONSTANTS_viewCatalogs;
  viewContentBlocks: SHARED_CONSTANTS_viewContentBlocks;
  viewConversationalSettings: SHARED_CONSTANTS_viewConversationalSettings;
  viewConversationalWorkflows: SHARED_CONSTANTS_viewConversationalWorkflows;
  viewCrossChannelProfileLinking: SHARED_CONSTANTS_viewCrossChannelProfileLinking;
  viewCurrentsIntegrations: SHARED_CONSTANTS_viewCurrentsIntegrations;
  viewCustomAgents: SHARED_CONSTANTS_viewCustomAgents;
  viewCustomAttributes: SHARED_CONSTANTS_viewCustomAttributes;
  viewCustomAttributesMarkedAsPii: SHARED_CONSTANTS_viewCustomAttributesMarkedAsPii;
  viewCustomEvents: SHARED_CONSTANTS_viewCustomEvents;
  viewCustomObjects: SHARED_CONSTANTS_viewCustomObjects;
  viewDecisioningStudioActionBanks: SHARED_CONSTANTS_viewDecisioningStudioActionBanks;
  viewDecisioningStudioAgents: SHARED_CONSTANTS_viewDecisioningStudioAgents;
  viewDecisioningStudioAudience: SHARED_CONSTANTS_viewDecisioningStudioAudience;
  viewDecisioningStudioConversionEvent: SHARED_CONSTANTS_viewDecisioningStudioConversionEvent;
  viewDecisioningStudioGuardrails: SHARED_CONSTANTS_viewDecisioningStudioGuardrails;
  viewDecisioningStudioReports: SHARED_CONSTANTS_viewDecisioningStudioReports;
  viewDecisioningStudioTiming: SHARED_CONSTANTS_viewDecisioningStudioTiming;
  viewDomainSettings: SHARED_CONSTANTS_viewDomainSettings;
  viewEmailSettings: SHARED_CONSTANTS_viewEmailSettings;
  viewEmailTemplates: SHARED_CONSTANTS_viewEmailTemplates;
  viewEventUserLog: SHARED_CONSTANTS_viewEventUserLog;
  viewFeatureFlags: SHARED_CONSTANTS_viewFeatureFlags;
  viewFreeTrialDevelopers: SHARED_CONSTANTS_viewFreeTrialDevelopers;
  viewFrequencyCaps: SHARED_CONSTANTS_viewFrequencyCaps;
  viewGlobalControlGroup: SHARED_CONSTANTS_viewGlobalControlGroup;
  viewGlobalRateLimits: SHARED_CONSTANTS_viewGlobalRateLimits;
  viewIamTemplates: SHARED_CONSTANTS_viewIamTemplates;
  viewImportUsers: SHARED_CONSTANTS_viewImportUsers;
  viewInternalUserGroups: SHARED_CONSTANTS_viewInternalUserGroups;
  viewKnowledgeSources: SHARED_CONSTANTS_viewKnowledgeSources;
  viewLandingPageTemplates: SHARED_CONSTANTS_viewLandingPageTemplates;
  viewLinkTemplates: SHARED_CONSTANTS_viewLinkTemplates;
  viewLocations: SHARED_CONSTANTS_viewLocations;
  viewMediaLibraryAssets: SHARED_CONSTANTS_viewMediaLibraryAssets;
  viewMessageActivityLog: SHARED_CONSTANTS_viewMessageActivityLog;
  viewMessageArchivingSettings: SHARED_CONSTANTS_viewMessageArchivingSettings;
  viewMessagePrioritization: SHARED_CONSTANTS_viewMessagePrioritization;
  viewMultiLanguageLocaleSettings: SHARED_CONSTANTS_viewMultiLanguageLocaleSettings;
  viewPii: SHARED_CONSTANTS_viewPii;
  viewPlacements: SHARED_CONSTANTS_viewPlacements;
  viewPreferenceCenters: SHARED_CONSTANTS_viewPreferenceCenters;
  viewProducts: SHARED_CONSTANTS_viewProducts;
  viewPushSettings: SHARED_CONSTANTS_viewPushSettings;
  viewQuietHoursSettings: SHARED_CONSTANTS_viewQuietHoursSettings;
  viewReporting: SHARED_CONSTANTS_viewReporting;
  viewSdkDebugger: SHARED_CONSTANTS_viewSdkDebugger;
  viewSegments: SHARED_CONSTANTS_viewSegments;
  viewTags: SHARED_CONSTANTS_viewTags;
  viewTeams: SHARED_CONSTANTS_viewTeams;
  viewTransformations: SHARED_CONSTANTS_viewTransformations;
  viewUserDeletionRecords: SHARED_CONSTANTS_viewUserDeletionRecords;
  viewUserEventProperties: SHARED_CONSTANTS_viewUserEventProperties;
  viewUserMergeRecords: SHARED_CONSTANTS_viewUserMergeRecords;
  viewVouchers: SHARED_CONSTANTS_viewVouchers;
  viewWebhookTemplates: SHARED_CONSTANTS_viewWebhookTemplates;
  viewWhatsappCatalog: SHARED_CONSTANTS_viewWhatsappCatalog;
  viewWhatsappFlows: SHARED_CONSTANTS_viewWhatsappFlows;
  viewWhatsappMessageTemplates: SHARED_CONSTANTS_viewWhatsappMessageTemplates;
  viewWhatsappMessageTemplatesFromMeta: SHARED_CONSTANTS_viewWhatsappMessageTemplatesFromMeta;
  viewWhatsappSettings: SHARED_CONSTANTS_viewWhatsappSettings;
}
export interface SHARED_CONSTANTS_PERMISSION_NAMES {
  ADD_REMOVE_APP_GROUPS: 14;
  ADMIN: 0;
  APPROVE_DENY_CAMPAIGNS: 31;
  APPROVE_DENY_CANVASES: 32;
  ARCHIVE_BANNER_TEMPLATES: 89;
  ARCHIVE_CAMPAIGNS: 123;
  ARCHIVE_CANVASES: 126;
  ARCHIVE_CANVAS_TEMPLATES: 44;
  ARCHIVE_CONTENT_BLOCKS: 119;
  ARCHIVE_CUSTOM_AGENTS: 192;
  ARCHIVE_EMAIL_TEMPLATES: 159;
  ARCHIVE_FEATURE_FLAGS: 65;
  ARCHIVE_IAM_TEMPLATES: 162;
  ARCHIVE_LANDING_PAGE_TEMPLATES: 58;
  ARCHIVE_LOCATIONS: 97;
  ARCHIVE_PLACEMENTS: 68;
  ARCHIVE_SEGMENTS: 173;
  ARCHIVE_TEAMS: 171;
  ARCHIVE_WEBHOOK_TEMPLATES: 165;
  BASIC_READ_ONLY: 1;
  BLOCKLIST_CUSTOM_ATTRIBUTES: 72;
  BLOCKLIST_CUSTOM_EVENTS: 77;
  BLOCKLIST_PRODUCTS: 83;
  CREATE_FREE_TRIAL_DEVELOPERS: 47;
  CREATE_LANDING_PAGE_DRAFTS: 38;
  CREATE_SUPPORT_TICKET: 168;
  DELETE_CATALOGS: 94;
  DELETE_CUSTOM_ATTRIBUTES: 73;
  DELETE_CUSTOM_EVENTS: 78;
  DELETE_CUSTOM_OBJECTS: 214;
  DELETE_FREE_TRIAL_DEVELOPERS: 48;
  DELETE_INTERNAL_USER_GROUPS: 149;
  DELETE_KNOWLEDGE_SOURCES: 202;
  DELETE_MEDIA_LIBRARY_ASSETS: 145;
  DELETE_MULTI_LANGUAGE_LOCALE_SETTINGS: 142;
  DELETE_REPORTING: 184;
  DELETE_TAGS: 176;
  DELETE_USERS: 62;
  DELETE_WHATSAPP_MESSAGE_TEMPLATES: 156;
  DEVELOPER_CONSOLE: 6;
  EDIT_API_KEYS: 105;
  EDIT_API_USAGE_ALERTS: 109;
  EDIT_APP_SETTINGS: 152;
  EDIT_BANNER_TEMPLATES: 88;
  EDIT_BRAND_GUIDELINES: 222;
  EDIT_CAMPAIGNS: 122;
  EDIT_CANVASES: 125;
  EDIT_CANVAS_TEMPLATES: 42;
  EDIT_CATALOGS: 92;
  EDIT_CLOUD_DATA_INGESTION: 129;
  EDIT_CONTENT_BLOCKS: 118;
  EDIT_CONVERSATIONAL_SETTINGS: 206;
  EDIT_CONVERSATIONAL_WORKFLOWS: 204;
  EDIT_CROSS_CHANNEL_PROFILE_LINKING: 103;
  EDIT_CURRENTS_INTEGRATIONS: 46;
  EDIT_CUSTOM_AGENTS: 100;
  EDIT_CUSTOM_ATTRIBUTES: 71;
  EDIT_CUSTOM_EVENTS: 76;
  EDIT_CUSTOM_EVENT_PROPERTY_SEGMENTATION: 80;
  EDIT_CUSTOM_OBJECTS: 213;
  EDIT_DASHBOARD_USERS: 90;
  EDIT_DECISIONING_STUDIO_AGENTS: 198;
  EDIT_DECISIONING_STUDIO_CREATIVE_VARIANTS: 210;
  EDIT_DECISIONING_STUDIO_GUARDRAILS: 217;
  EDIT_DECISIONING_STUDIO_REPORTS: 220;
  EDIT_DOMAIN_SETTINGS: 59;
  EDIT_EMAIL_SETTINGS: 60;
  EDIT_EMAIL_TEMPLATES: 158;
  EDIT_FEATURE_FLAGS: 64;
  EDIT_FREQUENCY_CAPS: 139;
  EDIT_GLOBAL_CONTROL_GROUP: 180;
  EDIT_GLOBAL_RATE_LIMITS: 85;
  EDIT_IAM_TEMPLATES: 161;
  EDIT_INTERNAL_USER_GROUPS: 148;
  EDIT_KNOWLEDGE_SOURCES: 201;
  EDIT_LANDING_PAGE_TEMPLATES: 56;
  EDIT_LINK_TEMPLATES: 167;
  EDIT_LOCATIONS: 96;
  EDIT_MEDIA_LIBRARY_ASSETS: 144;
  EDIT_MESSAGE_ARCHIVING_SETTINGS: 196;
  EDIT_MESSAGE_PRIORITIZATION: 137;
  EDIT_MULTI_LANGUAGE_LOCALE_SETTINGS: 141;
  EDIT_PLACEMENTS: 67;
  EDIT_PREFERENCE_CENTERS: 135;
  EDIT_PRODUCTS: 82;
  EDIT_PURCHASE_PROPERTY_SEGMENTATION: 84;
  EDIT_PUSH_SETTINGS: 115;
  EDIT_QUIET_HOURS_SETTINGS: 209;
  EDIT_REPORTING: 183;
  EDIT_SDK_DEBUGGER: 151;
  EDIT_SEGMENTS: 5;
  EDIT_TAGS: 175;
  EDIT_TEAMS: 170;
  EDIT_TECHNOLOGY_PARTNERS: 199;
  EDIT_USER_DATA: 113;
  EDIT_VOUCHERS: 131;
  EDIT_WEBHOOK_TEMPLATES: 164;
  EDIT_WHATSAPP_MESSAGE_TEMPLATES: 155;
  EXPORT_CATALOGS: 93;
  EXPORT_CUSTOM_ATTRIBUTES: 74;
  EXPORT_CUSTOM_EVENTS: 79;
  EXPORT_CUSTOM_OBJECTS: 215;
  EXPORT_DASHBOARD_USERS: 54;
  EXPORT_DATA: 2;
  EXPORT_VOUCHERS: 132;
  EXTERNAL_INTEGRATIONS: 23;
  IMPORT_AND_UPDATE_USERS: 22;
  IMPORT_USERS: 133;
  LAUNCH_AND_MANAGE_CONTENT_BLOCKS: 33;
  LAUNCH_CAMPAIGNS: 127;
  LAUNCH_CANVASES: 128;
  LAUNCH_CONTENT_BLOCKS: 120;
  LAUNCH_DECISIONING_STUDIO_AGENTS: 221;
  MANAGE_APPS: 19;
  MANAGE_APP_GROUP: 9;
  MANAGE_CATALOGS_DASHBOARD_PERMISSION: 36;
  MANAGE_COMPANY_SETTINGS: 15;
  MANAGE_CUSTOM_ATTRIBUTES_EVENTS_PRODUCTS: 16;
  MANAGE_CUSTOM_EVENT_PROPERTY_SEGMENTATION: 53;
  MANAGE_DEVELOPERS_AND_PERMISSIONS: 13;
  MANAGE_EMAIL_SETTINGS: 17;
  MANAGE_FEATURE_FLAGS: 29;
  MANAGE_FIELD_LEVEL_ENCRYPTION: 37;
  MANAGE_MEDIA_LIBRARY: 18;
  MANAGE_MULTI_LANGUAGE_SETTINGS: 34;
  MANAGE_PREFERENCE_CENTERS: 30;
  MANAGE_SUBSCRIPTION_GROUPS: 25;
  MANAGE_TAGS: 11;
  MANAGE_TERRITORIES: 7;
  MANAGE_TRANSFORMATIONS: 28;
  MERGE_DUPLICATE_USERS: 41;
  PLACEHOLDER: 999;
  PREVIEW_DUPLICATE_USERS: 50;
  PUBLISH_CARDS: 4;
  PUBLISH_LANDING_PAGES: 39;
  READ_LANDING_PAGES: 40;
  REPLACE_MEDIA_LIBRARY_ASSETS: 207;
  SEARCH_USERS: 12;
  SEND_CAMPAIGNS: 3;
  UPDATE_FREE_TRIAL_DEVELOPERS: 51;
  USE_MCP_SERVER: 218;
  USE_OPERATOR: 169;
  VIEW_API_IDENTIFIERS: 106;
  VIEW_API_KEYS: 104;
  VIEW_API_LIMITS: 111;
  VIEW_API_USAGE_ALERTS: 108;
  VIEW_API_USAGE_DASHBOARD: 110;
  VIEW_APP_SETTINGS: 153;
  VIEW_APP_USAGE: 8;
  VIEW_AUDIENCE_POPULATION: 211;
  VIEW_AUDIENCE_SYNC_SETTINGS: 190;
  VIEW_BANNER_TEMPLATES: 86;
  VIEW_BILLING: 10;
  VIEW_CAMPAIGNS: 121;
  VIEW_CANVASES: 124;
  VIEW_CANVAS_TEMPLATES: 43;
  VIEW_CATALOGS: 91;
  VIEW_CONTENT_BLOCKS: 117;
  VIEW_CONVERSATIONAL_SETTINGS: 205;
  VIEW_CONVERSATIONAL_WORKFLOWS: 203;
  VIEW_CROSS_CHANNEL_PROFILE_LINKING: 102;
  VIEW_CURRENTS_INTEGRATIONS: 45;
  VIEW_CUSTOM_AGENTS: 98;
  VIEW_CUSTOM_ATTRIBUTES: 70;
  VIEW_CUSTOM_ATTRIBUTES_MARKED_AS_PII: 35;
  VIEW_CUSTOM_EVENTS: 75;
  VIEW_CUSTOM_OBJECTS: 212;
  VIEW_DECISIONING_STUDIO_ACTION_BANKS: 194;
  VIEW_DECISIONING_STUDIO_AGENTS: 177;
  VIEW_DECISIONING_STUDIO_AUDIENCE: 181;
  VIEW_DECISIONING_STUDIO_CONVERSION_EVENT: 178;
  VIEW_DECISIONING_STUDIO_GUARDRAILS: 185;
  VIEW_DECISIONING_STUDIO_REPORTS: 219;
  VIEW_DECISIONING_STUDIO_TIMING: 193;
  VIEW_DOMAIN_SETTINGS: 191;
  VIEW_EMAIL_SETTINGS: 61;
  VIEW_EMAIL_TEMPLATES: 157;
  VIEW_EVENT_USER_LOG: 107;
  VIEW_FEATURE_FLAGS: 63;
  VIEW_FREE_TRIAL_DEVELOPERS: 49;
  VIEW_FREQUENCY_CAPS: 138;
  VIEW_GLOBAL_CONTROL_GROUP: 179;
  VIEW_GLOBAL_RATE_LIMITS: 197;
  VIEW_IAM_TEMPLATES: 160;
  VIEW_IMPORT_USERS: 112;
  VIEW_INTERNAL_USER_GROUPS: 146;
  VIEW_KNOWLEDGE_SOURCES: 200;
  VIEW_LANDING_PAGE_TEMPLATES: 57;
  VIEW_LINK_TEMPLATES: 166;
  VIEW_LOCATIONS: 95;
  VIEW_MEDIA_LIBRARY_ASSETS: 143;
  VIEW_MESSAGE_ACTIVITY_LOG: 116;
  VIEW_MESSAGE_ARCHIVING_SETTINGS: 195;
  VIEW_MESSAGE_PRIORITIZATION: 136;
  VIEW_MULTI_LANGUAGE_LOCALE_SETTINGS: 140;
  VIEW_PII: 24;
  VIEW_PLACEMENTS: 66;
  VIEW_PREFERENCE_CENTERS: 134;
  VIEW_PRODUCTS: 81;
  VIEW_PUSH_SETTINGS: 114;
  VIEW_QUIET_HOURS_SETTINGS: 208;
  VIEW_REPORTING: 182;
  VIEW_SDK_DEBUGGER: 150;
  VIEW_SEGMENTS: 172;
  VIEW_TAGS: 174;
  VIEW_TEAMS: 55;
  VIEW_TRANSFORMATIONS: 27;
  VIEW_USER_DELETION_RECORDS: 69;
  VIEW_USER_EVENT_PROPERTIES: 216;
  VIEW_USER_MERGE_RECORDS: 101;
  VIEW_VOUCHERS: 130;
  VIEW_WEBHOOK_TEMPLATES: 163;
  VIEW_WHATSAPP_CATALOG: 188;
  VIEW_WHATSAPP_FLOWS: 187;
  VIEW_WHATSAPP_MESSAGE_TEMPLATES: 154;
  VIEW_WHATSAPP_MESSAGE_TEMPLATES_FROM_META: 189;
  VIEW_WHATSAPP_SETTINGS: 186;
}
export interface SHARED_CONSTANTS_agent_console {
  custom_agents: "custom_agents";
}
export interface SHARED_CONSTANTS_ai_decisioning {
  decisioning_studio_action_banks: "decisioning_studio_action_banks";
  decisioning_studio_agents: "decisioning_studio_agents";
  decisioning_studio_audience: "decisioning_studio_audience";
  decisioning_studio_conversion_event: "decisioning_studio_conversion_event";
  decisioning_studio_creative_variants: "decisioning_studio_creative_variants";
  decisioning_studio_guardrails: "decisioning_studio_guardrails";
  decisioning_studio_reports: "decisioning_studio_reports";
  decisioning_studio_timing: "decisioning_studio_timing";
}
export interface SHARED_CONSTANTS_analytics {
  app_usage: "app_usage";
  dashboard_reports: "dashboard_reports";
}
export interface SHARED_CONSTANTS_audience {
  audience_population: "audience_population";
  cross_channel_profile_linking: "cross_channel_profile_linking";
  duplicate_users: "duplicate_users";
  global_control_group: "global_control_group";
  import_users: "import_users";
  locations: "locations";
  segments: "segments";
  subscription_groups: "subscription_groups";
  subscriptions: "subscriptions";
  user_data: "user_data";
  user_deletion_records: "user_deletion_records";
  user_event_properties: "user_event_properties";
  user_merge_records: "user_merge_records";
}
export interface SHARED_CONSTANTS_data_settings {
  catalogs: "catalogs";
  cloud_data_ingestion: "cloud_data_ingestion";
  custom_attributes: "custom_attributes";
  custom_event_property_segmentation: "custom_event_property_segmentation";
  custom_events: "custom_events";
  custom_objects: "custom_objects";
  data_transformation: "data_transformation";
  pii: "pii";
  products: "products";
  promotion_codes: "promotion_codes";
  purchase_property_segmentation: "purchase_property_segmentation";
}
export interface SHARED_CONSTANTS_messaging {
  campaigns: "campaigns";
  canvas: "canvas";
  feature_flags: "feature_flags";
  frequency_caps: "frequency_caps";
  landing_pages: "landing_pages";
  message_archiving_settings: "message_archiving_settings";
  message_prioritization: "message_prioritization";
  quiet_hours_settings: "quiet_hours_settings";
  whatsapp_catalog: "whatsapp_catalog";
  whatsapp_flows: "whatsapp_flows";
}
export interface SHARED_CONSTANTS_other {
  apps: "apps";
  banners: "banners";
  conversational_settings: "conversational_settings";
  conversational_workflows: "conversational_workflows";
  custom_attributes_events_products: "custom_attributes_events_products";
  custom_attributes_marked_as_pii: "custom_attributes_marked_as_pii";
  data: "data";
  developer_console: "developer_console";
  field_level_encryption: "field_level_encryption";
  free_trial_developers: "free_trial_developers";
  knowledge_sources: "knowledge_sources";
  mcp_server: "mcp_server";
  meta_bids: "meta_bids";
  operator: "operator";
  support: "support";
  support_tickets: "support_tickets";
  system: "system";
  transformations: "transformations";
}
export interface SHARED_CONSTANTS_partner_integrations {
  currents_integrations: "currents_integrations";
  technology_partners: "technology_partners";
}
export interface SHARED_CONSTANTS_settings {
  api_identifiers: "api_identifiers";
  api_keys: "api_keys";
  api_limits: "api_limits";
  api_usage_alerts: "api_usage_alerts";
  api_usage_data: "api_usage_data";
  app_settings: "app_settings";
  audience_sync_settings: "audience_sync_settings";
  billing: "billing";
  dashboard_users: "dashboard_users";
  email_settings: "email_settings";
  event_user_log: "event_user_log";
  external_integrations: "external_integrations";
  global_rate_limits: "global_rate_limits";
  internal_groups: "internal_groups";
  message_activity_log: "message_activity_log";
  multi_language_settings: "multi_language_settings";
  placements: "placements";
  preference_centers: "preference_centers";
  push_settings: "push_settings";
  sdk_debugger: "sdk_debugger";
  tags: "tags";
  teams: "teams";
  usage_data: "usage_data";
  whatsapp_settings: "whatsapp_settings";
}
export interface SHARED_CONSTANTS_template {
  banner_templates: "banner_templates";
  brand_guidelines: "brand_guidelines";
  canvas_templates: "canvas_templates";
  content_blocks: "content_blocks";
  creative_assets: "creative_assets";
  email_link_templates: "email_link_templates";
  email_templates: "email_templates";
  iam_templates: "iam_templates";
  landing_page_templates: "landing_page_templates";
  media_library_assets: "media_library_assets";
  message_body: "message_body";
  message_structure: "message_structure";
  webhook_templates: "webhook_templates";
  whatsapp_message_templates: "whatsapp_message_templates";
  whatsapp_message_templates_from_meta: "whatsapp_message_templates_from_meta";
}
export interface SHARED_CONSTANTS_PERMISSION_RESOURCE_GROUPS {
  agent_console: SHARED_CONSTANTS_agent_console;
  ai_decisioning: SHARED_CONSTANTS_ai_decisioning;
  analytics: SHARED_CONSTANTS_analytics;
  audience: SHARED_CONSTANTS_audience;
  data_settings: SHARED_CONSTANTS_data_settings;
  messaging: SHARED_CONSTANTS_messaging;
  other: SHARED_CONSTANTS_other;
  partner_integrations: SHARED_CONSTANTS_partner_integrations;
  settings: SHARED_CONSTANTS_settings;
  template: SHARED_CONSTANTS_template;
}
export interface SHARED_CONSTANTS_PERMISSION_SCOPES {
  APP_GROUP: 1;
  COMPANY: 0;
  TERRITORY: 2;
}
export interface SHARED_CONSTANTS_PII_FIELDS {
  ALL_CUSTOM_ATTRIBUTES: "all_custom_attributes";
  BIRTHDAY: "birthday";
  CITY: "city";
  DEVICE_IDS: "device_ids";
  EMAIL: "email";
  FIRST_NAME: "first_name";
  GENDER: "gender";
  LAST_NAME: "last_name";
  LINE_ID: "line_id";
  MOST_RECENT_LOCATION: "most_recent_location";
  PHONE: "phone";
}
export interface SHARED_CONSTANTS_PLACEMENTS_ERRORS {
  INVALID_ASSOCIATION: "placement_not_associated";
  INVALID_PLACEMENT: "INVALID_PLACEMENT";
  PLACEMENTS_HAVE_ACTIVE_CAMPAIGNS: "PLACEMENTS_HAVE_ACTIVE_CAMPAIGNS";
}
export interface SHARED_CONSTANTS_PLACEMENTS_SEARCHABLE_STATUSES {
  ACTIVE: "Active";
  ARCHIVED: "Archived";
}
export interface SHARED_CONSTANTS_INSERTION_POSITIONS {
  AFTER: "after";
  BEFORE: "before";
  INSIDE: "inside";
}
export interface SHARED_CONSTANTS_URL_MATCH_TYPES {
  CONTAINS: "contains";
  EQUALS: "equals";
  MATCHES: "matches_regex";
}
export interface SHARED_CONSTANTS_TARGETING {
  INSERTION_POSITIONS: SHARED_CONSTANTS_INSERTION_POSITIONS;
  URL_MATCH_TYPES: SHARED_CONSTANTS_URL_MATCH_TYPES;
}
export interface SHARED_CONSTANTS_PLACEMENTS {
  ERRORS: SHARED_CONSTANTS_PLACEMENTS_ERRORS;
  MAX_ACTIVE_CAMPAIGNS: 25;
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_PLACEMENTS_SEARCHABLE_STATUSES;
  TARGETING: SHARED_CONSTANTS_TARGETING;
}
export interface SHARED_CONSTANTS_PLATFORM_APP_TYPES {
  ANDROID: "Android";
  ANDROID_CHINA: "Android China";
  IOS: "iOS";
  KEPLER: "Kepler";
  KINDLE: "Kindle";
  LANDING_PAGE: "Landing Page";
  ROKU: "Roku";
  TVOS: "tvOS";
  WEB: "Web";
  WINDOWS_UNIVERSAL: "Windows Universal";
}
export interface SHARED_CONSTANTS_PLATFORM_BACKEND_KEYS {
  ALL_PLATFORMS_NAME: "all";
  ANDROID: "android";
  ANDROID_CHINA: "android_china";
  IOS: "ios";
  KEPLER: "kepler";
  KINDLE: "kindle";
  LANDING_PAGE: "landing_page";
  ROKU: "roku";
  TVOS: "tvos";
  WEB: "web";
  WINDOWS8: "windows8";
}
export interface SHARED_CONSTANTS_PLATFORM_CAMELCASE_NAMES {
  Android: "android";
  "Android China": "androidChina";
  Kepler: "kepler";
  Kindle: "kindle";
  "Landing Page": "landingPage";
  Roku: "roku";
  Web: "web";
  "Windows Universal": "windowsUniversal";
  iOS: "ios";
  tvOS: "tvos";
}
export interface SHARED_CONSTANTS_PLATFORM_MAPPING {
  Android: "android";
  "Android China": "android_china";
  Kepler: "kepler";
  Kindle: "kindle";
  "Landing Page": "landing_page";
  Roku: "roku";
  Web: "web";
  "Windows Universal": "windows8";
  iOS: "ios";
  tvOS: "tvos";
}
export interface SHARED_CONSTANTS_PLATFORMS {
  PLATFORM_APP_TYPES: SHARED_CONSTANTS_PLATFORM_APP_TYPES;
  PLATFORM_BACKEND_KEYS: SHARED_CONSTANTS_PLATFORM_BACKEND_KEYS;
  PLATFORM_CAMELCASE_NAMES: SHARED_CONSTANTS_PLATFORM_CAMELCASE_NAMES;
  PLATFORM_MAPPING: SHARED_CONSTANTS_PLATFORM_MAPPING;
}
export interface SHARED_CONSTANTS_PLATFORM_GROUPS {
  NATIVE: "NATIVE";
  ROKU: "ROKU";
  UNIVERSAL: "UNIVERSAL";
  WEB: "WEB";
}
export interface SHARED_CONSTANTS_FILTER_KEYS {
  CATEGORY: "churn_category_filter";
  SCORE: "churn_score_filter";
}
export interface SHARED_CONSTANTS_churn {
  DEFAULT_TIME_WINDOW: 7;
  FILTER_KEYS: SHARED_CONSTANTS_FILTER_KEYS;
  MAU_WARNING_LIMIT: 300000;
}
export interface SHARED_CONSTANTS_Purchase_FILTER_KEYS {
  CATEGORY: "purchase_category_filter";
  SCORE: "purchase_score_filter";
}
export interface SHARED_CONSTANTS_purchase {
  DEFAULT_TIME_WINDOW: 14;
  FILTER_KEYS: SHARED_CONSTANTS_Purchase_FILTER_KEYS;
  MAU_WARNING_LIMIT: 0;
}
export interface SHARED_CONSTANTS_BY_TYPE {
  churn: SHARED_CONSTANTS_churn;
  purchase: SHARED_CONSTANTS_purchase;
}
export interface SHARED_CONSTANTS_HIGH {
  RANGE: (0.75 | 1.01)[];
  VALUE: "high risk";
}
export interface SHARED_CONSTANTS_LOW {
  RANGE: (0 | 0.5)[];
  VALUE: "low risk";
}
export interface SHARED_CONSTANTS_MEDIUM {
  RANGE: (0.5 | 0.75)[];
  VALUE: "medium risk";
}
export interface SHARED_CONSTANTS_CATEGORIES {
  HIGH: SHARED_CONSTANTS_HIGH;
  LOW: SHARED_CONSTANTS_LOW;
  MEDIUM: SHARED_CONSTANTS_MEDIUM;
}
export interface SHARED_CONSTANTS_ByType_churn {
  CATEGORIES: SHARED_CONSTANTS_CATEGORIES;
  FF_PAID: "pred_churn_paid";
  FF_PREVIEW: "pred_churn_preview";
  NAME: "Churn";
  TARGET_CONDITION_DESCRIPTION: "Churn Risk";
  UNIVERSE_CONDITION: "non_churn";
}
export interface SHARED_CONSTANTS_CATEGORIES_HIGH {
  RANGE: (0.75 | 1.01)[];
  VALUE: "high likelihood";
}
export interface SHARED_CONSTANTS_CATEGORIES_LOW {
  RANGE: (0 | 0.5)[];
  VALUE: "low likelihood";
}
export interface SHARED_CONSTANTS_CATEGORIES_MEDIUM {
  RANGE: (0.5 | 0.75)[];
  VALUE: "medium likelihood";
}
export interface SHARED_CONSTANTS_Purchase_CATEGORIES {
  HIGH: SHARED_CONSTANTS_CATEGORIES_HIGH;
  LOW: SHARED_CONSTANTS_CATEGORIES_LOW;
  MEDIUM: SHARED_CONSTANTS_CATEGORIES_MEDIUM;
}
export interface SHARED_CONSTANTS_ByType_purchase {
  CATEGORIES: SHARED_CONSTANTS_Purchase_CATEGORIES;
  FF_PAID: "pred_purchase_paid";
  FF_PREVIEW: "pred_purchase_preview";
  NAME: "Event";
  TARGET_CONDITION_DESCRIPTION: "Event Likelihood";
  UNIVERSE_CONDITION: "universe";
}
export interface SHARED_CONSTANTS_byType {
  churn: SHARED_CONSTANTS_ByType_churn;
  purchase: SHARED_CONSTANTS_ByType_purchase;
}
export interface SHARED_CONSTANTS_custom_events_since_filter {
  comparisonKey: "4";
  displayName: "perform a custom event";
}
export interface SHARED_CONSTANTS_uninstall_filter {
  comparisonKey: "4";
  displayName: "uninstall";
}
export interface SHARED_CONSTANTS_do {
  custom_events_since_filter: SHARED_CONSTANTS_custom_events_since_filter;
  uninstall_filter: SHARED_CONSTANTS_uninstall_filter;
}
export interface SHARED_CONSTANTS_DoXnot_custom_events_since_filter {
  comparisonKey: "6";
  displayName: "perform a custom event";
}
export interface SHARED_CONSTANTS_last_purchase_since_filter {
  comparisonKey: "6";
  displayName: "make a purchase";
}
export interface SHARED_CONSTANTS_last_session_since_filter {
  comparisonKey: "6";
  displayName: "start a session";
}
export interface SHARED_CONSTANTS_doXnot {
  custom_events_since_filter: SHARED_CONSTANTS_DoXnot_custom_events_since_filter;
  last_purchase_since_filter: SHARED_CONSTANTS_last_purchase_since_filter;
  last_session_since_filter: SHARED_CONSTANTS_last_session_since_filter;
}
export interface SHARED_CONSTANTS_churnFilterConfig {
  do: SHARED_CONSTANTS_do;
  "do not": SHARED_CONSTANTS_doXnot;
}
export interface SHARED_CONSTANTS_FRONTEND_DATA {
  byType: SHARED_CONSTANTS_byType;
  churnFilterConfig: SHARED_CONSTANTS_churnFilterConfig;
}
export interface SHARED_CONSTANTS_MODEL_STATES {
  ACTIVE: "active";
  BUILT: "built";
  DRAFT: "draft";
  FAILED: "failed";
  PREACTIVE: "pre-serving";
  PRETRAINING: "pretraining";
  RETRAINING: "retraining";
  TRAINING: "training";
}
export interface SHARED_CONSTANTS_PARAMETER_STATES {
  INIT_UPDATE: "init_update";
  PULL: "pull";
  SERVE: "serve";
  TRAIN: "train";
  UPDATE: "update";
}
export interface SHARED_CONSTANTS_PREDICTION_TYPES {
  CHURN: "churn";
  PURCHASE: "purchase";
}
export interface SHARED_CONSTANTS_PREDICTIONS_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
  DRAFT: "draft";
}
export interface SHARED_CONSTANTS_PREDICTIONS_SEARCH_KEYS {
  EDITED: "edited";
  MODEL_TYPE: "model_type";
  STATUS: "status";
  TRAINED: "trained";
}
export interface SHARED_CONSTANTS_WIZARD_STEPS {
  AUDIENCE: 2;
  BASICS: 0;
  BUILD: 4;
  EVENTS: 1;
  SCHEDULE: 3;
}
export interface SHARED_CONSTANTS_PREDICTIONS {
  BY_TYPE: SHARED_CONSTANTS_BY_TYPE;
  FRONTEND_DATA: SHARED_CONSTANTS_FRONTEND_DATA;
  HIGHEST_LIKELIHOOD_SELECTION_HIGH: 100;
  HIGHEST_LIKELIHOOD_SELECTION_LOW: 75;
  MAX_ALLOWED_MODELS_PAID: 10;
  MAX_ALLOWED_MODELS_PREVIEW: 1;
  MAX_LOOK_BACK_TIME_WINDOW_MONGO: 14;
  MAX_LOOK_BACK_TIME_WINDOW_SNOWFLAKE: 60;
  MAX_LOOK_BACK_TOTAL_PERIOD_MONGO: 30;
  MAX_LOOK_BACK_TOTAL_PERIOD_SNOWFLAKE: 120;
  MAX_UNIVERSE_SIZE: 100000000;
  MAX_WEEKDAYS_SELECTED: 4;
  MODEL_STATES: SHARED_CONSTANTS_MODEL_STATES;
  PARAMETER_STATES: SHARED_CONSTANTS_PARAMETER_STATES;
  PREDICTION_TYPES: SHARED_CONSTANTS_PREDICTION_TYPES;
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_PREDICTIONS_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_PREDICTIONS_SEARCH_KEYS;
  TBED_COLLECTION_DAYS: 30;
  WIZARD_STEPS: SHARED_CONSTANTS_WIZARD_STEPS;
  WIZARD_STEPS_EVENTS_WINDOW: 1.5;
}
export interface SHARED_CONSTANTS_PREFERENCE_CENTER_STATUS {
  ACTIVE: "active";
  DRAFT: "draft";
}
export interface SHARED_CONSTANTS_PREFERENCE_CENTER_TYPE {
  DND: "dnd";
  HTML: "html";
}
export interface SHARED_CONSTANTS_PREFERENCE_CENTER {
  STATUS: SHARED_CONSTANTS_PREFERENCE_CENTER_STATUS;
  TYPE: SHARED_CONSTANTS_PREFERENCE_CENTER_TYPE;
}
export interface SHARED_CONSTANTS_PREVIEW_MESSAGE_TYPES {
  ANDROID_PUSH: "androidPush";
  BANNER: "banner";
  CONTENT_BLOCK: "contentBlock";
  CONTENT_CARD: "contentCard";
  DEPRECATED: "deprecated";
  EMAIL: "email";
  EMAIL_CUSTOM_FOOTER: "emailCustomFooter";
  EMAIL_PREFERENCE_CENTER: "emailPreferenceCenter";
  EMAIL_SUBSCRIPTION_PAGE: "emailSubscriptionPage";
  EMAIL_TEMPLATE: "emailTemplate";
  IN_APP_MESSAGE: "inAppMessage";
  IOS_PUSH: "iosPush";
  KAKAO: "kakao";
  KINDLE_PUSH: "kindlePush";
  LANDING_PAGE: "landingPage";
  LINE: "line";
  SMS: "sms";
  TRIGGER_IAM: "trigger";
  WEBHOOK: "webhook";
  WEB_PUSH: "webPush";
  WHATS_APP: "whatsApp";
}
export interface SHARED_CONSTANTS_PREVIEW_MESSAGE {
  TYPES: SHARED_CONSTANTS_PREVIEW_MESSAGE_TYPES;
}
export interface SHARED_CONSTANTS_PRIORITY_BUCKET {
  HIGH: 3;
  LOW: 1;
  MEDIUM: 2;
}
export interface SHARED_CONSTANTS_PRIORITY_MANAGER_TYPES {
  CAMPAIGN: "campaign";
  CANVAS: "canvas";
  CANVAS_STEP: "canvas_step";
}
export interface SHARED_CONSTANTS_PRIORITY_MANAGER {
  PRIORITY_BUCKET: SHARED_CONSTANTS_PRIORITY_BUCKET;
  TYPES: SHARED_CONSTANTS_PRIORITY_MANAGER_TYPES;
}
export interface SHARED_CONSTANTS_PUSH_CREDENTIAL_MANAGEMENT_ERROR_CODES {
  CERTIFICATE_DOWNLOAD_ERROR: "CERTIFICATE_DOWNLOAD_ERROR";
  CERTIFICATE_DOWNLOAD_TIMEOUT: "CERTIFICATE_DOWNLOAD_TIMEOUT";
  CERTIFICATE_NOT_SAVED: "CERTIFICATE_NOT_SAVED";
  INVALID_APPLE_PUSH_CERTIFICATE: "INVALID_APPLE_PUSH_CERTIFICATE";
  INVALID_CERTIFICATE_OR_PASSWORD_IOS: "INVALID_CERTIFICATE_OR_PASSWORD_IOS";
  LEGACY_CERTIFICATE_DEPRECATED: "LEGACY_CERTIFICATE_DEPRECATED";
  PASSWORD_PROTECTED_CERTIFICATE: "PASSWORD_PROTECTED_CERTIFICATE";
}
export interface SHARED_CONSTANTS_PUSH_CREDENTIAL_MANAGEMENT {
  ERROR_CODES: SHARED_CONSTANTS_PUSH_CREDENTIAL_MANAGEMENT_ERROR_CODES;
}
export interface SHARED_CONSTANTS_PUSH_CREDENTIAL_TYPES {
  DEVELOPMENT: "Development";
  PRODUCTION: "Production";
  UNIVERSAL: "Universal";
}
export interface SHARED_CONSTANTS_QUERY_BUILDER {
  DEFAULT_ROW_LIMIT: 1000;
}
export interface SHARED_CONSTANTS_ACTION_TYPES {
  REPLY: "reply";
  URL: "url";
}
export interface SHARED_CONSTANTS_FALLBACK_TYPES {
  TEXT: "text";
}
export interface SHARED_CONSTANTS_ACTION_SOURCES {
  BUTTON: "button";
  SUGGESTED_ACTION: "suggested_action";
}
export interface SHARED_CONSTANTS_INFOBIP_ACTION_TYPES {
  OPEN_URL: "OPEN_URL";
  REPLY: "REPLY";
}
export interface SHARED_CONSTANTS_INFOBIP {
  ACTION_SOURCES: SHARED_CONSTANTS_ACTION_SOURCES;
  ACTION_TYPES: SHARED_CONSTANTS_INFOBIP_ACTION_TYPES;
}
export interface SHARED_CONSTANTS_INTERACTION_TYPES {
  TEXT_URL: "TEXT_URL";
}
export interface SHARED_CONSTANTS_RCS_MESSAGE_TYPES {
  MEDIA: "media";
  RICH_CARD: "rich_card";
  TEXT: "text";
}
export interface SHARED_CONSTANTS_RICH_CARD_ALIGNMENTS {
  LEFT: "LEFT";
  RIGHT: "RIGHT";
}
export interface SHARED_CONSTANTS_RICH_CARD_HEIGHTS {
  MEDIUM: "MEDIUM";
  SHORT: "SHORT";
  TALL: "TALL";
}
export interface SHARED_CONSTANTS_RICH_CARD_ORIENTATIONS {
  HORIZONTAL: "HORIZONTAL";
  VERTICAL: "VERTICAL";
}
export interface SHARED_CONSTANTS_RICH_CARD_TYPES {
  MEDIA: "media";
  TEXT: "text";
}
export interface SHARED_CONSTANTS_TWILIO_ACTION_SOURCES {
  BUTTON: "button";
  SUGGESTED_ACTION: "suggested_action";
}
export interface SHARED_CONSTANTS_TWILIO_ACTION_TYPES {
  OPEN_URL: "OPEN_URL";
  REPLY: "REPLY";
}
export interface SHARED_CONSTANTS_VALIDATIONS {
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_DESCRIPTION: 1600;
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_TITLE: 200;
}
export interface SHARED_CONSTANTS_TWILIO {
  ACTION_SOURCES: SHARED_CONSTANTS_TWILIO_ACTION_SOURCES;
  ACTION_TYPES: SHARED_CONSTANTS_TWILIO_ACTION_TYPES;
  VALIDATIONS: SHARED_CONSTANTS_VALIDATIONS;
}
export interface SHARED_CONSTANTS_RCS_VALIDATIONS {
  MAX_CHARACTER_LIMIT_FOR_FALLBACK_TEXT: 1600;
  MAX_CHARACTER_LIMIT_FOR_MEDIA_URL: 1000;
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_DESCRIPTION: 2000;
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_DESCRIPTION_INFOBIP: 2000;
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_DESCRIPTION_TWILIO: 1600;
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_TITLE: 200;
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_TITLE_INFOBIP: 200;
  MAX_CHARACTER_LIMIT_FOR_RICH_CARD_TITLE_TWILIO: 200;
  MAX_CHARACTER_LIMIT_FOR_TEXT: 3072;
  MAX_CHARACTER_LIMIT_FOR_TEXT_INFOBIP: 3072;
  MAX_CHARACTER_LIMIT_FOR_TEXT_SUGGESTION: 25;
  MAX_CHARACTER_LIMIT_FOR_TEXT_TWILIO: 1600;
  MAX_CHARACTER_LIMIT_FOR_URL_SUGGESTION: 2048;
  MAX_NUMBER_RICH_CARD_BUTTONS: 4;
  MAX_NUMBER_SUGGESTED_ACTIONS: 5;
  MIN_NUMBER_RICH_CARD_BUTTONS: 1;
  MIN_NUMBER_SUGGESTED_ACTIONS: 0;
}
export interface SHARED_CONSTANTS_RCS {
  ACTION_TYPES: SHARED_CONSTANTS_ACTION_TYPES;
  FALLBACK_TYPES: SHARED_CONSTANTS_FALLBACK_TYPES;
  INFOBIP: SHARED_CONSTANTS_INFOBIP;
  INTERACTION_TYPES: SHARED_CONSTANTS_INTERACTION_TYPES;
  MESSAGE_TYPES: SHARED_CONSTANTS_RCS_MESSAGE_TYPES;
  RICH_CARD_ALIGNMENTS: SHARED_CONSTANTS_RICH_CARD_ALIGNMENTS;
  RICH_CARD_HEIGHTS: SHARED_CONSTANTS_RICH_CARD_HEIGHTS;
  RICH_CARD_ORIENTATIONS: SHARED_CONSTANTS_RICH_CARD_ORIENTATIONS;
  RICH_CARD_TYPES: SHARED_CONSTANTS_RICH_CARD_TYPES;
  TWILIO: SHARED_CONSTANTS_TWILIO;
  VALIDATIONS: SHARED_CONSTANTS_RCS_VALIDATIONS;
}
export interface SHARED_CONSTANTS_channel {
  company_prefix: "company-";
  developer_self_prefix: "developer-";
  global_events: "global-events";
  private_prefix: "private-";
}
export interface SHARED_CONSTANTS_event {
  arbitrary_error: "arbitrary_error";
  async_result_chunk_event_prefix: "async_result_chunk_";
  async_result_event_prefix: "async_result_";
  bad_android_gcm_key: "bad_android_gcm_key";
  blocklisting_status_updated: "blocklisting_status_updated";
  campaign_actual_audience_stats: "campaign_actual_audience_stats";
  campaign_conversion_correlation: "campaign_conversion_correlation";
  campaign_finished_sending: "campaign_finished_sending";
  campaign_started_sending: "campaign_started_sending";
  catalog_csv_generated: "catalog_csv_generated";
  catalog_item_updated: "catalog_item_updated";
  catalog_updated: "catalog_updated";
  conversational_preview_chat_turn: "conversational_preview_chat_turn";
  conversion_report: "conversion_report";
  csv_finished_exporting: "csv_finished_exporting";
  csv_finished_importing: "csv_finished_importing";
  custom_attribute_schema_generation_finished: "custom_attribute_schema_generation_finished";
  dashboard_builder: "dashboard_builder";
  duplicate_users_merge_completed: "duplicate_users_merge_completed";
  entity_stats_cancellation_update: "entity_stats_cancellation_update";
  entity_stats_concurrency_update: "entity_stats_concurrency_update";
  entity_stats_failure_update: "entity_stats_failure_update";
  entity_stats_progress_update: "entity_stats_progress_update";
  expressive_report: "expressive_report";
  force_refresh: "force_refresh";
  funnel_report: "funnel_report";
  generic_pusher_request: "generic_pusher_request";
  integration_bridge_updated: "integration_bridge_updated";
  item_upserted: "item_upserted";
  knowledge_source_sync_completed: "knowledge_source_sync_completed";
  maintenance_received: "maintenance_received";
  reload_page_on_next_request: "reload_on_next_navigation_request";
  report_builder: "report_builder";
  retention_report: "retention_v3_stats";
  sage_assistant_stream: "sage_assistant_stream";
  segment_actual_stats: "segment_actual_summary_statistics";
  segment_cohort_refreshed: "segment_cohort_refreshed";
  segment_finished_exporting: "segment_finished_exporting";
  segment_insights_actual_stats: "segment_insights_actual_summary_statistics";
  segment_stats_cancellation_update: "segment_stats_cancellation_update";
  segment_stats_concurrency_update: "segment_stats_concurrency_update";
  segment_stats_failure_update: "segment_stats_failure_update";
  segment_stats_progress_update: "segment_stats_progress_update";
  shopify_bridge_updated: "shopify_bridge_updated";
  shopify_catalog_item_errored: "shopify_catalog_item_errored";
  shopify_catalog_storage_limit_reached: "shopify_catalog_storage_limit_reached";
  shopify_item_error_csv_export_completed: "shopify_item_error_csv_export_completed";
  test_send_user_update_completed: "test_send_user_update_completed";
  users_merge_failed: "users_merge_failed";
  users_merge_succeeded: "users_merge_succeeded";
}
export interface SHARED_CONSTANTS_export_type {
  csv: "CSV file";
  facebook: "Facebook audience";
  meta_marketing: "WhatsApp audience";
}
export interface SHARED_CONSTANTS_REALTIME_NOTIFIER {
  channel: SHARED_CONSTANTS_channel;
  event: SHARED_CONSTANTS_event;
  export_type: SHARED_CONSTANTS_export_type;
}
export interface SHARED_CONSTANTS_RECOMMENDATIONS_EVENT_TYPES {
  CUSTOM_EVENT: "custom_event";
  PURCHASE: "purchase";
}
export interface SHARED_CONSTANTS_FREQUENCIES {
  DAILY: "daily";
  MONTHLY: "monthly";
  WEEKLY: "weekly";
}
export interface SHARED_CONSTANTS_RECOMMENDATIONS_MODEL_STATES {
  ACTIVE: "active";
  BUILT: "built";
  DRAFT: "draft";
  FAILED: "failed";
  PRETRAINING: "pretraining";
  RETRAINING: "retraining";
  TRAINING: "training";
  UPDATING: "updating";
}
export interface SHARED_CONSTANTS_RECOMMENDATIONS_PARAMETER_STATES {
  INIT_UPDATE: "init_update";
  TRAIN: "train";
  UPDATE: "update";
}
export interface SHARED_CONSTANTS_TRAIN_TYPES {
  MOST_POPULAR: "most_popular";
  MOST_RECENT: "most_recent";
  PERSONALIZED: "personalized";
  TRENDING: "trending";
}
export interface SHARED_CONSTANTS_RECOMMENDATIONS {
  EVENT_TYPES: SHARED_CONSTANTS_RECOMMENDATIONS_EVENT_TYPES;
  FREQUENCIES: SHARED_CONSTANTS_FREQUENCIES;
  LIQUID_TEMPLATE_COUNT: 30;
  MODEL_STATES: SHARED_CONSTANTS_RECOMMENDATIONS_MODEL_STATES;
  MODEL_TYPE: "recommendations";
  PARAMETER_STATES: SHARED_CONSTANTS_RECOMMENDATIONS_PARAMETER_STATES;
  PRODUCT_ID_LABEL: "product_id";
  PRODUCT_ID_PATH: "__product_id";
  TRAIN_TYPES: SHARED_CONSTANTS_TRAIN_TYPES;
}
export interface SHARED_CONSTANTS_ROOT_REGEXES {
  BSON_REGEX: "^[a-f0-9]{24}$";
  EMAIL_REGEX: "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$";
}
export interface SHARED_CONSTANTS_AUTOMATIC_SELECTION_SEND_TYPES {
  ANY_SEND: "any-send";
  LAST_SENT: "last-sent";
}
export interface SHARED_CONSTANTS_DECORATORS {
  CONVERSION_META: "conversionMeta";
  CONVERSION_META_B: "conversionMetaB";
  CONVERSION_META_C: "conversionMetaC";
  CONVERSION_META_D: "conversionMetaD";
  EMAIL_SUBJECT_LINE: "email.subjectLine";
  LAST_SENT_DATE: "lastSentDate";
  LTA_CONVERSION_META: "ltaConversionMeta";
}
export interface SHARED_CONSTANTS_DIMENSIONS {
  CAMPAIGN_API_ID: "campaign_api_id";
  CAMPAIGN_ID: "campaign_id";
  CAMPAIGN_NAME: "campaign_name";
  CANVAS_API_ID: "canvas_api_id";
  CANVAS_ID: "canvas_id";
  CANVAS_NAME: "canvas_name";
  CHANNEL: "channel";
  DATE: "date";
  SEGMENT_ID: "segment_id";
  SEGMENT_NAME: "segment_name";
  SEGMENT_TOKEN: "segment_token";
  STEP_ID: "step_id";
  STEP_NAME: "step_name";
  TAG: "tag";
  TYPE: "type";
  VARIANT_ID: "variant_id";
  VARIANT_NAME: "variant_name";
}
export interface SHARED_CONSTANTS_REPORT_BUILDER_ERROR_CODES {
  DATA_NOT_FOUND: "DATA_NOT_FOUND";
  MAX_TILES_REACHED: "MAX_TILES_REACHED";
  REPORT_NOT_FOUND: "REPORT_NOT_FOUND";
  REPORT_NOT_PERMITTED: "REPORT_NOT_PERMITTED";
}
export interface SHARED_CONSTANTS_KPIS {
  ALL_MOBILE_PUSH_BOUNCES: "allMobilePush.bounces";
  ALL_MOBILE_PUSH_BOUNCE_RATE: "allMobilePush.bounceRate";
  ALL_MOBILE_PUSH_DELIVERIES: "allMobilePush.deliveries";
  ALL_MOBILE_PUSH_DELIVERY_RATE: "allMobilePush.deliveryRate";
  ALL_MOBILE_PUSH_DIRECT_OPENS: "allMobilePush.directOpens";
  ALL_MOBILE_PUSH_DIRECT_OPEN_RATE: "allMobilePush.directOpenRate";
  ALL_MOBILE_PUSH_INFLUENCED_OPENS: "allMobilePush.influencedOpens";
  ALL_MOBILE_PUSH_INFLUENCED_OPEN_RATE: "allMobilePush.influencedOpenRate";
  ALL_MOBILE_PUSH_SENDS: "allMobilePush.sends";
  ALL_MOBILE_PUSH_TOTAL_OPENS: "allMobilePush.totalOpens";
  ALL_MOBILE_PUSH_TOTAL_OPEN_RATE: "allMobilePush.totalOpenRate";
  ANDROID_PUSH_BOUNCES: "androidPush.bounces";
  ANDROID_PUSH_BOUNCE_RATE: "androidPush.bounceRate";
  ANDROID_PUSH_DELIVERIES: "androidPush.deliveries";
  ANDROID_PUSH_DELIVERY_RATE: "androidPush.deliveryRate";
  ANDROID_PUSH_DIRECT_OPENS: "androidPush.directOpens";
  ANDROID_PUSH_DIRECT_OPEN_RATE: "androidPush.directOpenRate";
  ANDROID_PUSH_INFLUENCED_OPENS: "androidPush.influencedOpens";
  ANDROID_PUSH_INFLUENCED_OPEN_RATE: "androidPush.influencedOpenRate";
  ANDROID_PUSH_SENDS: "androidPush.sends";
  ANDROID_PUSH_TOTAL_OPENS: "androidPush.totalOpens";
  ANDROID_PUSH_TOTAL_OPEN_RATE: "androidPush.totalOpenRate";
  BANNER_CONTROL_IMPRESSIONS: "banner.controlImpressions";
  BANNER_TOTAL_CLICKS: "banner.totalClicks";
  BANNER_TOTAL_CLICK_RATE: "banner.totalClickRate";
  BANNER_TOTAL_DISMISSALS: "banner.totalDismissals";
  BANNER_TOTAL_DISMISSAL_RATE: "banner.totalDismissalRate";
  BANNER_TOTAL_IMPRESSIONS: "banner.totalImpressions";
  BANNER_UNIQUE_CLICKS: "banner.uniqueClicks";
  BANNER_UNIQUE_CLICK_RATE: "banner.uniqueClickRate";
  BANNER_UNIQUE_CONTROL_IMPRESSIONS: "banner.uniqueControlImpressions";
  BANNER_UNIQUE_DISMISSALS: "banner.uniqueDismissals";
  BANNER_UNIQUE_DISMISSAL_RATE: "banner.uniqueDismissalRate";
  BANNER_UNIQUE_IMPRESSIONS: "banner.uniqueImpressions";
  BANNER_UNIQUE_RECIPIENTS: "banner.uniqueRecipients";
  CONTENT_CARD_SENDS: "contentCard.sends";
  CONTENT_CARD_TOTAL_CLICKS: "contentCard.totalClicks";
  CONTENT_CARD_TOTAL_CLICK_RATE: "contentCard.totalClickRate";
  CONTENT_CARD_TOTAL_DISMISSALS: "contentCard.totalDismissals";
  CONTENT_CARD_TOTAL_DISMISSAL_RATE: "contentCard.totalDismissalRate";
  CONTENT_CARD_TOTAL_IMPRESSIONS: "contentCard.totalImpressions";
  CONTENT_CARD_UNIQUE_CLICKS: "contentCard.uniqueClicks";
  CONTENT_CARD_UNIQUE_CLICK_RATE: "contentCard.uniqueClickRate";
  CONTENT_CARD_UNIQUE_DISMISSALS: "contentCard.uniqueDismissals";
  CONTENT_CARD_UNIQUE_DISMISSAL_RATE: "contentCard.uniqueDismissalRate";
  CONTENT_CARD_UNIQUE_IMPRESSIONS: "contentCard.uniqueImpressions";
  CONTENT_CARD_UNIQUE_RECIPIENTS: "contentCard.uniqueRecipients";
  CONVERSION_CONFIDENCE: "conversionConfidence";
  CONVERSION_RATE: "conversionRate";
  CONVERSION_RATE_B: "conversionRateB";
  CONVERSION_RATE_C: "conversionRateC";
  CONVERSION_RATE_D: "conversionRateD";
  EMAIL_BOUNCES: "email.bounces";
  EMAIL_BOUNCE_RATE: "email.bounceRate";
  EMAIL_CLICK_TO_OPEN_RATE: "email.clickToOpenRate";
  EMAIL_DELIVERIES: "email.deliveries";
  EMAIL_DELIVERY_RATE: "email.deliveryRate";
  EMAIL_MACHINE_OPEN: "email.machineOpen";
  EMAIL_OTHER_OPENS: "email.otherOpens";
  EMAIL_SENDS: "email.sends";
  EMAIL_SOFT_BOUNCES: "email.softBounces";
  EMAIL_SOFT_BOUNCE_RATE: "email.softBounceRate";
  EMAIL_SPAM_REPORTS: "email.spamReports";
  EMAIL_SPAM_REPORT_RATE: "email.spamReportRate";
  EMAIL_SUBJECT_LINE: "email.subjectLine";
  EMAIL_TOTAL_CLICKS: "email.totalClicks";
  EMAIL_TOTAL_CLICK_RATE: "email.totalClickRate";
  EMAIL_TOTAL_OPENS: "email.totalOpens";
  EMAIL_TOTAL_OPEN_RATE: "email.totalOpenRate";
  EMAIL_UNIQUE_CLICKS: "email.uniqueClicks";
  EMAIL_UNIQUE_CLICK_RATE: "email.uniqueClickRate";
  EMAIL_UNIQUE_OPENS: "email.uniqueOpens";
  EMAIL_UNIQUE_OPEN_RATE: "email.uniqueOpenRate";
  EMAIL_UNSUBSCRIBES: "email.unsubscribes";
  EMAIL_UNSUBSCRIBE_RATE: "email.unsubscribeRate";
  ENTRIES: "entries";
  FEATURE_FLAG_EXPERIMENT_CONTROL_IMPRESSIONS: "featureFlagExperiment.controlImpressions";
  FEATURE_FLAG_EXPERIMENT_TOTAL_IMPRESSIONS: "featureFlagExperiment.totalImpressions";
  FEATURE_FLAG_EXPERIMENT_UNIQUE_CONTROL_IMPRESSIONS: "featureFlagExperiment.uniqueControlImpressions";
  FEATURE_FLAG_EXPERIMENT_UNIQUE_IMPRESSIONS: "featureFlagExperiment.uniqueImpressions";
  IOS_PUSH_BOUNCES: "iosPush.bounces";
  IOS_PUSH_BOUNCE_RATE: "iosPush.bounceRate";
  IOS_PUSH_DELIVERIES: "iosPush.deliveries";
  IOS_PUSH_DELIVERY_RATE: "iosPush.deliveryRate";
  IOS_PUSH_DIRECT_OPENS: "iosPush.directOpens";
  IOS_PUSH_DIRECT_OPEN_RATE: "iosPush.directOpenRate";
  IOS_PUSH_INFLUENCED_OPENS: "iosPush.influencedOpens";
  IOS_PUSH_INFLUENCED_OPEN_RATE: "iosPush.influencedOpenRate";
  IOS_PUSH_SENDS: "iosPush.sends";
  IOS_PUSH_TOTAL_OPENS: "iosPush.totalOpens";
  IOS_PUSH_TOTAL_OPEN_RATE: "iosPush.totalOpenRate";
  KINDLE_PUSH_BOUNCES: "kindlePush.bounces";
  KINDLE_PUSH_BOUNCE_RATE: "kindlePush.bounceRate";
  KINDLE_PUSH_DELIVERIES: "kindlePush.deliveries";
  KINDLE_PUSH_DELIVERY_RATE: "kindlePush.deliveryRate";
  KINDLE_PUSH_DIRECT_OPENS: "kindlePush.directOpens";
  KINDLE_PUSH_DIRECT_OPEN_RATE: "kindlePush.directOpenRate";
  KINDLE_PUSH_INFLUENCED_OPENS: "kindlePush.influencedOpens";
  KINDLE_PUSH_INFLUENCED_OPEN_RATE: "kindlePush.influencedOpenRate";
  KINDLE_PUSH_SENDS: "kindlePush.sends";
  KINDLE_PUSH_TOTAL_OPENS: "kindlePush.totalOpens";
  KINDLE_PUSH_TOTAL_OPEN_RATE: "kindlePush.totalOpenRate";
  LTA_CONVERSIONS: "ltaConversions";
  LTA_PURCHASES: "ltaPurchases";
  LTA_REVENUE: "ltaRevenue";
  PERCENT_CHANGE_FROM_CONTROL: "percentChangeFromControl";
  RCS_BUTTON_REPLY_CLICKS: "rcs.buttonReplyClicks";
  RCS_BUTTON_URL_CLICKS: "rcs.buttonUrlClicks";
  RCS_DELIVERIES: "rcs.deliveries";
  RCS_DELIVERY_RATE: "rcs.deliveryRate";
  RCS_FALLBACK_SMS_DELIVERIES: "rcs.fallbackSmsDeliveries";
  RCS_FALLBACK_SMS_REJECTIONS: "rcs.fallbackSmsRejections";
  RCS_READS: "rcs.reads";
  RCS_READ_RATE: "rcs.readRate";
  RCS_REJECTIONS: "rcs.rejections";
  RCS_REJECTION_RATE: "rcs.rejectionRate";
  RCS_SENDS: "rcs.sends";
  RCS_SUGGESTED_REPLY_CLICKS: "rcs.suggestedReplyClicks";
  RCS_SUGGESTED_URL_CLICKS: "rcs.suggestedUrlClicks";
  RCS_TOTAL_CLICKS: "rcs.totalClicks";
  RCS_TOTAL_CLICK_RATE: "rcs.totalClickRate";
  SEGMENT_PURCHASE_COUNT: "segmentPurchase.count";
  SEGMENT_PURCHASE_REVENUE_CENTS: "segmentPurchase.revenueCents";
  SMS_CONFIRMED_DELIVERIES: "sms.confirmedDeliveries";
  SMS_CONFIRMED_DELIVERY_RATE: "sms.confirmedDeliveryRate";
  SMS_FAILED_DELIVERIES: "sms.failedDeliveries";
  SMS_FAILED_DELIVERY_RATE: "sms.failedDeliveryRate";
  SMS_OPT_IN: "sms.optIn";
  SMS_OPT_IN_RATE: "sms.optInRate";
  SMS_OPT_OUT: "sms.optOut";
  SMS_OPT_OUT_RATE: "sms.optOutRate";
  SMS_REJECTIONS: "sms.rejections";
  SMS_REJECTION_RATE: "sms.rejectionRate";
  SMS_SENDS: "sms.sends";
  SMS_SENDS_TO_CARRIER: "sms.sendsToCarrier";
  SMS_SENDS_TO_CARRIER_RATE: "sms.sendsToCarrierRate";
  SMS_TOTAL_CLICKS: "sms.totalClicks";
  SMS_TOTAL_CLICK_RATE: "sms.totalClickRate";
  SUBJECT_LINE: "subjectLine";
  TOTAL_CONVERSIONS: "totalConversions";
  TOTAL_CONVERSIONS_B: "totalConversionsB";
  TOTAL_CONVERSIONS_C: "totalConversionsC";
  TOTAL_CONVERSIONS_D: "totalConversionsD";
  TOTAL_DEPRIORITIZED_MESSAGES: "totalDeprioritizedMessages";
  TOTAL_DEPRIORITIZED_RATE: "totalDeprioritizedRate";
  TOTAL_RETRIED_MESSAGES: "totalRetriedMessages";
  TOTAL_RETRIED_RATE: "totalRetriedRate";
  TOTAL_REVENUE: "totalRevenue";
  TOTAL_SENDS: "totalSends";
  TRIGGER_BODY_CLICKS: "trigger.bodyClicks";
  TRIGGER_BODY_CLICK_RATE: "trigger.bodyClickRate";
  TRIGGER_CUSTOM_BUTTON_CLICKS: "trigger.customButtonClicks";
  TRIGGER_FIRST_BUTTON_CLICKS: "trigger.firstButtonClicks";
  TRIGGER_FIRST_BUTTON_CLICK_RATE: "trigger.firstButtonClickRate";
  TRIGGER_SECOND_BUTTON_CLICKS: "trigger.secondButtonClicks";
  TRIGGER_SECOND_BUTTON_CLICK_RATE: "trigger.secondButtonClickRate";
  TRIGGER_TOTAL_IMPRESSIONS: "trigger.totalImpressions";
  TRIGGER_UNIQUE_IMPRESSIONS: "trigger.uniqueImpressions";
  UNIQUE_RECIPIENTS: "uniqueRecipients";
  WEBHOOK_ERRORS: "webhook.errors";
  WEBHOOK_ERROR_RATE: "webhook.errorRate";
  WEBHOOK_SENDS: "webhook.sends";
  WEB_PUSH_BOUNCES: "webPush.bounces";
  WEB_PUSH_BOUNCE_RATE: "webPush.bounceRate";
  WEB_PUSH_DELIVERIES: "webPush.deliveries";
  WEB_PUSH_DELIVERY_RATE: "webPush.deliveryRate";
  WEB_PUSH_SENDS: "webPush.sends";
  WEB_PUSH_TOTAL_OPENS: "webPush.totalOpens";
  WEB_PUSH_TOTAL_OPEN_RATE: "webPush.totalOpenRate";
  WHATS_APP_DELIVERIES: "whatsApp.deliveries";
  WHATS_APP_DELIVERY_RATE: "whatsApp.deliveryRate";
  WHATS_APP_FAILURES: "whatsApp.failures";
  WHATS_APP_FAILURE_RATE: "whatsApp.failureRate";
  WHATS_APP_READS: "whatsApp.reads";
  WHATS_APP_READ_RATE: "whatsApp.readRate";
  WHATS_APP_SENDS: "whatsApp.sends";
  WHATS_APP_TOTAL_CLICKS: "whatsApp.totalClicks";
  WHATS_APP_TOTAL_CLICK_RATE: "whatsApp.totalClickRate";
}
export interface SHARED_CONSTANTS_REPORT_BUILDER {
  AUTOMATIC_SELECTION_SEND_TYPES: SHARED_CONSTANTS_AUTOMATIC_SELECTION_SEND_TYPES;
  DECORATORS: SHARED_CONSTANTS_DECORATORS;
  DIMENSIONS: SHARED_CONSTANTS_DIMENSIONS;
  ERROR_CODES: SHARED_CONSTANTS_REPORT_BUILDER_ERROR_CODES;
  KPIS: SHARED_CONSTANTS_KPIS;
  REPORT_BUILDER_CENTS_VALUES: "segmentPurchase.revenueCents"[];
  REPORT_BUILDER_DOLLAR_VALUES: ("ltaRevenue" | "revenue" | "totalRevenue")[];
  REPORT_BUILDER_PERCENTAGE_VALUES: ("allMobilePush.bounceRate" | "allMobilePush.deliveryRate" | "allMobilePush.directOpenRate" | "allMobilePush.influencedOpenRate" | "allMobilePush.totalOpenRate" | "androidPush.bounceRate" | "androidPush.deliveryRate" | "androidPush.directOpenRate" | "androidPush.influencedOpenRate" | "androidPush.totalOpenRate" | "banner.totalClickRate" | "banner.totalDismissalRate" | "banner.uniqueClickRate" | "banner.uniqueDismissalRate" | "body_click_percentage" | "bounce_percentage" | "click_percentage" | "click_to_open_rate" | "clicked_shortened_sms_link_percentage" | "confirmed_delivery_percentage" | "contentCard.totalClickRate" | "contentCard.totalDismissalRate" | "contentCard.uniqueClickRate" | "contentCard.uniqueDismissalRate" | "conversionConfidence" | "conversionRate" | "conversionRateB" | "conversionRateC" | "conversionRateD" | "conversion_b_by_entry_time_percentage" | "conversion_b_by_send_time_percentage" | "conversion_b_percentage" | "conversion_c_by_entry_time_percentage" | "conversion_c_by_send_time_percentage" | "conversion_c_percentage" | "conversion_d_by_entry_time_percentage" | "conversion_d_by_send_time_percentage" | "conversion_d_percentage" | "delivery_failed_percentage" | "delivery_percentage" | "direct_open_percentage" | "email.bounceRate" | "email.clickToOpenRate" | "email.deliveryRate" | "email.softBounceRate" | "email.spamReportRate" | "email.totalClickRate" | "email.totalOpenRate" | "email.uniqueClickRate" | "email.uniqueOpenRate" | "email.unsubscribeRate" | "failed_percentage" | "first_button_click_percentage" | "impressions_percentage" | "influenced_open_percentage" | "iosPush.bounceRate" | "iosPush.deliveryRate" | "iosPush.directOpenRate" | "iosPush.influencedOpenRate" | "iosPush.totalOpenRate" | "kindlePush.bounceRate" | "kindlePush.deliveryRate" | "kindlePush.directOpenRate" | "kindlePush.influencedOpenRate" | "kindlePush.totalOpenRate" | "open_percentage" | "opt_in_percentage" | "opt_out_percentage" | "percentChangeFromControl" | "primary_conversion_a_by_entry_time_percentage" | "primary_conversion_a_by_send_time_percentage" | "primary_conversion_a_percentage" | "rcs.deliveryRate" | "rcs.readRate" | "rcs.rejectionRate" | "rcs.totalClickRate" | "read_percentage" | "rejected_percentage" | "reported_spam_percentage" | "second_button_click_percentage" | "sends_to_carrier_percentage" | "sms.confirmedDeliveryRate" | "sms.failedDeliveryRate" | "sms.optInRate" | "sms.optOutRate" | "sms.rejectionRate" | "sms.sendsToCarrierRate" | "sms.totalClickRate" | "totalDeprioritizedRate" | "totalRetriedRate" | "total_click_percentage" | "total_dismissal_percentage" | "total_open_percentage" | "trigger.bodyClickRate" | "trigger.firstButtonClickRate" | "trigger.secondButtonClickRate" | "unique_click_percentage" | "unique_dismissal_percentage" | "unique_open_percentage" | "unsubscribe_percentage" | "webPush.bounceRate" | "webPush.deliveryRate" | "webPush.totalOpenRate" | "webhook.errorRate" | "whatsApp.deliveryRate" | "whatsApp.failureRate" | "whatsApp.readRate" | "whatsApp.totalClickRate")[];
  REPORT_BUILDER_SUPPORTED_SEGMENT_METRICS: ("allMobilePush.bounces" | "allMobilePush.directOpens" | "allMobilePush.influencedOpens" | "allMobilePush.sends" | "androidPush.bounceRate" | "androidPush.bounces" | "androidPush.directOpenRate" | "androidPush.directOpens" | "androidPush.influencedOpenRate" | "androidPush.influencedOpens" | "androidPush.sends" | "androidPush.totalOpenRate" | "androidPush.totalOpens" | "banner.totalClicks" | "banner.totalDismissals" | "banner.totalImpressions" | "contentCard.sends" | "contentCard.totalClicks" | "contentCard.totalDismissals" | "contentCard.totalImpressions" | "email.bounceRate" | "email.bounces" | "email.deliveries" | "email.machineOpen" | "email.sends" | "email.softBounceRate" | "email.softBounces" | "email.spamReports" | "email.totalClicks" | "email.totalOpens" | "email.uniqueClicks" | "email.uniqueOpens" | "email.unsubscribes" | "iosPush.bounceRate" | "iosPush.bounces" | "iosPush.directOpenRate" | "iosPush.directOpens" | "iosPush.influencedOpenRate" | "iosPush.influencedOpens" | "iosPush.sends" | "iosPush.totalOpenRate" | "iosPush.totalOpens" | "kindlePush.bounceRate" | "kindlePush.bounces" | "kindlePush.directOpenRate" | "kindlePush.directOpens" | "kindlePush.influencedOpenRate" | "kindlePush.influencedOpens" | "kindlePush.sends" | "kindlePush.totalOpenRate" | "kindlePush.totalOpens" | "rcs.buttonReplyClicks" | "rcs.buttonUrlClicks" | "rcs.deliveries" | "rcs.fallbackSmsDeliveries" | "rcs.fallbackSmsRejections" | "rcs.readRate" | "rcs.reads" | "rcs.rejections" | "rcs.sends" | "rcs.suggestedReplyClicks" | "rcs.suggestedUrlClicks" | "rcs.totalClickRate" | "rcs.totalClicks" | "sms.confirmedDeliveries" | "sms.failedDeliveries" | "sms.sends" | "trigger.bodyClicks" | "trigger.totalImpressions" | "webPush.bounceRate" | "webPush.bounces" | "webPush.sends" | "webPush.totalOpenRate" | "webPush.totalOpens" | "webhook.errorRate" | "webhook.errors" | "webhook.sends" | "whatsApp.deliveries" | "whatsApp.failures" | "whatsApp.reads" | "whatsApp.sends")[];
}
export interface SHARED_CONSTANTS_SCHEDULE_HELPER {
  DAILY_VALUE: "Daily";
  END_CONDITION_AFTER: "after";
  END_CONDITION_NEVER: "never";
  END_CONDITION_ON: "on";
  HOURLY_VALUE: "Hourly";
  MONTHLY_VALUE: "Monthly";
  NONE: "None";
  ONCE_VALUE: "Once";
  WEEKLY_VALUE: "Weekly";
}
export interface SHARED_CONSTANTS_CHANGELOG_FIELD_NAMES {
  added_public_key: "added-public-key";
  changed_status: "changed-status";
  deleted_public_key: "deleted-public-key";
  set_primary_key: "set-primary-key";
}
export interface SHARED_CONSTANTS_FEATURE_STATES {
  disabled: 0;
  optional: 2;
  required: 1;
}
export interface SHARED_CONSTANTS_MANAGEMENT_ERRORS {
  duplicate_rsa_key: 2;
  exceeded_max_number_of_keys: 5;
  invalid_rsa_key: 1;
  invalid_status: 4;
  primary_key_deleted: 3;
  status_needs_key: 0;
}
export interface SHARED_CONSTANTS_VERIFICATION_ERRORS {
  decoding_error: 20;
  expiration_required: 10;
  incorrect_algorithm: 24;
  invalid_payload: 23;
  missing_token: 26;
  no_matching_public_keys: 27;
  payload_user_id_mismatch: 28;
  public_key_error: 25;
  result_expired: 22;
  subject_mismatch: 21;
}
export interface SHARED_CONSTANTS_SDK_AUTHENTICATION {
  CHANGELOG_FIELD_NAMES: SHARED_CONSTANTS_CHANGELOG_FIELD_NAMES;
  FEATURE_STATES: SHARED_CONSTANTS_FEATURE_STATES;
  MANAGEMENT_ERRORS: SHARED_CONSTANTS_MANAGEMENT_ERRORS;
  MAX_NUMBER_OF_PUBLIC_KEYS: 3;
  VERIFICATION_ERRORS: SHARED_CONSTANTS_VERIFICATION_ERRORS;
}
export interface SHARED_CONSTANTS_SDK_ENDPOINTS {
  V3_DATA: 1000;
}
export interface SHARED_CONSTANTS_SDK_MESSAGE_PROPERTIES_TYPES {
  BOOLEAN: "boolean";
  DATETIME: "datetime";
  IMAGE: "image";
  JSON: "jsonobject";
  NUMBER: "number";
  STRING: "string";
}
export interface SHARED_CONSTANTS_SDK_MESSAGE_PROPERTIES_VALIDATION_ERRORS {
  PROPERTIES_KEY_BLANK: "properties_key_blank";
  PROPERTIES_MISSING: "properties_missing";
  PROPERTIES_NOT_JSON: "properties_not_json";
  PROPERTIES_STRUCTURE_INVALID: "properties_structure_invalid";
  PROPERTIES_TOO_LONG: "properties_too_long";
  PROPERTIES_TYPE_MISSING: "properties_type_missing";
  PROPERTIES_TYPE_UNKNOWN: "properties_type_unknown";
  PROPERTIES_VALUE_NOT_COERCIBLE: "properties_value_not_coercible";
}
export interface SHARED_CONSTANTS_SDK_MESSAGE_PROPERTIES {
  MAX_PRE_TEMPLATED_PROPERTIES_LENGTH: 10000;
  TYPES: SHARED_CONSTANTS_SDK_MESSAGE_PROPERTIES_TYPES;
  VALIDATION_ERRORS: SHARED_CONSTANTS_SDK_MESSAGE_PROPERTIES_VALIDATION_ERRORS;
}
export interface SHARED_CONSTANTS_EXPORT_ERRORS {
  EXPORTED_EMPTY_LOGS: "EXPORTED_EMPTY_LOGS";
  EXPORT_FAILED: "EXPORT_FAILED";
  LOGS_EXPIRED: "LOGS_EXPIRED";
  LOGS_UNAVAILABLE: "LOGS_UNAVAILABLE";
  RESOURCE_NOT_FOUND: "RESOURCE_NOT_FOUND";
}
export interface SHARED_CONSTANTS_SDK_RECORDING_MANAGEMENT_SEARCH_KEYS {
  END_DATE: "end_date";
  START_DATE: "start_date";
}
export interface SHARED_CONSTANTS_SDK_RECORDING_MANAGEMENT {
  SEARCH_KEYS: SHARED_CONSTANTS_SDK_RECORDING_MANAGEMENT_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_SDK_RECORDING_STATUSES {
  ACTIVE: "active";
  EXPIRED: "expired";
  EXPORTED_EMPTY_LOGS: "exported_empty_logs";
  EXPORT_FAILED: "export_failed";
  FILE_AVAILABLE: "file_available";
  STOPPED: "stopped";
}
export interface SHARED_CONSTANTS_SDK_RECORDING_VALIDATION_ERRORS {
  DEVICE_LIMIT_EXCEEDED: "device_limit_exceeded";
  INVALID_STATUS: "invalid_status";
  INVALID_USER_ID: "invalid_user_id";
  USER_LIMIT_EXCEEDED: "user_limit_exceeded";
}
export interface SHARED_CONSTANTS_SDK_RECORDING {
  EXPORT_ERRORS: SHARED_CONSTANTS_EXPORT_ERRORS;
  MANAGEMENT: SHARED_CONSTANTS_SDK_RECORDING_MANAGEMENT;
  STATUSES: SHARED_CONSTANTS_SDK_RECORDING_STATUSES;
  VALIDATION_ERRORS: SHARED_CONSTANTS_SDK_RECORDING_VALIDATION_ERRORS;
}
export interface SHARED_CONSTANTS_AUTOMATIC_GATEWAY_DATA {
  ios: "10.0.0";
}
export interface SHARED_CONSTANTS_BANNER_DISMISS_BUTTON_SUPPORT_DATA {
  android: "42.1.0";
  ios: "14.1.0";
  kepler: null;
  kindle: "42.1.0";
  roku: null;
  tvos: null;
  web: "6.7.1";
}
export interface SHARED_CONSTANTS_BANNER_SUPPORT_DATA {
  android: "33.1.0";
  ios: "11.3.0";
  kepler: null;
  kindle: "33.1.0";
  roku: null;
  tvos: null;
  web: "5.6.0";
}
export interface SHARED_CONSTANTS_v1 {
  android: "21.0.0";
  android_china: null;
  ios: "5.4.0";
  kepler: "0.1.0";
  kindle: "21.0.0";
  roku: null;
  web: "4.0.3";
  windows8: null;
}
export interface SHARED_CONSTANTS_BRAZE_ACTION_DEEPLINK_PARAM_SUPPORT_DATA {
  v1: SHARED_CONSTANTS_v1;
}
export interface SHARED_CONSTANTS_Banner {
  android: "1.2";
  android_china: "0";
  ios: "2.2";
  kindle: "0";
  roku: null;
  tvos: null;
  web: "0";
  windows8: "0";
}
export interface SHARED_CONSTANTS_CaptionedImage {
  android: "1.2";
  android_china: "0";
  ios: "2.2";
  kindle: "0";
  roku: null;
  tvos: null;
  web: "0";
  windows8: "0";
}
export interface SHARED_CONSTANTS_NewsItem {
  android: "0";
  android_china: "0";
  ios: "0";
  kindle: "0";
  roku: null;
  tvos: null;
  web: "0";
  windows8: "0";
}
export interface SHARED_CONSTANTS_NonStandardAspectRatio {
  android: "1.5.0";
  android_china: "1.5.0";
  ios: "2.8.1";
  kindle: "1.5.0";
  roku: null;
  tvos: null;
  web: "0";
  windows8: null;
}
export interface SHARED_CONSTANTS_CARD_SUPPORT_DATA {
  Banner: SHARED_CONSTANTS_Banner;
  CaptionedImage: SHARED_CONSTANTS_CaptionedImage;
  NewsItem: SHARED_CONSTANTS_NewsItem;
  NonStandardAspectRatio: SHARED_CONSTANTS_NonStandardAspectRatio;
}
export interface SHARED_CONSTANTS_FEATURE_FLAGS_NIL_RESPONSE_DATA {
  android: "24.2.0";
  ios: "10.0.0";
  web: "4.6.0";
}
export interface SHARED_CONSTANTS_IN_APP_CLICK_BEHAVIOR_DATA_android {
  IAM_OPEN_LINKS_WITHOUT_CLOSING_MESSAGE: "26.0.0";
  PUSH_PRIMER_SDK_SUPPORT: "26.0.0";
}
export interface SHARED_CONSTANTS_android_china {
  IAM_OPEN_LINKS_WITHOUT_CLOSING_MESSAGE: "26.0.0";
  PUSH_PRIMER_SDK_SUPPORT: "26.0.0";
}
export interface SHARED_CONSTANTS_ios {
  IAM_OPEN_LINKS_WITHOUT_CLOSING_MESSAGE: "6.2.0";
  PUSH_PRIMER_SDK_SUPPORT: "6.5.0";
}
export interface SHARED_CONSTANTS_web {
  CLICK_BEHAVIOR: "1.4.0";
  PUSH_PRIMER_SDK_SUPPORT: "4.8.1";
}
export interface SHARED_CONSTANTS_IN_APP_CLICK_BEHAVIOR_DATA {
  android: SHARED_CONSTANTS_IN_APP_CLICK_BEHAVIOR_DATA_android;
  android_china: SHARED_CONSTANTS_android_china;
  ios: SHARED_CONSTANTS_ios;
  web: SHARED_CONSTANTS_web;
}
export interface SHARED_CONSTANTS_FULL {
  android: "1.7";
  android_china: "1.7";
  ios: "2.11";
  kepler: null;
  kindle: "1.7";
  roku: null;
  tvos: null;
  web: "0";
  windows8: null;
}
export interface SHARED_CONSTANTS_HTML {
  android: "8.0.0";
  android_china: null;
  ios: "3.23.0";
  kepler: null;
  kindle: "25.0.0";
  roku: null;
  web: "2.5.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_HTML_FULL {
  android: "1.9";
  android_china: "1.9";
  ios: "2.16";
  kepler: null;
  kindle: "1.9";
  roku: null;
  tvos: null;
  web: null;
  windows8: null;
}
export interface SHARED_CONSTANTS_MODAL {
  android: "1.7";
  android_china: "1.7";
  ios: "2.11";
  kepler: null;
  kindle: "1.7";
  roku: null;
  tvos: null;
  web: "0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V1_SUPPORT_DATA_SLIDEUP {
  android: "1.7";
  android_china: "1.7";
  ios: "2.11";
  kepler: null;
  kindle: "1.7";
  roku: null;
  tvos: null;
  web: "0";
  windows8: null;
}
export interface SHARED_CONSTANTS_WEB_HTML {
  android: null;
  android_china: null;
  ios: null;
  kepler: null;
  kindle: null;
  roku: null;
  web: "1.6.7";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V1_SUPPORT_DATA {
  FULL: SHARED_CONSTANTS_FULL;
  HTML: SHARED_CONSTANTS_HTML;
  HTML_FULL: SHARED_CONSTANTS_HTML_FULL;
  MODAL: SHARED_CONSTANTS_MODAL;
  SLIDEUP: SHARED_CONSTANTS_IN_APP_V1_SUPPORT_DATA_SLIDEUP;
  WEB_HTML: SHARED_CONSTANTS_WEB_HTML;
}
export interface SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_FULL {
  android: "1.15";
  android_china: "1.15";
  ios: "2.23";
  kepler: null;
  kindle: "1.15";
  roku: null;
  web: "1.5";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_HTML {
  android: "8.0.0";
  android_china: null;
  ios: "3.23.0";
  kepler: null;
  kindle: "25.0.0";
  roku: null;
  web: "2.5.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_HTML_FULL {
  android: "1.9";
  android_china: "1.9";
  ios: "2.16";
  kepler: null;
  kindle: "1.9";
  roku: null;
  web: null;
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_MODAL {
  android: "1.15";
  android_china: "1.15";
  ios: "2.23";
  kepler: null;
  kindle: "1.15";
  roku: null;
  web: "1.5";
  windows8: null;
}
export interface SHARED_CONSTANTS_MODAL_STYLED {
  android: null;
  android_china: null;
  ios: null;
  kepler: null;
  kindle: null;
  roku: null;
  web: "2.2.4";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_SLIDEUP {
  android: "1.7";
  android_china: "1.7";
  ios: "2.11";
  kepler: null;
  kindle: "1.7";
  roku: null;
  web: "0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_WEB_HTML {
  android: null;
  android_china: null;
  ios: null;
  kepler: null;
  kindle: null;
  roku: null;
  web: "1.6.7";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA {
  FULL: SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_FULL;
  HTML: SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_HTML;
  HTML_FULL: SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_HTML_FULL;
  MODAL: SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_MODAL;
  MODAL_STYLED: SHARED_CONSTANTS_MODAL_STYLED;
  SLIDEUP: SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_SLIDEUP;
  WEB_HTML: SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA_WEB_HTML;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_FULL {
  android: "3.2.0";
  android_china: "3.2.0";
  ios: "3.14.0";
  kepler: "0.1.0";
  kindle: "3.2.0";
  roku: null;
  web: "2.3.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_HTML {
  android: "8.0.0";
  android_china: null;
  ios: "3.23.0";
  kepler: "0.1.0";
  kindle: "25.0.0";
  roku: null;
  web: "2.5.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_HTML_FULL {
  android: "3.2.0";
  android_china: "3.2.0";
  ios: "3.14.0";
  kepler: null;
  kindle: "3.2.0";
  roku: null;
  web: null;
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_MODAL {
  android: "3.2.0";
  android_china: "3.2.0";
  ios: "3.14.0";
  kepler: "0.1.0";
  kindle: "3.2.0";
  roku: "0.1.0";
  web: "2.3.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_MODAL_STYLED {
  android: null;
  android_china: null;
  ios: null;
  kepler: null;
  kindle: null;
  roku: null;
  web: "2.3.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_SLIDEUP {
  android: "3.2.0";
  android_china: "3.2.0";
  ios: "3.14.0";
  kepler: "0.1.0";
  kindle: "3.2.0";
  roku: null;
  web: "2.3.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_WEB_HTML {
  android: null;
  android_china: null;
  ios: null;
  kepler: null;
  kindle: null;
  roku: null;
  web: "2.3.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA {
  FULL: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_FULL;
  HTML: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_HTML;
  HTML_FULL: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_HTML_FULL;
  MODAL: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_MODAL;
  MODAL_STYLED: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_MODAL_STYLED;
  SLIDEUP: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_SLIDEUP;
  WEB_HTML: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA_WEB_HTML;
}
export interface SHARED_CONSTANTS_JIT_SUPPORT_DATA {
  android: "23.0.0";
  android_china: "0";
  ios: "4.5.0";
  kepler: null;
  kindle: "0";
  roku: null;
  tvos: null;
  web: "4.2.0";
  windows8: null;
}
export interface SHARED_CONSTANTS_PUSH_DATA_android {
  BUTTONS: "1.19.0";
  EXPANDED_VIEW_WILL_HIDE_MESSAGE: "1.7.0";
  ICON_IMAGE: "1.13.3";
  INLINE_IMAGE_PUSH: "10.0.0";
  MESSAGE_WILL_NOT_APPEAR_WITH_IMAGE: "1.8.2";
  PUSH_MAX: "29.0.1";
  PUSH_STORY: "2.2.0";
  SOUND: "1.5.4";
  SUMMARY_TEXT: "1.5.4";
  WEB_VIEW: "2.0.0";
}
export interface SHARED_CONSTANTS_PUSH_DATA_ios {
  PUSH_STORY: "3.2.0";
  PUSH_STORY_IN_APS: "3.13.0";
  WEB_VIEW: "2.29.0";
}
export interface SHARED_CONSTANTS_kindle {
  WEB_VIEW: "2.0.0";
}
export interface SHARED_CONSTANTS_PUSH_DATA_web {
  BUTTONS: "1.6.12";
  LARGE_NOTIFICATION_IMAGE: "1.6.7";
  MESSAGE_CLOSE: "1.6.13";
}
export interface SHARED_CONSTANTS_PUSH_DATA {
  android: SHARED_CONSTANTS_PUSH_DATA_android;
  ios: SHARED_CONSTANTS_PUSH_DATA_ios;
  kindle: SHARED_CONSTANTS_kindle;
  web: SHARED_CONSTANTS_PUSH_DATA_web;
}
export interface SHARED_CONSTANTS_SDK_SUPPORT_VERIFIER {
  AUTOMATIC_GATEWAY_DATA: SHARED_CONSTANTS_AUTOMATIC_GATEWAY_DATA;
  BANNER_DISMISS_BUTTON_SUPPORT_DATA: SHARED_CONSTANTS_BANNER_DISMISS_BUTTON_SUPPORT_DATA;
  BANNER_SUPPORT_DATA: SHARED_CONSTANTS_BANNER_SUPPORT_DATA;
  BRAZE_ACTION_DEEPLINK_PARAM_SUPPORT_DATA: SHARED_CONSTANTS_BRAZE_ACTION_DEEPLINK_PARAM_SUPPORT_DATA;
  CARD_SUPPORT_DATA: SHARED_CONSTANTS_CARD_SUPPORT_DATA;
  FEATURE_FLAGS_NIL_RESPONSE_DATA: SHARED_CONSTANTS_FEATURE_FLAGS_NIL_RESPONSE_DATA;
  IN_APP_CLICK_BEHAVIOR_DATA: SHARED_CONSTANTS_IN_APP_CLICK_BEHAVIOR_DATA;
  IN_APP_V1_SUPPORT_DATA: SHARED_CONSTANTS_IN_APP_V1_SUPPORT_DATA;
  IN_APP_V2_SUPPORT_DATA: SHARED_CONSTANTS_IN_APP_V2_SUPPORT_DATA;
  IN_APP_V3_SUPPORT_DATA: SHARED_CONSTANTS_IN_APP_V3_SUPPORT_DATA;
  JIT_SUPPORT_DATA: SHARED_CONSTANTS_JIT_SUPPORT_DATA;
  PUSH_DATA: SHARED_CONSTANTS_PUSH_DATA;
}
export interface SHARED_CONSTANTS_COMPARABLE_ATTRIBUTE_TYPES {
  PURCHASES: "purchases";
  USAGE: "usage";
}
export interface SHARED_CONSTANTS_CSV_EXPORT {
  DISALLOW_EMAIL_EXPORT_AFTER_USERS: 1000000;
  DISALLOW_FULL_EXPORT_AFTER_USERS: 500000;
}
export interface SHARED_CONSTANTS_SEGMENTER_CUSTOM_GROUPINGS {
  ANALYTICS_TRACKING: "enable_analytics_tracking?";
  CREATED_BY: "created_by";
  LAST_UPDATED_BY: "last_updated_by";
}
export interface SHARED_CONSTANTS_DATE_FORMATS {
  MONTH_DAY: "MM-DD";
  YEAR_MONTH_DAY: "YYYY-MM-DD";
}
export interface SHARED_CONSTANTS_DEPENDENCY_RELEVANCY {
  ACTIVE: "Active";
  INACTIVE: "Inactive";
  RECENTLY_SENT: "Inactive but Recently Sent";
}
export interface SHARED_CONSTANTS_SEGMENTER_ERROR_CODES {
  ACTIVE_TRACKED_SEGMENTS_AT_LIMIT: "ACTIVE_TRACKED_SEGMENTS_AT_LIMIT";
  COMPLEXITY_ENABLE_ERROR: "complexity_enable_error";
  COMPLEXITY_UNARCHIVE_ERROR: "complexity_unarchive_error";
  ENABLED_SUPPRESSION_LISTS_AT_LIMIT: "enabled_suppression_lists_at_limit";
  ENABLED_SUPPRESSION_LISTS_FILTERS_REQUIRED: "enabled_suppression_lists_filters_required";
  SUPPRESSION_LIST_ARCHIVE_ERROR: "suppression_list_archive_error";
  SUPPRESSION_LIST_ENABLE_ERROR: "suppression_list_enable_error";
}
export interface SHARED_CONSTANTS_FACEBOOK_EXPORT_DATA_TYPES {
  EMAIL: "email";
  IDFA: "mobile_id";
  PHONE: "phone";
}
export interface SHARED_CONSTANTS_SEGMENTER_SEARCH_KEYS {
  API_ID: "api_id";
  CREATED: "created";
  CREATED_BY_ME: "created_by_me";
  EDITED: "edited";
  EDITED_BY: "edited_by";
  TAG: "tag";
  TERRITORY: "team";
}
export interface SHARED_CONSTANTS_SEGMENT_EDIT_ERRORS {
  PERMISSION: "permission_error";
}
export interface SHARED_CONSTANTS_VALID_FILTER_VALUES {
  ANY: "any";
  BOOLEAN: "boolean";
  CUSTOM: "custom_defined_valid_values";
  DATE: "date";
  LOCATION: "location";
  LOOK_BACK_OVERRIDE: "look_back_restricted_days";
  MULTI_RICH_OBJECT_WITH_BOUND: "multirichobjectwithbound";
  NESTED_CUSTOM_ATTRIBUTES: "nested_custom_attributes";
  NESTED_OBJECT: "nested_object";
  RICH_OBJECT: "richobject";
  RICH_OBJECT_WITH_BOUND: "richobjectwithbound";
  TIME: "time";
  X_EVENT_PROPERTY_IN_Y_DAYS: "x_property_in_y";
  X_IN_Y_DAYS: "x_in_y";
  X_IN_Y_DAYS_UNRESTRICTED: "x_in_y_unrestricted";
  X_PURCHASE_PROPERTY_IN_Y_DAYS: "x_purchase_property_in_y";
}
export interface SHARED_CONSTANTS_filterKeys {
  age: "age_filter";
  andFilter: "and_filter";
  anniversaries: "anniversary_filter";
  anyLinkClickedFilter: "any_link_clicked_filter";
  appVersion: "app_version_filter";
  appVersionByApp: "app_version_by_app_filter";
  appVersionCodeByApp: "app_version_code_by_app_filter";
  averageOrderValueCalculatedAttributeFilter: "average_order_value_calculated_attribute_filter";
  birthdayFilter: "birthday_filter";
  calculatedFilterFilter: "calculated_filter_filter";
  campaignLinkClickedFilter: "campaign_link_clicked_filter";
  campaignOrCanvasWithTagRetarget: "campaign_or_canvas_with_tag_retarget_filter";
  campaignRetarget: "campaign_retarget_filter";
  cardsClicked: "card_filter";
  channelEngagement: "channel_engagement_filter";
  churnCategoryFilter: "churn_category_filter";
  churnScoreFilter: "churn_score_filter";
  contextVariableFilter: "context_variable_filter";
  controlGroup: "control_group_filter";
  conversionEvent: "conversion_event_filter";
  createdAtFilter: "created_at_filter";
  createdFromFilter: "created_from_filter";
  csvImport: "csv_import_filter";
  customAttributes: "custom_attributes_filter";
  customEvents: "custom_events_filter";
  customEventsFirstSince: "custom_events_first_since_filter";
  customEventsSince: "custom_events_since_filter";
  customerLifetimeValueCalculatedAttributeFilter: "customer_lifetime_value_calculated_attribute_filter";
  deviceOsVersionCodeFilter: "device_os_version_code_filter";
  ecommerceSourceFilter: "ecommerce_source_filter";
  emailFilter: "email_filter";
  eventProperties: "custom_event_properties_filter";
  facebookFriends: "facebook_friends_filter";
  featureFlagExperimentConversionEventFilter: "feature_flag_experiment_conversion_event_filter";
  featureFlagMembershipFilter: "feature_flag_membership_filter";
  firstPurchaseByApp: "first_purchase_by_app_filter";
  firstSession: "first_session_since_filter";
  firstUsedSpecificApp: "first_used_specific_app_filter";
  hasApp: "has_app_filter";
  hasUninstalled: "has_uninstalled_filter";
  inAppPurchase: "in_app_purchase_filter";
  internalWorkflowStepRetarget: "internal_workflow_step_retarget_filter";
  landingPageRetargetFilter: "landing_page_retarget_filter";
  lastOrderPlacedCalculatedAttributeFilter: "last_order_placed_calculated_attribute_filter";
  lastPurchaseByApp: "last_purchase_by_app_filter";
  lastReceivedCampaignOrCanvasWithTag: "last_received_campaign_or_canvas_with_tag_filter";
  lastReceivedSpecificCampaign: "last_received_specific_campaign_filter";
  lastReceivedSpecificWorkflowStep: "last_received_specific_workflow_step_filter";
  lastSentSpecificSmsInboundKeyword: "last_sent_specific_sms_inbound_keyword_filter";
  lastSession: "last_session_since_filter";
  lastUsedSpecificApp: "last_used_specific_app_filter";
  lineInboundMessageBody: "line_inbound_message_body_filter";
  liveActivityPushToStartRegisteredForApp: "has_live_activity_push_to_start_for_app_filter";
  locationFilter: "location_filter";
  markedAsSpam: "has_marked_as_spam_filter";
  medianSessionDuration: "median_session_duration_filter";
  messageEngagementSince: "message_engagement_since_filter";
  nestedCustomAttributes: "nested_custom_attributes_filter";
  nestedObject: "nested_object_filter";
  newsFeedViewed: "news_feed_view_count_filter";
  optedInToEmail: "email_opt_in_since_filter";
  optedInToPush: "push_opt_in_since_filter";
  orBehaviorConditionFilter: "or_behavior_condition_filter";
  orFilter: "or_filter";
  pendingArchivalFilter: "pending_archival_filter";
  productPurchased: "product_purchased_filter";
  productPurchasedFirstSince: "product_purchased_first_since_filter";
  productPurchasedSince: "product_purchased_since_filter";
  purchaseCategoryFilter: "purchase_category_filter";
  purchaseScoreFilter: "purchase_score_filter";
  pushEnabledForApp: "has_push_by_app_filter";
  pushProvisionalForApp: "has_provisional_push_by_app_filter";
  randomNumber: "random_number_filter";
  receivedCampaign: "received_campaign_filter";
  receivedCampaignVariant: "received_campaign_variant_filter";
  receivedCampaignWithTag: "received_campaign_with_tag_filter";
  receivedFeatureFlagVariantFilter: "received_feature_flag_variant_filter";
  receivedWorkflowStep: "received_workflow_step_filter";
  refundValueCalculatedAttributeFilter: "refund_value_calculated_attribute_filter";
  revenueValueCalculatedAttributeFilter: "revenue_value_calculated_attribute_filter";
  segmentCohortFilter: "segment_cohort_filter";
  segmentMembership: "segment_membership_filter";
  sessionCount: "session_count_filter";
  sessionCountByApp: "session_count_by_app_filter";
  smsInboundMessageBody: "sms_inbound_message_body_filter";
  submittedSurveyCampaignFilter: "submitted_survey_campaign_filter";
  submittedSurveyLandingPageFilter: "submitted_survey_landing_page_filter";
  submittedSurveyWorkflowStepFilter: "submitted_survey_workflow_step_filter";
  subscriptionGroup: "subscription_group_filter";
  totalCancelledOrdersCalculatedAttributeFilter: "total_cancelled_orders_calculated_attribute_filter";
  totalNumberOfPurchases: "total_number_of_purchases_filter";
  totalOrdersCalculatedAttributeFilter: "total_orders_calculated_attribute_filter";
  totalOrdersFilter: "total_orders_filter";
  totalRefundsFilter: "total_refunds_filter";
  totalRevenueFilter: "total_revenue_filter";
  twitterFollowers: "twitter_followers_filter";
  uninstalled: "uninstall_filter";
  updatedAtFilter: "updated_at_filter";
  whatsAppInboundMessageBody: "whats_app_inbound_message_body_filter";
  whatsAppInboundMessageFlowId: "whats_app_inbound_message_flow_id_filter";
  workflowControlGroup: "workflow_control_group_filter";
  workflowConversionEvent: "workflow_conversion_event_filter";
  workflowEnteredVariation: "workflow_entered_variation_filter";
  workflowLinkClickedFilter: "workflow_link_clicked_filter";
  workflowStepRetarget: "workflow_step_retarget_filter";
  xCustomEventInYDays: "x_custom_event_in_y_days";
  xCustomEventPropertyInYDays: "x_custom_event_property_in_y_days";
  xMoneySpentInYDays: "x_money_spent_in_y_days";
  xPurchasePropertyInYDays: "x_specific_purchase_property_in_y_days";
  xPurchasesInYDays: "x_purchases_in_y_days";
  xSessionsInYDays: "x_sessions_in_y_days";
  xSoftBouncesInYDaysFilter: "x_soft_bounces_in_y_days";
  xSpecificPurchaseInYDays: "x_specific_purchase_in_y_days";
}
export interface SHARED_CONSTANTS_SEGMENTER {
  "# User::RAND_SAMPLING_BUCKETS the possible range is 0 - (RAND_SAMPLING_BUCKETS - 1)": null;
  "# We subtract 1 here because this constant is only used to describe the range of the random sampling bucket and when we generate a random number from": null;
  CHANGELOG_TYPE: "segment";
  COMPARABLE_ATTRIBUTE_TYPES: SHARED_CONSTANTS_COMPARABLE_ATTRIBUTE_TYPES;
  COMPARISONS_THAT_INCLUDE_TODAY: (15 | 4)[];
  CSV_AVAILABLE_TIME: "14";
  CSV_EXPORT: SHARED_CONSTANTS_CSV_EXPORT;
  CSV_IMPORTS_CACHED_PER_USER: "100";
  CUSTOM_GROUPINGS: SHARED_CONSTANTS_SEGMENTER_CUSTOM_GROUPINGS;
  DATE_FORMATS: SHARED_CONSTANTS_DATE_FORMATS;
  DATE_TODAY_COMPARISON: 20;
  DEFAULT_BASELINE_SEGMENT_ID: "baseline";
  DEFAULT_COMPARABLE_ATTRIBUTES: ("days_since_first_session" | "days_since_last_purchase" | "days_since_last_session" | "days_to_first_purchase" | "revenue_in_dollars" | "sessions_per_day")[];
  DEPENDENCY_RELEVANCY: SHARED_CONSTANTS_DEPENDENCY_RELEVANCY;
  DESCRIPTION_MAX_LENGTH: 250;
  EMPTY_SENTENCE: "None";
  ERROR_CODES: SHARED_CONSTANTS_SEGMENTER_ERROR_CODES;
  FACEBOOK_EXPORT_DATA_TYPES: SHARED_CONSTANTS_FACEBOOK_EXPORT_DATA_TYPES;
  FILTER_REGEX_MAX_BYTE_LENGTH: 10000;
  INTERVAL_COMPARISON_KEYS: (15 | 16 | 4 | 6)[];
  INTERVAL_COMPARISON_KEYS_IN_FUTURE: (15 | 16)[];
  MAX_SEGMENTS_FOR_ENABLE_ANALYTICS: 25;
  MAX_USERS_IN_SEGMENT_PREVIEW: 50;
  SEARCH_KEYS: SHARED_CONSTANTS_SEGMENTER_SEARCH_KEYS;
  SEGMENTS_GRID_SELECTOR: "#segments-grid";
  SEGMENT_EDIT_ERRORS: SHARED_CONSTANTS_SEGMENT_EDIT_ERRORS;
  SEGMENT_NAME_MAX_LENGTH: 150;
  SEGMENT_STATS_MIN_PERCENT: 0.01;
  SEGMENT_STATS_MOUSEOVER_HOLDER_ID: "segmenter-segment-stats";
  USER_RAND_SAMPLING_BUCKETS: 9999;
  VALID_FILTER_VALUES: SHARED_CONSTANTS_VALID_FILTER_VALUES;
  filterKeys: SHARED_CONSTANTS_filterKeys;
}
export interface SHARED_CONSTANTS_BOOLEAN_DOES_NOT_EQUAL {
  LABEL: "is not";
  VALUE: 11;
}
export interface SHARED_CONSTANTS_BOOLEAN_EQUALS {
  LABEL: "is";
  VALUE: 1;
}
export interface SHARED_CONSTANTS_NUMBER_EQUALS {
  LABEL: "exactly";
  VALUE: 2;
}
export interface SHARED_CONSTANTS_NUMBER_GREATER_THAN {
  LABEL: "more than";
  VALUE: 3;
}
export interface SHARED_CONSTANTS_NUMBER_LESS_THAN {
  LABEL: "less than";
  VALUE: 4;
}
export interface SHARED_CONSTANTS_STRING_CONTAINS {
  LABEL: "contains";
  VALUE: 7;
}
export interface SHARED_CONSTANTS_STRING_DOES_NOT_CONTAIN {
  LABEL: "does not contain";
  VALUE: 8;
}
export interface SHARED_CONSTANTS_STRING_DOES_NOT_EQUAL {
  LABEL: "does not equal";
  VALUE: 6;
}
export interface SHARED_CONSTANTS_STRING_EQUALS {
  LABEL: "equals";
  VALUE: 5;
}
export interface SHARED_CONSTANTS_STRING_IS_BLANK {
  LABEL: "is blank";
  VALUE: 12;
}
export interface SHARED_CONSTANTS_STRING_IS_NOT_BLANK {
  LABEL: "is not blank";
  VALUE: 13;
}
export interface SHARED_CONSTANTS_TIME_AFTER {
  LABEL: "after";
  VALUE: 10;
}
export interface SHARED_CONSTANTS_TIME_BEFORE {
  LABEL: "before";
  VALUE: 9;
}
export interface SHARED_CONSTANTS_SEGMENT_COHORTS_COMPARATOR {
  BOOLEAN_DOES_NOT_EQUAL: SHARED_CONSTANTS_BOOLEAN_DOES_NOT_EQUAL;
  BOOLEAN_EQUALS: SHARED_CONSTANTS_BOOLEAN_EQUALS;
  NUMBER_EQUALS: SHARED_CONSTANTS_NUMBER_EQUALS;
  NUMBER_GREATER_THAN: SHARED_CONSTANTS_NUMBER_GREATER_THAN;
  NUMBER_LESS_THAN: SHARED_CONSTANTS_NUMBER_LESS_THAN;
  STRING_CONTAINS: SHARED_CONSTANTS_STRING_CONTAINS;
  STRING_DOES_NOT_CONTAIN: SHARED_CONSTANTS_STRING_DOES_NOT_CONTAIN;
  STRING_DOES_NOT_EQUAL: SHARED_CONSTANTS_STRING_DOES_NOT_EQUAL;
  STRING_EQUALS: SHARED_CONSTANTS_STRING_EQUALS;
  STRING_IS_BLANK: SHARED_CONSTANTS_STRING_IS_BLANK;
  STRING_IS_NOT_BLANK: SHARED_CONSTANTS_STRING_IS_NOT_BLANK;
  TIME_AFTER: SHARED_CONSTANTS_TIME_AFTER;
  TIME_BEFORE: SHARED_CONSTANTS_TIME_BEFORE;
}
export interface SHARED_CONSTANTS_SEGMENT_COHORTS_CRITERIA_OPTIONS {
  CUSTOM_EVENT: "custom_event";
  ECOMMERCE_RECOMMENDED_EVENT: "ecommerce_recommended_event";
  MESSAGE_CHANNEL_INTERACTION: "message_channel_interaction";
  PURCHASE: "purchase";
}
export interface SHARED_CONSTANTS_SEGMENT_COHORTS_DEFINITION_STATUS {
  FAILED: "failed";
  PROCESSED: "processed";
  PROCESSING: "processing";
  UNPROCESSED: "unprocessed";
}
export interface SHARED_CONSTANTS_SEGMENT_COHORTS_PROPERTY_COMPLEXITY {
  BASIC: "basic";
  NESTED: "nested";
}
export interface SHARED_CONSTANTS_SMS_LIMITS {
  MAX_LINKS_TO_SHORTEN_IN_BODY: 25;
  MAX_MESSAGE_BODY_LENGTH: 1600;
  MAX_URL_LENGTH_FOR_SHORTENING: 4000;
  MMS_CAMPAIGN_IMAGE_MAX_SIZE_BYTES_LIMIT: 1048576;
  MMS_CAMPAIGN_IMAGE_WARN_SIZE_BYTES_LIMIT: 614400;
  UNIFIED_SHORT_LINK_PATH_LENGTH: 8;
}
export interface SHARED_CONSTANTS_SMS {
  HIGH_RISK_COUNTRIES: ("AF" | "AO" | "AZ" | "BD" | "BF" | "BI" | "BJ" | "BO" | "BY" | "CD" | "CF" | "CI" | "CM" | "CU" | "CV" | "DZ" | "EC" | "GH" | "GM" | "GQ" | "GT" | "GW" | "HN" | "ID" | "IL" | "IQ" | "IR" | "JE" | "JO" | "KE" | "KG" | "KH" | "KI" | "KM" | "KP" | "LB" | "LK" | "LY" | "MA" | "MG" | "ML" | "MM" | "MN" | "MR" | "MW" | "MY" | "NE" | "NF" | "NG" | "NU" | "OM" | "PK" | "PS" | "PY" | "SA" | "SD" | "SI" | "SL" | "SN" | "SO" | "SS" | "SY" | "TD" | "TG" | "TJ" | "TL" | "TN" | "TZ" | "UA" | "UG" | "UZ" | "VN" | "WF" | "XK" | "YE" | "ZM" | "ZW")[];
  LIMITS: SHARED_CONSTANTS_SMS_LIMITS;
  VALID_HTTP_URL_REGEX: "^https?://[^/]";
}
export interface SHARED_CONSTANTS_SMS_FROM_ADDRESS_DISPLAY_TYPES {
  ALPHA_SENDER: "Alphanumeric Code";
  PHONE_NUMBER: "Long Code";
  RCS_SENDER: "RCS Sender";
  SHORT_CODE: "Short Code";
}
export interface SHARED_CONSTANTS_DEFAULT {
  Help: ("HELP" | "INFO")[];
  "Opt-in": ("START" | "UNSTOP" | "YES")[];
  "Opt-out": ("CANCEL" | "END" | "OPT OUT" | "QUIT" | "REVOKE" | "STOP" | "STOPALL" | "UNSUBSCRIBE")[];
}
export interface SHARED_CONSTANTS_DISPLAY_PRIORITY {
  Help: 2;
  "Opt-in": 0;
  "Opt-out": 1;
}
export interface SHARED_CONSTANTS_SMS_GLOBAL_KEYWORDS_LIMITS {
  MaxCategoryNameLength: 100;
  MaxKeywordCount: 20;
  MaxKeywordLength: 34;
  MaxKeywordRegexMatchLength: 300;
  MaxResponseLength: 1600;
  MaxResponseTotalLength: 10000;
}
export interface SHARED_CONSTANTS_PROTECTED {
  "Entered Double Opt-in": "START"[];
  Help: "HELP"[];
  "Opt-in": "START"[];
  "Opt-out": "STOP"[];
}
export interface SHARED_CONSTANTS_SMS_GLOBAL_KEYWORDS {
  ALLOWED_FUZZY_OPT_OUT_LANGUAGES: "en"[];
  CONFIRMED_DOUBLE_OPT_IN: "Confirmed Double Opt-in";
  DEFAULT: SHARED_CONSTANTS_DEFAULT;
  DISPLAY_PRIORITY: SHARED_CONSTANTS_DISPLAY_PRIORITY;
  ENTERED_DOUBLE_OPT_IN: "Entered Double Opt-in";
  LIMITS: SHARED_CONSTANTS_SMS_GLOBAL_KEYWORDS_LIMITS;
  OPT_IN: "Opt-in";
  OTHER_CATEGORY_NAME: "Other";
  PROTECTED: SHARED_CONSTANTS_PROTECTED;
}
export interface SHARED_CONSTANTS_SMS_PROTOCOL {
  RCS: "rcs";
  SMS: "sms";
}
export interface SHARED_CONSTANTS_SMS_SP_INFOBIP {
  DISPLAY_NAME: "Infobip";
  SUPPORTS_SENDS_TO_CARRIER: false;
  VALUE: 1;
}
export interface SHARED_CONSTANTS_SMS_SP_TWILIO {
  DISPLAY_NAME: "Twilio";
  SUPPORTS_SENDS_TO_CARRIER: true;
  VALUE: 0;
}
export interface SHARED_CONSTANTS_SMS_SP {
  INFOBIP: SHARED_CONSTANTS_SMS_SP_INFOBIP;
  TWILIO: SHARED_CONSTANTS_SMS_SP_TWILIO;
}
export interface SHARED_CONSTANTS_STEP_EDIT_PAGE {
  AUDIENCE: 2;
  AUTO_ADVANCE_V2: 3;
  DECISION_SPLIT: 0;
  DELAY: 0;
  FACEBOOK_AUDIENCE_SYNC: 0;
  MESSAGE: 0;
  TRIGGER: 1;
}
export interface SHARED_CONSTANTS_SUBSCRIPTION_GROUP_CHANNELS {
  EMAIL: 0;
  KAKAO: 4;
  LINE: 3;
  SMS: 1;
  WHATS_APP: 2;
}
export interface SHARED_CONSTANTS_SUBSCRIPTION_GROUP_MANAGEMENT_SEARCHABLE_CHANNELS {
  EMAIL: "email";
  KAKAO: "kakao";
  LINE: "line";
  SMS: "sms";
  WHATS_APP: "whats_app";
}
export interface SHARED_CONSTANTS_SUBSCRIPTION_GROUP_MANAGEMENT_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ARCHIVED: "archived";
}
export interface SHARED_CONSTANTS_SUBSCRIPTION_GROUP_MANAGEMENT_SEARCH_KEYS {
  CHANNEL: "channel";
  STATUS: "status";
}
export interface SHARED_CONSTANTS_RECIPIENT_STATES {
  ANY_STATE: 0;
  ONLY_OPTED_IN: 2;
  SUBSCRIBED_OR_OPTED_IN: 1;
}
export interface SHARED_CONSTANTS_SUBSCRIPTION_STATES {
  CONFIRMED_DOUBLE_OPT_IN: 4;
  OPTED_IN: 2;
  PENDING_DOUBLE_OPT_IN: 5;
  RECIPIENT_STATES: SHARED_CONSTANTS_RECIPIENT_STATES;
  SUBSCRIBED: 0;
  UNSUBSCRIBED: 1;
}
export interface SHARED_CONSTANTS_SUPPORT_CASES_ERROR_CODES {
  COMMENT_REQUIRED: "COMMENT_REQUIRED";
  DESCRIPTION_REQUIRED: "DESCRIPTION_REQUIRED";
  FEATURE_NOT_ENABLED: "FEATURE_NOT_ENABLED";
  FREE_TRIAL_NOT_ALLOWED: "FREE_TRIAL_NOT_ALLOWED";
  IMPERSONATION_NOT_ALLOWED: "IMPERSONATION_NOT_ALLOWED";
  INVALID_CATEGORY: "INVALID_CATEGORY";
  INVALID_PRIORITY: "INVALID_PRIORITY";
  SALESFORCE_API_ERROR: "SALESFORCE_API_ERROR";
  SALESFORCE_CASE_CREATION_FAILED: "SALESFORCE_CASE_CREATION_FAILED";
  SALESFORCE_INVALID_ARGUMENTS: "SALESFORCE_INVALID_ARGUMENTS";
  TITLE_REQUIRED: "TITLE_REQUIRED";
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR";
}
export interface SHARED_CONSTANTS_SUPPORT_CASES {
  CATEGORIES: ("CLIP" | "COMPI" | "Chat Apps" | "Company Offboarding" | "Content Cards" | "Core Messaging" | "Core Objects" | "Currents & Data Lake" | "Email" | "Feature Flags" | "Feature Flip" | "Frontend Infrastructure & Experience" | "IAM" | "Ingestion" | "Intelligence" | "Messaging (CLX & MX)" | "Partner Onboarding" | "Product Partnerships" | "Push" | "Reporting" | "SDKs" | "SMS" | "Support Portal" | "User Targeting" | "WhatsApp")[];
  ERROR_CODES: SHARED_CONSTANTS_SUPPORT_CASES_ERROR_CODES;
}
export interface SHARED_CONSTANTS_SUPPRESSION_RULES_ERROR_CODES {
  INVALID_CREATED_BY: "SUPPRESSION_RULE_INVALID_CREATED_BY";
  INVALID_STATUS: "SUPPRESSION_RULE_INVALID_STATUS";
  INVALID_TYPE: "SUPPRESSION_RULE_INVALID_TYPE";
  NOT_FOUND: "SUPPRESSION_RULE_NOT_FOUND";
  SENDING_DOMAIN_TAKEN: "SUPPRESSION_RULE_SENDING_DOMAIN_TAKEN";
  VALIDATION_FAILED: "SUPPRESSION_RULE_VALIDATION_FAILED";
}
export interface SHARED_CONSTANTS_SUPPRESSION_RULES {
  ERROR_CODES: SHARED_CONSTANTS_SUPPRESSION_RULES_ERROR_CODES;
}
export interface SHARED_CONSTANTS_SURVEY_ERROR_CODES {
  INVALID_APP_GROUP_ID: "INVALID_APP_GROUP_ID";
  INVALID_END_DATE: "INVALID_END_DATE";
  INVALID_QUESTION_ID: "INVALID_QUESTION_ID";
  INVALID_START_DATE: "INVALID_START_DATE";
  INVALID_SURVEY_ID: "INVALID_SURVEY_ID";
  MISSING_REQUIRED_FIELDS: "MISSING_REQUIRED_FIELDS";
  QUESTION_DEFINITION_NOT_FOUND: "QUESTION_DEFINITION_NOT_FOUND";
  SURVEY_DEFINITION_NOT_FOUND: "SURVEY_DEFINITION_NOT_FOUND";
  UNSUPPORTED_QUESTION_TYPE: "UNSUPPORTED_QUESTION_TYPE";
}
export interface SHARED_CONSTANTS_DETRACTORS {
  MAX_SCORE: 6;
  MIN_SCORE: 0;
}
export interface SHARED_CONSTANTS_PASSIVES {
  MAX_SCORE: 8;
  MIN_SCORE: 7;
}
export interface SHARED_CONSTANTS_PROMOTERS {
  MAX_SCORE: 10;
  MIN_SCORE: 9;
}
export interface SHARED_CONSTANTS_SEGMENTS {
  DETRACTORS: SHARED_CONSTANTS_DETRACTORS;
  PASSIVES: SHARED_CONSTANTS_PASSIVES;
  PROMOTERS: SHARED_CONSTANTS_PROMOTERS;
}
export interface SHARED_CONSTANTS_NPS_SCORE {
  MAX_SCORE: 10;
  MIN_SCORE: 0;
  SEGMENTS: SHARED_CONSTANTS_SEGMENTS;
}
export interface SHARED_CONSTANTS_QUESTION_TYPES {
  EMAIL: "email";
  FREE_FORM_TEXT: "free_form_text";
  MULTIPLE_CHOICE: "multiple_choice";
  NPS: "nps";
  PHONE_NUMBER: "phone_number";
  SINGLE_BOOLEAN: "single_boolean";
  SINGLE_CHOICE: "single_choice";
  SINGLE_NUMBER: "single_number";
}
export interface SHARED_CONSTANTS_ROOT_SURVEY {
  ERROR_CODES: SHARED_CONSTANTS_SURVEY_ERROR_CODES;
  MAX_QUESTIONS_PER_SURVEY: 100;
  MAX_QUESTION_DISPLAY_TEXT_LENGTH: 2048;
  NPS_SCORE: SHARED_CONSTANTS_NPS_SCORE;
  QUESTION_TYPES: SHARED_CONSTANTS_QUESTION_TYPES;
}
export interface SHARED_CONSTANTS_TEAMS_ERROR_CODES {
  INVALID_TEAM_ID: "INVALID_TEAM_ID";
  TEAM_NOT_FOUND: "TEAM_NOT_FOUND";
}
export interface SHARED_CONSTANTS_TEAMS {
  ERROR_CODES: SHARED_CONSTANTS_TEAMS_ERROR_CODES;
}
export interface SHARED_CONSTANTS_DOCUMENTATION_METHOD_TITLES {
  API: "API";
  APIS: "APIs";
  CONNECTED_CONTENT: "Connected Content";
  CURRENTS: "Currents";
  DEEPLINK: "SDKs_deeplink";
  SDKS: "SDKs";
  SDKS_APIS: "SDKs/APIs";
  WEBHOOKS: "Webhooks";
}
export interface SHARED_CONSTANTS_INTEGRATION_METHODS {
  CONNECTED_CONTENT: "Connected Content";
  WEBHOOKS: "Webhooks";
}
export interface SHARED_CONSTANTS_SPECIALTIES {
  AMAZON_S3: "Amazon S3";
  ATTRIBUTION: "Attribution";
  BEHAVIORAL_ANALYTICS: "Behavioral Analytics";
  CONTEXTUAL_LOCATION: "Contextual Location";
  CUSTOMER_DATA_PLATFORM: "Customer Data Platform";
  DATA_WAREHOUSES: "Data Warehouses";
  EMAIL: "Email";
}
export interface SHARED_CONSTANTS_AB180 {
  CONFIGATRON_URL_KEY: "";
  ID: "001d0000021U3ZRAA0";
  INSTALL_ATTRIBUTION_KEY: "ab180";
  NAME: "AB180";
}
export interface SHARED_CONSTANTS_ADJUST {
  CONFIGATRON_URL_KEY: "";
  ID: "da507e25-4554-4803-8b8e-6c643a160683";
  INSTALL_ATTRIBUTION_KEY: "adjust";
  NAME: "Adjust";
}
export interface SHARED_CONSTANTS_AMAZON_BEDROCK {
  FEATURE_FLIPPER: "agent_console_amazon_bedrock";
  ID: "675f2604-6228-4e5c-9614-ba78b2b0cfd1";
  NAME: "Amazon Bedrock";
}
export interface SHARED_CONSTANTS_AUTH_TYPES {
  KEY: 1;
  ROLE: 2;
}
export interface SHARED_CONSTANTS_AMAZON_S3 {
  AUTH_TYPES: SHARED_CONSTANTS_AUTH_TYPES;
  CURRENTS_INTEGRATION_TYPE: "s3_export";
  ID: "824d6517-067e-440b-9a51-527e1d5ab898";
  WAREHOUSE_TYPE: 0;
}
export interface SHARED_CONSTANTS_AMPLITUDE {
  CONFIGATRON_URL_KEY: "";
  CURRENTS_INTEGRATION_TYPE: "amplitude_export";
  ID: "0608361d-4c57-41b6-8919-d902d345d8b0";
  NAME: "Amplitude";
}
export interface SHARED_CONSTANTS_ANTHROPIC {
  FEATURE_FLIPPER: "custom_ai_agents";
  ID: "001VP00000eGjIHYA0";
  NAME: "Anthropic";
}
export interface SHARED_CONSTANTS_APPSFLYER {
  CONFIGATRON_URL_KEY: "";
  ID: "34b1b45b-85a1-474d-8c11-89b4f2efc79f";
  INSTALL_ATTRIBUTION_KEY: "appsflyer";
  NAME: "Appsflyer";
}
export interface SHARED_CONSTANTS_APPTIMIZE {
  ID: "c6d8db60-e04e-4f06-94c9-71917b6459dd";
  NAME: "Apptimize";
}
export interface SHARED_CONSTANTS_APTELIGENT {
  ID: "60c8b652-cd75-4fa8-9b10-8b03469fc9f8";
  NAME: "Apteligent";
}
export interface SHARED_CONSTANTS_BRANCH {
  CONFIGATRON_URL_KEY: "";
  ID: "f26592fc-7354-4e60-a81f-764aa7ac7673";
  INSTALL_ATTRIBUTION_KEY: "branch";
  NAME: "Branch";
}
export interface SHARED_CONSTANTS_CENSUS {
  CONFIGATRON_URL_KEY: "";
  ID: "0010V00002OZId2QAH";
  NAME: "Census";
}
export interface SHARED_CONSTANTS_ERROR_STATES {
  DUPLICATE_SENDER_KEY: "duplicate_sender_key";
  M_PLACE_ID_ALREADY_EXISTS: "m_place_id_already_exists";
}
export interface SHARED_CONSTANTS_CJ_KAKAO {
  ERROR_STATES: SHARED_CONSTANTS_ERROR_STATES;
}
export interface SHARED_CONSTANTS_CJ {
  ID: "001d0000023JHCXAA4";
  KAKAO: SHARED_CONSTANTS_CJ_KAKAO;
  NAME: "CJ";
}
export interface SHARED_CONSTANTS_CRITEO {
  FEATURE_FLIPPER: "audience_sync_pro";
  ID: "001d000001t7ZFo";
}
export interface SHARED_CONSTANTS_FACEBOOK {
  ID: "3622cca3-f2ee-4b4b-a4f4-d75eb43d158e";
  NAME: "Facebook";
}
export interface SHARED_CONSTANTS_GEMINI {
  FEATURE_FLIPPER: "custom_ai_agents";
  ID: "001VP00000eGTwhYAG";
  NAME: "Google Gemini";
}
export interface SHARED_CONSTANTS_GIMBAL {
  ID: "64dabca3-1d21-4cb5-9cf9-bd4ccc713e31";
  NAME: "Gimbal";
}
export interface SHARED_CONSTANTS_GOOGLE_ADS {
  ID: "0013o00002VDJCuAAP";
  NAME: "Google Ads";
}
export interface SHARED_CONSTANTS_GOOGLE_CLOUD_STORE {
  CURRENTS_INTEGRATION_TYPE: "gcs_export";
  ID: "ca175d54-2bab-448b-9f8f-1a4229392909";
  NAME: "Google Cloud Store";
}
export interface SHARED_CONSTANTS_GOOGLE_DV360 {
  FEATURE_FLIPPER: "audience_sync_dv360";
  ID: "3fb8a971-2f8c-481d-8868-0c3e54b45720";
  NAME: "Google Display & Video 360";
}
export interface SHARED_CONSTANTS_GOOGLE_POSTMASTER {
  ID: "0013o00002bsuVu";
  V2_API_VERSION: "v2";
}
export interface SHARED_CONSTANTS_HEAP {
  CONFIGATRON_URL_KEY: "";
  ID: "0010V00002OZYbMQAX";
  NAME: "Heap";
}
export interface SHARED_CONSTANTS_HIGHTOUCH {
  CONFIGATRON_URL_KEY: "";
  ID: "0013o00002VdALbAAN";
  NAME: "Hightouch";
}
export interface SHARED_CONSTANTS_KAKAO_ERROR_STATES {
  DIFFERING_API_KEY: "differing_api_key";
  DUPLICATE_SENDER_KEY: "duplicate_sender_key";
}
export interface SHARED_CONSTANTS_INFOBIP_KAKAO {
  ERROR_STATES: SHARED_CONSTANTS_KAKAO_ERROR_STATES;
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_INFOBIP {
  FEATURE_FLIPPER: "kakao_infobip";
  ID: "001d000001j8GjHAAU";
  KAKAO: SHARED_CONSTANTS_INFOBIP_KAKAO;
  NAME: "Infobip";
}
export interface SHARED_CONSTANTS_KOCHAVA {
  CONFIGATRON_URL_KEY: "/attribution/kochava";
  ID: "45652b1b-6f80-47f3-b281-6632c8dfb7c7";
  INSTALL_ATTRIBUTION_KEY: "kochava";
  NAME: "Kochava";
}
export interface SHARED_CONSTANTS_KUBIT {
  CONFIGATRON_URL_KEY: "";
  ID: "0013o00002Sb1KDAAZ";
  NAME: "Kubit";
}
export interface SHARED_CONSTANTS_LINE_ERROR_STATES {
  DUPLICATE_CHANNEL: "duplicate_channel";
  FAILED_SINGLE_PROVIDER_CHECK: "failed_single_provider_check";
  FAILED_SUBSCRIPTION_GROUP_CREATION: "failed_subscription_group_creation";
  FAILED_WEBHOOK_STATUS_CHECK: "failed_webhook_status_check";
  INVALID_ACCESS_TOKEN: "invalid_access_token";
  INVALID_CHANNEL_SECRET: "invalid_channel_secret";
  INVALID_WEBHOOK_CONFIGURATION: "invalid_webhook_configuration";
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_LINE {
  ERROR_STATES: SHARED_CONSTANTS_LINE_ERROR_STATES;
  FEATURE_FLIPPER: "line";
  ID: "001VP00000D69luYAB";
}
export interface SHARED_CONSTANTS_LINKEDIN {
  FEATURE_FLIPPER: "audience_sync_pro";
  ID: "001d000001O3dWt";
}
export interface SHARED_CONSTANTS_MICROSOFT_AZURE {
  CURRENTS_INTEGRATION_TYPE: "azure_blob_export";
  ID: "ebd76b4a-397d-4030-a9f0-34b5c545f48e";
  NAME: "Microsoft Azure";
  WAREHOUSE_TYPE: 1;
}
export interface SHARED_CONSTANTS_MIXPANEL {
  CONFIGATRON_URL_KEY: "";
  CURRENTS_INTEGRATION_TYPE: "mixpanel_export";
  ID: "187f26b9-ad28-417f-b797-d2f230041a09";
}
export interface SHARED_CONSTANTS_MPARTICLE {
  CURRENTS_INTEGRATION_TYPE: "m_particle_export";
  ID: "a875ab89-c4f0-4138-8600-04901d865927";
  NAME: "mParticle";
}
export interface SHARED_CONSTANTS_NEURA {
  ID: "33f43f58-e999-424a-a9e7-86f3761c44bb";
  NAME: "Neura";
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_OPENAI {
  FEATURE_FLIPPER: "custom_ai_agents";
  ID: "001VP00000eGkHZYA0";
  NAME: "OpenAI";
}
export interface SHARED_CONSTANTS_PINTEREST {
  FEATURE_FLIPPER: "audience_sync_pro";
  ID: "001d000001S6amLAAR";
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_SEGMENT {
  CONFIGATRON_URL_KEY: "";
  CURRENTS_INTEGRATION_TYPE: "segment_dot_com_export";
  ID: "cdbd4820-9626-41d8-9df2-14280f8a2514";
  NAME: "Segment";
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_SHOPIFY {
  FEATURE_FLIPPER: "shopify";
  ID: "d53dcb7c-e1e9-4c42-b8e3-23b448af93c0";
  NAME: "Shopify";
}
export interface SHARED_CONSTANTS_SINGULAR {
  CONFIGATRON_URL_KEY: "/attribution/singular";
  ID: "4f767b75-ed36-4356-be55-5fd2b777f890";
  INSTALL_ATTRIBUTION_KEY: "singular";
  NAME: "Singular";
}
export interface SHARED_CONSTANTS_SNAPCHAT {
  FEATURE_FLIPPER: "audience_sync_pro";
  ID: "001d000001GTpDpAAL";
}
export interface SHARED_CONSTANTS_TEALIUM {
  ID: "a6046664-c21b-4f00-a7ac-a5335ddd8122";
  NAME: "Tealium";
}
export interface SHARED_CONSTANTS_THE_TRADE_DESK {
  FEATURE_FLIPPER: "audience_sync_pro";
  ID: "001VP000007AonWYAS";
}
export interface SHARED_CONSTANTS_TIKTOK {
  FEATURE_FLIPPER: "audience_sync_pro";
  ID: "0010V00002M24eKQAR";
}
export interface SHARED_CONSTANTS_TINYCLUES {
  CONFIGATRON_URL_KEY: "";
  ID: "0013o00002RZxIiAAL";
  NAME: "Tinyclues";
}
export interface SHARED_CONSTANTS_TREASURE_DATA {
  CONFIGATRON_URL_KEY: "";
  ID: "0013o00002UsvtJAAR";
  NAME: "Treasure Data";
}
export interface SHARED_CONSTANTS_TWITTER {
  FEATURE_FLIPPER: "canvas_consolidated_audience_sync_twitter";
  ID: "001d000001G9SH2";
  NAME: "Twitter";
}
export interface SHARED_CONSTANTS_SETUP_STATES {
  ADD_SYSTEM_USER_FAILED: 31;
  ADD_SYSTEM_USER_STARTED: 30;
  CREATE_SUBSCRIPTION_GROUP_FAILED: 111;
  CREATE_SUBSCRIPTION_GROUP_STARTED: 110;
  EMBEDDED_SIGNUP_COMPLETE: 10;
  FACEBOOK_SIGN_IN_FAILED: 1;
  FACEBOOK_SIGN_IN_STARTED: 0;
  INFOBIP_FAILED: 131;
  INFOBIP_STARTED: 130;
  INTEGRATION_COMPLETE: 1000;
  INTEGRATION_FAILED: -100;
  REGISTER_PHONE_NUMBERS_FAILED: 51;
  REGISTER_PHONE_NUMBERS_STARTED: 50;
  RETRIEVE_PHONE_NUMBERS_FAILED: 41;
  RETRIEVE_PHONE_NUMBERS_STARTED: 40;
  RETRIEVE_UPDATED_NUMBERS_FAILED: 61;
  RETRIEVE_UPDATED_NUMBERS_STARTED: 60;
  RETRIEVE_WABA_ID_FAILED: 21;
  RETRIEVE_WABA_ID_STARTED: 20;
  SHARE_CREDIT_LINE_FAILED: 71;
  SHARE_CREDIT_LINE_STARTED: 70;
  SUBSCRIBE_TO_WEBHOOKS_FAILED: 101;
  SUBSCRIBE_TO_WEBHOOKS_STARTED: 100;
  VALIDATE_INFOBIP_API_KEY_FAILED: 121;
  VALIDATE_INFOBIP_API_KEY_STARTED: 120;
  VERIFY_CREDIT_SHARING_MISMATCH_FAILURE: 92;
  VERIFY_CREDIT_SHARING_PART1_FAILED: 81;
  VERIFY_CREDIT_SHARING_PART1_STARTED: 80;
  VERIFY_CREDIT_SHARING_PART2_FAILED: 91;
  VERIFY_CREDIT_SHARING_PART2_STARTED: 90;
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_WHATS_APP {
  FEATURE_FLIPPER: "native_whatsapp";
  ID: "gzb6lr8h";
  NAME: "WhatsApp";
  SETUP_STATES: SHARED_CONSTANTS_SETUP_STATES;
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNERS {
  AB180: SHARED_CONSTANTS_AB180;
  ADJUST: SHARED_CONSTANTS_ADJUST;
  AMAZON_BEDROCK: SHARED_CONSTANTS_AMAZON_BEDROCK;
  AMAZON_S3: SHARED_CONSTANTS_AMAZON_S3;
  AMPLITUDE: SHARED_CONSTANTS_AMPLITUDE;
  ANTHROPIC: SHARED_CONSTANTS_ANTHROPIC;
  APPSFLYER: SHARED_CONSTANTS_APPSFLYER;
  APPTIMIZE: SHARED_CONSTANTS_APPTIMIZE;
  APTELIGENT: SHARED_CONSTANTS_APTELIGENT;
  BRANCH: SHARED_CONSTANTS_BRANCH;
  CENSUS: SHARED_CONSTANTS_CENSUS;
  CJ: SHARED_CONSTANTS_CJ;
  CRITEO: SHARED_CONSTANTS_CRITEO;
  FACEBOOK: SHARED_CONSTANTS_FACEBOOK;
  GEMINI: SHARED_CONSTANTS_GEMINI;
  GIMBAL: SHARED_CONSTANTS_GIMBAL;
  GOOGLE_ADS: SHARED_CONSTANTS_GOOGLE_ADS;
  GOOGLE_CLOUD_STORE: SHARED_CONSTANTS_GOOGLE_CLOUD_STORE;
  GOOGLE_DV360: SHARED_CONSTANTS_GOOGLE_DV360;
  GOOGLE_POSTMASTER: SHARED_CONSTANTS_GOOGLE_POSTMASTER;
  HEAP: SHARED_CONSTANTS_HEAP;
  HIGHTOUCH: SHARED_CONSTANTS_HIGHTOUCH;
  INFOBIP: SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_INFOBIP;
  KOCHAVA: SHARED_CONSTANTS_KOCHAVA;
  KUBIT: SHARED_CONSTANTS_KUBIT;
  LINE: SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_LINE;
  LINKEDIN: SHARED_CONSTANTS_LINKEDIN;
  MICROSOFT_AZURE: SHARED_CONSTANTS_MICROSOFT_AZURE;
  MIXPANEL: SHARED_CONSTANTS_MIXPANEL;
  MPARTICLE: SHARED_CONSTANTS_MPARTICLE;
  NEURA: SHARED_CONSTANTS_NEURA;
  OPENAI: SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_OPENAI;
  PINTEREST: SHARED_CONSTANTS_PINTEREST;
  SEGMENT: SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_SEGMENT;
  SHOPIFY: SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_SHOPIFY;
  SINGULAR: SHARED_CONSTANTS_SINGULAR;
  SNAPCHAT: SHARED_CONSTANTS_SNAPCHAT;
  TEALIUM: SHARED_CONSTANTS_TEALIUM;
  THE_TRADE_DESK: SHARED_CONSTANTS_THE_TRADE_DESK;
  TIKTOK: SHARED_CONSTANTS_TIKTOK;
  TINYCLUES: SHARED_CONSTANTS_TINYCLUES;
  TREASURE_DATA: SHARED_CONSTANTS_TREASURE_DATA;
  TWITTER: SHARED_CONSTANTS_TWITTER;
  WHATS_APP: SHARED_CONSTANTS_TECHNOLOGY_PARTNERS_WHATS_APP;
}
export interface SHARED_CONSTANTS_TECHNOLOGY_PARTNER {
  DOCUMENTATION_METHOD_TITLES: SHARED_CONSTANTS_DOCUMENTATION_METHOD_TITLES;
  INTEGRATION_METHODS: SHARED_CONSTANTS_INTEGRATION_METHODS;
  SPECIALTIES: SHARED_CONSTANTS_SPECIALTIES;
  TECHNOLOGY_PARTNERS: SHARED_CONSTANTS_TECHNOLOGY_PARTNERS;
}
export interface SHARED_CONSTANTS_EMAIL_FOOTER {
  MAX_SIZE_IN_BYTES: 102400;
  MAX_SIZE_IN_KB: 100;
}
export interface SHARED_CONSTANTS_EMAIL_OPT_IN_PAGE {
  MAX_SIZE_IN_BYTES: 768000;
  MAX_SIZE_IN_KB: 750;
}
export interface SHARED_CONSTANTS_EMAIL_UNSUBSCRIBE_PAGE {
  MAX_SIZE_IN_BYTES: 768000;
  MAX_SIZE_IN_KB: 750;
}
export interface SHARED_CONSTANTS_TEMPLATES_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
}
export interface SHARED_CONSTANTS_TEMPLATES_SEARCH_KEYS {
  CREATED_BY_ME: "created_by_me";
  STATUS: "status";
  TAG: "tag";
  TERRITORY: "team";
}
export interface SHARED_CONSTANTS_IMAGE_ERROR_TYPES {
  IMAGE_CORRUPTED: "image_corrupted";
  IMAGE_MISSING: "image_missing";
  IMAGE_OVERSIZE: "image_oversize";
}
export interface SHARED_CONSTANTS_MESSAGE_ERROR_TYPES {
  IMAGE_COUNT_OVER_LIMIT: "image_count_over_limit";
  MISSING_TEMPLATE: "missing_template";
  MULTIPLE_TEMPLATES: "multiple_templates";
  ZIP_CORRUPTED: "zip_corrupted";
  ZIP_OVERSIZE: "zip_oversize";
}
export interface SHARED_CONSTANTS_ZIP_UPLOAD {
  IMAGE_ERROR_TYPES: SHARED_CONSTANTS_IMAGE_ERROR_TYPES;
  MAX_IMAGE_FILES: 50;
  MAX_ZIP_SIZE: 52428800;
  MESSAGE_ERROR_TYPES: SHARED_CONSTANTS_MESSAGE_ERROR_TYPES;
}
export interface SHARED_CONSTANTS_ProfileTypes {
  COLORS: 0;
  CSS: 1;
  HTML_CUSTOM_CODE_MESSAGE_TEMPLATE: 3;
  HTML_DND_MESSAGE_TEMPLATE: 2;
  HTML_DND_SURVEY_TEMPLATE: 4;
}
export interface SHARED_CONSTANTS_inAppMessages {
  ProfileTypes: SHARED_CONSTANTS_ProfileTypes;
}
export interface SHARED_CONSTANTS_themes {
  DARK: "dark";
  NORMAL: "__normal";
}
export interface SHARED_CONSTANTS_TEMPLATES {
  DESCRIPTION_MAX_LENGTH: 250;
  EMAIL_FOOTER: SHARED_CONSTANTS_EMAIL_FOOTER;
  EMAIL_OPT_IN_PAGE: SHARED_CONSTANTS_EMAIL_OPT_IN_PAGE;
  EMAIL_UNSUBSCRIBE_PAGE: SHARED_CONSTANTS_EMAIL_UNSUBSCRIBE_PAGE;
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_TEMPLATES_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_TEMPLATES_SEARCH_KEYS;
  ZIP_UPLOAD: SHARED_CONSTANTS_ZIP_UPLOAD;
  inAppMessages: SHARED_CONSTANTS_inAppMessages;
  themes: SHARED_CONSTANTS_themes;
}
export interface SHARED_CONSTANTS_TERRITORY_MANAGEMENT_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  ARCHIVED: "archived";
}
export interface SHARED_CONSTANTS_TERRITORY_MANAGEMENT_SEARCH_KEYS {
  STATUS: "status";
}
export interface SHARED_CONSTANTS_TERRITORY_MANAGEMENT {
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_TERRITORY_MANAGEMENT_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_TERRITORY_MANAGEMENT_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_TEST_SEND_ERRORS {
  INVALID_MESSAGE_VARIATION: "INVALID_MESSAGE_VARIATION";
  INVALID_RECIPIENT_EMAIL_ADDRESS: "INVALID_RECIPIENT_EMAIL_ADDRESS";
  INVALID_SENDER_EMAIL_ADDRESS: "INVALID_SENDER_EMAIL_ADDRESS";
}
export interface SHARED_CONSTANTS_BULK_USER_ADD_ERROR_CODES {
  EXCEEDS_MAX_SIZE: "exceeds-max-size";
  NO_TEST_USERS_PROVIDED: "no-test-users-provided";
  TEST_USER_EXISTS: "test-user-exists";
  UNABLE_TO_ADD: "unable-to-add";
}
export interface SHARED_CONSTANTS_TEST_USER_ERROR_CODES {
  NAME_REQUIRED: "name-required";
  USER_NOT_FOUND: "user-not-found";
}
export interface SHARED_CONSTANTS_TEST_USER {
  BULK_USER_ADD_ERROR_CODES: SHARED_CONSTANTS_BULK_USER_ADD_ERROR_CODES;
  ERROR_CODES: SHARED_CONSTANTS_TEST_USER_ERROR_CODES;
}
export interface SHARED_CONSTANTS_MESSAGE_COMPONENT_TYPES {
  PUSH_MESSAGE: "push_message";
  PUSH_TITLE: "push_title";
}
export interface SHARED_CONSTANTS_STEP_PAGES {
  DETAILS: "details";
  INSTRUCTIONS: "instructions";
  MESSAGE: "message";
  SUMMARY: "summary";
  VARIANTS: "variants";
}
export interface SHARED_CONSTANTS_UCO {
  MAX_COMBINATIONS: 9;
  MESSAGE_COMPONENT_TYPES: SHARED_CONSTANTS_MESSAGE_COMPONENT_TYPES;
  STEP_PAGES: SHARED_CONSTANTS_STEP_PAGES;
}
export interface SHARED_CONSTANTS_UCO_CAMPAIGN_TEST_TABS {
  COMPONENT_PERFORMANCE: 3;
  HOLDOUT_SEND: 1;
  INITIAL_TEST: 0;
  USER_CHARACTERISTICS: 2;
}
export interface SHARED_CONSTANTS_UCO_STEP_PAGES {
  DETAILS: "details";
  INSTRUCTIONS: "instructions";
  MESSAGE: "message";
  SUMMARY: "summary";
  VARIANTS: "variants";
}
export interface SHARED_CONSTANTS_UPTIME_API_TYPES {
  REST: "rest";
  SDK: "sdk";
}
export interface SHARED_CONSTANTS_USAGE_WITH_CREDITS_NAME_BY_CONSUMPTION_TYPE {
  AGENT_CONSOLE: "agent console";
  AUDIENCE_SYNC: "audience sync";
  BANNERS: "banner";
  CONTENT_CARDS: "content card";
  EMAIL: "email";
  KAKAO: "kakaotalk";
  LINE: "line";
  MESSAGE_ARCHIVING: "message archiving";
  SMS_MMS_RCS: "SMS/MMS/RCS";
  WEBHOOKS: "webhooks";
  WHATS_APP: "whatsapp";
}
export interface SHARED_CONSTANTS_USER_BEHAVIORS {
  ADDED_EMAIL_ADDRESS: "TrackedUserBehavior::AddedEmailAddress";
  ANY_PURCHASE: "TrackedUserBehavior::MadeAnyPurchase";
  ATTRIBUTE_UPDATED: "TrackedUserBehavior::AttributeUpdated";
  CAMPAIGN_INTERACTIONS: "TrackedUserBehavior::InteractedWithCampaign";
  CANVAS_CLICK: "TrackedUserBehavior::CanvasClick";
  CANVAS_OPEN: "TrackedUserBehavior::CanvasOpen";
  CARD_INTERACTIONS: "TrackedUserBehavior::InteractedWithCard";
  CART_UPDATED: "TrackedUserBehavior::CartUpdatedEvent";
  CATALOG_BACK_IN_STOCK: "TrackedUserBehavior::CatalogBackInStock";
  CATALOG_PRICE_DROP: "TrackedUserBehavior::CatalogPriceDrop";
  CHECKOUT_COMPLETED: "TrackedUserBehavior::CheckoutCompletedEvent";
  CHECKOUT_STARTED: "TrackedUserBehavior::CheckoutStartedEvent";
  CLICKED_EMAIL: "TrackedUserBehavior::ClickedEmailFromSameCampaign";
  CUSTOM_EVENTS: "TrackedUserBehavior::PerformedCustomEvent";
  CUSTOM_EVENTS_WITH_NESTED_OBJECT: "TrackedUserBehavior::PerformedCustomEventWithNestedObject";
  INTERNAL_STEP_INTERACTIONS: "TrackedUserBehavior::InteractedWithInternalStep";
  LANDING_PAGE_FORM_SUBMITTED: "TrackedUserBehavior::LandingPageFormSubmitted";
  LANDING_PAGE_SURVEY_SUBMITTED: "TrackedUserBehavior::LandingPageSurveySubmitted";
  LOCATION_EVENTS: "TrackedUserBehavior::EnteredGeoFence";
  LOCATION_SET_EVENTS: "TrackedUserBehavior::InteractedWithLocationSet";
  OPENED_EMAIL: "TrackedUserBehavior::OpenedEmailFromSameCampaign";
  ORDER_PLACED: "TrackedUserBehavior::PerformedOrderPlaced";
  PERFORMED_CAMPAIGN_EXCEPTION: "TrackedUserBehavior::PerformedCampaignException";
  PERFORMED_CONVERSION: "TrackedUserBehavior::PerformedConversion";
  PURCHASES: "TrackedUserBehavior::PurchasedProduct";
  PURCHASES_WITH_NESTED_OBJECT: "TrackedUserBehavior::PurchasedProductWithNestedObject";
  SENT_LINE_INBOUND_MESSAGE: "TrackedUserBehavior::SentLineInboundMessage";
  SENT_SMS_INBOUND_MESSAGE: "TrackedUserBehavior::SentSmsInboundMessage";
  SENT_WHATS_APP_INBOUND_MESSAGE: "TrackedUserBehavior::SentWhatsAppInboundMessage";
  SESSIONS: "TrackedUserBehavior::UsedApp";
  SUBSCRIPTION_GROUP_STATE_CHANGED: "TrackedUserBehavior::SubscriptionGroupStateChanged";
  SUBSCRIPTION_STATE_CHANGED: "TrackedUserBehavior::SubscriptionStateChanged";
  UPGRADED_APP_VERSION: "TrackedUserBehavior::UpgradedAppVersion";
  WORKFLOW_STEP_INTERACTIONS: "TrackedUserBehavior::InteractedWithWorkflowStep";
}
export interface SHARED_CONSTANTS_ATTRIBUTE_UPDATED {
  ALLOW_SPECIFIC_VALUE_CLASSES: ("FalseClass" | "Float" | "Integer" | "String" | "TrueClass")[];
  ARRAY: "Array";
  BOOLEAN_CLASSES: ("FalseClass" | "TrueClass")[];
  HASH: "Hash";
  NUMBER_CLASSES: ("Fixnum" | "Float" | "Integer")[];
  STRING: "String";
  UPDATE_TYPES: ("FalseClass" | "Fixnum" | "Float" | "Integer" | "String" | "Time" | "TrueClass")[];
}
export interface SHARED_CONSTANTS_USER_BEHAVIOR_CONSTANTS {
  ATTRIBUTE_UPDATED: SHARED_CONSTANTS_ATTRIBUTE_UPDATED;
}
export interface SHARED_CONSTANTS_USER_BEHAVIOR_SUBTYPES {
  INTERNAL_INTERACTION: "internal_canvas";
  PUSH_ONLY: "push_only";
}
export interface SHARED_CONSTANTS_COMPONENTS {
  BODY: ("Discover our incredible lineup of robots designed to make life easier and more exciting! From home helpers like vacuuming and mopping robots to DIY kits for building your custom bot, we’ve got it all. Explore delivery droids for seamless package management, entertainment bots for fun and games, and education bots perfect for STEM learning. Automate your home with smart assistants, boost productivity with industrial robots, or revolutionize farming with agribots. Don’t wait—shop top brands now at unbeatable prices and let robots transform your life today!" | "ROBOTS FOR $100.  ROBOTS FOR $250.  ROBOTS FOR $1000.  ROBOTS FOR $10,000.  ROBOTS FOR ANY PRICE RANGE!")[];
  HEADER: ("Robot Products Await" | "Roses are red, violets are blue, robots are on sale, they wanna be bought by you")[];
  SUBJECT: ("Huge sale on Robots and Robot Accessories" | "🤖 get your robots here, yo")[];
}
export interface SHARED_CONSTANTS_COMPONENT_STORE_STUB {
  COMPONENTS: SHARED_CONSTANTS_COMPONENTS;
}
export interface SHARED_CONSTANTS_CONVERSION_TYPES {
  CLICKS: "clicks";
  CONVERSION_0: "c_0";
  CONVERSION_1: "c_1";
  CONVERSION_2: "c_2";
  CONVERSION_3: "c_3";
  OPENS: "opens";
}
export interface SHARED_CONSTANTS_STATS_COMBINATION_SUFFIXES {
  CANVAS_CONVERTED: "canvas_converted";
  CANVAS_CONVERTED_BY_SEND_TIME_PART2: "_by_send_time";
  DISPATCHED: "dispatched";
  NOT_OPTIMIZATION_CONVERTED: "not_optimization_converted";
  NOT_OPTIMIZATION_CONVERTED_BY_SEND_TIME: "not_optimization_converted_by_send_time";
  OPTIMIZATION_CONVERTED: "optimization_converted";
  OPTIMIZATION_CONVERTED_BY_SEND_TIME: "optimization_converted_by_send_time";
  UNIQUE_RECIPIENTS: "unique_recipients";
}
export interface SHARED_CONSTANTS_USER_CENTRIC_OPTIMIZATION {
  COMPONENT_STORE_STUB: SHARED_CONSTANTS_COMPONENT_STORE_STUB;
  CONVERSION_TYPES: SHARED_CONSTANTS_CONVERSION_TYPES;
  MESSAGE_STATS: "uco_message_stats";
  STATS_COMBINATION_PREFIX: "combination";
  STATS_COMBINATION_SUFFIXES: SHARED_CONSTANTS_STATS_COMBINATION_SUFFIXES;
  STATS_SEPARATOR: ":";
}
export interface SHARED_CONSTANTS_CSV_IMPORT_TYPES {
  ATTRIBUTES: "attributes";
  EVENTS: "events";
  RECOMMENDED_EVENT: "recommended_events";
}
export interface SHARED_CONSTANTS_USER_CSV_IMPORT {
  CSV_IMPORT_TYPES: SHARED_CONSTANTS_CSV_IMPORT_TYPES;
  MAX_UPLOAD_MB: 500;
}
export interface SHARED_CONSTANTS_USER_DELETION_STATUS {
  CANCELED: "Canceled";
  CANCELING: "Canceling";
  COMPLETE: "Complete";
  FAILED: "Failed";
  MARKING: "Marking";
  NEEDS_CONFIRMATION: "Needs confirmation";
  PROCESSING: "Processing";
  WAITING_FOR_DISPATCH: "Waiting for dispatch";
}
export interface SHARED_CONSTANTS_USER_ERRORS {
  CANNOT_ADD_DELETED_SEGMENTS: "CANNOT_ADD_DELETED_SEGMENTS";
  CANVAS_STEPS_FILTER_REFERENCES_DELETED_STEPS: "CANVAS_STEPS_FILTER_REFERENCES_DELETED_STEPS";
  CONVERSIONS_INVALID: "CONVERSIONS_INVALID";
  CONVERSIONS_MISSING_DEADLINE: "CONVERSIONS_MISSING_DEADLINE";
  DELAY_STEP_VALIDATION_FAILED: "DELAY_STEP_VALIDATION_FAILED";
  DEPRECATED_MESSAGING_CHANNEL: "DEPRECATED_MESSAGING_CHANNEL";
  FILTER_REFERENCES_DELETED_OBJECT: "FILTER_REFERENCES_DELETED_OBJECT";
  FILTER_REFERENCES_DELETED_STEPS: "FILTER_REFERENCES_DELETED_STEPS";
  FILTER_VALIDATION_FAILED: "FILTER_VALIDATION_FAILED";
  INVALID_ACTION_PATH_LINK_ALIAS: "INVALID_ACTION_PATH_LINK_ALIAS";
  INVALID_SEND_TO_DESTINATION: "INVALID_SEND_TO_DESTINATION";
  INVALID_WORKFLOW_ID: "INVALID_WORKFLOW_ID";
  INVALID_WORKFLOW_STEP_ID: "INVALID_WORKFLOW_STEP_ID";
  PARSING_STEP_ACTIONS_ERROR: "PARSING_STEP_ACTIONS_ERROR";
  REELIGIBILITY_VALUE_INVALID: "REELIGIBILITY_VALUE_INVALID";
  UNRECOGNIZED_WORKFLOW_STEP_TYPE: "UNRECOGNIZED_WORKFLOW_STEP_TYPE";
  WORKFLOW_NOT_FOUND: "WORKFLOW_NOT_FOUND";
  WORKFLOW_STEP_HAS_MIXED_NEXT_STEPS: "WORKFLOW_STEP_HAS_MIXED_NEXT_STEPS";
  WORKFLOW_STEP_NOT_FOUND: "WORKFLOW_STEP_NOT_FOUND";
  WORKFLOW_STEP_VALIDATION_FAILED: "WORKFLOW_STEP_VALIDATION_FAILED";
  WORKFLOW_VALIDATION_FAILED: "WORKFLOW_VALIDATION_FAILED";
}
export interface SHARED_CONSTANTS_USER_INFO_ERROR_CODES {
  RECENT_EVENT_HISTORY_TIMEOUT: "USER_RECENT_EVENT_HISTORY_TIMEOUT";
}
export interface SHARED_CONSTANTS_PUSH_TOKEN_TYPES {
  BACKGROUND: "BACKGROUND";
  FOREGROUND: "FOREGROUND";
  IOS_LIVE_ACTIVITY: "IOS_LIVE_ACTIVITY";
  PROVISIONAL: "PROVISIONAL";
}
export interface SHARED_CONSTANTS_USER_INFO {
  ERROR_CODES: SHARED_CONSTANTS_USER_INFO_ERROR_CODES;
  PUSH_TOKEN_TYPES: SHARED_CONSTANTS_PUSH_TOKEN_TYPES;
}
export interface SHARED_CONSTANTS_USER_UPDATER_SOURCES_NAMES {
  "# ENHANCED_PREFERENCE_CENTER is Deprecated. Use PREFERENCE_CENTER": null;
  ATTRIBUTION_PROVIDER: "Attribution Provider";
  BACKFILL: "Backfill";
  CANVAS: "Canvas";
  CANVAS_USER_UPDATE_STEP: "Canvas User Update Step";
  CSV_IMPORT: "CSV Import";
  DASHBOARD: "Dashboard";
  EMAIL_CALLBACK: "Email Webhook";
  ENHANCED_PREFERENCE_CENTER: "Preference Center";
  INBOUND_SMS: "Inbound Message";
  LIST_UNSUBSCRIBE: "List-Unsubscribe";
  MIGRATION: "Migration";
  OUTBOUND_SMS: "Outbound Message";
  PREFERENCE_CENTER: "Preference Center";
  PROXY_RECTIFIER: "Proxy Rectifier";
  PUSH_AUTO_OPT_IN: "Push Token Registration";
  REST_API: "REST API";
  SDK: "SDK";
  SHOPIFY_PROVIDER: "Shopify";
  SUBSCRIPTION_PAGE: "Subscription Page";
  USER_MERGE: "User Merge";
}
export interface SHARED_CONSTANTS_VERIFIED_DOMAIN_ERRORS {
  ALREADY_EXISTS: "VERIFIED_DOMAIN_ALREADY_EXISTS";
  DELEGATED_DOMAIN_LIMIT_REACHED: "VERIFIED_DOMAIN_DELEGATED_DOMAIN_LIMIT_REACHED";
  DOMAIN_ACTIVE: "VERIFIED_DOMAIN_ACTIVE";
  INVALID_DOMAIN: "VERIFIED_DOMAIN_INVALID_DOMAIN";
  INVALID_ROOT_DOMAIN: "VERIFIED_DOMAIN_INVALID_ROOT_DOMAIN";
  INVALID_STATUS: "VERIFIED_DOMAIN_INVALID_STATUS";
  LINK_SHORTENING_DOMAIN_LIMIT_REACHED: "VERIFIED_DOMAIN_LINK_SHORTENING_DOMAIN_LIMIT_REACHED";
  MISSING_ROOT_DOMAIN: "VERIFIED_DOMAIN_MISSING_ROOT_DOMAIN";
  MISSING_SUBDOMAIN: "VERIFIED_DOMAIN_MISSING_SUBDOMAIN";
  MISSING_TYPE: "VERIFIED_DOMAIN_MISSING_TYPE";
  NOT_FOUND: "VERIFIED_DOMAIN_NOT_FOUND";
  SES_REQUIRED: "VERIFIED_DOMAIN_SES_REQUIRED";
  UNSUPPORTED_TYPE: "VERIFIED_DOMAIN_UNSUPPORTED_TYPE";
  ZONE_HAS_RECORDS: "VERIFIED_DOMAIN_ZONE_HAS_RECORDS";
}
export interface SHARED_CONSTANTS_VERIFIED_DOMAIN {
  ERRORS: SHARED_CONSTANTS_VERIFIED_DOMAIN_ERRORS;
}
export interface SHARED_CONSTANTS_VOUCHER_SEARCHABLE_STATUSES {
  ACTIVE: "active";
  ALL: "all";
  EXPIRED: "expired";
}
export interface SHARED_CONSTANTS_VOUCHER_SEARCH_KEYS {
  STATUS: "status";
  TAG: "tag";
}
export interface SHARED_CONSTANTS_VOUCHER {
  SEARCHABLE_STATUSES: SHARED_CONSTANTS_VOUCHER_SEARCHABLE_STATUSES;
  SEARCH_KEYS: SHARED_CONSTANTS_VOUCHER_SEARCH_KEYS;
}
export interface SHARED_CONSTANTS_VOUCHER_GROUP {
  DEFAULT_NOTIFY_WHEN_UNUSED_VOUCHERS_IS_LESS_THAN: 1000;
  MAX_VOUCHERS_FOR_PREVIEW: 10;
  TYPE: "Voucher Feed";
}
export interface SHARED_CONSTANTS_BODY_TYPE {
  JSON: "json";
  PLAINTEXT: "plaintext";
}
export interface SHARED_CONSTANTS_REQUEST_METHOD {
  DELETE: "DELETE";
  GET: "GET";
  PATCH: "PATCH";
  POST: "POST";
  PUT: "PUT";
}
export interface SHARED_CONSTANTS_WEBHOOK_MESSAGE_VARIATION {
  BODY_TYPE: SHARED_CONSTANTS_BODY_TYPE;
  MAX_CHARS_IN_BODY: 65536;
  REQUEST_METHOD: SHARED_CONSTANTS_REQUEST_METHOD;
}
export interface SHARED_CONSTANTS_MESSAGE_CATEGORIES {
  AUTHENTICATION: "Authentication";
  MARKETING: "Marketing";
  MARKETING_BYO: "Marketing_Byo";
  MARKETING_LITE: "Marketing_Lite";
  REST_OF_MESSAGE_TYPES_BYO: "Rest_Of_Message_Types_Byo";
  SERVICE: "Service";
  UTILITY: "Utility";
}
export interface SHARED_CONSTANTS_WHATS_APP_MESSAGE_TYPES {
  RESPONSE: "response";
  TEMPLATE: "template";
}
export interface SHARED_CONSTANTS_SOLUTION_PARTNERS {
  DIRECT_BYO: "DIRECT_BYO";
  INFOBIP: "INFOBIP";
}
export interface SHARED_CONSTANTS_ROOT_WHATS_APP {
  MESSAGE_CATEGORIES: SHARED_CONSTANTS_MESSAGE_CATEGORIES;
  MESSAGE_TYPES: SHARED_CONSTANTS_WHATS_APP_MESSAGE_TYPES;
  SOLUTION_PARTNERS: SHARED_CONSTANTS_SOLUTION_PARTNERS;
}
export interface SHARED_CONSTANTS_CONTEXT_OPTIONS {
  MAX_VARIABLE_DEFINITION_LENGTH: 10240;
  MAX_VARIABLE_NAME_LENGTH: 100;
  VALID_VARIABLE_NAME_PATTERN: "^[a-zA-Z0-9_]+$";
}
export interface SHARED_CONSTANTS_DELAY_OPTIONS {
  AFTER: "after";
  IMMEDIATELY: "immediately";
  IN: "in";
  NEXT: "on the next";
}
export interface SHARED_CONSTANTS_IAM_AVAILABILITY_TYPES {
  AVAILABLE_FOR_A_FIXED_DURATION_IN_SECONDS: "available_for_a_fixed_duration_in_seconds";
  AVAILABLE_UNTIL_EXPIRATION_DATE: "available_until_expiration_date";
  AVAILABLE_UNTIL_PERSONALIZED_EXPIRATION: "available_until_personalized_expiration";
}
export interface SHARED_CONSTANTS_IAM_EXPIRATION_OPTIONS {
  TIME_BASED_OPTION: "1";
  TTL_OPTION: "0";
}
export interface SHARED_CONSTANTS_MANAGEMENT_USER_ERRORS {
  CANVAS_FILTER_REFERENCES_DELETED_OBJECT: "CANVAS_FILTER_REFERENCES_DELETED_OBJECT";
  CANVAS_FILTER_VALIDATION_FAILED: "CANVAS_FILTER_VALIDATION_FAILED";
  CANVAS_STEP_FILTER_REFERENCES_DELETED_OBJECT: "CANVAS_STEP_FILTER_REFERENCES_DELETED_OBJECT";
  CANVAS_STEP_FILTER_VALIDATION_FAILED: "CANVAS_STEP_FILTER_VALIDATION_FAILED";
  CANVAS_STEP_VALIDATION_FAILED: "CANVAS_STEP_VALIDATION_FAILED";
  DRAFT_MISSING_OBJECT: "DRAFT_MISSING_OBJECT";
  DRAFT_STOPPED_OBJECT: "DRAFT_STOPPED_OBJECT";
  FREE_TRIAL_CANVAS_LAUNCH_RESTRICTION: "FREE_TRIAL_CANVAS_LAUNCH_RESTRICTION";
  INVALID_CHANNEL_RATE_LIMITS: "INVALID_CHANNEL_RATE_LIMITS";
  INVALID_WORKFLOW_RETARGETING_FILTER: "INVALID_WORKFLOW_RETARGETING_FILTER";
  SEGMENT_REGEX_TOO_LARGE: "SEGMENT_REGEX_TOO_LARGE";
  UPDATE_ARCHIVED_OBJECT: "UPDATE_ARCHIVED_OBJECT";
  WORKFLOW_VALIDATION_FAILED: "WORKFLOW_VALIDATION_FAILED";
}
export interface SHARED_CONSTANTS_WORKFLOW_MANAGEMENT {
  USER_ERRORS: SHARED_CONSTANTS_MANAGEMENT_USER_ERRORS;
}
export interface SHARED_CONSTANTS_STEP_CLASS_KEYS {
  "# <DO NOT REMOVE THIS COMMENT FOR CanvasStepGenerator>": null;
  ACTION_PATHS: "ACTION_PATHS";
  AUDIENCE_PATHS: "AUDIENCE_PATHS";
  AUDIENCE_SYNC: "AUDIENCE_SYNC";
  CONTENT_OPTIMIZATION: "CONTENT_OPTIMIZATION";
  CONTEXT_UPDATE_STEP: "CONTEXT_UPDATE_STEP";
  CONTROL: "CONTROL";
  DECISION_SPLIT: "DECISION_SPLIT";
  DELAY: "DELAY";
  EXPERIMENT: "EXPERIMENT";
  FACEBOOK_AUDIENCE: "FACEBOOK_AUDIENCE_SYNC";
  FEATURE_FLAG: "FEATURE_FLAG";
  FULL: "FULL";
  GOOGLE_AUDIENCE: "GOOGLE_AUDIENCE_SYNC";
  LLM: "LLM";
  MESSAGE: "MESSAGE";
  SEND_TO_DESTINATION: "SEND_TO_DESTINATION";
  TIKTOK_AUDIENCE: "TIKTOK_AUDIENCE_SYNC";
  USER_CENTRIC_OPTIMIZATION: "USER_CENTRIC_OPTIMIZATION";
  USER_UPDATE: "USER_UPDATE";
}
export interface SHARED_CONSTANTS_WORKFLOW {
  CONTEXT_OPTIONS: SHARED_CONSTANTS_CONTEXT_OPTIONS;
  DELAY_OPTIONS: SHARED_CONSTANTS_DELAY_OPTIONS;
  IAM_AVAILABILITY_TYPES: SHARED_CONSTANTS_IAM_AVAILABILITY_TYPES;
  IAM_EXPIRATION_OPTIONS: SHARED_CONSTANTS_IAM_EXPIRATION_OPTIONS;
  MANAGEMENT: SHARED_CONSTANTS_WORKFLOW_MANAGEMENT;
  MAX_BANNER_AVAILABILITY_IN_DAYS: 31;
  MAX_BANNER_AVAILABILITY_IN_SECONDS: 2678400;
  MAX_CONVERSION_WINDOW_IN_DAYS: 31;
  MAX_CONVERSION_WINDOW_IN_SECONDS: 2678400;
  MAX_DELAY_IN_DAYS: 31;
  MAX_DELAY_IN_SECONDS: 2678400;
  MAX_DELAY_IN_SECONDS_INCREASED: 63072000;
  MAX_IAM_AVAILABILITY_IN_DAYS: 31;
  MAX_IAM_AVAILABILITY_IN_SECONDS: 2678400;
  MAX_TRIGGER_WINDOW_IN_DAYS: 31;
  MAX_TRIGGER_WINDOW_IN_SECONDS: 2678400;
  NAME_MAX_LENGTH: 256;
  PERSONALIZED_DURATION_UNITS: ("days" | "hours" | "minutes" | "seconds" | "weeks")[];
  PERSONALIZED_DURATION_UNITS_WITH_CALENDAR_DAYS: ("calendar_days" | "days" | "hours" | "minutes" | "seconds" | "weeks")[];
  STEP_CLASS_KEYS: SHARED_CONSTANTS_STEP_CLASS_KEYS;
  WORKFLOW_STEP_BASE_TYPE: "Canvas Step";
}
export interface SHARED_CONSTANTS_WORKSPACE_RATE_LIMITS_ERROR_CODE {
  COMPANY_RATE_LIMIT_NOT_FOUND: "COMPANY_RATE_LIMIT_NOT_FOUND";
  MISSING_REQUIRED_PARAMETERS: "MISSING_REQUIRED_PARAMETERS";
}
export interface SHARED_CONSTANTS_WORKSPACE_RATE_LIMITS {
  ERROR_CODE: SHARED_CONSTANTS_WORKSPACE_RATE_LIMITS_ERROR_CODE;
}
export interface SHARED_CONSTANTS_ROOT {
  "# Anywhere this value is updated should be compatible with https://github.com/Appboy/platform/pull/13836": null;
  ACCESSIBILITY_TESTING_CATEGORIES: SHARED_CONSTANTS_ACCESSIBILITY_TESTING_CATEGORIES;
  ACCESSIBILITY_TESTING_ERRORS: SHARED_CONSTANTS_ACCESSIBILITY_TESTING_ERRORS;
  ACCESSIBILITY_TEST_STATUS: SHARED_CONSTANTS_ACCESSIBILITY_TEST_STATUS;
  AGENTIC_CREDENTIAL: SHARED_CONSTANTS_AGENTIC_CREDENTIAL;
  AI_SETTINGS: SHARED_CONSTANTS_AI_SETTINGS;
  ALLOYS: SHARED_CONSTANTS_ALLOYS;
  ANALYTICS_REPORT_REPORT_TYPES: SHARED_CONSTANTS_ANALYTICS_REPORT_REPORT_TYPES;
  ANDROID_FIREBASE_PUSH_SENDER_PRIORITIES: SHARED_CONSTANTS_ANDROID_FIREBASE_PUSH_SENDER_PRIORITIES;
  API_DASHBOARD: SHARED_CONSTANTS_API_DASHBOARD;
  API_LIMITS: SHARED_CONSTANTS_API_LIMITS;
  APPROVALS: SHARED_CONSTANTS_APPROVALS;
  APP_ANALYTICS_PROVIDER: SHARED_CONSTANTS_APP_ANALYTICS_PROVIDER;
  APP_GROUP_API_KEY_PERMISSIONS: SHARED_CONSTANTS_APP_GROUP_API_KEY_PERMISSIONS;
  APP_ICON: SHARED_CONSTANTS_APP_ICON;
  APP_SETTINGS: SHARED_CONSTANTS_APP_SETTINGS;
  ATTRIBUTION_INTEGRATION_ERRORS: SHARED_CONSTANTS_ATTRIBUTION_INTEGRATION_ERRORS;
  AUDIENCE_SYNC_SETTINGS: SHARED_CONSTANTS_AUDIENCE_SYNC_SETTINGS;
  AUTOMATIC_VARIANT_SELECTION: SHARED_CONSTANTS_AUTOMATIC_VARIANT_SELECTION;
  BANNER: SHARED_CONSTANTS_BANNER;
  BANNER_CONSTANTS: SHARED_CONSTANTS_BANNER_CONSTANTS;
  BOUNCE_CLASSIFICATION: SHARED_CONSTANTS_BOUNCE_CLASSIFICATION;
  BRAZE_AGENTIC_AI: SHARED_CONSTANTS_BRAZE_AGENTIC_AI;
  BRAZE_AI_ASSISTANT: SHARED_CONSTANTS_BRAZE_AI_ASSISTANT;
  BRAZE_CLUSTERS: ("au_01" | "d-use-1" | "eu_01" | "eu_02" | "id_01" | "jp_01" | "kr_01" | "us_01" | "us_02" | "us_03" | "us_04" | "us_05" | "us_06" | "us_07" | "us_08" | "us_09" | "us_10")[];
  BRAZE_DOCS_FALLBACK_SEARCH: SHARED_CONSTANTS_BRAZE_DOCS_FALLBACK_SEARCH;
  BRAZE_DOCS_LOOKUP: SHARED_CONSTANTS_BRAZE_DOCS_LOOKUP;
  BRAZE_DOCS_SEARCH: SHARED_CONSTANTS_BRAZE_DOCS_SEARCH;
  BRAZE_GITHUB_TEAMS: SHARED_CONSTANTS_BRAZE_GITHUB_TEAMS;
  BRAZE_TEAMS: SHARED_CONSTANTS_BRAZE_TEAMS;
  CALCULATED_ATTRIBUTES: SHARED_CONSTANTS_CALCULATED_ATTRIBUTES;
  CALCULATED_FILTERS: SHARED_CONSTANTS_CALCULATED_FILTERS;
  CAMPAIGNS: SHARED_CONSTANTS_CAMPAIGNS;
  CAMPAIGN_AB_TEST_TABS: SHARED_CONSTANTS_CAMPAIGN_AB_TEST_TABS;
  CAMPAIGN_BRIEF: SHARED_CONSTANTS_CAMPAIGN_BRIEF;
  CAMPAIGN_COMPARISON_MAXIMUM_COMPARABLE_ROWS: 50;
  CAMPAIGN_COMPARISON_REPORTS: SHARED_CONSTANTS_CAMPAIGN_COMPARISON_REPORTS;
  CAMPAIGN_COMPARISON_REPORT_MAX_OFFSET_MONTHS: 12;
  CAMPAIGN_COMPARISON_REPORT_TYPES: SHARED_CONSTANTS_CAMPAIGN_COMPARISON_REPORT_TYPES;
  CAMPAIGN_DEFAULT_INFLUENCE_PERIOD_SECONDS: 259200;
  CAMPAIGN_GROUPER: SHARED_CONSTANTS_CAMPAIGN_GROUPER;
  CAMPAIGN_MAX_INFLUENCE_PERIOD_SECONDS: 2592000;
  CAMPAIGN_MESSAGE_TYPES: SHARED_CONSTANTS_CAMPAIGN_MESSAGE_TYPES;
  CAMPAIGN_SCHEDULE_TYPES: SHARED_CONSTANTS_CAMPAIGN_SCHEDULE_TYPES;
  CAMPAIGN_STATS_TIMESERIES: SHARED_CONSTANTS_CAMPAIGN_STATS_TIMESERIES;
  CAMPAIGN_SUM_MESSAGE: "sum_message";
  CAMPAIGN_TYPES: SHARED_CONSTANTS_CAMPAIGN_TYPES;
  CAMPAIGN_UNIVERSAL_STATS_CATEGORY: "campaign_universal";
  CAMPAIGN_VARIATION_DISTRIBUTION_REELIGIBILITY: 84600;
  CANVAS: SHARED_CONSTANTS_ROOT_CANVAS;
  CANVAS_COMPARISON_MAXIMUM_COMPARABLE_ROWS: 5;
  CANVAS_COMPARISON_REPORT_MAX_OFFSET_MONTHS: 12;
  CANVAS_COMPARISON_REPORT_TYPES: SHARED_CONSTANTS_CANVAS_COMPARISON_REPORT_TYPES;
  CANVAS_CONVERSION_ERRORS: SHARED_CONSTANTS_CANVAS_CONVERSION_ERRORS;
  CANVAS_OPEN_MAX_TIME_MS: 10000;
  CANVAS_SAVE_MAX_TIME_MS: 15000;
  CANVAS_SCHEDULE_TYPES: SHARED_CONSTANTS_CANVAS_SCHEDULE_TYPES;
  CANVAS_STATS_OPEN_MAX_TIME_MS: 10000;
  CANVAS_STEP_CONSTANTS: SHARED_CONSTANTS_CANVAS_STEP_CONSTANTS;
  CANVAS_UNIVERSAL_STATS_CATEGORY: "canvas_universal";
  CANVAS_VERSIONS: SHARED_CONSTANTS_CANVAS_VERSIONS;
  CANVAS_WIZARD_STEPS: SHARED_CONSTANTS_CANVAS_WIZARD_STEPS;
  CARDS: SHARED_CONSTANTS_CARDS;
  CATALOGS: SHARED_CONSTANTS_ROOT_CATALOGS;
  CHANGELOG: SHARED_CONSTANTS_CHANGELOG;
  CHANNELS: SHARED_CONSTANTS_CHANNELS;
  CLIENT_SAFE_API_KEY_PERMISSIONS: (144 | 145)[];
  COMMENTS: SHARED_CONSTANTS_COMMENTS;
  COMMUNICATION: SHARED_CONSTANTS_COMMUNICATION;
  COMPANY: SHARED_CONSTANTS_COMPANY;
  COMPANY_ACCOUNT_STATUSES: SHARED_CONSTANTS_COMPANY_ACCOUNT_STATUSES;
  COMPANY_INDUSTRY: SHARED_CONSTANTS_COMPANY_INDUSTRY;
  COMPANY_PROVISIONING_STATUSES: SHARED_CONSTANTS_COMPANY_PROVISIONING_STATUSES;
  COMPARISONS: SHARED_CONSTANTS_COMPARISONS;
  CONSUMPTION_TYPES: SHARED_CONSTANTS_CONSUMPTION_TYPES;
  CONTENT_BLOCK_EDITOR_TYPE: SHARED_CONSTANTS_CONTENT_BLOCK_EDITOR_TYPE;
  CONTENT_CARDS: SHARED_CONSTANTS_CONTENT_CARDS;
  CONTENT_FEED: SHARED_CONSTANTS_CONTENT_FEED;
  CONTENT_OPTIMIZATION: SHARED_CONSTANTS_CONTENT_OPTIMIZATION;
  CONTENT_OPTIMIZATION_EXCLUDED_LINK_PREFIXES: SHARED_CONSTANTS_CONTENT_OPTIMIZATION_EXCLUDED_LINK_PREFIXES;
  CONVERSATIONAL_WORKFLOW: SHARED_CONSTANTS_CONVERSATIONAL_WORKFLOW;
  CONVERSATION_TOOL_DEFINITION: SHARED_CONSTANTS_CONVERSATION_TOOL_DEFINITION;
  CURRENTS_INTEGRATION: SHARED_CONSTANTS_CURRENTS_INTEGRATION;
  CUSTOM_ATTRIBUTES: SHARED_CONSTANTS_CUSTOM_ATTRIBUTES;
  CUSTOM_EVENTS: SHARED_CONSTANTS_CUSTOM_EVENTS;
  CUSTOM_EVENTS_INTEGRATION: SHARED_CONSTANTS_CUSTOM_EVENTS_INTEGRATION;
  CUSTOM_PAGE_STRINGS: SHARED_CONSTANTS_CUSTOM_PAGE_STRINGS;
  DASHBOARD_API_TABLE: SHARED_CONSTANTS_DASHBOARD_API_TABLE;
  DASHBOARD_BUILDER: SHARED_CONSTANTS_DASHBOARD_BUILDER;
  DASHBOARD_ENVIRONMENT: SHARED_CONSTANTS_DASHBOARD_ENVIRONMENT;
  DATADOG_INTEGRATION_ERRORS: SHARED_CONSTANTS_DATADOG_INTEGRATION_ERRORS;
  DATALAKE: SHARED_CONSTANTS_DATALAKE;
  DATA_TRANSFORMATION: SHARED_CONSTANTS_DATA_TRANSFORMATION;
  DECISIONING_STUDIO: SHARED_CONSTANTS_DECISIONING_STUDIO;
  DEDUPLICATE_CLASS_NAMES: SHARED_CONSTANTS_DEDUPLICATE_CLASS_NAMES;
  DEPARTMENTS: SHARED_CONSTANTS_DEPARTMENTS;
  DESCRIPTION_MAX_LENGTH: 250;
  DEVELOPER: SHARED_CONSTANTS_DEVELOPER;
  DISPLAY_NAME_BY_CHANNEL: SHARED_CONSTANTS_DISPLAY_NAME_BY_CHANNEL;
  DISPLAY_NAME_BY_CONSUMPTION_TYPE: SHARED_CONSTANTS_DISPLAY_NAME_BY_CONSUMPTION_TYPE;
  DND_EDITOR: SHARED_CONSTANTS_DND_EDITOR;
  DOMAIN: SHARED_CONSTANTS_DOMAIN;
  ECOMMERCE: SHARED_CONSTANTS_ROOT_ECOMMERCE;
  EMAIL: SHARED_CONSTANTS_EMAIL;
  EMAIL_EDITOR_EDIT_PANELS: SHARED_CONSTANTS_EMAIL_EDITOR_EDIT_PANELS;
  EMAIL_EDITOR_PREVIEW_TYPES: SHARED_CONSTANTS_EMAIL_EDITOR_PREVIEW_TYPES;
  EMAIL_GLOBAL_STYLE_SETTINGS: SHARED_CONSTANTS_EMAIL_GLOBAL_STYLE_SETTINGS;
  EMAIL_IP_WARMING: SHARED_CONSTANTS_EMAIL_IP_WARMING;
  EMAIL_MAILBOX_PROVIDERS: SHARED_CONSTANTS_EMAIL_MAILBOX_PROVIDERS;
  EMAIL_MESSAGE: SHARED_CONSTANTS_EMAIL_MESSAGE;
  EMAIL_SELF_SERVE: SHARED_CONSTANTS_EMAIL_SELF_SERVE;
  EMBEDDED_DEVICE: SHARED_CONSTANTS_EMBEDDED_DEVICE;
  ENGAGEMENT_REPORT: SHARED_CONSTANTS_ENGAGEMENT_REPORT;
  ESP: SHARED_CONSTANTS_ROOT_ESP;
  EVENT_NAMESPACES: SHARED_CONSTANTS_EVENT_NAMESPACES;
  EXPERIMENT: SHARED_CONSTANTS_EXPERIMENT;
  EXPERIMENT_STEP_DEFAULT_CONTROL_PERCENT: 20;
  EXPERIMENT_STEP_DEFAULT_CONVERSION_WINDOW_SECONDS: 1209600;
  EXPERIMENT_STEP_DEFAULT_EXPERIMENT_WINDOW_SECONDS: 43200;
  EXPERIMENT_STEP_DESCRIPTION_MAX_LENGTH: 256;
  EXPERIMENT_STEP_EXPERIMENT_PREFIXES: SHARED_CONSTANTS_EXPERIMENT_STEP_EXPERIMENT_PREFIXES;
  EXPERIMENT_STEP_INPUTS: SHARED_CONSTANTS_EXPERIMENT_STEP_INPUTS;
  EXPERIMENT_STEP_MIN_CONVERSION_WINDOW_SECONDS: 86400;
  EXPERIMENT_STEP_VALID_NON_CONTROL_SPLITS: 4;
  EXPERIMENT_STEP_VALID_PERCENT_SUM: 100;
  EXPORT_LOGS: SHARED_CONSTANTS_EXPORT_LOGS;
  FEATURE_FLAG: SHARED_CONSTANTS_FEATURE_FLAG;
  FEATURE_LIMITATIONS: SHARED_CONSTANTS_FEATURE_LIMITATIONS;
  FIELD_LEVEL_ENCRYPTION: SHARED_CONSTANTS_FIELD_LEVEL_ENCRYPTION;
  FILTER: SHARED_CONSTANTS_FILTER;
  FLEXIBLE_ON_CLICK: SHARED_CONSTANTS_FLEXIBLE_ON_CLICK;
  FREE_TRIAL: SHARED_CONSTANTS_FREE_TRIAL;
  FREQUENCY_CAPPING: SHARED_CONSTANTS_FREQUENCY_CAPPING;
  GENERATIVE_AI: SHARED_CONSTANTS_GENERATIVE_AI;
  GLOBAL_CONTROL_GROUP_REPORT_MAX_OFFSET_MONTHS: 12;
  GLOBAL_FREQUENCY_CAPPING_RULE: SHARED_CONSTANTS_GLOBAL_FREQUENCY_CAPPING_RULE;
  GLOBAL_RATE_LIMITS: SHARED_CONSTANTS_GLOBAL_RATE_LIMITS;
  GLOBAL_SUBSCRIPTION_CHANNELS: SHARED_CONSTANTS_GLOBAL_SUBSCRIPTION_CHANNELS;
  GRAPES_EDITOR: SHARED_CONSTANTS_GRAPES_EDITOR;
  INBOX_VISION: SHARED_CONSTANTS_INBOX_VISION;
  INDUSTRY: SHARED_CONSTANTS_INDUSTRY;
  INTELLIGENCE: SHARED_CONSTANTS_INTELLIGENCE;
  INTERNAL_PERMISSIONS: SHARED_CONSTANTS_ROOT_INTERNAL_PERMISSIONS;
  INTERNAL_ROLE: SHARED_CONSTANTS_INTERNAL_ROLE;
  INTERNAL_USER_GROUP: SHARED_CONSTANTS_INTERNAL_USER_GROUP;
  IN_APP_MESSAGE: SHARED_CONSTANTS_IN_APP_MESSAGE;
  IOS_INTERRUPTION_LEVEL: SHARED_CONSTANTS_IOS_INTERRUPTION_LEVEL;
  IOS_RELEVANCE_SCORE: SHARED_CONSTANTS_IOS_RELEVANCE_SCORE;
  KAKAO: SHARED_CONSTANTS_KAKAO;
  KINDLE_PUSH: SHARED_CONSTANTS_ROOT_KINDLE_PUSH;
  KNOWLEDGE_SOURCE: SHARED_CONSTANTS_KNOWLEDGE_SOURCE;
  LANDING_PAGE: SHARED_CONSTANTS_LANDING_PAGE;
  LANDING_PAGES: SHARED_CONSTANTS_LANDING_PAGES;
  LANDING_PAGE_ERRORS: SHARED_CONSTANTS_LANDING_PAGE_ERRORS;
  LEARNING_SANDBOX_TEST_SEND_ERRORS: SHARED_CONSTANTS_LEARNING_SANDBOX_TEST_SEND_ERRORS;
  LINE: SHARED_CONSTANTS_LINE;
  LINK_ALIASING_CB_INCLUSION_LABEL_PREFIX: "cb";
  LINK_ALIASING_LINK_NAME_PREFIX: "link";
  LINK_ALIASING_MAX_LINK_NAME_LENGTH: 25;
  LINK_ALIASING_VALID_LINK_NAME_REGEX: "^[\\w\\-]+$";
  LIQUID: SHARED_CONSTANTS_LIQUID;
  LIQUID_CONSTANTS: SHARED_CONSTANTS_LIQUID_CONSTANTS;
  LIQUID_VALIDATION: SHARED_CONSTANTS_LIQUID_VALIDATION;
  LIST_UNSUBSCRIBE: SHARED_CONSTANTS_LIST_UNSUBSCRIBE;
  LOCATION: SHARED_CONSTANTS_LOCATION;
  MANAGE_AUDIENCE: SHARED_CONSTANTS_MANAGE_AUDIENCE;
  MEDIA_LIBRARY: SHARED_CONSTANTS_MEDIA_LIBRARY;
  MESSAGE_ACTIVITY_LOG: SHARED_CONSTANTS_MESSAGE_ACTIVITY_LOG;
  MESSAGE_PRIORITIZATION: SHARED_CONSTANTS_MESSAGE_PRIORITIZATION;
  MESSAGE_QUIET_HOURS: SHARED_CONSTANTS_MESSAGE_QUIET_HOURS;
  MESSAGE_USAGE: SHARED_CONSTANTS_MESSAGE_USAGE;
  META_BIDS: SHARED_CONSTANTS_META_BIDS;
  MMAPI_AUDIENCE_EXPORT: SHARED_CONSTANTS_MMAPI_AUDIENCE_EXPORT;
  MOBILE_APP_LINKING: SHARED_CONSTANTS_MOBILE_APP_LINKING;
  MOBILE_APP_LINKING_ERRORS: SHARED_CONSTANTS_MOBILE_APP_LINKING_ERRORS;
  MULTI_LANGUAGE_COMPOSITION: SHARED_CONSTANTS_MULTI_LANGUAGE_COMPOSITION;
  NON_API_TRIGGERED_CAMPAIGN_TYPES: ("api" | "banner" | "feature_flag" | "feature_flag_experiment" | "in_app_message")[];
  NOTIFICATIONS: SHARED_CONSTANTS_NOTIFICATIONS;
  NOTIFICATION_PREFERENCE_ERRORS: SHARED_CONSTANTS_NOTIFICATION_PREFERENCE_ERRORS;
  OAUTH: SHARED_CONSTANTS_OAUTH;
  OPEN_AI: SHARED_CONSTANTS_OPEN_AI;
  PERMISSIONS: SHARED_CONSTANTS_PERMISSIONS;
  PERMISSION_ACTIONS: SHARED_CONSTANTS_PERMISSION_ACTIONS;
  PERMISSION_INFOS: SHARED_CONSTANTS_PERMISSION_INFOS;
  PERMISSION_NAMES: SHARED_CONSTANTS_PERMISSION_NAMES;
  PERMISSION_RESOURCE_GROUPS: SHARED_CONSTANTS_PERMISSION_RESOURCE_GROUPS;
  PERMISSION_SCOPES: SHARED_CONSTANTS_PERMISSION_SCOPES;
  PII_FIELDS: SHARED_CONSTANTS_PII_FIELDS;
  PLACEMENTS: SHARED_CONSTANTS_PLACEMENTS;
  PLATFORMS: SHARED_CONSTANTS_PLATFORMS;
  PLATFORMS_TO_ALLOW_CREATION: ("Android" | "Kepler" | "Kindle" | "Roku" | "Web" | "iOS" | "tvOS")[];
  PLATFORM_GROUPS: SHARED_CONSTANTS_PLATFORM_GROUPS;
  PREDICTIONS: SHARED_CONSTANTS_PREDICTIONS;
  PREFERENCE_CENTER: SHARED_CONSTANTS_PREFERENCE_CENTER;
  PREVIEW_MESSAGE: SHARED_CONSTANTS_PREVIEW_MESSAGE;
  PRIORITY_MANAGER: SHARED_CONSTANTS_PRIORITY_MANAGER;
  PUSH_CREDENTIAL_MANAGEMENT: SHARED_CONSTANTS_PUSH_CREDENTIAL_MANAGEMENT;
  PUSH_CREDENTIAL_TYPES: SHARED_CONSTANTS_PUSH_CREDENTIAL_TYPES;
  QUERY_BUILDER: SHARED_CONSTANTS_QUERY_BUILDER;
  RCS: SHARED_CONSTANTS_RCS;
  REALTIME_NOTIFIER: SHARED_CONSTANTS_REALTIME_NOTIFIER;
  RECOMMENDATIONS: SHARED_CONSTANTS_RECOMMENDATIONS;
  REGEXES: SHARED_CONSTANTS_ROOT_REGEXES;
  REPORT_BUILDER: SHARED_CONSTANTS_REPORT_BUILDER;
  SCHEDULE_HELPER: SHARED_CONSTANTS_SCHEDULE_HELPER;
  SDK_AUTHENTICATION: SHARED_CONSTANTS_SDK_AUTHENTICATION;
  SDK_ENDPOINTS: SHARED_CONSTANTS_SDK_ENDPOINTS;
  SDK_MESSAGE_PROPERTIES: SHARED_CONSTANTS_SDK_MESSAGE_PROPERTIES;
  SDK_RECORDING: SHARED_CONSTANTS_SDK_RECORDING;
  SDK_SUPPORT_VERIFIER: SHARED_CONSTANTS_SDK_SUPPORT_VERIFIER;
  SEGMENTABLE_EVENT_PROPERTY_TYPES: ("FalseClass" | "Float" | "Integer" | "String" | "TrueClass")[];
  SEGMENTER: SHARED_CONSTANTS_SEGMENTER;
  SEGMENT_COHORTS_COMPARATOR: SHARED_CONSTANTS_SEGMENT_COHORTS_COMPARATOR;
  SEGMENT_COHORTS_CRITERIA_OPTIONS: SHARED_CONSTANTS_SEGMENT_COHORTS_CRITERIA_OPTIONS;
  SEGMENT_COHORTS_DEFINITION_STATUS: SHARED_CONSTANTS_SEGMENT_COHORTS_DEFINITION_STATUS;
  SEGMENT_COHORTS_PROPERTY_COMPLEXITY: SHARED_CONSTANTS_SEGMENT_COHORTS_PROPERTY_COMPLEXITY;
  SMS: SHARED_CONSTANTS_SMS;
  SMS_FROM_ADDRESS_DISPLAY_TYPES: SHARED_CONSTANTS_SMS_FROM_ADDRESS_DISPLAY_TYPES;
  SMS_GLOBAL_KEYWORDS: SHARED_CONSTANTS_SMS_GLOBAL_KEYWORDS;
  SMS_PROTOCOL: SHARED_CONSTANTS_SMS_PROTOCOL;
  SMS_SP: SHARED_CONSTANTS_SMS_SP;
  STEP_EDIT_PAGE: SHARED_CONSTANTS_STEP_EDIT_PAGE;
  SUBSCRIPTION_GROUP_CHANNELS: SHARED_CONSTANTS_SUBSCRIPTION_GROUP_CHANNELS;
  SUBSCRIPTION_GROUP_MANAGEMENT_SEARCHABLE_CHANNELS: SHARED_CONSTANTS_SUBSCRIPTION_GROUP_MANAGEMENT_SEARCHABLE_CHANNELS;
  SUBSCRIPTION_GROUP_MANAGEMENT_SEARCHABLE_STATUSES: SHARED_CONSTANTS_SUBSCRIPTION_GROUP_MANAGEMENT_SEARCHABLE_STATUSES;
  SUBSCRIPTION_GROUP_MANAGEMENT_SEARCH_KEYS: SHARED_CONSTANTS_SUBSCRIPTION_GROUP_MANAGEMENT_SEARCH_KEYS;
  SUBSCRIPTION_STATES: SHARED_CONSTANTS_SUBSCRIPTION_STATES;
  SUPPORT_CASES: SHARED_CONSTANTS_SUPPORT_CASES;
  SUPPRESSION_RULES: SHARED_CONSTANTS_SUPPRESSION_RULES;
  SURVEY: SHARED_CONSTANTS_ROOT_SURVEY;
  TARGETTABLE_CHANNELS: ("ANDROID_PUSH" | "CONTENT_CARD" | "EMAIL" | "FEATURE_FLAG_EXPERIMENT" | "IOS_PUSH" | "KINDLE_PUSH" | "SLIDEUP" | "SMS" | "TRIGGER_IAM" | "WEBHOOK" | "WEB_PUSH" | "WHATS_APP")[];
  TEAMS: SHARED_CONSTANTS_TEAMS;
  TECHNOLOGY_PARTNER: SHARED_CONSTANTS_TECHNOLOGY_PARTNER;
  TEMPLATES: SHARED_CONSTANTS_TEMPLATES;
  TERRITORY_MANAGEMENT: SHARED_CONSTANTS_TERRITORY_MANAGEMENT;
  TEST_SEND_ERRORS: SHARED_CONSTANTS_TEST_SEND_ERRORS;
  TEST_USER: SHARED_CONSTANTS_TEST_USER;
  UCO: SHARED_CONSTANTS_UCO;
  UCO_CAMPAIGN_TEST_TABS: SHARED_CONSTANTS_UCO_CAMPAIGN_TEST_TABS;
  UCO_STEP_PAGES: SHARED_CONSTANTS_UCO_STEP_PAGES;
  UPTIME_API_TYPES: SHARED_CONSTANTS_UPTIME_API_TYPES;
  USAGE_WITH_CREDITS_NAME_BY_CONSUMPTION_TYPE: SHARED_CONSTANTS_USAGE_WITH_CREDITS_NAME_BY_CONSUMPTION_TYPE;
  USER_BEHAVIORS: SHARED_CONSTANTS_USER_BEHAVIORS;
  USER_BEHAVIOR_CONSTANTS: SHARED_CONSTANTS_USER_BEHAVIOR_CONSTANTS;
  USER_BEHAVIOR_SUBTYPES: SHARED_CONSTANTS_USER_BEHAVIOR_SUBTYPES;
  USER_CENTRIC_OPTIMIZATION: SHARED_CONSTANTS_USER_CENTRIC_OPTIMIZATION;
  USER_CSV_IMPORT: SHARED_CONSTANTS_USER_CSV_IMPORT;
  USER_DELETION_STATUS: SHARED_CONSTANTS_USER_DELETION_STATUS;
  USER_ERRORS: SHARED_CONSTANTS_USER_ERRORS;
  USER_INFO: SHARED_CONSTANTS_USER_INFO;
  USER_UPDATER_SOURCES_NAMES: SHARED_CONSTANTS_USER_UPDATER_SOURCES_NAMES;
  VARIATION_BLANK: "variationBlank";
  VERIFIED_DOMAIN: SHARED_CONSTANTS_VERIFIED_DOMAIN;
  VOUCHER: SHARED_CONSTANTS_VOUCHER;
  VOUCHER_GROUP: SHARED_CONSTANTS_VOUCHER_GROUP;
  WEBHOOK_MESSAGE_VARIATION: SHARED_CONSTANTS_WEBHOOK_MESSAGE_VARIATION;
  WHATS_APP: SHARED_CONSTANTS_ROOT_WHATS_APP;
  WORKFLOW: SHARED_CONSTANTS_WORKFLOW;
  WORKSPACE_RATE_LIMITS: SHARED_CONSTANTS_WORKSPACE_RATE_LIMITS;
}
import _sharedConstants from "./shared_constants.json";

const sharedConstants = _sharedConstants as unknown as SHARED_CONSTANTS_ROOT;
export default sharedConstants;
